module.exports = {
  nativeDescription: 'English',
  englishDescription: 'English',
  translation: {

    ozaria_home: {
      subtitle: 'Computer Science that Captivates',
      heading_subtitle: 'A coding adventure for students and your turnkey solution for teaching Computer Science.',
      item_list_p: 'Try Chapter 1 for Free Today!',
      engaging_heading_corner: 'A solution to Engage Students and Support Teachers',
      engaging_row1_h2: 'Easy Implementation',
      engaging_row1_p: 'Even with no coding experience, you can teach a full Computer Science curriculum with Ozaria. Our ready-to-go lesson plans and intuitive dashboard will provide you with the tools you need to be ready to teach on day one.',
      engaging_row2_h2: 'Immersive Gameplay',
      engaging_row2_p: 'Students are immersed in an adventure game in which their knowledge of Computer Science advances with the storyline. In this engaging learning environment, students build real-world skills through the power of play.',
      engaging_row3_h2: 'Standards-Aligned Curriculum',
      engaging_row3_p: 'Ozaria meets CSTA and ISTE standards, enabling you to teach with confidence as your students master core Computer Science concepts, develop computational thinking skills, and learn about the relevance of Computer Science to their daily lives.',
      pd_blurb: 'Learn the skills to effectively teach computer science with our self-directed, CSTA-accredited __pd__ course. Earn up to 40 credit hours any time, from any device.',
      back_cta_1_a: 'Try Chapter 1 for Free',
      speech_bubble_testimonial_1_blockquote: 'Once again, your team has managed to accomplish the Holy Grail of Edutainment. In my opinion as a 26-year veteran Middle School educator, there is no more engaging resource for teaching coding.',
      core_curriculum_header: 'Core Computer Science Curriculum',
      core_curriculum_p: 'We have developed our instructional model based on proven theories and extensive evidence around how students learn best.',
      core_curriculum_carousel_item1_header: 'Make Connections',
      core_curriculum_carousel_item1_p: 'At the start of every module, use our turnkey lesson slides to help your students make the connection between new Computer Science concepts and relevant examples from their daily lives.',
      core_curriculum_carousel_item2_header: 'Construct Own Meaning',
      core_curriculum_carousel_item2_p: 'Next, guide your students in constructing a deeper understanding of new concepts through unplugged and discussion activities that are built into our lesson plans.',
      core_curriculum_carousel_item3_header: 'Learn New Concepts',
      core_curriculum_carousel_item3_p: 'In the third stage of the learning cycle, your students will learn new concepts through expositional dialogue between characters in the Ozaria story. Voice-over, graphics, and animations make absorbing new information even more accessible and fun.',
      core_curriculum_carousel_item4_header: 'Apply New Knowledge',
      core_curriculum_carousel_item4_p: 'Next, your students will put what they learned into practice by typing real Python or JavaScript to solve a variety of challenges in scaffolded game levels. Built-in hints help students identify and fix bugs, leading to greater coding confidence.',
      core_curriculum_carousel_item5_header: 'Summative Project',
      core_curriculum_carousel_item5_p: 'At the end of each chapter, your students will be challenged to showcase their new skills and express their creativity through summative projects in which they build their own games, stories, and more.',
      core_curriculum_scope_sequence: 'View Scope & Sequence',
      core_curriculum_sample_lesson_slides: 'View Sample Lesson Slides',
      global_community_header: 'Join Our Global Community',
      global_community_row1_p: 'Learners',
      global_community_row2_p: 'Lines of Code',
      global_community_row3_p: 'Teachers',
      global_community_row4_p: 'Countries',
      admin_dashboard_header: 'Comprehensive Teacher & Admin Dashboards',
      admin_dashboard_p: 'Designed with feedback from our community of over 140,000 educators, Ozaria addresses the challenges of teaching Computer Science by providing tools and resources that work.',
      admin_dashboard_row1_p: 'The intuitive Teacher Dashboard provides access to student-facing lesson plans, pacing guides, distance learning strategies, and other resources to support your needs.',
      admin_dashboard_row2_p: 'The Track Progress page allows you to monitor student progress on an ongoing basis, get valuable information on their performance, and immediately identify whether interventions are needed.',
      admin_dashboard_row3_a: 'Request a Quote',
      acodus_awards_a: 'Try Chapter 1 for Free',
      speech_bubble_testimonial_2_blockquote: 'It’s the most accessible programming site I’ve seen as of yet. I appreciate the story that goes with Ozaria, as it aligns with a mission my students can empathize with. Frankly, I love it. In fact, I found myself playing for far longer than I wish to admit last weekend!',
      shareable_resources_header: 'Shareable Resources',
      shareable_resources_p: 'Share the resources below with teachers, administrators, and others involved in bringing Computer Science to your school or expanding offerings already in place.',
      shareable_resources_a: 'Download Flyer',
      back_cta_2_a: 'Try Chapter 1 for Free',
      faq_header: 'Frequently Asked Questions',
      faq_row1_header: 'How is Ozaria related to CodeCombat?',
      faq_row1_p: 'Ozaria is the classroom-centered evolution of CodeCombat, one of the most popular coding games in history. We built Ozaria based off the insights gained from teaching over 20 million learners Python and JavaScript. Ozaria incorporates new pedagogical models, an immersive story-driven narrative, and was designed to be implemented in classrooms, for both in-person and remote learning settings.',
      faq_row2_header: 'What ages or grades are appropriate for Ozaria?',
      faq_row2_p: 'Ozaria is aligned to the CSTA and ISTE middle school CS standards, but has been practiced and enjoyed by students ranging from upper elementary through high school.',
      faq_row3_header: 'How much does it cost to access all of the available units and resources?',
      faq_row3_p_part1: 'We customize solutions for schools and districts and work with you to understand your use case, context, and budget. ',
      faq_row3_p_part2: ' for further details! We also provide a ', //
      faq_row3_p_part3: 'funding resources guide',
      faq_row3_p_part4: ' for school and district CS programs.',
      faq_row4_header: 'Does Ozaria have project-based learning?',
      faq_row4_p: 'Yes. Ozaria incorporates shareable Capstone Projects at the end of each Chapter, where students create their own games. These projects serve as summative assessments and are great ways for students to express themselves and demonstrate their learnings to classmates, friends, and family.',
      faq_row5_header: 'Can I use Ozaria as my class’s main curriculum?',
      faq_row5_p: "Absolutely! Ozaria has everything you need to run a full Computer Science class, even if you don't have a Computer Science background. From lesson plans and solution guides to project rubrics and built-in standards alignment, it's all here.",
      faq_row6_p_part1: 'If you have any other questions, please ',
      see_faq_prefix: 'See more',
      see_faq_link: 'frequently asked questions in our help center',
      see_faq_suffix: '.',
      summary: 'Ozaria is a computer science program, an adventure game, and a fantasy story where students master the lost magic of coding to save their world.',
      value_prop1_h1: 'Epic Story. Immersive Gameplay.',
      value_prop1_h2: 'Inspire a deeper connection to learning',
      value_prop1_p: 'In Ozaria, students find themselves embedded in a new world where they master core computer science concepts to progress within the game. The unfolding narrative creates a powerful student-centered learning experience, with each student’s investment in Ozaria’s story paralleling the investment they are making in their own learning journey.',
      value_prop2_h1: 'Discover the Hero within Every Student',
      value_prop2_h2: 'Build real skills through play',
      value_prop2_p: 'Concepts and skills are introduced via a thoughtfully-designed content progression that includes game levels, instructional character dialogue, cutscenes, and more. Students learn to type Python or JavaScript, problem-solve using computational thinking, demonstrate understanding through formative assessments, and apply what they learn by making their own projects.',
      value_prop3_h1: 'Start Your Journey For Free',
      value_prop3_p: 'Teach through adventure with free content covering introductory computer science concepts, plus access to implementation guides and lesson plans.',
      projects_inspire_heading: 'Projects that Inspire. Resources that Empower.',
      student_creativity: 'Unleash Student Creativity',
      student_creativity_paragraph: "At the end of each unit, students apply what they've learned by creating projects, from games to choose-your-own adventure stories and more. Built with scaffolded goals, yet allowing for limitless ideation, students build a shareable and playable portfolio of work that showcases their creative identity.",
      teach_with_support: 'Teach with Support',
      teach_with_support_paragraph: 'Ozaria is built for educators. Each unit throughout the curriculum has a lesson plan that outlines learning objectives, common student misconceptions, key terms, and CSTA standards. In addition, a comprehensive teacher dashboard helps teachers to track student progress and check student code.',
      request_demo: 'Request a Demo',
      im_an_educator: "I'm an Educator",
      im_a_student: "I'm a Student",
      global_title: 'Join Our Global Community of Learners and Educators',
      global_subtitle1: 'Learners',
      global_subtitle2: 'Lines of Code',
      global_subtitle3: 'Teachers',
      global_subtitle4: 'Countries',
      sign_up: 'Sign Up',
      individual_account_warning: 'You are logged in as __name__, which is an individual account. Ozaria is for teacher and student accounts only; do you need to update your account?',
      learner_number: '12 Million',
      code_line_number: '1 Billion',
      dei_initiatives: 'What initiatives does Ozaria have to ensure diversity, equity, and inclusion in the game?',
      dei_initiatives_blurb: 'Ozaria is dedicated to promoting diversity, equity, and inclusion (DEI) within the game. Through diverse character representation, equitable opportunities, and an inclusive environment, Ozaria embraces differences and fosters a welcoming experience for players of all backgrounds and abilities. Explore our __deipage__ to learn more about our commitment and initiatives towards DEI in Ozaria.',
      dei_page: 'DEI page',
      ozaria_efficacy: 'How does Ozaria measure and demonstrate its effectiveness in improving learning outcomes in the classroom?',
      ozaria_efficacy_blurb: 'We prioritize effectiveness through evidence-based practices and assessment. Our __efficacypage__ offers detailed statistics, real teacher quotes, and compelling case studies demonstrating the transformative impact of Ozaria. By creating meaningful learning experiences and employing evidence-based practices, we design content that delivers the outcomes that matter most to teachers and students.',
      efficacy_page: 'efficacy page',
      social_learning: 'Does Ozaria promote social and emotional learning (SEL)?',
      social_learning_blurb: 'Yes! Ozaria actively integrates social and emotional learning (SEL) into its curriculum. Through gamified activities, students develop essential skills such as decision-making, self-awareness, self-management, social awareness, relationship skills, and responsible decision-making. You can learn more about our philosophy on our __selpage__.',
      sel_page: 'SEL page',
    },

    new_home: {
      title_coco: 'CodeCombat - Coding games to learn Python and JavaScript',
      title_ozar: 'Ozaria - Computer science that captivates',
      title_cn_home: 'CodeCombat|Python, Javascript',
      meta_keywords_coco: 'CodeCombat, python, javascript, Coding Games',
      meta_keywords_ozar: 'CodeCombat, python, javascript, Coding Games, Computer Science Program, Adventure, Epic Story',
      meta_description_coco: 'Learn typed code through a programming game. Learn Python, JavaScript, and HTML as you solve puzzles and learn to make your own coding games and websites.',
      meta_description_ozar: 'Ozaria is a computer science program, an adventure game, and a fantasy story where students master the lost magic of coding to save their world.',
      meta_og_url: 'https://codecombat.com',
      become_investor: 'to become an investor in CodeCombat',
      built_for_teachers_title: 'A Coding Game Built with Teachers in Mind',
      built_for_teachers_blurb: 'Teaching kids to code can often feel overwhelming. CodeCombat helps all educators teach students how to code in either JavaScript or Python, two of the most popular programming languages. With a comprehensive curriculum that includes six computer science units and reinforces learning through project-based game development and web development units, kids will progress on a journey from basic syntax to recursion!',
      built_for_teachers_subtitle1: 'Computer Science',
      built_for_teachers_subblurb1: 'Starting with our free Introduction to Computer Science course, students master core coding concepts such as while/for loops, functions, and algorithms.',
      built_for_teachers_subtitle2: 'Game Development',
      built_for_teachers_subblurb2: 'Learners construct mazes and use basic input handling to code their own games that can be shared with friends and family.',
      built_for_teachers_subtitle3: 'Web Development',
      built_for_teachers_subblurb3: 'Using HTML, CSS, and jQuery, learners flex their creative muscles to program their own webpages with a custom URL to share with their classmates.',
      century_skills_title: '21st Century Skills',
      century_skills_blurb1: "Students Don't Just Level Up Their Hero, They Level Up Themselves",
      century_skills_quote1: "You mess up…so then you think about all of the possible ways to fix it, and then try again. I wouldn't be able to get here without trying hard.",
      century_skills_subtitle1: 'Critical Thinking',
      century_skills_subblurb1: "With coding puzzles that are naturally scaffolded into increasingly challenging levels, CodeCombat's programming game ensures kids are always practicing critical thinking.",
      century_skills_quote2: 'Everyone else was making mazes, so I thought, ‘capture the flag’ and that’s what I did.',
      century_skills_subtitle2: 'Creativity',
      century_skills_subblurb2: 'CodeCombat encourages students to showcase their creativity by building and sharing their own games and webpages.',
      century_skills_quote3: 'If I got stuck on a level. I would work with people around me until we were all able to figure it out.',
      century_skills_subtitle3: 'Collaboration',
      century_skills_subblurb3: 'Throughout the game, there are opportunities for students to collaborate when they get stuck and to work together using our pair programming guide.',
      century_skills_quote4: 'I’ve always had aspirations of designing video games and learning how to code ... this is giving me a great starting point.',
      century_skills_quote4_author: 'Joey, 10th Grade',
      century_skills_subtitle4: 'Communication',
      century_skills_subblurb4: 'Coding requires kids to practice new forms of communication, including communicating with the computer itself and conveying their ideas using the most efficient code.',
      classroom_in_box_title: 'We Strive To:',
      classroom_in_box_blurb1: 'Engage every student so that they believe coding is for them.',
      classroom_in_box_blurb2: 'Empower any educator to feel confident when teaching coding.',
      classroom_in_box_blurb3: 'Inspire all school leaders to create a world-class computer science program.',
      classroom_in_box_blurb4: '', // only for koudashijie.com
      click_here: 'Click here',
      creativity_rigor_title: 'Where Creativity Meets Rigor',
      creativity_rigor_subtitle1: 'Make coding fun and teach real-world skills',
      creativity_rigor_blurb1: 'Students type real Python and JavaScript while playing games that encourage trial-and-error, critical thinking, and creativity. Students then apply the coding skills they’ve learned by developing their own games and websites in project-based courses.',
      creativity_rigor_subtitle2: 'Reach students at their level',
      creativity_rigor_blurb2: "Every CodeCombat level is scaffolded based on millions of data points and optimized to adapt to each learner. Practice levels and hints help students when they get stuck, and challenge levels assess students' learning throughout the game.",
      creativity_rigor_subtitle3: 'Built for all teachers, regardless of experience',
      creativity_rigor_blurb3: 'CodeCombat’s self-paced, standards-aligned curriculum makes teaching computer science possible for everyone. CodeCombat equips teachers with the training, instructional resources, and dedicated support to feel confident and successful in the classroom.',
      featured_partners_title1: 'Featured In',
      featured_partners_title2: 'Awards & Partners',
      featured_partners_blurb1: 'Clever Partner',
      featured_partners_blurb2: 'Best Creativity Tool for Students',
      featured_partners_blurb3: 'Top Pick for Learning',
      featured_partners_blurb4: 'Code.org Official Partner',
      featured_partners_blurb5: 'CSforAll Official Member',
      featured_partners_blurb6: 'Hour of Code Activity Partner',
      for_leaders_title: 'For School Leaders',
      for_leaders_blurb: 'A Comprehensive, Standards-Aligned Computer Science Program',
      for_leaders_subtitle1: 'Easy Implementation',
      for_leaders_subblurb1: 'A web-based program that requires no IT support. Get started in under 5 minutes using Google or Clever Single Sign-On (SSO).',
      for_leaders_subtitle2: 'Full Coding Curriculum',
      for_leaders_subblurb2: 'A standards-aligned curriculum with instructional resources and professional development to enable any teacher to teach computer science.',
      for_leaders_subtitle3: 'Flexible Use Cases',
      for_leaders_subblurb3: 'Whether you want to build a Middle School coding elective, a CTE pathway, or an AP Computer Science Principles class, CodeCombat is tailored to suit your needs.',
      for_leaders_subtitle4: 'Real-World Skills',
      for_leaders_subblurb4: 'Students build grit and develop a growth mindset through coding challenges that prepare them for the 500K+ open computing jobs.',
      for_teachers_title: 'For Teachers',
      for_teachers_blurb: 'Tools to Unlock Student Potential',
      for_teachers_subtitle1: 'Project-Based Learning',
      for_teachers_subblurb1: 'Promote creativity, problem-solving, and confidence in project-based courses where students develop their own games and webpages.',
      for_teachers_subtitle2: 'Teacher Dashboard',
      for_teachers_subblurb2: 'View data on student progress, discover curriculum resources, and access real-time support to empower student learning.',
      for_teachers_subtitle3: 'Built-in Assessments',
      for_teachers_subblurb3: 'Personalize instruction and ensure students understand core concepts with formative and summative assessments.',
      for_teachers_subtitle4: 'Automatic Differentiation',
      for_teachers_subblurb4: "Engage all learners in a diverse classroom with practice levels that adapt to each student's learning needs.",
      game_based_blurb: 'CodeCombat is a game-based computer science program where students type real code and see their characters react in real time.',
      get_started: 'Get started',
      global_title: 'Join Our Global Community of Learners and Educators',
      global_subtitle1: 'Learners',
      global_subtitle2: 'Lines of Code',
      global_subtitle3: 'Teachers',
      global_subtitle4: 'Countries',
      go_to_my_classes: 'Go to my classes',
      go_to_my_courses: 'Go to my courses',
      quotes_quote1: 'Name any program online, I’ve tried it. None of them match up to CodeCombat & Ozaria. Any teacher who wants their students to learn how to code... start here!',
      quotes_quote2: ' I was surprised about how easy and intuitive CodeCombat makes learning computer science. The scores on the AP exam were much higher than I expected and I believe CodeCombat is the reason why this was the case.',
      quotes_quote3: 'CodeCombat has been the most beneficial for teaching my students real-life coding capabilities. My husband is a software engineer and he has tested out all of my programs. He put this as his top choice.',
      quotes_quote4: 'The feedback … has been so positive that we are structuring a computer science class around CodeCombat. The program really engages the students with a gaming style platform that is entertaining and instructional at the same time. Keep up the good work, CodeCombat!',
      quotes_quote5: 'Even though the class starts every Saturday at 7am, my son is so excited that he wakes up before me! CodeCombat creates a pathway for my son to advance his coding skills.',
      quotes_quote5_author: 'Latthaphon Pohpon, Parent',
      see_example: 'See example',
      slogan: 'The most engaging way to learn computer science',
      slogan_power_of_play: 'Learn to Code Through the Power of Play',
      teach_cs1_free: 'Teach CS1 Free',
      teachers_love_codecombat_title: 'Teachers Love CodeCombat',
      teachers_love_codecombat_blurb1: 'Report that their students enjoy using CodeCombat to learn how to code',
      teachers_love_codecombat_blurb2: 'Would recommend CodeCombat to other computer science teachers',
      teachers_love_codecombat_blurb3: 'Say that CodeCombat helps them support students’ problem solving abilities',
      teachers_love_codecombat_subblurb: 'In partnership with McREL International, a leader in research-based guidance and evaluations of educational technology.',
      top_banner_blurb: 'Parents, give your child the gift of coding and personalized instruction with our live teachers!',
      top_banner_summer_camp: 'Enrollment now open for our summer coding camps–ask us about our week-long virtual sessions starting at just $199.',
      top_banner_blurb_pd: 'We now offer professional development for educators.',
      top_banner_blurb_funding: 'New: CARES Act funding resources guide to ESSER and GEER funds for your CS programs.',
      top_banner_blurb_maintenance: 'Upgrades coming! Scheduled maintenance: up to 3 hours starting at __maintenanceStartTime__.',
      top_banner_blurb_podcast: 'NEW: Explore the world of EdTech with our new podcast EdTech Adventures.',
      top_banner_blurb_roblox: 'NEW! CodeCombat is coming to Roblox!',
      top_banner_blurb_roblox_teachers: 'NEW! CodeCombat has partnered with Roblox Education!',
      top_banner_blurb_roblox_players: 'NEW! Learn to code while playing Roblox!',
      top_banner_blurb_roblox_players_cta: 'Join Beta Waitlist',
      top_banner_blurb_live_online_classes_parents: 'PARENTS! Get your child coding today with a free trial class.',
      top_banner_blurb_live_online_classes: 'Live online coding classes powered by play!',
      top_banner_blurb_live_online_classes_cta: 'Sign up for a free trial class!',
      top_banner_blurb_demo_day: 'Please join us for a demo day webinar on Thursday, August 25 at 4:00 pm EDT.',
      top_banner_blurb_demo_day_10_20: 'Join us for a spooktacular demo of CodeCombat & Ozaria on Thursday, October 20 at 4:00 pm CDT.',
      top_banner_blurb_hoc_2022_12_01: 'Join us Dec. 1st for our Hour of Code Walkthrough! Everything you need to implement our all new activities __topBannerHereLink__',
      top_banner_blurb_hoc_2022_12_01_here: 'HERE',
      top_banner_blurb_demo_day_2023_02_16: 'LIVE DEMO! See how you can use esports to teach coding. Join us Thursday February 16th at 2:00 pm PST.',
      try_the_game: 'Try the game',
      classroom_edition: 'Classroom Edition:',
      learn_to_code: 'Learn to code:',
      play_now: 'Play Now',
      im_a_parent: "I'm a Parent",
      im_a_parent_description: 'Explore our live online coding classes',
      im_an_educator: "I'm an Educator",
      im_an_educator_description: 'Teach Computer Science with CodeCombat',
      im_a_teacher: "I'm a Teacher",
      im_a_student: "I'm a Student",
      im_a_student_description: 'Learn Computer Science with your class',
      im_an_individual: "I'm an Individual",
      im_an_individual_description: 'Play at home outside of a class setting',
      learn_more: 'Learn more',
      check_it_out: 'Check it out!',
      classroom_in_a_box: 'A classroom in-a-box for teaching computer science.',
      codecombat_is: 'CodeCombat is a platform <strong>for students</strong> to learn computer science while playing through a real game.',
      our_courses: 'Our courses have been specifically playtested <strong>to excel in the classroom</strong>, even for teachers with little to no prior programming experience.',
      watch_how: 'Watch how CodeCombat is transforming the way people learn computer science.',
      top_screenshots_hint: 'Students write code and see their changes update in real-time',
      designed_with: 'Designed with teachers in mind',
      real_code: 'Real, typed code',
      from_the_first_level: 'from the first level',
      getting_students: 'Getting students to typed code as quickly as possible is critical to learning programming syntax and proper structure.',
      educator_resources: 'Educator Resources',
      course_guides: 'and course guides',
      teaching_computer_science: 'Teaching computer science does not require a costly degree, because we provide tools to support educators of all backgrounds.',
      accessible_to: 'Accessible to',
      everyone: 'everyone',
      democratizing: 'Democratizing the process of learning coding is at the core of our philosophy. Everyone should be able to learn to code.',
      forgot_learning: 'I think they actually forgot that they were learning something.',
      wanted_to_do: " Coding is something I've always wanted to do, and I never thought I would be able to learn it in school.",
      builds_concepts_up: "I like how CodeCombat builds the concepts up. It's really easy to understand and fun to figure it out.",
      why_games: 'Why is learning through games important?',
      games_reward: 'Games reward the productive struggle.',
      encourage: 'Gaming is a medium that encourages interaction, discovery, and trial-and-error. A good game challenges the player to master skills over time, which is the same critical process students go through as they learn.',
      excel: 'Games excel at rewarding',
      struggle: 'productive struggle',
      kind_of_struggle: 'the kind of struggle that results in learning that’s engaging and',
      motivating: 'motivating',
      not_tedious: 'not tedious.',
      gaming_is_good: 'Studies suggest gaming is good for children’s brains. (it’s true!)',
      game_based: 'When game-based learning systems are',
      compared: 'compared',
      conventional: 'against conventional assessment methods, the difference is clear: games are better at helping students retain knowledge, concentrate and',
      perform_at_higher_level: 'perform at a higher level of achievement',
      feedback: 'Games also provide real-time feedback that allows students to adjust their solution path and understand concepts more holistically, instead of being limited to just “correct” or “incorrect” answers.',
      real_game: 'A real game, played with real coding.',
      great_game: 'A great game is more than just badges and achievements - it’s about a player’s journey, well-designed puzzles, and the ability to tackle challenges with agency and confidence.',
      agency: 'CodeCombat is a game that gives players that agency and confidence with our robust typed code engine, which helps beginner and advanced students alike write proper, valid code.',
      request_demo_title: 'Get your students started today!',
      request_demo_subtitle: 'Request a demo and get your students started in less than an hour.',
      get_started_title: 'Set up your class today',
      get_started_subtitle: 'Set up a class, add your students, and monitor their progress as they learn computer science.',
      request_demo: 'Request a Demo',
      request_quote: 'Request a Quote',
      setup_a_class: 'Set Up a Class',
      have_an_account: 'Have an account?',
      logged_in_as: 'You are currently logged in as',
      computer_science: 'Our self-paced courses cover basic syntax to advanced concepts',
      ffa: 'Free for all students',
      coming_soon: 'More coming soon!',
      courses_available_in: 'Courses are available in JavaScript and Python. Web Development courses utilize HTML, CSS, and jQuery.',
      boast: 'Boasts riddles that are complex enough to fascinate gamers and coders alike.',
      winning: 'A winning combination of RPG gameplay and programming homework that pulls off making kid-friendly education legitimately enjoyable.',
      run_class: 'Everything you need to run a computer science class in your school today, no CS background required.',
      goto_classes: 'Go to My Classes',
      view_profile: 'View My Profile',
      view_progress: 'View Progress',
      go_to_courses: 'Go to My Courses',
      want_coco: 'Want CodeCombat at your school?',
      educator: 'Educator',
      student: 'Student',
      go_to_my_dashboard: 'Go to My Dashboard',
      our_coding_programs: 'Our Coding Programs',
      codecombat: 'CodeCombat Classroom',
      ozaria: 'Ozaria Classroom',
      codecombat_blurb: 'Our original coding game. Recommended for parents, individuals, educators, and students who want to experience one of the most-loved coding games in the world.',
      ozaria_blurb: 'An adventure game and Computer Science program where students master the lost magic of coding to save their world. Recommended for educators and students.',
      ozaria_china_blurb: '',
      try_codecombat: 'Try CodeCombat',
      try_ozaria: 'Try Ozaria',
      explore_codecombat: 'Explore CodeCombat',
      explore_ai_league: 'Explore AI League',
      explore_ozaria: 'Explore Ozaria',
      explore_online_classes: 'Explore Online Classes',
      explore_pd: 'Explore Professional Development',
      new_adventure_game_blurb: 'Ozaria is our brand new adventure game and your turnkey solution for teaching Computer science. Our student-facing __slides__ and teacher-facing notes make planning and delivering lessons easier and faster.',
      lesson_slides: 'lesson slides',
      pd_blurb: 'Learn the skills to effectively teach computer science with our self-directed, CSTA-accredited professional development course. Earn up to 40 credit hours any time, from any device. Pairs well with Ozaria Classroom.',
      ai_league_blurb: 'Competitive coding has never been so epic with this educational esports league, uniquely both an AI battle simulator and game engine for learning real code.',
      codecombat_live_online_classes: 'CodeCombat Live Online Classes',
      learning_technology_blurb: 'Our original game teaches real-world skills through the power of play. The scaffolded curriculum systematically builds on student’s experiences and knowledge as they progress.',
      learning_technology_blurb_short: 'Our innovative game-based learning technology has transformed the way students learn to code.',
      online_classes_blurb: 'Our online coding classes combine the power of gameplay and personalized instruction for an experience your child will love. With both private or group options available, this is remote learning that works.',
      codecombat_home_blurb: '__codecombatHome__ offers your child a fun and engaging way to advance their coding skills. With access to over 530 levels and exclusive features like pets, premium-only items, and heroes, your child can fully immerse themselves in the world of coding. They can even design games to challenge their friends, build websites and apps to share, and create private teams to compete on a group leaderboard, all in a safe and interactive environment that encourages learning and socialization.',
      codecombat_home: 'CodeCombat',
      for_educators: 'For Educators',
      for_parents: 'For Parents',
      for_everyone: 'For Everyone',
      for_students: 'For Students',
      for_individuals: 'For Individuals',
      for_libraries: 'For Libraries',
      for_partners: 'For Partners',
      for_partners_title: 'Partner With CodeCombat',
      for_partners_blurb: 'Join our mission to make coding accessible and engaging for all by becoming a valued partner with CodeCombat. Our partnership structures include educational businesses, esports sponsors, international distributors, and social impact partners. Partners receive access to our easy-to-use programs, implementation resources, and training options for a successful and enjoyable experience.',
      for_partners_button: 'Explore Partnerships',
      for_libraries_title: 'Library Integration',
      for_libraries_blurb: 'As an entirely self-paced and self-directed digital resource, CodeCombat is the best integration for libraries that want to empower their members of all ages to learn how to code. Our platform offers everything learners need to experience a high-level coding education through a uniquely exciting, game-based curriculum. Perfect for learners in third grade all the way up to adults who want to master college-level coding concepts.',
      for_libraries_button: 'Explore Libraries',
      what_our_customers_are_saying: 'What Our Customers Are Saying',
      game_based_learning: 'Game-Based Learning',
      unique_approach_blurb: 'With our unique approach, students embrace learning as they play and write code from the very start of their adventure, promoting active learning and a growth mindset.',
      text_based_coding: 'Text-Based Coding',
      custom_code_engine_blurb: 'Our custom code engine and interpreter is designed for beginners, teaching true Python, JavaScript, and C++ programming languages using human, beginner-friendly terms.',
      student_impact: 'Student Impact',
      help_enjoy_learning_blurb: 'Our products have helped over 20 million students enjoy learning Computer Science, teaching them to be critical, confident, and creative learners. We engage all students, regardless of experience, helping them to realize a pathway to success in Computer Science.',
      global_community: 'Join Our Global Community',
      million: '__num__ Million',
      billion: '__num__ Billion',
      meta_keywords_podcast: 'CodeCombat, python, javascript, Coding Games, podcast, edtech',
      coco_worlds_header: 'CodeCombat Worlds',
      coco_worlds_description: 'Embark on a 3D coding adventure in Roblox, where you can program pets, play with friends, and develop games all while playing one. Join the CodeCombat community and unleash your creativity in the metaverse!',
      coco_worlds_button: 'Explore CodeCombat Worlds',
      promo_modal_title: 'CodeCombat Home',
      promo_modal_subtitle: 'Learn Real Coding Through Epic Gameplay',
      promo_modal_text: 'Dive into real‑world coding with **Python** and **JavaScript**, solving epic puzzles, battling foes, and building a strong coding foundation. Along the way, you’ll learn the skills to **create your own games** and **websites** — all in their browser, no downloads needed.',
    },

    nav: {
      aiyouth: 'AI Youth',
      educators: 'Educators',
      follow_us: 'Follow Us',
      general: 'General',
      map: 'Map',
      play: 'Levels', // The top nav bar entry where players choose which levels to play
      community: 'Community',
      courses: 'Courses',
      units: 'Units',
      blog: 'Blog',
      forum: 'Forum',
      account: 'Account',
      my_account: 'My Account',
      profile: 'Profile',
      home: 'Home',
      contribute: 'Contribute',
      legal: 'Legal',
      privacy: 'Privacy Notice',
      about: 'About',
      events: 'Events',
      impact: 'Impact',
      star: 'CoCoStar',
      contact: 'Contact',
      press: 'Press',
      twitter_follow: 'Follow',
      my_classrooms: 'My Classes',
      my_courses: 'My Courses',
      my_units: 'My Units',
      my_teachers: 'My Teachers',
      careers: 'Careers',
      facebook: 'Facebook',
      twitter: 'Twitter',
      create_a_class: 'Create a Class',
      other: 'Other',
      learn_to_code: 'Learn to Code!',
      toggle_nav: 'Toggle navigation',
      schools: 'Schools',
      get_involved: 'Get Involved',
      related_urls: 'Related Links',
      open_source: 'Open source (GitHub)',
      support: 'Support',
      faqs: 'FAQs',
      copyright_prefix: 'Copyright',
      copyright_suffix: 'All Rights Reserved.',
      help_pref: 'Need help? Email',
      help_suff: "and we'll get in touch!",
      resource_hub: 'Teacher Toolkit',
      apcsp: 'AP CS Principles',
      parent: 'Parents',
      faq: 'FAQ',
      return_coco: 'Return to CodeCombat',
      classes: 'Classes',
      term_of_service: 'Terms of Service',
      esports: 'Esports',
      browser_recommendation: 'For the best experience we recommend using the latest version of Chrome. Download the browser here!',
      ozaria_classroom: 'Ozaria Classroom',
      codecombat_classroom: 'CodeCombat Classroom',
      ozaria_dashboard: 'Ozaria Dashboard',
      ozaria_teacher_dashboard: 'Ozaria Teacher Dashboard',
      ozaria_admin_dashboard: 'Ozaria Admin Dashboard',
      codecombat_dashboard: 'CodeCombat Dashboard',
      codecombat_teacher_dashboard: 'CodeCombat Teacher Dashboard',
      codecombat_admin_dashboard: 'CodeCombat Admin Dashboard',
      professional_development: 'Professional Development',
      new: 'New!',
      admin: 'Admin',
      api: 'API',
      api_dashboard: 'API Dashboard',
      funding_resources_guide: 'Funding Resources Guide',
      partnerships: 'Partnerships',
      podcast: 'Our Podcast',
      dashboard: 'Dashboard',
      products: 'Products',
      live_online_classes: 'Live Online Classes',
      codecombat_home: 'CodeCombat',
      libraries: 'Libraries',
      codecombat_worlds_on_roblox: 'CodeCombat Worlds on Roblox',
      pricing: 'Pricing',
      help_center: 'Help Center',
      research_efficacy: 'Research - Efficacy',
      research_impact: 'Research - Impact',
      terms: 'Terms',
      podcast_simple: 'Podcast',
      create_free_account: 'Create Free Account',
      school_district_solutions: 'School & District Solutions',
      teacher_toolkit_preview: 'Teacher Toolkit Preview',
      teacher_toolkit: 'Teacher Toolkit',
      efficacy_studies: 'Efficacy Studies',
      success_stories: 'Success Stories',
      hoc: 'Hour of Code & AI',
      grants_funding_resources: 'Grants & Funding Resources',
      accessibility: 'Accessibility (ACR/VPAT)',
      request_quote_demo: 'Request a Demo or Quote',
      coco_junior_beta: 'CodeCombat Junior (Beta)',
      coco_junior: 'CodeCombat Junior',
      ap_csp: 'AP CSP',
      ai_league_esports: 'AI League Esports',
      ai_hackstack_beta: 'AI HackStack (Beta)',
      ai_junior_beta: 'AI Junior (Beta)',
      premium_self_paced: 'Premium Self-Paced',
      codequest: 'CodeQuest',
      library_solutions: 'Library Solutions',
      partner_solutions: 'Partner Solutions',
      teaching_solutions: 'Teaching Solutions',
      play2: 'Play',
      my_dashborads: 'My Dashboards',
      resources: 'Resources',
      curriculum: 'Curriculum',
      company: 'Company',
      coco_home_description: 'With access to all 530 levels and exclusive features like pets, premium only items, and heroes, anyone can fully immerse themselves in the world of coding.',
      coco_classroom_description: 'A full CS curriculum that builds from core concepts all the way through web development, game development and AP CSP.',
      coco_junior_description: 'Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.',
      oz_classroom_description: 'An enchanting narrative coding adventure that establishes the fundamentals of computer science.',
      ap_csp_description: 'Endorsed by the College Board, our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.',
      ai_league_description: 'An epic competitive coding esports platform that encourages creative programming practice in a game-based environment.',
      roblox_description: 'This MMORPG teaches Lua coding and provides a real-world platform to create amazing games and experiences.',
      ai_hackstack_description: 'The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety.',
      ai_junior_description: 'Introduces multimodal generative AI in a simple and intuitive platform designed specifically for K-5 students.',
      learning_options: 'Learning Options',
      ai_hackstack: 'AI HackStack',
      beta: 'Beta',
      teacher_tools: 'Teacher Tools',
      ai_teacher_tool: 'AI Teacher Tool',
      ccw_short: 'Roblox',
    },

    modal: {
      close: 'Close',
      okay: 'Okay',
      cancel: 'Cancel',
      try_again: 'Try Again',
    },

    not_found: {
      page_not_found: 'Page not found',
    },

    diplomat_suggestion: {
      title: 'Help translate CodeCombat!', // This shows up when a player switches to a non-English language using the language selector.
      sub_heading: 'We need your language skills.',
      pitch_body: "We develop CodeCombat in English, but we already have players all over the world. Many of them want to play in {English} but don't speak English, so if you can speak both and are a native speaker of {English}, please consider signing up to be a Diplomat and help translate both the CodeCombat website and all the levels into {English}.",
      missing_translations: "Until we can translate everything into {English}, you'll see English when {English} isn't available.",
      learn_more: 'Learn more about being a Diplomat',
      subscribe_as_diplomat: 'Subscribe as a Diplomat',
    },

    new_home_faq: {
      what_programming_languages: 'What programming languages are available?',
      python_and_javascript: 'We currently support Python, JavaScript, C++, Java, and Lua.',
      why_python: 'Why should you choose Python?',
      why_python_blurb: 'Python is both beginner-friendly and currently used by major corporations (such as Google). If you have younger or first-time learners, we strongly recommend Python.',
      why_javascript: 'Why should you choose JavaScript?',
      why_javascript_blurb: 'JavaScript is the language of the web and is used across nearly every website. You may prefer to choose JavaScript if you are planning to also study web development. We’ve also made it easy for students to transition from Python to JavaScript-based web development.',
      javascript_versus_python: 'JavaScript’s syntax is a little more difficult for beginners than Python, so if you cannot decide between the two, we recommend Python.',
      how_do_i_get_started: 'How do I get started?',
      getting_started_1: 'Create your Teacher Account',
      getting_started_2: 'Create a class',
      getting_started_3: 'Add students',
      getting_started_4: 'Sit back and watch your students have fun learning to code',
      main_curriculum: 'Can I use CodeCombat or Ozaria as my main curriculum?',
      main_curriculum_blurb: 'Absolutely! We’ve spent time consulting with education specialists to craft classroom curriculum and materials specifically for teachers who are using CodeCombat or Ozaria without any prior computer science experience themselves. Many schools are implementing CodeCombat and/or Ozaria as the main computer science curriculum.',
      clever_instant_login: 'Does CodeCombat and Ozaria support Clever Instant Login?',
      clever_instant_login_blurb: 'Yes! Check out our __clever__ for more details on how to get started.',
      clever_integration_faq: 'Clever Integration FAQ',
      google_classroom: 'What about Google Classroom?',
      google_classroom_blurb1: 'Yup! Be sure to use the Google Single Sign-On (SSO) Modal to sign up for your teacher account. If you already have an account using your Google email, use the Google SSO modal to log in next time. In the Create Class modal, you will see an option to Link Google Classroom. We only support rostering via Google Classroom at this time.',
      google_classroom_blurb2: 'Note: you must use Google SSO to sign up or log in at least once in order to see the Google Classroom integration option.',
      how_much_does_it_cost: 'How much does it cost to access all of the available courses and resources?',
      how_much_does_it_cost_blurb: 'We customize solutions for schools and districts and work with you to understand your use case, context, and budget. __contact__ for further details! See also our __funding__ for how to leverage CARES Act funding sources like ESSER and GEER.', //
      recommended_systems: 'Is there a recommended browser and operating system?',
      recommended_systems_blurb: 'CodeCombat and Ozaria run best on computers with at least 4GB of RAM, on a modern browser such as Chrome, Safari, Firefox, or Edge. Chromebooks with 2GB of RAM may have minor graphics issues in later courses. A minimum of 200 Kbps bandwidth per student is required, although 1+ Mbps is recommended.',
      other_questions: 'If you have any other questions, please __contact__.',
      see_faq_prefix: 'See more',
      see_faq_link: 'frequently asked questions in our help center',
      see_faq_suffix: '.',
      ai_bot_faq_title: 'What is the AI Level Help Bot and what measures are in place to ensure safety?',
      ai_bot_faq_blurb: 'The AI Chat Level Help Bot in CodeCombat empowers learners with AI-driven hints for coding challenges, ensuring a guided yet independent learning experience. Safety is paramount, as the AI filters out personal data and is trained to handle improper requests.',
    },

    play: {
      title: 'Play CodeCombat Levels - Learn Python, JavaScript, and HTML',
      meta_description: 'Learn programming with a coding game for beginners. Learn Python or JavaScript as you solve mazes, make your own games, and level up. Challenge your friends in multiplayer arena levels!',
      level_title: '__level__ - CodeCombat',
      level_title_ozaria: '__level__ - Ozaria',
      video_title: '__video__ | Video Level',
      game_development_title: '__level__ | Game Development',
      web_development_title: '__level__ | Web Development',
      anon_signup_title_1: 'CodeCombat has a',
      anon_signup_title_2: 'Classroom Version!',
      anon_signup_enter_code: 'Enter Class Code:',
      anon_signup_ask_teacher: "Don't have one? Ask your teacher!",
      anon_signup_create_class: 'Want to create a class?',
      anon_signup_setup_class: 'Set up a class, add your students, and monitor progress!',
      anon_signup_create_teacher: 'Create free teacher account',
      play_as: 'Play As', // Ladder page
      get_course_for_class: 'Assign Game Development and more to your classes!',
      request_licenses: 'Contact our school specialists for details.',
      compete: 'Compete!', // Course details page
      spectate: 'Spectate', // Ladder page
      simulate_all: 'Simulate All',
      players: 'players', // Hover over a level on /play
      hours_played: 'hours played', // Hover over a level on /play
      items: 'Items', // Tooltip on item shop button from /play
      unlock: 'Unlock', // For purchasing items and heroes
      confirm: 'Confirm',
      owned: 'Owned', // For items you own
      locked: 'Locked',
      locked_by_teacher: 'Locked By Teacher',
      locked_campaign: 'Complete previous world to unlock',
      locked_campaign_forest: 'Complete Kithgard Dungeon to unlock',
      locked_campaign_desert: 'Complete Backwoods Forest to unlock',
      locked_campaign_mountain: 'Complete Sarven Desert to unlock',
      locked_campaign_glacier: 'Complete Cloudrip Mountain to unlock',
      locked_campaign_volcano: 'Complete Kelvintaph Mountain to unlock',
      available: 'Available',
      skills_granted: 'Skills Granted', // Property documentation details
      heroes: 'Heroes', // Tooltip on hero shop button from /play
      pets: 'Pets', // Tooltip on pet shop button from /play
      achievements: 'Achievements', // Tooltip on achievement list button from /play
      settings: 'Settings', // Tooltip on settings button from /play
      poll: 'Poll', // Tooltip on poll button from /play
      next: 'Next', // Go from choose hero to choose inventory before playing a level
      change_hero: 'Change Hero', // Go back from choose inventory to choose hero
      change_hero_or_language: 'Change Hero or Language',
      change_language: 'Code Language / Code Format',
      buy_gems: 'Buy Gems',
      subscribers_only: 'Subscribers Only!',
      subscribe_unlock: 'Subscribe to Unlock!',
      subscriber_heroes: 'Subscribe today to immediately unlock Amara, Hushbaum, and Hattori!',
      subscriber_gems: 'Subscribe today to purchase this hero with gems!',
      practice_license_required: '(license required for practice levels)',
      anonymous: 'Anonymous',
      level_difficulty: 'Difficulty: ',
      awaiting_levels_adventurer_prefix: 'We release new levels every week.',
      awaiting_levels_adventurer: 'Sign up as an Adventurer',
      awaiting_levels_adventurer_suffix: 'to be the first to play new levels.',
      adjust_volume: 'Adjust volume',
      toggle_fullscreen: 'Toggle fullscreen',
      campaign_multiplayer: 'Multiplayer Arenas',
      campaign_multiplayer_description: '... in which you code head-to-head against other players.',
      brain_pop_done: 'You’ve defeated the Ogres with code! You win!',
      brain_pop_challenge: 'Challenge yourself to play again using a different programming language!',
      replay: 'Replay',
      back_to_classroom: 'Back to Class',
      teacher_button: 'For Teachers',
      get_more_codecombat: 'Get More CodeCombat',
      back_to_dashboard: 'Back to Dashboard',
      back_to_ozaria: 'Back to ozaria.com',
      customize_hero: 'Customize Hero',
      account_settings: 'Account Settings',
      back_to_tutorial: 'Back to tutorial',
      teacher_vega_message: 'Students are guided by these tutorial messages. In order to view these messages and to save your progress as you play through the game, please create a student account and play Ozaria as a student.',
      beta_levels_on: 'beta levels on',
      beta_levels_turn_off: 'turn off',
      confirm_m7_off: 'Are you sure to turn beta levels off?',
      play_codecombat: 'Play CodeCombat',
      play_codecombat_junior: 'Play CodeCombat Junior',
      age_codecombat: 'Ages 8+',
      age_codecombat_junior: 'Ages 5-8',
      age_description_codecombat: 'Real Python or JavaScript coding for everyone',
      age_description_codecombat_junior: 'Blocks or simple text coding for beginners',
      campaign_about_dungeon: 'Real text programming for brave adventurers!',
      campaign_about_junior: 'Blocks or simple text coding for young heroes!',
      want_more_hints: 'Want more hints?',
      choose_your_adventure: 'Choose Your Adventure',
      junior: 'Junior',
      original: 'Original',
      roblox_button_hover: 'Play, Code and Create on Roblox',
      ai_league_button_hover: 'Compete in AI League Esports',
      hackstack_button_hover: 'Code and Create with AI HackStack',
      junior_button_hover: 'Blocks coding for beginners',
      cchome_button_hover: 'Original CodeCombat Adventure',
      home_campaign_redirect_student: 'Please visit the course map from your student page.',
      blockly_error_msg: 'Oops! Something went wrong loading your blocks. Try reloading the page to bring your workspace back.',
    },

    code: {
      if: 'if', // Keywords--these translations show up on hover, so please translate them all, even if it's kind of long. (In the code editor, they will still be in English.)
      else: 'else',
      elif: 'else if',
      while: 'while',
      loop: 'loop',
      for: 'for',
      break: 'break',
      continue: 'continue',
      pass: 'pass',
      return: 'return',
      then: 'then',
      do: 'do',
      end: 'end',
      function: 'function',
      def: 'define',
      var: 'variable',
      self: 'self',
      hero: 'hero',
      this: 'this',
      or: 'or',
      '||': 'or',
      and: 'and',
      '&&': 'and',
      not: 'not',
      '!': 'not',
      '=': 'assign', // For this section, conjugate it like it's the verb part of a sentence when possible
      '==': 'equals',
      '===': 'strictly equals',
      '!=': 'does not equal',
      '!==': 'does not strictly equal',
      '>': 'is greater than',
      '>=': 'is greater than or equal',
      '<': 'is less than',
      '<=': 'is less than or equal',
      '*': 'multiplied by',
      '/': 'divided by',
      '+': 'plus',
      '-': 'minus',
      '+=': 'add and assign',
      '-=': 'subtract and assign',
      True: 'True',
      true: 'true',
      False: 'False',
      false: 'false',
      undefined: 'undefined',
      null: 'null',
      nil: 'nil',
      None: 'None',
    },

    share_progress_modal: {
      blurb: "You’re making great progress! Tell your parent how much you've learned with CodeCombat.",
      email_invalid: 'Email address invalid.',
      form_blurb: "Enter your parent's email below and we’ll show them!",
      form_label: 'Email Address',
      placeholder: 'email address',
      title: 'Excellent Work, Apprentice',
    },

    login: {
      auth_sign_up: 'New to Ozaria? Create an Account',
      sign_up: 'Create Account',
      email_or_username: 'Email or Username',
      or: 'or',
      log_in: 'Log In',
      sign_in: 'Sign In',
      logging_in: 'Logging In',
      log_out: 'Log Out',
      forgot_password: 'Forgot your password?',
      finishing: 'Finishing',
      sign_in_with_facebook: 'Facebook',
      sign_in_with_gplus: 'Google',
      signup_switch: 'Want to create an account?',
      already_have_account1: 'Already have a CodeCombat Teacher or Student account?',
      already_have_account2: 'You can sign into Ozaria.com using that account.',
      sign_into_ozaria: 'Sign Into Ozaria.com',
      individual_users_not_supported: 'Ozaria is for classrooms only!  Please visit CodeCombat to continue playing!',
      accounts_merge_confirmation: 'There is an account associated with the email from this Google account. Would you like to merge these accounts?',
      stop_spying: 'Stop Spying',
      stop_switching: 'Stop Switching',
      test_as_student: 'Test as Student',
      gplus_linked: 'Google Account linked successfully',
      plus_link_error: 'Google Account linked failed',
      email_or_username_or_library: 'Email or Username or Library Card number',
      login_failed: 'Login failed. You may need to sign up first.',
    },

    signup: {
      complete_subscription: 'Complete Subscription',
      create_student_header: 'Create Student Account',
      create_teacher_header: 'Create Teacher Account',
      create_individual_header: 'Create a Free Individual Account',
      email_announcements: 'Receive announcements about new CodeCombat levels and features!',
      sign_in_to_continue: 'Sign in or create an account to continue',
      create_account_to_submit_multiplayer: 'Create a free account to rank your multiplayer AI and explore the whole game!',
      teacher_email_announcements: 'Keep me updated on new teacher resources, curriculum, and courses!',
      creating: 'Creating Account...',
      sign_up: 'Sign Up',
      log_in: 'log in with password',
      login: 'Login',
      required: 'You need to log in before you can go that way.',
      login_switch: 'Already have an account?',
      optional: 'optional',
      connected_gplus_header: "You've successfully connected with Google+!",
      connected_gplus_p: 'Finish signing up so you can log in with your Google+ account.',
      connected_facebook_header: "You've successfully connected with Facebook!",
      connected_facebook_p: 'Finish signing up so you can log in with your Facebook account.',
      hey_students: 'Students, enter the class code from your teacher.',
      birthday: 'Birthday',
      parent_email_blurb: "We know you can't wait to learn programming &mdash; we're excited too! Your parents will receive an email with further instructions on how to create an account for you. Email {{email_link}} if you have any questions.",
      classroom_not_found: 'No classes exist with this Class Code. Check your spelling or ask your teacher for help.',
      activation_code_used: 'The activation code has been used. Check your spelling or ask your teacher for help.',
      checking: 'Checking...',
      account_exists: 'This email is already in use:',
      sign_in: 'Sign in',
      email_good: 'Email looks good!',
      name_taken: 'Username already taken! Try {{suggestedName}}?',
      name_available: 'Username available!',
      name_is_email: 'Username may not be an email',
      choose_type: 'Choose your account type:',
      teacher_type_1: 'Teach programming using CodeCombat!',
      teacher_type_2: 'Set up your class',
      teacher_type_3: 'Access Course Guides',
      teacher_type_4: 'View student progress',
      signup_as_teacher: 'Create Teacher Account',
      student_type_1: 'Learn to program while playing an engaging game!',
      student_type_2: 'Play with your class',
      student_type_3: 'Compete in arenas',
      student_type_4: 'Choose your hero!',
      student_type_5: 'Have your Class Code ready!',
      signup_as_student: 'Create Student Account',
      individuals_or_parents: 'Individuals & Parents',
      individual_type: 'For players learning to code outside of a class. Parents should sign up for an account here.',
      signup_as_individual: 'Sign up as an Individual',
      enter_class_code: 'Enter your Class Code',
      enter_birthdate: 'Birthday',
      parent_use_birthdate: 'Parents, please enter your own birthday',
      ask_teacher_1: 'Ask your teacher for your Class Code.',
      ask_teacher_2: 'Not part of a class? Create an ',
      ask_teacher_3: 'Individual Account',
      ask_teacher_4: ' instead.',
      about_to_join: "You're about to join:",
      enter_parent_email: 'Enter your parent’s email address:',
      parent_email_error: 'Something went wrong when trying to send the email. Check the email address and try again.',
      parent_email_sent: 'We’ve sent an email with further instructions on how to create an account. Ask your parent to check their inbox.',
      parent_email_header: "What's your parent's email?",
      parent_email_label: 'Parent email',
      parent_email_excited_blurb: "We're excited for you to start coding! Your parent will get an email with instructions to create your account. Contact us at {{email_link}} with any questions.",
      parent_email_check_inbox: "Check your parent's inbox",
      parent_email_finish_blurb: 'Your parent needs to open the email and finish creating your account before you can save progress.',
      send_to_parent: 'Send to my parent',
      step_1_of_2: 'Step 1 of 2',
      im_under_13: "I'm under 13",
      account_created: 'Account Created!',
      confirm_student_blurb: "Write down your information so that you don't forget it. Your teacher can also help you reset your password at any time.",
      confirm_individual_blurb: 'Write down your login information in case you need it later. Verify your email so you can recover your account if you ever forget your password - check your inbox!',
      confirm_individual_blurb_without_email: 'Write down your login information in case you need it later.',
      write_this_down: 'Write down your username:',
      start_playing: 'Start Playing',
      sso_connected: 'Successfully connected with:',
      select_your_starting_hero: 'Select Your Starting Hero:',
      you_can_always_change_your_hero_later: 'You can always change your hero later.',
      finish: 'Finish',
      teacher_ready_to_create_class: "You're ready to create your first class!",
      teacher_students_can_start_now_coco: 'Your students will be able to start playing the first course, Introduction to Computer Science, immediately.',
      teacher_students_can_start_now_ozar: 'Your students will be able to start playing the first unit, Chapter 1: Up The Mountain, immediately.',
      teacher_list_create_class: 'On the next screen you will be able to create a new class.',
      teacher_list_add_students: 'Add students to the class by clicking the View Class link, then sending your students the Class Code or URL. You can also invite them via email if they have email addresses.',
      teacher_list_resource_hub_1: 'Check out the',
      teacher_list_resource_hub_2_coco: 'Course Guides',
      teacher_list_resource_hub_2_ozar: 'Unit Guides',
      teacher_list_resource_hub_3: 'for solutions to every level, and the',
      teacher_list_resource_hub_4: 'Teacher Toolkit',
      teacher_list_resource_hub_5: 'for curriculum guides, activities, and more!',
      teacher_additional_questions: 'That’s it! If you need additional help or have questions, reach out to __supportEmail__.',
      dont_use_our_email_silly: "Don't put our email here! Put your parent's email.",
      want_codecombat_in_school: 'Want to play CodeCombat all the time?',
      eu_confirmation: 'I agree to allow CodeCombat to store my data on US servers.',
      eu_confirmation_place_of_processing: 'Learn more about the possible risks',
      eu_confirmation_student: 'If you are not sure, ask your teacher.',
      eu_confirmation_individual: 'If you do not want us to store your data on US servers, you can always keep playing anonymously without saving your code.',
      request_class_code: 'Students, request a Class Code from your Teacher to create an Account!',
      educators_create_account: 'Educators, create a Teacher Account to access the first unit for free!',
      looking_for_classroom: 'Looking for classroom...',
      create_your_educator_account: 'Create your educator account',
      educator_signup_list_1_title: 'See what your students see:',
      educator_signup_list_1_desc: 'Demo each game level in the first unit',
      educator_signup_list_2_title: 'See teacher resources:',
      educator_signup_list_2_desc: 'Access scope and sequence, lessons, and more',
      educator_signup_list_3_title: 'See your students thrive:',
      educator_signup_list_3_desc: 'Try the first unit with your class for free',
      signup_with_email: 'Sign up with Email',
      sign_up_with: 'Sign up with',
      already_have_account: 'Already have a CodeCombat or Ozaria account',
      already_have_account_q: 'Already have an account?',
      choose_account_title: 'Create A Free Account',
      choose_account_subtitle: 'Please select the option that best describes you',
      select_your_role: 'Select your role',
      select_your_state: 'Select your state',
      password_requirements: '4 to 64 characters with no repeating',
      invalid: 'Invalid',
      invalid_password: 'Invalid password',
      with: 'with',
      want_to_play_codecombat: "No, I don't have one but want to play CodeCombat!",
      have_a_classcode: 'Have a Class Code?',
      yes_i_have_classcode: 'Yes, I have a Class Code!',
      enter_it_here: 'Enter it here:',
      play_without_saving: 'Play without saving',
    },

    recover: {
      recover_account_title: 'Recover Account',
      send_password: 'Send Recovery Password',
      recovery_sent: 'Recovery email sent.',
    },

    items: {
      primary: 'Primary',
      secondary: 'Secondary',
      armor: 'Armor',
      accessories: 'Accessories',
      misc: 'Misc',
      books: 'Books',
    },

    common: {
      default_title_coco: 'CodeCombat - Coding games to learn Python and JavaScript',
      default_title_ozar: 'Ozaria - Computer science that captivates',
      ozaria: 'Ozaria',
      default_meta_description_coco: 'Learn typed code through a programming game. Learn Python, JavaScript, and HTML as you solve puzzles and learn to make your own coding games and websites.',
      default_meta_description_ozar: 'Ozaria is a computer science program, an adventure game, and a fantasy story where students master the lost magic of coding to save their world.',
      back: 'Back', // When used as an action verb, like "Navigate backward"
      coming_soon: 'Coming soon!',
      continue: 'Continue', // When used as an action verb, like "Continue forward"
      next: 'Next',
      default_code: 'Default Code',
      loading: 'Loading...',
      overview: 'Overview',
      processing: 'Processing...',
      solution: 'Solution',
      table_of_contents: 'Table of Contents',
      intro: 'Intro',
      saving: 'Saving...',
      sending: 'Sending...',
      send: 'Send',
      sent: 'Sent',
      cancel: 'Cancel',
      save: 'Save',
      publish: 'Publish',
      output: 'Output',
      create: 'Create',
      fork: 'Fork',
      clone: 'Clone',
      play: 'Play', // When used as an action verb, like "Play next level"
      retry: 'Retry',
      actions: 'Actions',
      info: 'Info',
      help: 'Help',
      watch: 'Watch',
      unwatch: 'Unwatch',
      submit_patch: 'Submit Patch',
      submit_changes: 'Submit Changes',
      save_changes: 'Save Changes',
      required_field: 'required',
      submit: 'Submit',
      replay: 'Replay',
      complete: 'Complete',
      pick_image: 'Pick Image',
      continue_editing: 'Continue Editing',
      logout: 'Logout',
      empty: 'Empty',
      done: 'Done',
      remove: 'Remove',
      locked: 'Locked',
      internal_error: 'Internal Error',
      manage: 'Manage',
      empty_results: 'Empty Results.',
      roblox: 'Roblox',
      warning: 'Warning',
    },

    general: {
      and: 'and',
      name: 'Name',
      date: 'Date',
      body: 'Body',
      version: 'Version',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      withdrawn: 'Withdrawn',
      accept: 'Accept',
      accept_and_save: 'Accept&Save',
      reject: 'Reject',
      withdraw: 'Withdraw',
      submitter: 'Submitter',
      submitted: 'Submitted',
      commit_msg: 'Commit Message',
      version_history: 'Version History',
      version_history_for: 'Version History for: ',
      select_changes: 'Select two changes below to see the difference.',
      undo_prefix: 'Undo',
      undo_shortcut: '(Ctrl+Z)',
      redo_prefix: 'Redo',
      redo_shortcut: '(Ctrl+Shift+Z)',
      play_preview: 'Play preview of current level',
      result: 'Result',
      results: 'Results',
      description: 'Description',
      or: 'or',
      subject: 'Subject',
      email: 'Email',
      password: 'Password',
      confirm_password: 'Confirm Password',
      message: 'Message',
      code: 'Code',
      ladder: 'Ladder',
      when: 'When',
      opponent: 'Opponent',
      opponent_and_team: 'Opponent',
      rank: 'Rank',
      score: 'Score',
      win: 'Win',
      loss: 'Loss',
      tie: 'Tie',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      player: 'Player',
      player_level: 'Level', // Like player level 5, not like level: Dungeons of Kithgard
      warrior: 'Warrior',
      ranger: 'Ranger',
      wizard: 'Wizard',
      first_name: 'First Name',
      last_name: 'Last Name',
      last_initial: 'Last Initial',
      username: 'Username',
      contact_us: 'Contact Us',
      close_window: 'Close Window',
      learn_more: 'Learn More',
      more: 'More',
      fewer: 'Fewer',
      with: 'with',
      archived: 'Archived',
      chat: 'Chat',
      chat_with_us: 'Chat with us',
      email_us: 'Send us an email',
      sales: 'Sales',
      support: 'Support',
      here: 'here',
      from: 'From',
      classrooms: 'Classrooms',
    },

    units: {
      second: 'second',
      seconds: 'seconds',
      sec: 'sec',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      week: 'week',
      weeks: 'weeks',
      month: 'month',
      months: 'months',
      year: 'year',
      years: 'years',
    },

    play_level: {
      back_to_map: 'Back to Map',
      directions: 'Directions',
      edit_level: 'Edit Level',
      keep_learning: 'Keep Learning',
      explore_codecombat: 'Explore CodeCombat',
      finished_hoc: "I'm finished with my Hour of Code",
      get_certificate: 'Get your certificate!',
      level_complete: 'Level Complete',
      level_complete_at: 'Level Completed ',
      completed_level: 'Completed Level:',
      course: 'Course:',
      done: 'Done',
      next_level: 'Next Level',
      combo_challenge: 'Combo Challenge',
      concept_challenge: 'Concept Challenge',
      challenge: 'Challenge',
      challenge_unlocked: 'Challenge Unlocked',
      combo_challenge_unlocked: 'Combo Challenge Unlocked',
      concept_challenge_unlocked: 'Concept Challenge Unlocked',
      concept_challenge_complete: 'Concept Challenge Complete!',
      combo_challenge_complete: 'Combo Challenge Complete!',
      combo_challenge_complete_body: "Great job, it looks like you're well on your way to understanding __concept__!",
      replay_level: 'Replay Level',
      combo_concepts_used: '__complete__/__total__ Concepts Used',
      combo_all_concepts_used: 'You used all concepts possible to solve the challenge. Great job!',
      combo_not_all_concepts_used: 'You used __complete__ out of the __total__ concepts possible to solve the challenge. Try to get all __total__ concepts next time!',
      start_challenge: 'Start Challenge',
      next_game: 'Next game',
      languages: 'Languages',
      programming_language: 'Programming language',
      show_menu: 'Show game menu',
      home: 'Home', // Not used any more, will be removed soon.
      level: 'Level', // Like "Level: Dungeons of Kithgard"
      skip: 'Skip',
      game_menu: 'Game Menu',
      restart: 'Restart',
      goals: 'Goals',
      goal: 'Goal',
      challenge_level_goals: 'Challenge Level Goals',
      challenge_level_goal: 'Challenge Level Goal',
      concept_challenge_goals: 'Concept Challenge Goals',
      combo_challenge_goals: 'Challenge Level Goals',
      concept_challenge_goal: 'Concept Challenge Goal',
      combo_challenge_goal: 'Challenge Level Goal',
      running: 'Running...',
      success: 'Success!',
      incomplete: 'Incomplete',
      timed_out: 'Ran out of time',
      failing: 'Failing',
      reload: 'Reload',
      reload_title: 'Reload All Code?',
      reload_really: 'Are you sure you want to reload this level back to the beginning?',
      reload_confirm: 'Reload All',
      restart_really: "Are you sure you want to restart the level? You'll lose all the code you've written.",
      restart_confirm: 'Yes, Restart',
      test_level: 'Test Level',
      victory: 'Victory',
      victory_title_prefix: '',
      victory_title_suffix: ' Complete',
      victory_sign_up: 'Sign Up to Save Progress',
      victory_sign_up_poke: 'Want to save your code? Create a free account!',
      victory_rate_the_level: 'How fun was this level?',
      victory_return_to_ladder: 'Return to Ladder',
      victory_saving_progress: 'Saving Progress',
      victory_go_home: 'Go Home',
      victory_review: 'Tell us more!',
      victory_review_placeholder: 'How was the level?',
      victory_hour_of_code_done: 'Are You Done?',
      victory_hour_of_code_done_yes: "Yes, I'm finished with my Hour of Code™!",
      victory_experience_gained: 'XP Gained',
      victory_gems_gained: 'Gems Gained',
      victory_new_item: 'New Item',
      victory_new_hero: 'New Hero',
      victory_viking_code_school: "Holy smokes, that was a hard level you just beat! If you aren't already a software developer, you should be. You just got fast-tracked for acceptance with Viking Code School, where you can take your skills to the next level and become a professional web developer in 14 weeks.",
      victory_become_a_viking: 'Become a Viking',
      victory_no_progress_for_teachers: 'Progress is not saved for teachers. But, you can add a student account to your classroom for yourself.',
      tome_cast_button_run: 'Run',
      tome_cast_button_running: 'Running',
      tome_cast_button_ran: 'Ran',
      tome_cast_button_update: 'Update',
      tome_submit_button: 'Submit',
      tome_reload_method: 'Reload original code to restart the level',
      tome_available_spells: 'Available Spells',
      tome_your_skills: 'Your Skills',
      blocks: 'Blocks',
      hints: 'Hints',
      docs: 'Docs',
      videos: 'Videos',
      hints_title: 'Hint {{number}}',
      code_saved: 'Code Saved',
      chat_placeholder: 'Need coding help? Chat with the AI. (experimental!)',
      chat_fix_show: 'Show Me',
      chat_fix_hide: 'Hide',
      chat_fix_show_code: 'Show Code',
      chat_fix_hide_code: 'Hide Code',
      apply_code: 'Apply =>',
      skip_tutorial: 'Skip (esc)',
      keyboard_shortcuts: 'Key Shortcuts',
      loading_start: 'Start Level',
      loading_start_combo: 'Start Combo Challenge',
      loading_start_concept: 'Start Concept Challenge',
      problem_alert_title: 'Fix Your Code',
      problem_alert_need_help: 'Need help?',
      problem_alert_ask_the_ai: 'Ask the AI',
      ask_ai: 'Ask AI',
      ask_ai_placeholder: 'Enter your request here...',
      problem_alert_need_hint: 'Need a hint? You can ask the AI for help.',
      time_current: 'Now:',
      time_total: 'Max:',
      time_goto: 'Go to:',
      non_user_code_problem_title: 'Unable to Load Level',
      infinite_loop_title: 'Infinite Loop Detected',
      infinite_loop_description: "The initial code to build the world never finished running. It's probably either really slow or has an infinite loop. Or there might be a bug. You can either try running this code again or reset the code to the default state. If that doesn't fix it, please let us know.",
      non_user_code_problem_description: "The initial code to build the world never finished running because of an error: <pre>__error__</pre>You can either try running this code again or reset the code to the default state. If that doesn't fix it, please let us know.",
      check_dev_console: 'You can also open the developer console to see what might be going wrong.',
      check_dev_console_link: '(instructions)',
      infinite_loop_try_again: 'Try Again',
      infinite_loop_reset_level: 'Reset Level',
      infinite_loop_comment_out: 'Comment Out My Code',
      tip_toggle_play: 'Toggle play/paused with Ctrl+P.',
      tip_scrub_shortcut: 'Use Ctrl+[ and Ctrl+] to rewind and fast-forward.',
      tip_guide_exists: 'Click the guide, inside game menu (at the top of the page), for useful info.',
      tip_open_source: 'CodeCombat is part of the open source community!',
      tip_tell_friends: 'Enjoying CodeCombat? Tell your friends about us!',
      tip_beta_launch: 'CodeCombat launched its beta in October, 2013.',
      tip_think_solution: 'Think of the solution, not the problem.',
      tip_theory_practice: 'In theory, there is no difference between theory and practice. But in practice, there is. - Yogi Berra',
      tip_error_free: 'There are two ways to write error-free programs; only the third one works. - Alan Perlis',
      tip_debugging_program: 'If debugging is the process of removing bugs, then programming must be the process of putting them in. - Edsger W. Dijkstra',
      tip_forums: 'Head over to the forums and tell us what you think!',
      tip_baby_coders: 'In the future, even babies will be Archmages.',
      tip_morale_improves: 'Loading will continue until morale improves.',
      tip_all_species: 'We believe in equal opportunities to learn programming for all species.',
      tip_reticulating: 'Reticulating spines.',
      tip_harry: 'Yer a Wizard, ',
      tip_great_responsibility: 'With great coding skill comes great debug responsibility.',
      tip_munchkin: "If you don't eat your vegetables, a munchkin will come after you while you're asleep.",
      tip_binary: "There are only 10 types of people in the world: those who understand binary, and those who don't.",
      tip_commitment_yoda: 'A programmer must have the deepest commitment, the most serious mind. ~ Yoda',
      tip_no_try: 'Do. Or do not. There is no try. - Yoda',
      tip_patience: 'Patience you must have, young Padawan. - Yoda',
      tip_documented_bug: 'A documented bug is not a bug; it is a feature.',
      tip_impossible: "It always seems impossible until it's done. - Nelson Mandela",
      tip_talk_is_cheap: 'Talk is cheap. Show me the code. - Linus Torvalds',
      tip_first_language: 'The most disastrous thing that you can ever learn is your first programming language. - Alan Kay',
      tip_hardware_problem: "Q: How many programmers does it take to change a light bulb?  A: None, it's a hardware problem.",
      tip_hofstadters_law: "Hofstadter's Law: It always takes longer than you expect, even when you take into account Hofstadter's Law.",
      tip_premature_optimization: 'Premature optimization is the root of all evil. - Donald Knuth',
      tip_brute_force: 'When in doubt, use brute force. - Ken Thompson',
      tip_extrapolation: 'There are only two kinds of people: those that can extrapolate from incomplete data...',
      tip_superpower: 'Coding is the closest thing we have to a superpower.',
      tip_control_destiny: 'In real open source, you have the right to control your own destiny. - Linus Torvalds',
      tip_no_code: 'No code is faster than no code.',
      tip_code_never_lies: 'Code never lies, comments sometimes do. — Ron Jeffries',
      tip_reusable_software: 'Before software can be reusable it first has to be usable.',
      tip_optimization_operator: 'Every language has an optimization operator. In most languages that operator is ‘//’',
      tip_lines_of_code: 'Measuring programming progress by lines of code is like measuring aircraft building progress by weight. — Bill Gates',
      tip_source_code: 'I want to change the world but they would not give me the source code.',
      tip_javascript_java: 'Java is to JavaScript what Car is to Carpet. - Chris Heilmann',
      tip_move_forward: 'Whatever you do, keep moving forward. - Martin Luther King Jr.',
      tip_google: "Have a problem you can't solve? Google it!",
      tip_adding_evil: 'Adding a pinch of evil.',
      tip_hate_computers: "That's the thing about people who think they hate computers. What they really hate is lousy programmers. - Larry Niven",
      tip_open_source_contribute: 'You can help CodeCombat improve!',
      tip_recurse: 'To iterate is human, to recurse divine. - L. Peter Deutsch',
      tip_free_your_mind: 'You have to let it all go, Neo. Fear, doubt, and disbelief. Free your mind. - Morpheus',
      tip_strong_opponents: 'Even the strongest of opponents always has a weakness. - Itachi Uchiha',
      tip_paper_and_pen: 'Before you start coding, you can always plan with a sheet of paper and a pen.',
      tip_solve_then_write: 'First, solve the problem. Then, write the code. - John Johnson',
      tip_compiler_ignores_comments: 'Sometimes I think that the compiler ignores my comments.',
      tip_understand_recursion: 'The only way to understand recursion is to understand recursion.',
      tip_life_and_polymorphism: 'Open Source is like a totally polymorphic heterogeneous structure: All types are welcome.',
      tip_mistakes_proof_of_trying: 'Mistakes in your code are just proof that you are trying.',
      tip_adding_orgres: 'Rounding up ogres.',
      tip_sharpening_swords: 'Sharpening the swords.',
      tip_ratatouille: 'You must not let anyone define your limits because of where you come from. Your only limit is your soul. - Gusteau, Ratatouille',
      tip_nemo: "When life gets you down, want to know what you've gotta do? Just keep swimming, just keep swimming. - Dory, Finding Nemo",
      tip_internet_weather: "Just move to the internet, it's great here. We get to live inside where the weather is always awesome. - John Green",
      tip_nerds: "Nerds are allowed to love stuff, like jump-up-and-down-in-the-chair-can't-control-yourself love it. - John Green",
      tip_self_taught: "I taught myself 90% of what I've learned. And that's normal! - Hank Green",
      tip_luna_lovegood: "Don't worry, you're just as sane as I am. - Luna Lovegood",
      tip_good_idea: 'The best way to have a good idea is to have a lot of ideas. - Linus Pauling',
      tip_programming_not_about_computers: 'Computer Science is no more about computers than astronomy is about telescopes. - Edsger Dijkstra',
      tip_mulan: 'Believe you can, then you will. - Mulan',
      project_complete: 'Project Complete!',
      share_this_project: 'Share this project with friends or family:',
      ready_to_share: 'Ready to publish your project?',
      click_publish: 'Click "Publish" to make it appear in the class gallery, then check out what your classmates built! You can come back and continue to work on this project. Any further changes will automatically be saved and shared with your classmates.',
      already_published_prefix: 'Your changes have been published to the class gallery.',
      already_published_suffix: 'Keep experimenting and making this project even better, or see what the rest of your class has built! Your changes will automatically be saved and shared with your classmates.',
      view_gallery: 'View Gallery',
      project_published_noty: 'Your level has been published!',
      keep_editing: 'Keep Editing',
      learn_new_concepts: 'Learn new concepts',
      watch_a_video: 'Watch a video on __concept_name__',
      concept_unlocked: 'Concept Unlocked',
      use_at_least_one_concept: 'Use at least one concept: ',
      command_bank: 'Code Bank',
      learning_goals: 'Learning Goals',
      start: 'Start',
      vega_character: 'Vega Character',
      capella_character: 'Capella Character',
      octans_character: 'Octans Character',
      click_to_continue: 'Click to Continue',
      fill_in_solution: 'Fill in solution',
      toggle_solution: 'Toggle solution',
      play_as_humans: 'Play As Red',
      play_as_ogres: 'Play As Blue',
      changed: 'Last edited ',
      team_humans: 'Red',
      team_ogres: 'Blue',
      watch_game: 'Spectate',
      block_go: 'go',
      block_up: 'up',
      block_down: 'down',
      block_left: 'left',
      block_right: 'right',
      share_your_project: 'Share Your Project',
      keep_editing_your_project: 'You can always keep editing your project, even after sharing it.',
      copy_url: 'Copy URL',
      level_status: 'Status',
      level_status_locked: 'Locked',
      level_status_in_progress: 'In Progress',
      level_status_skipped: 'Skipped',
      level_status_complete: 'Complete',
      level_status_unlocked: 'Unlocked',
      level_status_optional: 'Optional',
      level_type_practice: 'Practice',
      level_type_challenge: 'Challenge',
      level_type_level: 'Level',
      level_type_cutscene: 'Cutscene',
      level_type_capstone: 'Capstone',
      level_type_intro: 'Intro',
      level_type_practice_level: 'Practice Level',
      level_type_challenge_level: 'Challenge Level',
      level_type_cutscene_level: 'Cutscene Level',
      level_type_capstone_level: 'Capstone Level',
      level_type_capstone_project: 'Capstone Project',
      level_type_intro_level: 'Intro Level',
      content_type_avatar: 'Avatar Selection',
      content_type_cinematic: 'Cinematic',
      content_type_interactive: 'Concept Check',
      content_type_arena: 'Arena',
      feedback: 'Feedback',
      ask_teacher_for_help: 'Ask your teacher for help',
      ask_teacher_for_help_offline: 'Your Teacher is currently offline',
      not_enough_credits_bot: 'Oops! Looks like you don’t have enough queries. Subscribe now and get the queries you want for the AI-powered support you need!',
      not_enough_credits_interval: 'No credits left for the __interval__. Consumed __amount__ credits.',
      not_enough_credits_interval_multiple: 'No credits left for __duration__ __interval__. Consumed __amount__ credits.',
      create_account_to_get_credits: 'Create an account to get free credits for using the AI-powered support!',
      ask_teacher_for_credits: 'Ask your teacher for an AI Hackstack license.',
      get_credits: 'Get Credits',
      get_ai_hs_license: 'Get AI Hackstack License',
      use: 'Create',
      learn_to_use: 'Learn',
      navigate_to_previous_page: 'Navigate to the previous page',
      navigate_to_next_page: 'Navigate to the next page',
      restart_capstone_stage: 'Do you want to restart capstone stage progress to 1?',
    },

    apis: {
      methods: 'Methods',
      events: 'Events',
      handlers: 'Handlers',
      properties: 'Properties',
      snippets: 'Snippets',
      spawnable: 'Spawnable',
      html: 'HTML',
      math: 'Math',
      array: 'Array',
      object: 'Object',
      string: 'String',
      function: 'Function',
      vector: 'Vector',
      date: 'Date',
      jquery: 'jQuery',
      json: 'JSON',
      number: 'Number',
      webjavascript: 'JavaScript',
    },

    amazon_hoc: {
      title: 'Keep Learning with Amazon!',
      congrats: 'Congratulations on conquering that challenging Hour of Code!',
      educate_1: 'Now, keep learning about coding and cloud computing with AWS Educate, an exciting, free program from Amazon for both students and teachers. With AWS Educate, you can earn cool badges as you learn about the basics of the cloud and cutting-edge technologies such as gaming, virtual reality, and Alexa.',
      educate_2: 'Learn more and sign up here',
      future_eng_1: 'You can also try to build your own school facts skill for Alexa',
      future_eng_2: 'here',
      future_eng_3: '(device is not required). This Alexa activity is brought to you by the',
      future_eng_4: 'Amazon Future Engineer',
      future_eng_5: 'program which creates learning and work opportunities for all K-12 students in the United States who wish to pursue computer science.',
    },

    live_class: {
      title: 'Thank you!',
      content: 'Amazing! We just launched live online classes.',
      link: 'Ready to get ahead on your coding?',
    },

    code_quest: {
      great: 'Great!',
      join_paragraph: "Join the largest international Python AI coding tournament for all ages and compete for the top of the leaderboard! This month-long global battle starts August 1st and includes $5k worth of prizes and a virtual awards ceremony where we'll announce winners and recognize your coding skills.",
      link: 'Click here to register and learn more',
      global_tournament: 'Global Tournament',
      register: 'Register',
      date: 'Aug 1 - Aug 31',
    },

    play_game_dev_level: {
      created_by: 'Created by {{name}}',
      created_during_hoc: 'Created during Hour of Code',
      restart: 'Restart Level',
      play: 'Play Level',
      play_more_codecombat: 'Play More CodeCombat',
      learn_about_ozaria: 'Learn About Ozaria',
      default_student_instructions: 'Click to control your hero and win your game!',
      goal_survive: 'Survive.',
      goal_survive_time: 'Survive for __seconds__ seconds.',
      goal_defeat: 'Defeat all enemies.',
      goal_defeat_amount: 'Defeat __amount__ enemies.',
      goal_move: 'Move to all the red X marks.',
      goal_collect: 'Collect all the items.',
      goal_collect_amount: 'Collect __amount__ items.',
    },

    game_menu: {
      inventory_tab: 'Inventory',
      save_load_tab: 'Save/Load',
      options_tab: 'Options',
      my_code_tab: 'My Code',
      guide_tab: 'Guide',
      guide_video_tutorial: 'Video Tutorial',
      guide_tips: 'Tips',
      multiplayer_tab: 'Multiplayer',
      auth_tab: 'Sign Up',
      inventory_caption: 'Equip your hero',
      choose_hero_caption: 'Choose hero, language',
      change_langugae_caption: 'Choose language',
      change_language_tab: 'Code Format',
      options_caption: 'Configure settings',
      my_code_caption: 'Quick Code Actions',
      guide_caption: 'Docs and tips',
      multiplayer_caption: 'Play with friends!',
      auth_caption: 'Save your progress.',
    },

    leaderboard: {
      view_other_solutions: 'View Leaderboards',
      scores: 'Scores',
      top_players: 'Top Players by',
      day: 'Today',
      week: 'This Week',
      all: 'All-Time',
      latest: 'Latest',
      time: 'Win Time',
      damage_taken: 'Damage Taken',
      damage_dealt: 'Damage Dealt',
      difficulty: 'Difficulty',
      gold_collected: 'Gold Collected',
      survival_time: 'Survived',
      defeated: 'Enemies Defeated',
      code_length: 'Lines of Code',
      score_display: '__scoreType__: __score__',
    },

    inventory: {
      equipped_item: 'Equipped',
      required_purchase_title: 'Required',
      available_item: 'Available',
      restricted_title: 'Restricted',
      should_equip: '(double-click to equip)',
      equipped: '(equipped)',
      locked: '(locked)',
      restricted: '(restricted in this level)',
      equip: 'Equip',
      unequip: 'Unequip',
      warrior_only: 'Warrior Only',
      ranger_only: 'Ranger Only',
      wizard_only: 'Wizard Only',
    },

    buy_gems: {
      few_gems: 'A few gems',
      pile_gems: 'Pile of gems',
      chest_gems: 'Chest of gems',
      purchasing: 'Purchasing...',
      declined: 'Your card was declined',
      retrying: 'Server error, retrying.',
      prompt_title: 'Not Enough Gems',
      prompt_body: 'Do you want to get more?',
      prompt_button: 'Enter Shop',
      recovered: 'Previous gems purchase recovered. Please refresh the page.',
      price: 'x{{gems}} / mo',
      buy_premium: 'Buy Premium',
      purchase: 'Purchase',
      purchased: 'Purchased',
    },

    subscribe_for_gems: {
      prompt_title: 'Not Enough Gems!',
      prompt_body: 'Subscribe to Premium to get gems and access to even more levels!',
    },

    earn_gems: {
      prompt_title: 'Not Enough Gems',
      prompt_body: 'Keep playing to earn more!',
    },

    subscribe: {
      best_deal: 'Best Deal!',
      confirmation: 'Congratulations! You now have a CodeCombat Premium Subscription!',
      premium_already_subscribed: "You're already subscribed to Premium!",
      subscribe_modal_title: 'CodeCombat Premium',
      comparison_blurb: 'Become a Master Coder - subscribe to <b>Premium</b> today!',
      must_be_logged: 'You must be logged in first. Please create an account or log in from the menu above.',
      subscribe_title: 'Subscribe', // Actually used in subscribe buttons, too
      unsubscribe: 'Unsubscribe',
      confirm_unsubscribe: 'Confirm Unsubscribe',
      never_mind: 'Never Mind, I Still Love You',
      thank_you_months_prefix: 'Thank you for supporting us these last',
      thank_you_months_suffix: 'months.',
      thank_you: 'Thank you for supporting CodeCombat.',
      sorry_to_see_you_go: 'Sorry to see you go! Please let us know what we could have done better.',
      unsubscribe_feedback_placeholder: 'O, what have we done?',
      stripe_description: 'Monthly Subscription',
      stripe_yearly_description: 'Annual Subscription',
      buy_now: 'Buy Now',
      subscription_required_to_play: "You'll need a subscription to play this level.",
      unlock_help_videos: 'Subscribe to unlock all video tutorials.',
      personal_sub: 'Personal Subscription', // Accounts Subscription View below
      loading_info: 'Loading subscription information...',
      managed_by: 'Managed by',
      will_be_cancelled: 'Will be cancelled on',
      currently_free: 'You currently have a free subscription',
      currently_free_until: 'You currently have a subscription until __date__',
      free_subscription: 'Free subscription',
      was_free_until: 'You had a free subscription until',
      managed_subs: 'Managed Subscriptions',
      subscribing: 'Subscribing...',
      current_recipients: 'Current Recipients',
      unsubscribing: 'Unsubscribing',
      subscribe_prepaid: 'Click Subscribe to use prepaid code',
      using_prepaid: 'Using prepaid code for monthly subscription',
      subscribe_to_premium: 'Subscribe to Premium',
      feature_level_access: 'Play 600+ levels',
      feature_heroes: 'Unlock exclusive heroes and pets',
      feature_learn: 'Create games and websites',
      feature_languages: 'Get all supported languages',
      feature_aiyouth: '',
      feature_gems: 'Earn __gems__ gems/mo (__gems12__ gems/yr)',
      feature_all_products: '4-in-1: CodeCombat Home, CodeCombat Junior, CodeCombat Worlds on Roblox, and CodeCombat AI HackStack',
      feature_products: 'Access CodeCombat Junior, CodeCombat & AI HackStack',
      month_price: '$__price__/mo',
      month_price_without_currency: '__price__/mo',
      first_month_price: 'Only $__price__ for your first month!',
      lifetime: 'Lifetime Access',
      lifetime_price: '$__price__',
      year_subscription: 'Annual Subscription',
      year_price: '$__price__/yr',
      year_price_without_currency: '__price__/yr',
      support_part1: 'Need help with payment or prefer PayPal? Email',
      support_part2: 'support@codecombat.com',
      go_prepaid: 'Click here after scaning the code and purchasing',
      forever: 'Forever',
      subscription_status: 'Your Subscription Status',
      currently_not_free: "You don't have a Subscription yet.",
      online_classes: 'Online Classes',
      feature_ai_level_bot: 'Accelerate learning with AI-powered support',
      sure_buy_as_parent: 'Are you sure you want premium access for yourself instead of your child?',
      having_activation_code: 'Having an activation Code for Premium? <a href="/account/prepaid">Activate the code here</a>',
    },

    announcement: {
      now_available: 'Now available for subscribers!',
      subscriber: 'subscriber',
      cuddly_companions: 'Cuddly Companions!', // Pet Announcement Modal
      kindling_name: 'Kindling Elemental',
      kindling_description: 'Kindling Elementals just want to keep you warm at night. And during the day. All the time, really.',
      griffin_name: 'Baby Griffin',
      griffin_description: 'Griffins are half eagle, half lion, all adorable.',
      raven_name: 'Raven',
      raven_description: 'Ravens are excellent at gathering shiny bottles full of health for you.',
      mimic_name: 'Mimic',
      mimic_description: 'Mimics can pick up coins for you. Move them on top of coins to increase your gold supply.',
      cougar_name: 'Cougar',
      cougar_description: 'Cougars like to earn a PhD by Purring Happily Daily.',
      fox_name: 'Blue Fox',
      fox_description: 'Blue foxes are very clever and love digging in the dirt and snow!',
      pugicorn_name: 'Pugicorn',
      pugicorn_description: 'Pugicorns are some of the rarest creatures and can cast spells!',
      wolf_name: 'Wolf Pup',
      wolf_description: 'Wolf pups excel in hunting, gathering, and playing a mean game of hide-and-seek!',
      ball_name: 'Red Squeaky Ball',
      ball_description: 'ball.squeak()',
      collect_pets: 'Collect pets for your heroes!',
      each_pet: 'Each pet has a unique helper ability!',
      upgrade_to_premium: 'Become a {{subscriber}} to equip pets.',
      play_second_kithmaze: 'Play {{the_second_kithmaze}} to unlock the Wolf Pup!',
      the_second_kithmaze: 'The Second Kithmaze',
      keep_playing: 'Keep playing to discover the first pet!',
      coming_soon: 'Coming soon',
      ritic: 'Ritic the Cold', // Ritic Announcement Modal
      ritic_description: 'Ritic the Cold. Trapped in Kelvintaph Glacier for countless ages, finally free and ready to tend to the ogres that imprisoned him.',
      ice_block: 'A block of ice',
      ice_description: 'There appears to be something trapped inside...',
      blink_name: 'Blink',
      blink_description: 'Ritic disappears and reappears in a blink of an eye, leaving nothing but a shadow.',
      shadowStep_name: 'Shadowstep',
      shadowStep_description: 'A master assassin knows how to walk between the shadows.',
      tornado_name: 'Tornado',
      tornado_description: "It is good to have a reset button when one's cover is blown.",
      wallOfDarkness_name: 'Wall of Darkness',
      wallOfDarkness_description: 'Hide behind a wall of shadows to prevent the gaze of prying eyes.',
      notifications: 'Notifications',
      x_announcement: '__x__ Notification',
      x_announcements: '__x__ Notifications',
      x_announcement_with_unread: '__x__ Notification (__y__ unread)',
      x_announcements_with_unread: '__x__ Notifications (__y__ unread)',
      see_more: 'See __unread__ more unread Notifications',
      mark_read: 'Mark Read',
      read_all: 'Read All',
      more_announcements: 'more notifications...',
    },

    avatar_selection: {
      pick_an_avatar: 'Pick an avatar that will represent you as a player',
      select_avatar_title: 'Choose Player Avatar',
    },

    premium_features: {
      get_premium: 'Get<br>CodeCombat<br>Premium', // Fit into the banner on the /features page
      master_coder: 'Become a Master Coder by subscribing today!',
      paypal_redirect: 'You will be redirected to PayPal to complete the subscription process.',
      subscribe_now: 'Subscribe Now',
      hero_blurb_1: 'Get access to __premiumHeroesCount__ super-charged subscriber-only heroes! Harness the unstoppable power of Okar Stompfoot, the deadly precision of Naria of the Leaf, or summon "adorable" skeletons with Nalfar Cryptor.',
      hero_blurb_2: 'Premium Warriors unlock stunning martial skills like Warcry, Stomp, and Hurl Enemy. Or, play as a Ranger, using stealth and bows, throwing knives, traps! Try your skill as a true coding Wizard, and unleash a powerful array of Primordial, Necromantic or Elemental magic!',
      hero_caption: 'Exciting new heroes!',
      pet_blurb_1: "Pets aren't just adorable companions, they also provide unique functionality and methods. The Baby Griffin can carry units through the air, the Wolf Pup plays catch with enemy arrows, the Cougar is fond of chasing ogres around, and the Mimic attracts coins like a magnet!",
      pet_blurb_2: 'Collect all the pets to discover their unique abilities!',
      pet_caption: 'Adopt pets to accompany your hero!',
      game_dev_blurb: 'Learn game scripting and build new levels to share with your friends! Place the items you want, write code for unit logic and behavior, and see if your friends can beat the level!',
      game_dev_caption: 'Design your own games to challenge your friends!',
      everything_in_premium: 'Everything you get in CodeCombat Premium:',
      list_gems: 'Receive bonus gems to buy gear, pets, and heroes',
      list_levels: 'Gain access to __premiumLevelsCount__ more levels',
      list_heroes: 'Unlock exclusive heroes, include Ranger and Wizard classes',
      list_game_dev: 'Make and share games with friends',
      list_web_dev: 'Build websites and interactive apps',
      list_items: 'Equip Premium-only items like pets',
      list_support: 'Get Premium support to help you debug tricky code',
      list_clans: 'Create private clans to invite your friends and compete on a group leaderboard',
      ai_bot_learning: 'AI-powered support to accelerate learning outcomes!',
      ai_bot_description: "CodeCombat’s AI-powered hints feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available young learners will still need to work through each level's coding challenge. Premium subscribers receive an allocation of <b>10 AI hints per day</b> to ensure they always have the support they need.",
      list_ai_bot: 'Premium subscribers receive an allocation of 10 AI hints per day',
      ai_bot_notice: '* AI hints rates are subject to change.',
    },

    choose_hero: {
      choose_hero: 'Choose Your Hero',
      programming_language: 'Programming Language',
      programming_language_description: 'Which programming language do you want to use?',
      default: 'Default',
      experimental: 'Experimental',
      python_blurb: 'Simple yet powerful, great for beginners and experts.',
      javascript_blurb: 'The language of the web. (Not the same as Java.)',
      coffeescript_blurb: 'Nicer JavaScript syntax.',
      lua_blurb: 'Game scripting language.',
      java_blurb: '(Subscriber Only) Android and enterprise.',
      cpp_blurb: '(Subscriber Only) Game development and high performance computing.',
      code_format: 'Code Format',
      text_code: 'Text code',
      blocks_and_code: 'Blocks and code',
      blocks_text: 'Blocks',
      blocks_icons: 'Blocks (Icons)',
      blocks_icons_helptext: 'Junior only',
      text_code_blurb: 'Type text-based code in a real code editor',
      blocks_and_code_blurb: 'Blocks and text code side-by-side',
      blocks_text_blurb: 'Drag and drop blocks for tablets or younger learners',
      blocks_icons_blurb: 'Icon-based blocks for phones or pre-readers',
      status: 'Status',
      weapons: 'Weapons',
      weapons_warrior: 'Swords - Short Range, No Magic',
      weapons_ranger: 'Crossbows, Guns - Long Range, No Magic',
      weapons_wizard: 'Wands, Staffs - Long Range, Magic',
      attack: 'Damage', // Can also translate as "Attack"
      health: 'Health',
      speed: 'Speed',
      regeneration: 'Regen',
      range: 'Range', // As in "attack or visual range"
      blocks: 'Blocks', // As in "this shield blocks this much damage"
      backstab: 'Backstab', // As in "this dagger does this much backstab damage"
      skills: 'Skills',
      attack_1: 'Deals',
      attack_2: 'of listed',
      attack_3: 'weapon damage.',
      health_1: 'Gains',
      health_2: 'of listed',
      health_3: 'armor health.',
      speed_1: 'Moves at',
      speed_2: 'meters per second.',
      available_for_purchase: 'Available for Purchase', // Shows up when you have unlocked, but not purchased, a hero in the hero store
      level_to_unlock: 'Level to unlock:', // Label for which level you have to beat to unlock a particular hero (click a locked hero in the store to see)
      restricted_to_certain_heroes: 'Only certain heroes can play this level.',
      code_format_not_supported: 'Not Supported',
      code_format_only_junior: 'Only Supported in CodeCombat Junior',
      code_format_in_mobile: 'Only Supported in Big Screen(Pad, laptop, PC...)',
      code_format_disable_by_teacher: 'Disabled by Teacher',
      code_language_subscriber_only: 'Subscriber Only',
      code_language_not_support_by_blocks: 'Not Supported with Blocks',
      code_language_not_support_in_classroom: 'Not support in Classroom',
    },

    char_customization_modal: {
      heading: 'Customize Your Hero',
      body: 'Body',
      name_label: "Hero's Name",
      hair_label: 'Hair Color',
      skin_label: 'Skin Color',
    },

    skill_docs: {
      function: 'function', // skill types
      method: 'method',
      snippet: 'snippet',
      number: 'number',
      array: 'array',
      object: 'object',
      string: 'string',
      writable: 'writable', // Hover over "attack" in Your Skills while playing a level to see most of this
      read_only: 'read-only',
      action: 'Action',
      spell: 'Spell',
      action_name: 'name',
      action_cooldown: 'Takes',
      action_specific_cooldown: 'Cooldown',
      action_damage: 'Damage',
      action_range: 'Range',
      action_radius: 'Radius',
      action_duration: 'Duration',
      example: 'Example',
      ex: 'ex', // Abbreviation of "example"
      current_value: 'Current Value',
      default_value: 'Default value',
      parameters: 'Parameters',
      required_parameters: 'Required Parameters',
      optional_parameters: 'Optional Parameters',
      returns: 'Returns',
      granted_by: 'Granted by',
      still_undocumented: 'Still undocumented, sorry.',
      description_coming_soon: 'Description coming soon',
    },

    save_load: {
      granularity_saved_games: 'Saved',
      granularity_change_history: 'History',
    },

    options: {
      general_options: 'General Options', // Check out the Options tab in the Game Menu while playing a level
      volume_label: 'Volume',
      music_label: 'Music',
      music_description: 'Turn background music on/off.',
      editor_config_title_coco: 'Editor Configuration',
      editor_config_title_ozar: 'Level Options:',
      editor_config_livecompletion_label: 'Enable Autocomplete',
      editor_config_livecompletion_description: 'Displays autocomplete suggestions while typing.',
      editor_config_invisibles_label: 'Show Invisibles',
      editor_config_invisibles_description: 'Displays invisibles such as spaces or tabs.',
      editor_config_indentguides_label: 'Show Indent Guides',
      editor_config_indentguides_description: 'Displays vertical lines to see indentation better.',
      editor_config_behaviors_label: 'Enable Smart Behaviors',
      editor_config_behaviors_description: 'Autocompletes brackets, braces, and quotes.',
      editor_config_wide_editor_label: 'Enable Wide Editor',
      editor_config_wide_editor_description: 'Increase the width of editor like old style',
      editor_config_screen_reader_mode_label: 'Enable Screen Reader Mode',
      editor_config_screen_reader_mode_label_disable: 'Disable Screen Reader Mode',
      editor_config_screen_reader_mode_description: 'Display levels in text rather than visually.',
      editor_config_livecompletion_disabled_by_teacher: 'Your teacher has disabled your autocomplete.',
    },

    about: {
      title: 'About CodeCombat - Engaging Students, Empowering Teachers, Inspiring Creation',
      meta_description: 'Our mission is to level computer science through game-based learning and make coding accessible to every learner. We believe programming is magic and want learners to be empowered to to create things from pure imagination.',
      learn_more: 'Learn More',
      main_title: 'If you want to learn to program, you need to write (a lot of) code.',
      main_description: "Our job is to make sure you're doing that with a smile on your face.",
      mission_link: 'Mission',
      team_link: 'Team',
      story_link: 'Story',
      press_link: 'Press',
      mission_title: 'Our mission: make computer science accessible to every student on Earth.',
      mission_description_1: "<strong>Programming is magic</strong>. It's the ability to create things from pure imagination. We started CodeCombat to give learners the feeling of wizardly power at their fingertips by using <strong>typed code</strong>.",
      mission_description_2: "As it turns out, that enables them to learn faster too. WAY faster. It's like having a conversation instead of reading a manual. We want to bring that conversation to every school and to <strong>every student</strong>, because everyone should have the chance to learn the magic of programming.",
      team_title: 'Meet the CodeCombat team',
      team_values: 'We value open and respectful dialogue, where the best idea wins. Our decisions are grounded in customer research and our process is focused on delivering tangible results for them. Everyone is hands-on, from our CEO to our GitHub contributors, because we value growth and learning in our team.',
      nick_title: 'Cofounder, CEO',
      csr_title: 'Customer Success Representative',
      csm_title: 'Customer Success Manager',
      scsm_title: 'Senior Customer Success Manager',
      ae_title: 'Account Executive',
      sae_title: 'Senior Account Executive',
      sgd_title: 'Senior Game Developer',
      gd_title: 'Game Developer',
      dois_title: 'Director of Inside Sales',
      ism_title: 'Inside Sales Manager',
      sism_title: 'Senior Inside Sales Manager',
      shan_title: 'Inside Sales, Europe',
      run_title: 'Head of Operations, CodeCombat Greater China',
      lance_title: 'Head of Technology, CodeCombat Greater China',
      zhiran_title: 'Head of Curriculum, CodeCombat Greater China',
      yuqiang_title: 'Head of Innovation, CodeCombat Greater China',
      swe_title: 'Software Engineer',
      sswe_title: 'Senior Software Engineer',
      css_title: 'Customer Support Specialist',
      am_cs_title: 'Associate Manager, Customer Success',
      css_qa_title: 'Customer Support / QA Specialist',
      maya_title: 'Senior Curriculum Developer',
      bill_title: 'General Manager, CodeCombat Greater China',
      pvd_title: 'Product and Visual Designer',
      spvd_title: 'Senior Product and Visual Designer',
      daniela_title: 'Marketing Manager',
      mm_title: 'Marketing Manager',
      bobby_title: 'Senior Game Designer',
      brian_title: 'Senior Game Design Manager',
      stephanie_title: 'Customer Support Specialist',
      sdr_title: 'Sales Development Representative',
      bd_pr_title: 'Business Development and Partnerships Representative',
      retrostyle_title: 'Illustration',
      retrostyle_blurb: 'RetroStyle Games',
      community_title: '...and our open-source community',
      lgd_title: 'Lead Game Designer',
      oa_title: 'Operations Associate',
      ac_title: 'Administrative Coordinator',
      sac_title: 'Senior Administrative Coordinator',
      oss_title: 'Operations Support Specialist',
      ea_title: 'Executive Assistant',
      om_title: 'Operations Manager',
      som_title: 'Senior Operations Manager',
      sales_om_title: 'Sales Operations Manager',
      pe_title: 'Principal Engineer',
      mo_title: 'Manager, Operations',
      smo_title: 'Senior Manager, Operations',
      do_title: 'Director of Operations',
      vp_o_title: 'VP, Operations',
      scd_title: 'Senior Curriculum Developer',
      lcd_title: 'Lead Curriculum Developer',
      cd_title: 'Curriculum Developer',
      sem_title: 'Senior Education Manager',
      de_title: 'Director of Education',
      vpm_title: 'VP, Marketing',
      vps_title: 'VP, Sales',
      vpsm_title: 'VP, Sales and Marketing',
      oi_title: 'Online Instructor',
      m_oi_title: 'Manager, Online Instruction',
      aoim_title: 'Associate Online Instructor Manager',
      bdm_title: 'Business Development Manager',
      community_subtitle: 'Over 600 contributors have helped build CodeCombat, with more joining every week!',
      community_description_3: 'CodeCombat is a',
      community_description_link_2: 'community project',
      community_description_1: 'with hundreds of players volunteering to create levels, contribute to our code to add features, fix bugs, playtest, and even translate the game into 50 languages so far. Employees, contributors and the site gain by sharing ideas and pooling effort, as does the open source community in general. The site is built on numerous open source projects, and we are open sourced to give back to the community and provide code-curious players a familiar project to explore and experiment with. Anyone can join the CodeCombat community! Check out our',
      community_description_link: 'contribute page',
      community_description_2: 'for more info.',
      number_contributors: 'Over 650 contributors have lent their support and time to this project.',
      story_title: 'Our story so far',
      story_subtitle: 'Since 2013, CodeCombat has grown from a mere set of sketches to a living, thriving game.',
      story_statistic_1a: '20,000,000+',
      story_statistic_1b: 'total players',
      story_statistic_1c: 'have started their programming journey through CodeCombat and Ozaria',
      story_statistic_2a: 'We’ve been translated into over 50 languages — our players hail from',
      story_statistic_2b: '190+ countries',
      story_statistic_3a: 'Together, they have written',
      story_statistic_3b: '1 billion lines of code and counting',
      story_statistic_3c: 'across many different programming languages',
      story_long_way_1: "Though we've come a long way...",
      story_sketch_caption: 'Our very first sketch depicting a programming game in action.',
      story_long_way_2: 'we still have much to do before we complete our quest, so...',
      jobs_title: 'Come join us and bring computer science to the world!',
      jobs_subtitle: "Don't see a good fit but interested in keeping in touch? See our \"Create Your Own\" listing.",
      jobs_benefits: 'Employee Benefits',
      jobs_benefit_4: 'Flexible hours, unlimited vacation',
      jobs_benefit_5: '$1000/yr professional development and continuing education support',
      jobs_benefit_6: 'Medical (gold), dental, vision, 401K',
      jobs_benefit_9: '10-year option exercise window',
      jobs_benefit_10: 'Maternity leave: 12 weeks paid, next 6 @ 55% salary',
      jobs_benefit_11: '12 weeks paid parental leave',
      jobs_benefit_12: '$50/mo internet & biz services benefit',
      jobs_benefit_14: '100% distributed team',
      jobs_custom_title: 'Create Your Own',
      jobs_custom_description: "Are you passionate about CodeCombat but don't see a job listed that matches your qualifications? Write us and show how you think you can contribute to our team. We'd love to hear from you!",
      jobs_custom_contact_1: 'Send us a note at',
      jobs_custom_contact_2: 'introducing yourself and we might get in touch in the future!',
      contact_title: 'Press & Contact',
      contact_subtitle: 'Need more information? Get in touch with us at',
      press_subtitle: 'or visit our press site at',
      screenshots_title: 'Game Screenshots',
      screenshots_hint: '(click to view full size)',
      downloads_title: 'Download Assets & Information',
      about_codecombat: 'About CodeCombat',
      logo: 'Logo',
      screenshots: 'Screenshots',
      character_art: 'Character Art',
      download_all: 'Download All',
      previous: 'Previous',
      location_title: "We're located in downtown SF:",
      ceo: 'CEO',
      coo: 'COO',
      game_director: 'Game Director',
      eng_team_lead: 'Engineering Team Lead',
    },

    teachers: {
      licenses_needed: 'Licenses needed',
      google_classroom_disabled_text: 'To link Google Classroom, login using Google SSO',
      select_class: 'Select class',
      programming_language: 'Programming Language',
      programming_language_edit_desc: 'Language cannot be changed once students join a class. We recommend creating a new class for the same students.',
      programming_language_edit_desc_new: "If you change the programming language, your students' progress in the old language will be hidden, and they will have to start over in the new language. We recommend creating a new class for the same students.",
      add_a_class: 'Add a new class',
      select_desired_lang: 'Select desired language for your class',
      elementary: 'Elementary',
      middle: 'Middle',
      high_school: 'High School',
      class_name: 'Class Name',
      grades: 'Grades',
      select_all_that_apply: 'Select all that apply',
      class_info_modal_sub_title: 'Invite students to join your class by sending them:',
      class_url: 'Class Url',
      class_url_desc: 'Share URL to have students join your class after signing up',
      class_code: 'Class Code',
      class_code_desc: 'Students can enter this code when they sign up at',
      invite_by_email: 'Invite by Email',
      regenerate_class_code: 'Regenerate',
      invite_modal_sub_title: 'Separate each email address by a line break or commas',
      no_new_students_imported: 'No new students imported',
      error_in_importing_classrooms: 'Error in importing classrooms',
      error_in_importing_students: 'Error in importing students',
      classroom_items_description: 'Whether students should earn gems and equip items during gameplay.',
      classroom_live_completion: 'Whether to enable coding autocomplete in this classroom. Disabled: turns autocomplete off for all levels. Enabled: allows students to choose. We recommend leaving this enabled.',
      classroom_disable_paste: 'Whether to disable pasting code into the code editor in this classroom.',
      disable_paste_noty: 'Your teacher has disabled the paste feature!',
      code_formats: 'Code Formats',
      code_formats_description: 'Which code formats students can choose from.',
      code_formats_disabled_by: 'Blocks and code, Blocks are not supported with __language__ language',
      code_formats_mobile: '* Students on mobile will be set to block-based mode',
      code_formats_fallback: '* Students will fallback to text-mode for courses without blocks support',
      code_formats_text: 'text code: real code editor',
      code_formats_block: 'blocks: block-based editor (python, javascript only)',
      code_formats_block_text: 'blocks and code: block-based editor with text code(python, javascript only)',
      code_formats_block_icon: 'blocks(icons): icons editor without text (Junior only) ',
      default_code_format: 'Default Code Format',
      default_code_format_description: 'The code format that students will start with.',
      not_allow_to_solution: '# Licenses needed to view solutions',
      classroom_level_chat: 'AI Level Hints',
      classroom_level_chat_blurb: 'Whether students can ask for AI hints and error explanations.',
      classroom_level_chat_option_free_form: 'Free form',
      classroom_level_chat_option_fixed_prompt_only: 'Fixed prompt only',
      classroom_level_chat_option_none: 'No chat',
      initial_free_courses: 'Initial Courses',
      free_course_blurb_junior: 'Great for grades K-5, CodeCombat Junior can flex down to block-based and mobile options for pre-readers, up to Python or JavaScript text code for upper elementary, or to parallel blocks-and-code to help with the transition.',
      'free_course_blurb_introduction-to-computer-science': 'Great for grades 6-12, CodeCombat\'s core CS courses progress from the beginner-friendly Introduction to Computer Science, through AP Computer Science Principles, and beyond into advanced CS courses. Start here for middle and high school students.',
      'free_course_blurb_intro-to-ai': "Learn essential prompt engineering skills in a wide range of subjects using Al HackStack's Learning Scenarios with popular Al models like ChatGPT, Claude, and DALL-E.",
      'free_course_blurb_chapter-1-sky-mountain': 'Great for grades 6-8, a narrative coding adventure that establishes the fundamentals of computer science.',
      start_teaching_ai_today: 'Start Teaching AI Today!',
      hackstack_beta_release: 'HackStack Beta Release',
      introducing_ai_hackstack: 'Introducing AI HackStack, a generative AI teaching tool for beginners. It provides safe access to top AI models like ChatGPT, Claude, and DALL-E.',
      our_curriculum_empowers_students: 'Our curriculum empowers students to use AI to create websites, games, art, and more. Currently in beta.',
      test_student_promotion_1: 'Ready to walk a mile in your students\' coding shoes? Clicking "Test as Student" lets you dive into the learning experience firsthand. ',
      test_student_promotion_2: 'You\'ll be creating a unique test account that not only mimics the student journey but also saves your progress — unlike the quick previews in our curriculum guide, which are great for a sneak-peek but don\'t keep track of where you\'ve been.',
      test_student_promotion_3: 'Your first course is free. Ready for more? We\'ll guide you on adding a license for continued learning adventures.',
      dashboard_update: 'Dashboard Update',
      dashboard_update_message: 'We are currently optimizing the dashboard for your convenience. You can now find the Curriculum Guide in the left sidebar.',
      ai_algebra_promotion_title: 'A Teacher-Led Algebra + AI Curriculum',
      ai_algebra_promotion_description: 'Algebra + AI is a structured, year-long, classroom-ready curriculum that strengthens core Algebra skills while integrating AI as an acceleration tool. Traditional methods remain central, teachers guide the instruction, and students apply math through modeling, design thinking, and meaningful assessments.',
      switch_to_test_student: 'Switching to test student account..',
      import_ozaria_classroom: 'Import Ozaria Classroom',
      import_codecombat_classroom: 'Import Codecombat Classroom',
      select_ozaria_classroom: 'Select Ozaria Classroom',
      select_codecombat_classroom: 'Select Codecombat Classroom',
      select_to_import_from_ozaria: 'Select to Import from Ozaria',
      select_to_import_from_codecombat: 'Select to Import from Codecombat',
      all_classrooms_imported: 'All classrooms already imported',
      club_type: 'Club / Camp Type',
      create_students_prompt: 'How many students would you like to create?',
      initial_free_courses_description: '*Courses can be updated using Assign Content after creating class too.',
      junior_code_format_only: 'Blocks (Icons) only available for Junior',
      hackstack_no_code_language_format: 'AI HackStack does not need a programming language or code format',
      licenses_activated_success: 'Licenses have been Activated Successfully!',
      license_code_used: 'License Code used.',
      ai_hs_remix: 'AI HackStack Remix',
      ai_hs_remix_blurb: 'Whether students can use other student\'s projects to take inspiration from.',
      and_more: 'and more',
      import_classroom: 'Import Classroom',
      re_import_classroom: 'Re-Import Classroom',
      need_more_license: 'Oops! It looks like you need __additionalLicensesNum__ more license(s) for the course. Visit My Licenses to learn more!',
      confirm_apply_license: 'Please confirm that you\'d like to apply licenses to __numberEnrolled__ student(s). You will have __numberRemaining__ license(s) remaining.',
      fail_get_license: 'Error! __fails__ students failed to get license',
      no_licenses_applied: 'No licenses applied to selected student(s).',
      revoke_license_tips: 'Revoking a license will make it available to apply to other students. Students will no longer be able to access paid content, but their progress will be saved. Please confirm you\'d like to proceed.',
      assign_course_confirm: 'Please confirm that you\'d like to assign __courseName__ to __numStudents__ student(s). __numberEnrolled__ license(s) will be applied.',
      near_end_trial: 'Your Students Are Nearing the End of the Trial Content',
      schedule_demo_subheading: 'Schedule a Demo to Continue Your Students Coding Journey With...',
      schedule_demo_description: 'Schedule a demo with our team to unlock more free content and explore our products, curricula, and resources. Let us help you craft a tailored solution for your class, school, or district.',
      practice_and_application: 'Practice & Application Experiences',
      roster_via_csv: 'Roster via CSV',
      roster_sub_text: 'Supports email, firstName and lastName columns. Required: email and firstName.',
      roster_sub_text_2: 'In case of log-in without SSO, students will have to reset their password.',
      roster_sub_text_3: 'Existing students in the classroom are not removed.',
      roster_download_example: 'Download Example CSV',
      roster_completed: 'Sync completed, refresh to see changes.',
    },

    no_licenses_page: {
      are_your_students_ready: 'Are your students excited and ready to learn more?',
      once_students_have_completed: 'Once students have completed Chapter 1, they will need licenses in order to continue their journey through the next chapter and beyond.',
      get_licenses: 'Get Licenses',
      get_full_access_to_ozaria: 'Get Full Access to Ozaria',
      unlock_all: 'Unlock all the above plus all the teacher support you need',
      unlock_all_dsa: 'Unlock all the above plus all the support teachers need',
      comprehensive_dashboards: 'Comprehensive teacher and administrator dashboards',
      lesson_plans_rubrics_guides: 'Lesson Plans, Project Rubrics, Solution Guides, and more',
      dedicated_customer_success_manager: 'A dedicated customer success manager',
      automatic_access: 'Automatic access to new content and features',
      license_quote: '"In my opinion as a 26 year veteran middle school educator, there is no more engaging resource for teaching coding."',
      join_our_community: 'Join our community',
      join_our_community_desc: 'Over 12 million people have learned to write Python and JavaScript using CodeCombat. Now, we welcome you to join our community of over 82,000 educators and 25,000 schools with Ozaria, designed for educators who want to inspire a new generation of students to learn Computer Science.',
      teach_real_typed_code: 'Teach Real, Typed Code',
      teach_real_typed_code_desc: 'Students learn Python and JavaScript, the two most popular coding languages, and build 21st century skills that will prepare them for any career.',
      support_student_progress: 'Support Student Progress',
      support_student_progress_desc: 'Unlock formative and summative assessment data from Concept Checks, Levels, and Capstone Projects to support student progress.',
      creative_projects: 'Creative Projects',
      creative_projects_desc: 'Inspire imagination and unleash student creativity with shareable capstone projects, like in Chapter 2 where students design their own storytelling game. ',
      looking_for_engaging: 'Looking for engaging computer science curriculum?',
      licenses_are_required: 'Licenses are required for students to continue their journey beyond Chapter 1.',
      real_world_skills: 'Real-World Skills',
      real_world_skills_desc: 'Students learn typed Python and JavaScript, the two most popular coding languages, and enhance their critical-thinking skills, creativity, and resilience to prepare them for any career.',
      personalized_learning: 'Personalized Learning and Scaffolded Instruction',
      personalized_learning_desc: 'Students learn concepts at their own pace. Levels increase in difficulty while providing built-in hints to encourage persistence and grit.',
      flexible_curriculum: 'Flexible Standards- Aligned Curriculum',
      flexible_curriculum_desc: '100% CSTA-aligned curriculum that can easily be adapted to any schedule, scenario, or setting.',
      resources_to_support: 'Resources to Support Teachers',
      resources_to_support_desc: 'Lesson plans, extension activities, curriculum guides, and more instructional resources designed with remote and hybrid settings in mind.',
      actionable_insights: 'Actionable Insights for Educators',
      actionable_insights_desc: 'Empower educators with intuitive student progress and assessment data that makes differentiating instruction possible.',
    },

    special_offer: {
      special_offer: 'Special Offer',
      project_based_title: 'Project-Based Courses',
      project_based_description: 'Web and Game Development courses feature shareable final projects.',
      great_for_clubs_title: 'Great for clubs and electives',
      great_for_clubs_description: 'Teachers can purchase up to __maxQuantityStarterLicenses__ Starter Licenses.', //
      low_price_title: 'Just __starterLicensePrice__ per student',
      low_price_description: 'Starter Licenses are active for __starterLicenseLengthMonths__ months from purchase.',
      three_great_courses: 'Three great courses included in the Starter License:',
      license_limit_description: 'Teachers can purchase up to __maxQuantityStarterLicenses__ Starter Licenses. You have already purchased __quantityAlreadyPurchased__. If you need more, contact __supportEmail__. Starter Licenses are valid for __starterLicenseLengthMonths__ months.',
      student_starter_license: 'Student Starter License',
      purchase_starter_licenses: 'Purchase Starter Licenses',
      purchase_starter_licenses_to_grant: 'Purchase Starter Licenses to grant access to __starterLicenseCourseList__',
      starter_licenses_can_be_used: 'Starter Licenses can be used to assign additional courses immediately after purchase.',
      pay_now: 'Pay Now',
      we_accept_all_major_credit_cards: 'We accept all major credit cards.',
      cs2_description: 'builds on the foundation from Introduction to Computer Science, diving into if-statements, functions, events and more.',
      wd1_description: 'introduces the basics of HTML and CSS while teaching skills needed for students to build their first webpage.',
      gd1_description: 'uses syntax students are already familiar with to show them how to build and share their own playable game levels.',
      see_an_example_project: 'see an example project',
      get_started_today: 'Get started today!',
      want_all_the_courses: 'Want all the courses? Request information on our Full Licenses.',
      compare_license_types: 'Compare License Types:',
      cs: 'Computer Science',
      wd: 'Web Development',
      wd1: 'Web Development 1',
      gd: 'Game Development',
      gd1: 'Game Development 1',
      maximum_students: 'Maximum # of Students',
      unlimited: 'Unlimited',
      priority_support: 'Priority support',
      yes: 'Yes',
      price_per_student: '__price__ per student',
      pricing: 'Pricing',
      free: 'Free',
      purchase: 'Purchase',
      courses_prefix: 'Courses',
      courses_suffix: '',
      course_prefix: 'Course',
      course_suffix: '',
    },

    teachers_quote: {
      subtitle_coco: 'Learn more about CodeCombat with an interactive walk through of the product, pricing, and implementation!',
      subtitle_ozar: 'Learn more about Ozaria with an interactive walk through of the product, pricing, and implementation!',
      email_exists: 'User exists with this email.',
      phone_number: 'Phone number',
      phone_number_help: "What's the best number to reach you?",
      primary_role_label: 'Your Primary Role',
      role_default: 'Select Role',
      primary_role_default: 'Select Primary Role',
      purchaser_role_default: 'Select Purchaser Role',
      teacher: 'Teacher',
      tech_coordinator: 'Technology coordinator',
      advisor: 'Curriculum Specialist/Advisor',
      principal: 'Principal',
      superintendent: 'Superintendent',
      parent: 'Parent',
      purchaser_role_label: 'Your Purchaser Role',
      influence_advocate: 'Influence/Advocate',
      evaluate_recommend: 'Evaluate/Recommend',
      approve_funds: 'Approve Funds',
      no_purchaser_role: 'No role in purchase decisions',
      teacher_account_details: 'Teacher Account Details',
      district_label: 'District',
      district_name: 'District Name',
      district_na: 'Enter N/A if not applicable',
      organization_label: 'School',
      school_name: 'School Name',
      city: 'City',
      state: 'State / Region',
      country: 'Country / Region',
      num_students_help: 'How many students will use __product__?',
      num_students_default: 'Select Range',
      education_level_label: 'Education Level of Students',
      education_level_help: 'Choose as many as apply.',
      elementary_school: 'Elementary School',
      high_school: 'High School',
      please_explain: '(please explain)',
      middle_school: 'Middle School',
      college_plus: 'College or higher',
      referrer: 'How did you hear about us?',
      referrer_help: 'For example: from another teacher, a conference, your students, Code.org, etc.',
      referrer_default: 'Select One',
      referrer_conference: 'Conference (e.g. ISTE)',
      referrer_hoc: 'Code.org/Hour of Code',
      referrer_teacher: 'A teacher',
      referrer_admin: 'An administrator',
      referrer_student: 'A student',
      referrer_pd: 'Professional trainings/workshops',
      referrer_web: 'Google',
      referrer_other: 'Other',
      anything_else: 'What kind of class do you anticipate using __product__ for?',
      anything_else_helper: '',
      thanks_header: 'Request Received!',
      thanks_sub_header_coco: 'Thanks for expressing interest in CodeCombat for your school.',
      thanks_sub_header_ozar: 'Thanks for expressing interest in Ozaria for your school.',
      thanks_p: "We'll be in touch soon! If you need to get in contact, you can reach us at:",
      back_to_classes: 'Back to Classes',
      finish_signup: 'Finish creating your teacher account:',
      finish_signup_p: 'Create an account to set up a class, add your students, and monitor their progress as they learn computer science.',
      signup_with: 'Sign up with:',
      connect_with: 'Connect with:',
      conversion_warning: 'WARNING: Your current account is a <em>Student Account</em>. Once you submit this form, your account will be updated to a Teacher Account.',
      learn_more_modal: 'Teacher accounts on CodeCombat have the ability to monitor student progress, assign licenses and manage classrooms. Teacher accounts cannot be a part of a classroom - if you are currently enrolled in a class using this account, you will no longer be able to access it once you update to a Teacher Account.',
      create_account: 'Create a Teacher Account',
      create_account_subtitle: 'Get access to teacher-only tools for using CodeCombat in the classroom.  <strong>Set up a class</strong>, add your students, and <strong>monitor their progress</strong>!',
      convert_account_title: 'Update to Teacher Account',
      not: 'Not',
      full_name_required: 'First and last name required',
    },

    versions: {
      save_version_title: 'Save New Version',
      new_major_version: 'New Major Version',
      submitting_patch: 'Submitting Patch...',
      cla_prefix: 'To save changes, first you must agree to our',
      cla_url: 'CLA',
      cla_suffix: '.',
      cla_agree: 'I AGREE',
      owner_approve: 'An owner will need to approve it before your changes will become visible.',
    },

    contact: {
      contact_us: 'Contact CodeCombat',
      welcome: "Good to hear from you! Let us know how we can help, and we'll get back to you within a day.",
      forum_prefix: 'You can check out our ',
      reddit_page: 'public subreddit here ',
      faq_prefix: 'and our ',
      faq: 'FAQs here',
      faq_suffix: ' for additional assistance.',
      prefer_email_prefix: 'If you prefer, you can email ',
      prefer_email_suffix: ' instead.',
      subscribe_prefix: 'If you need help figuring out a level, please',
      subscribe: 'buy a CodeCombat subscription',
      subscribe_suffix: "and we'll be happy to help you with your code.",
      subscriber_support: "Since you're a CodeCombat subscriber, your email will get our priority support.",
      screenshot_included: 'Screenshot included.',
      where_reply: 'Where should we reply?',
      send: 'Send',
      ooo_blurb: 'The CodeCombat team will be out of the office from June 5th to June 9th, and during this time will have limited access to emails. We will respond to your inquiry as soon as possible, please be aware of the anticipated wait time.',
    },

    account_settings: {
      title: 'Account Settings',
      not_logged_in: 'Log in or create an account to change your settings.',
      me_tab: 'Me',
      picture_tab: 'Picture',
      delete_account_tab: 'Delete Your Account',
      wrong_email: 'Wrong Email or Username',
      wrong_password: 'Wrong Password',
      temp_password_expired: 'Your temporary password has been expired.',
      delete_this_account: 'Delete this account permanently',
      reset_progress_tab: 'Reset All Progress',
      reset_your_progress: 'Clear all your progress and start over',
      connect_roblox_tab: 'Connect Roblox',
      connect_roblox_button: 'Connect',
      re_connect_roblox_button: 'Connect Another Account',
      disconnect_roblox_button: 'Disconnect',
      roblox_connected: 'Your account <strong>__username__</strong> is connected to Roblox.',
      roblox_connected_other_user: 'The student\'s account is connected to  <strong>__username__</strong> Roblox account.',
      roblox_not_connected: 'Connect your CodeCombat and Roblox accounts.',
      roblox_not_connected_other_user: 'Connect the student\'s CodeCombat and Roblox accounts.',
      roblox_disconnect_confirm: 'Are you sure you want to disconnect your Roblox account?',
      god_mode: 'God Mode',
      emails_tab: 'Emails',
      admin: 'Admin',
      manage_subscription: 'Click here to manage your subscription.',
      current_password: 'Current Password',
      new_password: 'New Password',
      new_password_verify: 'Verify',
      type_in_email: 'Type in your email or username to confirm account deletion.',
      type_in_email_progress: 'Type in your email to confirm deleting your progress.',
      type_in_password: 'Also, type in your password.',
      email_subscriptions: 'Email Subscriptions',
      email_subscriptions_none: 'No Email Subscriptions.',
      email_announcements: 'Announcements',
      email_announcements_description: 'Get emails on the latest news and developments at CodeCombat.',
      email_notifications: 'Notifications',
      email_notifications_summary: 'Controls for personalized, automatic email notifications related to your CodeCombat activity.',
      email_any_notes: 'Any Notifications',
      email_any_notes_description: 'Disable to stop all activity notification emails.',
      email_news: 'News',
      email_recruit_notes: 'Job Opportunities',
      email_recruit_notes_description: 'If you play really well, we may contact you about getting you a (better) job.',
      contributor_emails: 'Contributor Class Emails',
      contribute_prefix: "We're looking for people to join our party! Check out the ",
      contribute_page: 'contribute page',
      contribute_suffix: ' to find out more.',
      email_toggle: 'Toggle All',
      error_saving: 'Error Saving',
      saved: 'Changes Saved',
      password_mismatch: 'Password does not match.',
      password_repeat: 'Please repeat your password.',
      switch_new_teacher_dashboard: 'Try the new Teacher Dashboard',
      view_trial_class_bookings: 'View Trial Class Bookings',
    },

    keyboard_shortcuts: {
      keyboard_shortcuts: 'Keyboard Shortcuts',
      space: 'Space',
      enter: 'Enter',
      press_enter: 'press enter',
      escape: 'Escape',
      shift: 'Shift',
      run_code: 'Run current code.',
      run_real_time: 'Run in real time.',
      continue_script: 'Continue past current script.',
      skip_scripts: 'Skip past all skippable scripts.',
      toggle_playback: 'Toggle play/pause.',
      scrub_playback: 'Scrub back and forward through time.',
      single_scrub_playback: 'Scrub back and forward through time by a single frame.',
      scrub_execution: 'Scrub through current spell execution.',
      toggle_debug: 'Toggle debug display.',
      toggle_grid: 'Toggle grid overlay.',
      toggle_pathfinding: 'Toggle pathfinding overlay.',
      beautify: 'Beautify your code by standardizing its formatting.',
    },

    cinematic: {
      click_anywhere_continue: 'Click to Continue',
      instructional_tooltip: 'Click these arrow buttons to go backwards and forwards. You can also use the arrow keys on your keyboard to do the same.',
      error_find: 'Error finding cinematic __slug__.',
    },

    community: {
      main_title: 'CodeCombat Community',
      introduction: 'Check out the ways you can get involved below and decide what sounds the most fun. We look forward to working with you!',
      level_editor_prefix: 'Use the CodeCombat',
      level_editor_suffix: 'to create and edit levels. Users have created levels for their classes, friends, hackathons, students, and siblings. If create a new level sounds intimidating you can start by forking one of ours!',
      thang_editor_prefix: "We call units within the game 'thangs'. Use the",
      thang_editor_suffix: "to modify the CodeCombat source artwork. Allow units to throw projectiles, alter the direction of an animation, change a unit's hit points, or upload your own vector sprites.",
      article_editor_prefix: 'See a mistake in some of our docs? Want to make some instructions for your own creations? Check out the',
      article_editor_suffix: 'and help CodeCombat players get the most out of their playtime.',
      find_us: 'Find us on these sites',
      social_github: 'Check out all our code on GitHub',
      social_reddit: 'Join the CodeCombat community on Reddit',
      social_blog: 'Read the CodeCombat blog',
      social_discource: 'Join the discussion on our Discourse forum',
      social_facebook: 'Like CodeCombat on Facebook',
      social_twitter: 'Follow CodeCombat on Twitter',
      social_slack: 'Chat with us in the public CodeCombat Slack channel',
      contribute_to_the_project: 'Contribute to the project',
    },

    clans: {
      title: 'Join CodeCombat Clans - Learn to Code in Python, JavaScript, and HTML',
      clan_title: '__clan__ - Join CodeCombat Clans and Learn to Code',
      meta_description: 'Join a Clan or build your own community of coders. Play multiplayer arena levels and level up your hero and your coding skills.',
      clan: 'Clan',
      clans: 'Clans',
      new_name: 'New clan name',
      new_description: 'New clan description',
      make_private: 'Make clan private',
      subs_only: 'subscribers only',
      create_clan: 'Create New Clan',
      private_preview: 'Preview',
      private_clans: 'Private Clans',
      public_clans: 'Public Clans',
      my_clans: 'My Clans',
      clan_name: 'Clan Name',
      name: 'Name',
      chieftain: 'Chieftain',
      edit_clan_name: 'Edit Clan Name',
      edit_clan_description: 'Edit Clan Description',
      edit_name: 'edit name',
      edit_description: 'edit description',
      private: '(private)',
      summary: 'Summary',
      average_level: 'Average Level',
      average_achievements: 'Average Achievements',
      delete_clan: 'Delete Clan',
      leave_clan: 'Leave Clan',
      join_clan: 'Join Clan',
      invite_1: 'Invite:',
      invite_2: '*Invite players to this Clan by sending them this link.',
      members: 'Members',
      progress: 'Progress',
      not_started_1: 'not started',
      started_1: 'started',
      complete_1: 'complete',
      exp_levels: 'Expand levels',
      rem_hero: 'Remove Hero',
      status: 'Status',
      complete_2: 'Complete',
      started_2: 'Started',
      not_started_2: 'Not Started',
      view_solution: 'Click to view solution.',
      view_attempt: 'Click to view attempt.',
      latest_achievement: 'Latest Achievement',
      playtime: 'Playtime',
      last_played: 'Last played',
      leagues_explanation: 'Play in a league against other clan members in these multiplayer arena instances.',
      track_concepts1: 'Track concepts',
      track_concepts2a: 'learned by each student',
      track_concepts2b: 'learned by each member',
      track_concepts3a: 'Track levels completed for each student',
      track_concepts3b: 'Track levels completed for each member',
      track_concepts4a: "See your students'",
      track_concepts4b: "See your members'",
      track_concepts5: 'solutions',
      track_concepts6a: 'Sort students by name or progress',
      track_concepts6b: 'Sort members by name or progress',
      track_concepts7: 'Requires invitation',
      track_concepts8: 'to join',
      private_require_sub: 'Private clans require a subscription to create or join.',
    },

    courses: {
      create_new_class: 'Create New Class',
      hoc_blurb1: 'Try the',
      hoc_blurb2: 'Code, Play, Share',
      hoc_blurb3: 'activity! Construct four different minigames to learn the basics of game development, then make your own!',
      solutions_require_licenses: 'Level solutions are available for teachers who have licenses.',
      unnamed_class: 'Unnamed Class',
      edit_settings1: 'Edit Class Settings',
      add_students: 'Add Students',
      stats: 'Statistics',
      student_email_invite_blurb: 'Your students can also use class code <strong>__classCode__</strong> when creating a Student Account, no email required.',
      total_students: 'Total students:',
      average_time: 'Average level play time:',
      total_time: 'Total play time:',
      average_levels: 'Average levels completed:',
      total_levels: 'Total levels completed:',
      students: 'Students',
      concepts: 'Concepts',
      play_time: 'Play time:',
      completed: 'Completed:',
      enter_emails: 'Separate each email address by a line break or commas',
      send_invites: 'Invite Students',
      number_programming_students: 'Number of Programming Students',
      number_total_students: 'Total Students in School/District',
      enroll: 'Enroll',
      enroll_paid: 'Enroll Students in Paid Courses',
      get_enrollments: 'Get More Licenses',
      change_language: 'Change Course Language',
      keep_using: 'Keep Using',
      switch_to: 'Switch To',
      greetings: 'Greetings!',
      back_classrooms: 'Back to my classrooms',
      back_classroom: 'Back to classroom',
      back_courses_coco: 'Back to my courses',
      back_courses_ozar: 'Back to Classes',
      edit_details: 'Edit class details',
      purchase_enrollments: 'Purchase Student Licenses',
      remove_student: 'remove student',
      assign: 'Assign',
      to_assign: 'to assign paid courses.',
      student: 'Student',
      teacher: 'Teacher',
      arena: 'Arena',
      available_levels: 'Available Levels',
      started: 'started',
      complete: 'complete',
      practice: 'practice',
      required: 'required',
      python: 'Python (supports blocks)',
      javascript: 'JavaScript (supports blocks)',
      java: 'Java (beta)',
      welcome_to_courses_coco: 'Adventurer, welcome to CodeCombat!',
      welcome_to_courses_ozar: 'Adventurers, welcome to Courses!',
      ready_to_play: 'Ready to play?',
      start_new_game: 'Start New Game',
      play_now_learn_header: 'Play now to learn',
      play_now_learn_1: 'basic syntax to control your character',
      play_now_learn_2: 'while loops to solve pesky puzzles',
      play_now_learn_3: 'strings & variables to customize actions',
      play_now_learn_4: 'how to defeat an ogre (important life skills!)',
      welcome_to_page: 'Student Dashboard',
      my_classes: 'Current Classes',
      class_added: 'Class successfully added!',
      view_map: 'view map',
      view_videos: 'view videos',
      view_project_gallery: "view my classmates' projects",
      join_class: 'Join a Class',
      join_class_2: 'Join class',
      ask_teacher_for_code_coco: 'Ask your teacher if you have a CodeCombat class code! If so, enter it below:',
      ask_teacher_for_code_ozar: 'Ask your teacher if you have a Ozaria class code! If so, enter it below:',
      enter_c_code_coco: '<Enter Class Code>',
      enter_c_code_ozar: 'Enter Class Code',
      join: 'Join',
      joining: 'Joining class',
      course_complete: 'Course Complete',
      unit_complete: 'Unit Complete',
      play_arena: 'Play Arena',
      view_project: 'View Project',
      start: 'Start',
      last_level: 'Last level played',
      not_you: 'Not you?',
      continue_playing: 'Continue Playing',
      option1_header: 'Invite Students by Email',
      remove_student1: 'Remove Student',
      are_you_sure: 'Are you sure you want to remove this student from this class?',
      remove_description1: 'Student will lose access to this classroom and assigned classes. Progress and gameplay is NOT lost, and the student can be added back to the classroom at any time.',
      remove_description2: 'The activated paid license will not be returned.',
      license_will_revoke: "This student's paid license will be revoked and made available to assign to another student.",
      keep_student: 'Keep Student',
      removing_user: 'Removing user',
      subtitle: 'Review course overviews and levels', // Flat style redesign
      changelog: 'View latest changes to course levels.',
      select_language: 'Select language',
      select_level: 'Select level',
      play_level: 'Play Level',
      concepts_covered: 'Concepts covered',
      view_guide_online: 'Level Overviews and Solutions',
      lesson_slides: 'Lesson Slides',
      grants_lifetime_access: 'Grants access to all Courses.',
      enrollment_credits_available: 'Licenses Available:',
      language_select: 'Select a language', // ClassroomSettingsModal
      language_cannot_change: 'Language cannot be changed once students join a class.',
      avg_student_exp_label: 'Average Student Programming Experience',
      avg_student_exp_desc: 'This will help us understand how to pace courses better.',
      avg_student_exp_select: 'Select the best option',
      avg_student_exp_none: 'No Experience - little to no experience',
      avg_student_exp_beginner: 'Beginner - some exposure or block-based',
      avg_student_exp_intermediate: 'Intermediate - some experience with typed code',
      avg_student_exp_advanced: 'Advanced - extensive experience with typed code',
      avg_student_exp_varied: 'Varied Levels of Experience',
      class_type_label: 'Class Type',
      class_type_in_school: 'In School',
      class_type_after_school: 'After School',
      class_type_online: 'Online',
      class_type_camp: 'Camp',
      class_type_camp_esports: 'Camp (Esports)',
      class_type_camp_junior: 'Camp (Roblox)',
      class_type_homeschool: 'Homeschool',
      class_type_other: 'Other',
      student_age_range_label: 'Student Age Range',
      student_age_range_younger: 'Younger than 6',
      student_age_range_older: 'Older than 18',
      student_age_range_to: 'to',
      estimated_class_dates_label: 'Estimated Class Dates',
      estimated_class_frequency_label: 'Estimated Class Frequency',
      classes_per_week: 'classes per week',
      minutes_per_class: 'minutes per class',
      create_class: 'Create Class',
      class_name: 'Class Name',
      teacher_account_restricted: 'Your account is a teacher account and cannot access student content.',
      account_restricted: 'A student account is required to access this page.',
      update_account_login_title: 'Log in to update your account',
      update_account_title: 'Your account needs attention!',
      update_account_blurb: 'Before you can access your classes, choose how you want to use this account.',
      update_account_current_type: 'Current Account Type:',
      update_account_account_email: 'Account Email/Username:',
      update_account_am_teacher: 'I am a teacher',
      update_account_no_progress: 'Let me create classes but save no game progress',
      update_account_teachers_can: 'Teacher accounts can:',
      update_account_teachers_can1: 'Create/manage/add classes',
      update_account_teachers_can2: 'Assign/enroll students in courses',
      update_account_teachers_can3: 'Unlock all course levels to try out',
      update_account_teachers_can4: 'Access new teacher-only features as we release them',
      update_account_teachers_warning_new: 'Warning: you will not be able to save your progress on any levels; you will need separate student accounts to do that.',
      update_account_remain_teacher: 'Remain a Teacher',
      update_account_update_teacher: 'Update to Teacher',
      update_account_am_student: 'I am a student',
      update_account_no_home: 'Let me join classes but not play outside of class',
      update_account_students_can: 'Student accounts can:',
      update_account_students_can1: 'Join classes',
      update_account_students_can2: 'Play through courses as a student and track your own progress',
      update_account_students_can3: 'Compete against classmates in arenas',
      update_account_students_can4: 'Access new student-only features as we release them',
      update_account_students_warning_new: 'Warning: you will only be able to play the levels your teacher has assigned.',
      unsubscribe_warning: 'Warning: You will be unsubscribed from your monthly subscription.',
      update_account_remain_student: 'Remain a Student',
      update_account_update_student: 'Update to Student',
      update_account_am_individual: 'I am a individual',
      update_account_no_classes: 'Let me play independently but not join classes',
      update_account_individuals_can: 'Individual accounts can:',
      update_account_individuals_can1: 'Earn gems, experience, items, and heroes',
      update_account_individuals_can2: 'Play through the game as an individual and track your own progress',
      update_account_individuals_can3: 'Compete against the world in arenas',
      update_account_individuals_can4: 'Access new individual-only features as we release them',
      update_account_individuals_warning_ozaria: 'Warning: individual accounts cannot play Ozaria, only CodeCombat.',
      update_account_remain_individual: 'Remain an Individual',
      need_a_class_code: "You'll need a Class Code for the class you're joining:",
      update_account_not_sure: 'Not sure which one to choose? Email',
      update_account_confirm_update_student: 'Are you sure you want to update your account to a Student experience?',
      update_account_confirm_update_student2: 'You will not be able to manage any classes that you have previously created or create new classes. Your previously created classes will be removed from CodeCombat and cannot be restored.',
      instructor: 'Instructor: ',
      youve_been_invited_1: "You've been invited to join ",
      youve_been_invited_2: ", where you'll learn ",
      youve_been_invited_3: ' with your classmates in CodeCombat.',
      by_joining_1: 'By joining ',
      by_joining_2: 'will be able to help reset your password if you forget or lose it. You can also verify your email address so that you can reset the password yourself!',
      sent_verification: "We've sent a verification email to:",
      you_can_edit: 'You can edit your email address in ',
      account_settings: 'Account Settings',
      select_your_hero: 'Select Your Hero',
      select_your_hero_description: 'You can always change your hero by going to your Courses page and clicking "Change Hero"',
      select_this_hero: 'Select this Hero',
      current_hero: 'Current Hero:',
      current_hero_female: 'Current Hero:',
      web_dev_language_transition: 'All classes program in HTML / JavaScript for this course.  Classes that have been using Python will start with extra JavaScript intro levels to ease the transition.  Classes that are already using JavaScript will skip the intro levels.',
      course_membership_required_to_play: "You'll need to join a course to play this level.",
      license_required_to_play_coco: 'Ask your teacher to assign a license to you so you can continue to play CodeCombat!',
      license_required_to_play_ozar: 'Ask your teacher to assign you a license so you can continue to play Ozaria!',
      level_locked: 'This level is locked.',
      update_old_classroom: 'New school year, new levels!',
      update_old_classroom_detail: "To make sure you're getting the most up-to-date levels, make sure you create a new class for this semester by clicking Create a New Class on your",
      teacher_dashboard: 'teacher dashboard',
      update_old_classroom_detail_2: 'and giving students the new Class Code that appears.',
      view_assessments: 'View Assessments',
      view_challenges: 'view challenge levels',
      challenge: 'Challenge:',
      challenge_level: 'Challenge Level:',
      status: 'Status:',
      assessments: 'Assessments',
      challenges: 'Challenges',
      level_name: 'Level Name:',
      keep_trying: 'Keep Trying',
      start_challenge: 'Start Challenge',
      locked: 'Locked',
      concepts_used: 'Concepts Used:',
      show_change_log: "Show changes to this course's levels",
      hide_change_log: "Hide changes to this course's levels",
      concept_videos: 'Concept Videos',
      concept: 'Concept:',
      basic_syntax: 'Basic Syntax',
      while_loops: 'While Loops',
      variables: 'Variables',
      basic_syntax_desc: "Syntax is how we write code. Just as spelling and grammar are important in writing narratives and essays, syntax is important when writing code. Humans are good at figuring out what something means, even if it isn't exactly correct, but computers aren't that smart, and they need you to write very precisely.",
      while_loops_desc: "A loop is a way of repeating actions in a program. You can use them so you don't have to keep writing repetitive code, and when you don't know exactly how many times an action will need to occur to accomplish a task.",
      variables_desc: "Working with variables is like organizing things in shoeboxes. You give the shoebox a name, like \"School Supplies\", and then you put things inside. The exact contents of the box might change over time, but whatever's inside will always be called \"School Supplies\". In programming, variables are symbols used to store data that will change over the course of the program. Variables can hold a variety of data types, including numbers and strings.",
      locked_videos_desc: 'Keep playing the game to unlock the __concept_name__ concept video.',
      unlocked_videos_desc: 'Review the __concept_name__ concept video.',
      video_shown_before: 'shown before __level__',
      link_google_classroom: 'Link Google Classroom',
      select_your_classroom: 'Select Your Classroom',
      no_classrooms_found: 'No classrooms found',
      create_classroom_manually: 'Create classroom manually',
      classes: 'Classes',
      certificate_btn_print: 'Print',
      certificate_btn_toggle: 'Toggle',
      error_in_creating_data: 'Error in creating data for intro level!',
      ask_next_course: 'Want to play more? Ask your teacher for access to the next course.',
      set_start_locked_level: 'Lock levels starting at',
      no_level_limit: '-- (no levels locked)',
      ask_teacher_to_unlock: 'Ask Teacher To Unlock',
      ask_teacher_to_unlock_instructions: 'To play the next level, ask your teacher to unlock it on their Course Progress screen',
      play_next_level: 'Play Next Level',
      play_tournament: 'Play Tournament',
      levels_completed: 'Levels Completed: __count__',
      ai_league_team_rankings: 'AI League Team Rankings',
      view_standings: 'View Standings',
      view_winners: 'View Winners',
      classroom_announcement: 'Classroom Announcement',
      link_lms_classroom: 'Link LMS Classroom',
      classroom_items: 'Items & Gems',
      classroom_live_completion: 'Classroom Code Autocomplete: ',
      classroom_disable_paste: 'Classroom Disable Paste: ',
      learn_without_classroom_title: 'You can still learn and play without a classroom',
      learn_without_classroom_blurb: "Start by playing the free Sky Mountain chapter by <a href='/play/chapter-1-sky-mountain'>clicking here</a>.",
      learn_without_classroom_blurb_coco: "Start by playing the free Hour of Code campaign by <a href='/play/intro'>clicking here</a>.",
      all_courses_completed: 'All Courses Completed!',
      all_units_completed: 'All Units Completed!',
      hide_options: 'Hide Options',
      more_options: 'More Options',
      get_test_license: 'Get Test Student License',
      create_students: 'Generate Students',
      custom_tournaments: 'Custom Tournaments',
      play_ozaria: 'Play Ozaria',
      play_ccw_on_roblox: 'Play CodeCombat Worlds on Roblox',
      camp_activities: 'Camp Activities',
      view_camp_activities: 'View Camp Activities',
    },

    project_gallery: {
      no_projects_published: 'Be the first to publish a project in this course!',
      view_project: 'View Project',
      edit_project: 'Edit Project',
    },

    teacher: {
      assigning_course: 'Assigning course',
      back_to_top: 'Back to Top',
      click_student_code: 'Click on any level that the student has started or completed below to view the code they wrote.',
      code: "__name__'s Code",
      complete_solution: 'Complete Solution',
      course_not_started: 'Student has not started this course yet.',
      hoc_happy_ed_week: 'Happy Computer Science Education Week!',
      hoc_blurb1: 'Learn about the free',
      hoc_blurb2: 'Code, Play, Share',
      hoc_blurb3: 'activity, download a new teacher lesson plan, and tell your students to log in to play!',
      hoc_button_text: 'View Activity',
      no_code_yet: 'Student has not written any code for this level yet.',
      open_ended_level: 'Open-Ended Level',
      partial_solution: 'Partial Solution',
      capstone_solution: 'Capstone Solution',
      removing_course: 'Removing course',
      solution_arena_blurb: 'Students are encouraged to solve arena levels creatively. The solution provided below meets the requirements of the arena level.',
      solution_challenge_blurb: 'Students are encouraged to solve open-ended challenge levels creatively. One possible solution is displayed below.',
      solution_project_blurb: 'Students are encouraged to build a creative project in this level. Please refer to curriculum guides in the Teacher Toolkit for information on how to evaluate these projects.',
      feedback_capstone: 'The student will create a base project in Part 1. They will make creative updates based on peer feedback in Part 2. Here is a <a target="_blank" rel="noopener" href="https://docs.google.com/document/d/1itB0vY6WphjINQYJ9NHkILATcLLlYD3GDSg6FJg55OQ">Peer Feedback Template</a> that you can share with your students.',
      students_code_blurb: 'A correct solution to each level is provided where appropriate. In some cases, it’s possible for a student to solve a level using different code. Solutions are not shown for levels the student has not started.',
      course_solution: 'Course Solution',
      level_overview_solutions: 'Level Overview and Solutions',
      no_student_assigned: 'No students have been assigned this course.',
      paren_new: '(new)',
      student_code: "__name__'s Student Code",
      teacher_dashboard: 'Teacher Dashboard', // Navbar
      my_classes: 'My Classes',
      courses_coco: 'Course Guides',
      courses_ozar: 'Unit Guides',
      enrollments: 'Student Licenses',
      resources: 'Resources',
      help: 'Help',
      language: 'Language',
      edit_class_settings: 'edit class settings',
      access_restricted: 'Account Update Required',
      teacher_account_required: 'A teacher account is required to access this content.',
      create_teacher_account: 'Create a Teacher Account',
      what_is_a_teacher_account: "What's a Teacher Account?",
      teacher_account_explanation: 'A CodeCombat Teacher account allows you to set up classrooms, monitor students’ progress as they work through courses, manage licenses and access resources to aid in your curriculum-building.',
      current_classes: 'Current Classes',
      archived_classes: 'Archived Classes',
      shared_classes: 'Shared Classes',
      archived_classes_blurb: 'Classes can be archived for future reference. Unarchive a class to view it in the Current Classes list again.',
      view_class: 'view class',
      view_ai_league_team: 'View AI League team',
      archive_class: 'archive class',
      unarchive_class: 'unarchive class',
      unarchive_this_class: 'Unarchive this class',
      no_students_yet: 'This class has no students yet.',
      no_students_yet_view_class: 'View class to add students.',
      try_refreshing: '(You may need to refresh the page)',
      create_new_class: 'Create a New Class',
      class_overview: 'Class Overview', // View Class page
      avg_playtime: 'Average level playtime',
      total_playtime: 'Total play time',
      avg_completed: 'Average levels completed',
      total_completed: 'Total levels completed',
      created: 'Created',
      concepts_covered: 'Concepts covered',
      earliest_incomplete: 'Earliest incomplete level',
      latest_complete: 'Latest completed level',
      enroll_student: 'Enroll student',
      apply_modal_subtitle: 'You will be redirected to your My Classes page, where you can apply licenses to your students by:',
      apply_modal_list_item_1: 'Selecting or creating a class',
      apply_modal_list_item_2: 'Selecting students you want to apply licenses to',
      apply_modal_list_item_3: 'Clicking the “Apply Licenses” button',
      apply_license: 'Apply License',
      revoke_license: 'Revoke License',
      revoke_licenses: 'Revoke All Licenses',
      revoke_these_licenses: 'Select Students and Revoke These Licenses',
      check_and_revoke_license: 'Status & Revoke',
      manage_license: 'Manage License',
      course_progress: 'Course Progress',
      unit_progress: 'Unit Progress',
      not_applicable: 'N/A',
      edit: 'edit',
      edit_2: 'Edit',
      remove: 'remove',
      latest_completed: 'Latest completed:',
      sort_by: 'Sort by',
      progress: 'Progress',
      concepts_used: 'Concepts used by Student:',
      concept_checked: 'Concept checked:',
      completed: 'Completed',
      practice: 'Practice',
      started: 'Started',
      no_progress: 'No progress',
      not_required: 'Not required',
      view_student_code: 'Click to view student code',
      select_course_coco: 'Select course to view',
      select_course_ozar: 'Select unit to view',
      progress_color_key: 'Progress color key:',
      level_in_progress: 'Level in Progress',
      level_not_started: 'Level Not Started',
      project_or_arena: 'Project or Arena',
      students_not_assigned: 'Students who have not been assigned {{courseName}}',
      course_overview: 'Course Overview',
      copy_class_code: 'Copy Class Code',
      class_code_blurb: 'Students can join your class using this Class Code. No email address is required when creating a Student account with this Class Code.',
      copy_class_url: 'Copy Class URL',
      class_join_url_blurb: 'You can also post this unique class URL to a shared webpage.',
      add_students_manually: 'Invite Students by Email',
      bulk_assign: 'Select course',
      assigned_msg_1: '{{numberAssigned}} students were assigned {{courseName}}.',
      assigned_msg_2: '{{numberEnrolled}} licenses were applied.',
      assigned_msg_3: 'You now have {{remainingSpots}} available licenses remaining.',
      assign_course: 'Assign Course',
      removed_course_msg: '{{numberRemoved}} students were removed from {{courseName}}.',
      remove_course: 'Remove Course',
      not_assigned_msg_1: 'Cannot add users to a course instance until they are added to a prepaid that includes this course',
      not_assigned_modal_title: 'Courses were not assigned',
      not_assigned_modal_starter_body_1: 'This course requires a Starter License. You do not have enough Starter Licenses available to assign this course to all __selected__ selected students.',
      not_assigned_modal_starter_body_2: 'Purchase Starter Licenses to grant access to this course.',
      not_assigned_modal_full_body_1: 'This course requires a Full License. You do not have enough Full Licenses available to assign this course to all __selected__ selected students.',
      not_assigned_modal_full_body_2: 'You only have __numFullLicensesAvailable__ Full Licenses available (__numStudentsWithoutFullLicenses__ students do not currently have a Full License active).',
      not_assigned_modal_full_body_3: 'Please select fewer students, or reach out to __supportEmail__ for assistance.',
      assigned: 'Assigned',
      enroll_selected_students: 'Enroll Selected Students',
      no_students_selected: 'No students were selected.',
      show_students_from: 'Show students from', // Enroll students modal
      apply_licenses_to_the_following_students: 'Apply Licenses to the Following Students',
      select_license_type: 'Select License Type to Apply',
      students_have_licenses: 'The following students already have licenses applied:',
      all_students: 'All Students',
      apply_licenses: 'Apply Licenses',
      not_enough_enrollments: 'Not enough licenses available.',
      enrollments_blurb: 'Students are required to have a license to access any content after the first course.',
      how_to_apply_licenses: 'How to Apply Licenses',
      export_student_progress: 'Export Student Progress (CSV)',
      send_email_to: 'Send Recover Password Email to:',
      email_sent: 'Email sent',
      send_recovery_email: 'Send recovery email',
      enter_new_password_below: 'Enter new password below:',
      change_password: 'Change Password',
      changed: 'Changed',
      available_credits: 'Available Licenses',
      pending_credits: 'Pending Licenses',
      empty_credits: 'Exhausted Licenses',
      license_remaining: 'license remaining',
      licenses_remaining: 'licenses remaining',
      student_enrollment_history: 'Student Enrollment History',
      enrollment_explanation_1: 'The',
      enrollment_explanation_2: 'Student Enrollment History',
      enrollment_explanation_3: 'displays the total number of unique students who were enrolled across all teachers and classrooms added to your dashboard. This includes students in both archived and unarchived classrooms with a class creation date between July 1- June 30 of each respective school year.',
      enrollment_explanation_4: 'Remember',
      enrollment_explanation_5: 'classes may be archived and licenses may be reused throughout the school year, so this view allows administrators to understand how many students truly participated in the program overall.',
      one_license_used: '1 out of __totalLicenses__ licenses has been used',
      num_licenses_used: '__numLicensesUsed__ out of __totalLicenses__ licenses have been used',
      starter_licenses: 'starter licenses',
      start_date: 'start date:',
      end_date: 'end date:',
      get_enrollments_blurb: " We'll help you build a solution that meets the needs of your class, school or district.",
      see_also_our: 'See also our',
      for_more_funding_resources: 'for how to leverage CARES Act funding sources like ESSER and GEER.',
      how_to_apply_licenses_blurb_1: 'When a teacher assigns a course to a student for the first time, we’ll automatically apply a license. Use the bulk-assign dropdown in your classroom to assign a course to selected students:',
      how_to_apply_licenses_blurb_2: 'Can I still apply a license without assigning a course?',
      how_to_apply_licenses_blurb_3: 'Yes — go to the License Status tab in your classroom and click "Apply License" to any student who does not have an active license.',
      request_sent: 'Request Sent!',
      assessments: 'Assessments',
      license_status: 'License Status',
      status_expired: 'Expired on {{date}}',
      status_not_enrolled: 'Not Enrolled',
      status_enrolled: 'Expires on {{date}}',
      status_partly_expires: 'Partly expires on {{date}}',
      select_all: 'Select All',
      project: 'Project',
      projects: 'Projects',
      project_gallery: 'Project Gallery',
      view_project: 'View Project',
      unpublished: '(unpublished)',
      view_arena_ladder: 'View Arena Ladder',
      resource_hub: 'Teacher Toolkit',
      pacing_guides: 'Classroom-in-a-Box Pacing Guides',
      pacing_guides_desc: "Learn how to incorporate all of CodeCombat's resources to plan your school year!",
      pacing_guides_elem: 'Elementary School Pacing Guide',
      pacing_guides_middle: 'Middle School Pacing Guide',
      pacing_guides_high: 'High School Pacing Guide',
      getting_started: 'Getting Started',
      student_resources: 'Student Resources',
      curriculum: 'Curriculum',
      lesson_slides: 'Lesson Slides',
      section: 'Section',
      educator_faq: 'Educator FAQ',
      educator_faq_desc: 'Frequently asked questions about using Ozaria in your classroom or school.',
      teacher_getting_started: 'Teacher Getting Started Guide',
      teacher_getting_started_desc: 'New to Ozaria? Download this Teacher Getting Started Guide to set up your account, create your first class, and invite students to the first unit.',
      student_getting_started: 'Student Quick Start Guide',
      student_getting_started_desc: 'You can distribute this guide to your students before starting CodeCombat so that they can familiarize themselves with the code editor. This guide can be used for both Python and JavaScript classrooms.',
      standardized_curricula: 'Standardized Curricula',
      ap_cs_principles: 'AP Computer Science Principles',
      ap_cs_principles_desc: 'AP Computer Science Principles gives students a broad introduction to the power, impact, and possibilities of Computer Science. The course emphasizes computational thinking and problem solving while also teaching the basics of programming.',
      cs1: 'Introduction to Computer Science',
      cs2: 'Computer Science 2',
      cs3: 'Computer Science 3',
      cs4: 'Computer Science 4',
      cs5: 'Computer Science 5',
      cs1_syntax_python: 'Course 1 Python Syntax Guide',
      cs1_syntax_python_desc: 'Cheatsheet with references to common Python syntax that students will learn in Introduction to Computer Science.',
      cs1_syntax_javascript: 'Course 1 JavaScript Syntax Guide',
      cs1_syntax_javascript_desc: 'Cheatsheet with references to common JavaScript syntax that students will learn in Introduction to Computer Science.',
      coming_soon: 'Additional guides coming soon!',
      engineering_cycle_worksheet: 'Engineering Cycle Worksheet',
      engineering_cycle_worksheet_desc: 'Use this worksheet to teach students the basics of the engineering cycle: Assess, Design, Implement and Debug. Refer to the completed example worksheet as a guide.',
      engineering_cycle_worksheet_link: 'View example',
      progress_journal: 'Progress Journal',
      progress_journal_desc: 'Encourage students to keep track of their progress via a progress journal.',
      cs1_curriculum: 'Introduction to Computer Science - Curriculum Guide',
      cs1_curriculum_desc: 'Scope and sequence, lesson plans, activities and more for Course 1.',
      arenas_curriculum: 'Arena Levels - Teacher Guide',
      arenas_curriculum_desc: 'Instructions on how to run Wakka Maul, Cross Bones and Power Peak multiplayer arenas with your class.',
      assessments_curriculum: 'Assessment Levels - Teacher Guide',
      assessments_curriculum_desc: "Learn how to use Challenge Levels and Combo Challenge levels to assess students' learning outcomes.",
      cs2_curriculum: 'Computer Science 2 - Curriculum Guide',
      cs2_curriculum_desc: 'Scope and sequence, lesson plans, activities and more for Course 2.',
      cs2_syntax_python: 'Course 2 Python Syntax Guide',
      cs3_curriculum: 'Computer Science 3 - Curriculum Guide',
      cs3_curriculum_desc: 'Scope and sequence, lesson plans, activities and more for Course 3.',
      cs3_syntax_python: 'Course 3 Python Syntax Guide',
      cs4_curriculum: 'Computer Science 4 - Curriculum Guide',
      cs4_curriculum_desc: 'Scope and sequence, lesson plans, activities and more for Course 4.',
      cs4_syntax_python: 'Course 4 Python Syntax Guide',
      cs5_curriculum_js: 'Computer Science 5 - Curriculum Guide (JavaScript)',
      cs5_curriculum_desc_js: 'Scope and sequence, lesson plans, activities and more for Course 5 classes using JavaScript.',
      cs5_curriculum_py: 'Computer Science 5 - Curriculum Guide (Python)',
      cs5_curriculum_desc_py: 'Scope and sequence, lesson plans, activities and more for Course 5 classes using Python.',
      cs1_pairprogramming: 'Pair Programming Activity',
      cs1_pairprogramming_desc: 'Introduce students to a pair programming exercise that will help them become better listeners and communicators.',
      gd1: 'Game Development 1',
      gd1_guide: 'Game Development 1 - Project Guide',
      gd1_guide_desc: 'Use this to guide your students as they create their first shareable game project in 5 days.',
      gd1_rubric: 'Game Development 1 - Project Rubric',
      gd1_rubric_desc: 'Use this rubric to assess student projects at the end of Game Development 1.',
      gd2: 'Game Development 2',
      gd2_curriculum: 'Game Development 2 - Curriculum Guide',
      gd2_curriculum_desc: 'Lesson plans for Game Development 2.',
      gd3: 'Game Development 3',
      gd3_curriculum: 'Game Development 3 - Curriculum Guide',
      gd3_curriculum_desc: 'Lesson plans for Game Development 3.',
      wd1: 'Web Development 1',
      wd1_curriculum: 'Web Development 1 - Curriculum Guide',
      wd1_curriculum_desc: 'Scope and sequence, lesson plans, activities, and more for Web Development 1.',
      wd1_headlines: 'Headlines & Headers Activity',
      wd1_headlines_example: 'View sample solution',
      wd1_headlines_desc: 'Why are paragraph and header tags important? Use this activity to show how well-chosen headers make web pages easier to read. There are many correct solutions to this!',
      wd1_html_syntax: 'HTML Syntax Guide',
      wd1_html_syntax_desc: 'One-page reference for the HTML style students will learn in Web Development 1.',
      wd1_css_syntax: 'CSS Syntax Guide',
      wd1_css_syntax_desc: 'One-page reference for the CSS and Style syntax students will learn in Web Development 1.',
      wd2: 'Web Development 2',
      wd2_jquery_syntax: 'jQuery Functions Syntax Guide',
      wd2_jquery_syntax_desc: 'One-page reference for the jQuery functions students will learn in Web Development 2.',
      wd2_quizlet_worksheet: 'Quizlet Planning Worksheet',
      wd2_quizlet_worksheet_instructions: 'View instructions & examples',
      wd2_quizlet_worksheet_desc: 'Before your students build their personality quiz project at the end of Web Development 2, they should plan out their quiz questions, outcomes and responses using this worksheet. Teachers can distribute the instructions and examples for students to refer to.',
      intro_to_cs_short: 'Intro to CS',
      GD1_short: 'Game Dev 1',
      GD2_short: 'Game Dev 2',
      GD3_short: 'Game Dev 3',
      WD1_short: 'Web Dev 1',
      WD2_short: 'Web Dev 2',
      WD3_short: 'Web Dev 3',
      CS1_short: 'Comp Sci 1',
      CS2_short: 'Comp Sci 2',
      CS3_short: 'Comp Sci 3',
      CS4_short: 'Comp Sci 4',
      CS5_short: 'Comp Sci 5',
      CS6_short: 'Comp Sci 6',
      JR_short: 'Junior',
      AI_short: 'AI',
      student_overview: 'Overview',
      student_details: 'Student Details',
      student_name: 'Student Name',
      no_name: 'No name provided.',
      no_username: 'No username provided.',
      no_email: 'Student has no email address set.',
      student_profile: 'Student Profile',
      playtime_detail: 'Playtime Detail',
      student_completed: 'Student Completed',
      student_in_progress: 'Student in Progress',
      class_average: 'Class Average',
      not_assigned: 'has not been assigned the following courses',
      playtime_axis: 'Playtime in Seconds',
      levels_axis: 'Levels in',
      student_state: 'How is',
      student_state_2: 'doing?',
      student_good: 'is doing well in',
      student_good_detail: "This student is keeping pace with the class's average level completion times.",
      student_warn: 'might need some help in',
      student_warn_detail: "This student's average level completion times suggest they might need some help with new concepts that have been introduced in this course.",
      student_great: 'is doing great in',
      student_great_detail: 'This student might be a good candidate to help other students working through this course, based on average level completion times.',
      full_license: 'Full License',
      starter_license: 'Starter License',
      customized_license: 'Customized License',
      hackstack_license: 'AI HackStack License',
      hackstack_credits: 'Credits: __limit__ prompts / __durationAmount__ __durationKey__(s)',
      coco_full_license: 'CoCo License',
      ozar_full_license: 'Ozaria License',
      trial: 'Trial',
      hoc_welcome: 'Happy Computer Science Education Week',
      hoc_title: 'Hour of Code Games - Free Activities to Learn Real Coding Languages',
      hoc_meta_description: 'Make your own game or code your way out of a dungeon! CodeCombat has four different Hour of Code activities and over 60 levels to learn code, play, and create.',
      hoc_intro: 'There are three ways for your class to participate in Hour of Code with CodeCombat',
      hoc_self_led: 'Self-Led Gameplay',
      hoc_self_led_desc: 'Students can play through our Hour of Code CodeCombat tutorials on their own',
      hoc_game_dev: 'Game Development',
      hoc_and: 'and',
      hoc_programming: 'JavaScript/Python Programming',
      hoc_teacher_led: 'Teacher-Led Lessons',
      hoc_teacher_led_desc1: 'Download our',
      hoc_teacher_led_link_coco: 'Hour of Code lesson plans',
      hoc_teacher_led_link_ozar: 'Introduction to Computer Science lesson plans',
      hoc_teacher_led_desc2: 'to introduce your students to programming concepts using offline activities',
      hoc_group: 'Group Gameplay',
      hoc_group_desc_1: 'Teachers can use the lessons in conjunction with our Introduction to Computer Science course to track student progress. See our',
      hoc_group_link: 'Getting Started Guide',
      hoc_group_desc_2: 'for more details',
      hoc_additional_desc1: 'For additional CodeCombat resources and activities, see our',
      hoc_additional_desc2: 'Questions',
      hoc_additional_contact: 'Get in touch',
      regenerate_class_code_tooltip: 'Generate a new Class Code',
      regenerate_class_code_confirm: 'Are you sure you want to generate a new Class Code?',
      revoke_confirm: 'Are you sure you want to revoke a Full License from {{student_name}}? The license will become available to assign to another student.',
      revoke_alert_no_student: 'Please select students first.',
      revoke_selected_confirm: 'Are you sure you want to revoke Licenses from all selected students?',
      revoke_all_confirm: 'Are you sure you want to revoke Full Licenses from all students in this class?',
      revoking: 'Revoking...',
      unused_licenses: "You have unused Licenses that allow you to assign students paid courses when they're ready to learn more!",
      remember_new_courses: 'Remember to assign new courses!',
      more_info: 'More Info',
      how_to_assign_courses: 'How to Assign Courses',
      select_students: 'Select Students',
      select_instructions: 'Click the checkbox next to each student you want to assign courses to.',
      choose_course: 'Choose Course',
      choose_instructions: 'Select the course from the dropdown menu you’d like to assign, then click “Assign to Selected Students.”',
      push_projects: 'We recommend assigning Web Development 1 or Game Development 1 after students have finished Introduction to Computer Science! See our {{resource_hub}} for more details on those courses.',
      teacher_quest: "Teacher's Quest for Success",
      quests_complete: 'Quests Complete',
      teacher_quest_create_classroom: 'Create Classroom',
      teacher_quest_add_students: 'Add Students',
      teacher_quest_teach_methods: 'Help your students learn how to `call methods`.',
      teacher_quest_teach_methods_step1: 'Get 75% of at least one class through the first level, Dungeons of Kithgard',
      teacher_quest_teach_methods_step2: 'Print out the [Student Quick Start Guide](https://files.codecombat.com/docs/resources/StudentQuickStartGuide.pdf) in the Teacher Toolkit.',
      teacher_quest_teach_strings: "Don't string your students along, teach them `strings`.",
      teacher_quest_teach_strings_step1: 'Get 75% of at least one class through True Names',
      teacher_quest_teach_strings_step2: 'Use the Teacher Level Selector on [Course Guides](/teachers/courses) page to preview True Names.',
      teacher_quest_teach_loops: 'Keep your students in the loop about `loops`.',
      teacher_quest_teach_loops_step1: 'Get 75% of at least one class through Fire Dancing.',
      teacher_quest_teach_loops_step2: 'Use the Loops Activity in the [CS1 Curriculum guide](/teachers/resources/cs1) to reinforce this concept.',
      teacher_quest_teach_variables: 'Vary it up with `variables`.',
      teacher_quest_teach_variables_step1: 'Get 75% of at least one class through Known Enemy.',
      teacher_quest_teach_variables_step2: 'Encourage collaboration by using the [Pair Programming Activity](/teachers/resources/pair-programming).',
      teacher_quest_kithgard_gates_100: 'Escape the Kithgard Gates with your class.',
      teacher_quest_kithgard_gates_100_step1: 'Get 75% of at least one class through Kithgard Gates.',
      teacher_quest_kithgard_gates_100_step2: 'Guide students to think through hard problems using the [Engineering Cycle Worksheet](https://files.codecombat.com/docs/resources/EngineeringCycleWorksheet.pdf).',
      teacher_quest_wakka_maul_100: 'Prepare to duel in Wakka Maul.',
      teacher_quest_wakka_maul_100_step1: 'Get 75% of at least one class to Wakka Maul.',
      teacher_quest_wakka_maul_100_step2: 'See the [Arena Guide](/teachers/resources/arenas) in the [Teacher Toolkit](/teachers/resources) for tips on how to run a successful arena day.',
      teacher_quest_reach_gamedev: 'Explore new worlds!',
      teacher_quest_reach_gamedev_step1: '[Get licenses](/teachers/licenses) so that your students can explore new worlds, like Game Development and Web Development!',
      teacher_quest_done: 'Want your students to learn even more code? Get in touch with our [school specialists](mailto:schools@codecombat.com) today!',
      teacher_quest_keep_going: "Keep going! Here's what you can do next:",
      teacher_quest_more: 'See all quests',
      teacher_quest_less: 'See fewer quests',
      refresh_to_update: '(refresh the page to see updates)',
      view_project_gallery: 'View Project Gallery',
      office_hours: 'Teacher Webinars',
      office_hours_detail: 'Learn how to keep up with with your students as they create games and embark on their coding journey! Come and attend our',
      office_hours_link: 'teacher webinar',
      office_hours_detail_2: 'sessions.',
      success: 'Success',
      in_progress: 'In Progress',
      not_started: 'Not Started',
      mid_course: 'Mid-Course',
      end_course: 'End of Course',
      none: 'None detected yet',
      explain_open_ended: 'Note: Students are encouraged to solve this level creatively — one possible solution is provided below.',
      level_label: 'Level:',
      time_played_label: 'Time Spent:',
      practice_threshold_label: 'Practice Threshold:',
      back_to_resource_hub: 'Back to Teacher Toolkit',
      back_to_course_guides: 'Back to Course Guides',
      print_guide: 'Print this guide',
      combo: 'Combo',
      combo_explanation: 'Students pass Combo challenge levels by using at least one listed concept. Review student code by clicking the progress dot.',
      concept: 'Concept',
      sync_google_classroom: 'Sync Google Classroom',
      unit_overview: 'Unit Overview',
      module_overview: 'Module Overview',
      chapter1_unit_overview_desc: 'Summary of student experience, including Cutscenes, Practice Levels, Intros, and the Capstone project in Chapter 1.',
      lesson_plan: 'Lesson Plan',
      chapter1_lesson_plan_desc: 'Detailed classroom guide including learning objectives, CSTA standards, reflection activities, facilitation tips, and more.',
      capstone_rubric: 'Capstone Rubric',
      chapter1_capstone_rubric_desc: "Rubric for evaluating students' Capstone projects and reflection activities at the end of this unit.",
      chapter1: 'Chapter 1: Up The Mountain',
      chapter2: 'Chapter 2: The Moon Dancers',
      chapter3: 'Chapter 3: The Phoenix Lands',
      module1: 'Module 1: ',
      module2: 'Module 2: ',
      module3: 'Module 3: ',
      module4: 'Module 4: ',
      module5: 'Module 5: ',
      module6: 'Module 6: ',
      module7: 'Module 7: ',
      module8: 'Module 8: ',
      algorithms_and_syntax: 'Algorithms and Syntax',
      debugging: 'Debugging',
      variables: 'Variables',
      conditionals: 'Conditionals',
      capstone_intro: 'Capstone Intro',
      capstone_project: 'Capstone Project',
      level_code: 'Level Code',
      review_needed: 'Review Needed',
      review_tooltip_heading: 'What does this mean?',
      review_tooltip_text: 'Red flags appear next to Concept Checks where your student(s) attempted to answer the question 3 or more times. In the <strong>Course Overview</strong> section, red flags appear next to Concept Checks if at least 50% of students who have started or completed the concept check attempted it 3 or more times.',
      scroll_to_see_more: 'Scroll to see more',
      click_to_view_concept_check: 'Click to view concept check',
      click_to_view_project_gallery: 'Click to view project gallery',
      review_learning_goal: 'Review "Learning Goal: __learningGoal__" with students.',
      view_capstone_project: 'View Capstone Project',
      ozaria_dashboard_guide: 'Teacher Dashboard Guide',
      dashboard_guide_desc: 'Walkthrough of Ozaria Teacher Dashboard features that will help you view student progress and work.',
      review: 'Review',
      for_loops: 'For Loops',
      peer_feedback: 'Peer Feedback Form',
      presentation_checklist: 'Presentation Checklist',
      try_ozaria_footer: 'Try our new adventure game, Ozaria!',
      try_ozaria_free: 'Try Ozaria for free',
      ozaria_intro: 'Introducing Our New Computer Science Program',
      share_class: 'share class',
      permission: 'Permission',
      not_write_permission: "You don't have write permission to the class",
      not_read_permission: "You don't have read permission to the class",
      owned_license: 'Licensed',
      archive_revoke_confirm: ' students of the archived class have active licenses. Would you like to revoke them so that you can re-apply them to other students?',
      archive_without_revoking: 'Archive Without Revoking',
      revoke_and_archive: 'Revoke and Archive',
      license_stats: 'License Stats',
      redeemers: 'Active Students',
      removed_redeemers: 'Inactive Students',
      latest_podcast_episode: 'Latest Podcast Episode',
      from_the_podcast: 'From the Podcast',
      edit_student_access_title: 'Edit Student Access to Levels',
      edit_student_access_title_scenarios: 'Edit Student Access to Projects',
      edit_student_access_subtitle: 'You have selected __levels__ levels for __students__ students.',
      edit_student_access_subtitle_scenarios: 'You have selected __levels__ projects for __students__ students.',
      student_ask_for_help: 'Your student __name__ asking for your help.',
      never_played: 'Never Played',
      test_student_modal_header: 'Creating Test Student',
      test_student_modal_p1: 'You\'ll be creating a unique test account that mimics the student journey and saves your progress.',
      test_student_modal_no_class: 'Please create a class to join as a student',
      test_student_modal_choose_class: 'Choose a class to join:',
      test_student_modal_redirect: 'You will be redirected to your test student account!',
      stop_spying_student: 'You can return to the teacher account by clicking `Stop Spying` in the user dropdown',
      show_practice_levels: 'Show Practice Levels',
      hide_practice_levels: 'Hide Practice Levels',
      dashboard_deprecation_message: 'This legacy dashboard will be discontinued soon. To ensure uninterrupted access to all features and the best teaching tools, please transition to our new and improved Teacher Dashboard.',
      INTRO_short: 'Intro',
      ELA_short: 'ELA',
      ALG_short: 'ALG',
      CR1_short: 'CR1',
      CR2_short: 'CR2',
      AI1_short: 'AI 1',
      AI2_short: 'AI 2',
      CS_short: 'CS',
      SANDBOX_short: 'Sandbox',
      EXPLORATIONS_short: 'Explorations',
      course_not_covered: 'Course __course__ not covered',
      license_is: 'The student license is: ',
    },

    teacher_licenses: {
      active_licenses: 'Active Licenses',
      expired_licenses: 'Expired Licenses',
    },

    teacher_ozaria_encouragement_modal: {
      title: 'Build Computer Science Skills to Save Ozaria',
      sub_title: 'You are invited to try the new adventure game from CodeCombat',
      cancel: 'Back to CodeCombat',
      accept: 'Try First Unit Free',
      bullet1: 'Deepen student connection to learning through an epic story and immersive gameplay',
      bullet2: 'Teach CS fundamentals, Python or JavaScript and 21st century skills',
      bullet3: 'Unlock creativity through capstone projects',
      bullet4: 'Support instructions through dedicated curriculum resources',
      you_can_return: 'You can always return to CodeCombat',
    },

    educator_signup_ozaria_encouragement: {
      recommended_for: 'Recommended for:',
      independent_learners: 'Independent learners',
      homeschoolers: 'Homeschoolers',
      educators_continue_coco: 'Educators who want to continue using CodeCombat in their class',
      continue_coco: 'Continue with CodeCombat',
    },

    ozaria_cta: {
      title1: 'Standards Aligned Core Curriculum',
      description1: 'Immersive, story based curriculum that meets all 6th-8th grade CSTA standards.',
      title2: 'Turnkey Lesson Plans',
      description2: 'In-depth presentations and worksheets for teachers to guide students through learning objectives.',
      title3: 'New Teacher & Admin Dashboards',
      description3: 'All the actionable insights educators need at a glance, such as student progress and concept understanding.',
    },

    share_licenses: {
      share_licenses: 'Share Licenses',
      shared_by: 'Shared By:',
      add_teacher_label: 'Enter exact teacher email:',
      add_teacher_button: 'Add Teacher',
      modal_subtitle: 'You can make your licenses available to other teachers in a shared pool.',
      modal_list_item_1: 'Each license can only be used for one student at a time.',
      modal_list_item_2: 'When teachers revoke licenses from students, the licenses will be returned to the shared pool for other teachers in this group to use.',
      subheader: 'You can make your licenses available to other teachers in your organization. Each license can only be used for one student at a time.',
      teacher_not_found: 'Teacher not found. Please make sure this teacher has already created a Teacher Account.',
      teacher_not_valid: 'This is not a valid Teacher Account. Only teacher accounts can share licenses.',
      already_shared: "You've already shared these licenses with that teacher.",
      have_not_shared: "You've not shared these licenses with that teacher.",
      teachers_using_these: 'Teachers who can access these licenses:',
      footer: 'When teachers revoke licenses from students, the licenses will be returned to the shared pool for other teachers in this group to use.',
      you: '(you)',
      one_license_used: '(1/__all__ license used)',
      licenses_used: '(__licensesUsed__/__all__ licenses used)',
      licenses_used_no_braces: '__licensesUsed__/__all__ licenses used',
      more_info: 'More info',
      shared_pool_label: 'Teachers in your shared pool:',
      teacher_delete_warning: "The shared licenses assigned to the teacher won't be revoked!",
      licenses_limit: 'Licenses Limit:',
    },

    sharing: {
      game: 'Game',
      webpage: 'Webpage',
      your_students_preview: 'Your students will click here to see their finished projects! Unavailable in teacher preview.',
      unavailable: 'Link sharing not available in teacher preview.',
      share_game: 'Share This Game',
      share_web: 'Share This Webpage',
      victory_share_prefix: 'Share this link to invite your friends & family to',
      victory_share_prefix_short: 'Invite people to',
      victory_share_game: 'play your game level',
      victory_share_web: 'view your webpage',
      victory_share_suffix: '.',
      victory_course_share_prefix: 'This link will let your friends & family',
      victory_course_share_game: 'play the game',
      victory_course_share_web: 'view the webpage',
      victory_course_share_suffix: 'you just created.',
      copy_url: 'Copy URL',
      share_with_teacher_email: 'Send to your teacher',
      share_ladder_link: 'Share Multiplayer Link',
      ladder_link_title: 'Share Your Multiplayer Match Link',
      ladder_link_blurb: 'Share your AI battle link so your friends and family can play versus your code:',
    },

    game_dev: {
      creator: 'Creator',
    },

    web_dev: {
      image_gallery_title: 'Image Gallery',
      select_an_image: 'Select an image you want to use',
      scroll_down_for_more_images: '(Scroll down for more images)',
      copy_the_url: 'Copy the URL below',
      copy_the_url_description: 'Useful if you want to replace an existing image.',
      copy_the_img_tag: 'Copy the <img> tag',
      copy_the_img_tag_description: 'Useful if you want to insert a new image.',
      copy_url: 'Copy URL',
      copy_img: 'Copy <img>',
      how_to_copy_paste: 'How to Copy/Paste',
      copy: 'Copy',
      paste: 'Paste',
      back_to_editing: 'Back to Editing',
    },

    classes: {
      archmage_title: 'Archmage',
      archmage_title_description: '(Coder)',
      archmage_summary: 'If you are a developer interested in coding educational games, become an archmage to help us build CodeCombat!',
      artisan_title: 'Artisan',
      artisan_title_description: '(Level Builder)',
      artisan_summary: 'Build and share levels for you and your friends to play. Become an Artisan to learn the art of teaching others to program.',
      adventurer_title: 'Adventurer',
      adventurer_title_description: '(Level Playtester)',
      adventurer_summary: 'Get our new levels (even our subscriber content) for free one week early and help us work out bugs before our public release.',
      scribe_title: 'Scribe',
      scribe_title_description: '(Article Editor)',
      scribe_summary: 'Good code needs good documentation. Write, edit, and improve the docs read by millions of players across the globe.',
      diplomat_title: 'Diplomat',
      diplomat_title_description: '(Translator)',
      diplomat_summary: 'CodeCombat is localized in 45+ languages by our Diplomats. Help us out and contribute translations.',
      ambassador_title: 'Ambassador',
      ambassador_title_description: '(Support)',
      ambassador_summary: 'Tame our forum users and provide direction for those with questions. Our ambassadors represent CodeCombat to the world.',
      teacher_title: 'Teacher',
    },

    editor: {
      main_title: 'CodeCombat Editors',
      concept_title: 'Concept Editor',
      standards_title: 'Standards Correlation Editor',
      article_title: 'Article Editor',
      thang_title: 'Thang Editor',
      level_title: 'Level Editor',
      course_title: 'Course Editor',
      achievement_title: 'Achievement Editor',
      poll_title: 'Poll Editor',
      resource_title: 'Resource Editor',
      chat_title: 'Chat Editor',
      ai_scenario_title: 'AI Scenario Editor',
      ai_project_title: 'AI Project Editor',
      ai_model_title: 'AI Model Editor',
      ai_document_title: 'AI Document Editor',
      ai_chat_message_title: 'AI Chat Message Editor',
      ai_junior_scenario_title: 'AI Junior Scenario Editor',
      ai_junior_project_title: 'AI Junior Project Editor',
      resource_title_general: '__resource__ Editor',
      back: 'Back',
      revert: 'Revert',
      revert_models: 'Revert Models',
      pick_a_terrain: 'Pick A Terrain',
      dungeon: 'Dungeon',
      indoor: 'Indoor',
      desert: 'Desert',
      grassy: 'Grassy',
      mountain: 'Mountain',
      glacier: 'Glacier',
      small: 'Small',
      large: 'Large',
      fork_title: 'Fork New Version',
      fork_creating: 'Creating Fork...',
      generate_terrain: 'Generate Terrain',
      generate_level: 'Generate Level',
      generate_practice_level: 'Generate Practice Level',
      generate_all_practice_levels: 'Generate All Practice Levels',
      more: 'More',
      wiki: 'Wiki',
      live_chat: 'Slack',
      thang_main: 'Main',
      thang_spritesheets: 'Spritesheets',
      thang_colors: 'Colors',
      level_some_options: 'Some Options?',
      level_tab_thangs: 'Thangs',
      level_tab_scripts: 'Scripts',
      level_tab_components: 'Components',
      level_tab_systems: 'Systems',
      level_tab_docs: 'Documentation',
      level_tab_thangs_title: 'Current Thangs',
      level_tab_thangs_all: 'All',
      level_tab_thangs_conditions: 'Starting Conditions',
      level_tab_thangs_add: 'Add Thangs',
      level_tab_thangs_search: 'Search thangs',
      add_components: 'Add Components',
      component_configs: 'Component Configurations',
      config_thang: 'Double click to configure a thang',
      delete: 'Delete',
      duplicate: 'Duplicate',
      stop_duplicate: 'Stop Duplicate',
      rotate: 'Rotate',
      level_component_tab_title: 'Current Components',
      level_component_btn_new: 'Create New Component',
      level_systems_tab_title: 'Current Systems',
      level_systems_btn_new: 'Create New System',
      level_systems_btn_add: 'Add System',
      level_components_title: 'Back to All Thangs',
      level_components_type: 'Type',
      concept_edit_title: 'Edit Concept',
      standards_edit_title: 'Edit Standards Correlation',
      level_component_edit_title: 'Edit Component',
      level_component_config_schema: 'Config Schema',
      level_system_edit_title: 'Edit System',
      course_edit_title: 'Edit Course',
      resource_edit_title: 'Edit Resource',
      resource_edit_title_general: 'Edit __resource__',
      chat_edit_title: 'Edit Chat',
      chat_edit_title_general: 'Edit __chat__',
      ai_scenario_edit_title: 'Edit Scenario',
      ai_scenario_edit_title_general: 'Edit __scenario__',
      ai_project_edit_title: 'Edit Project',
      ai_project_edit_title_general: 'Edit __project__',
      ai_model_edit_title: 'Edit Model',
      ai_document_edit_title: 'Edit Document',
      ai_chat_message_edit_title: 'Edit Chat Message',
      ai_junior_scenario_edit_title: 'Edit Junior Scenario',
      ai_junior_scenario_edit_title_general: 'Edit __scenario__',
      ai_junior_project_edit_title: 'Edit Junior Project',
      ai_junior_project_edit_title_general: 'Edit __project__',
      create_system_title: 'Create New System',
      new_concept_title: 'Create New Concept',
      new_standards_title: 'Create New Standards Correlation',
      new_component_title: 'Create New Component',
      new_component_field_system: 'System',
      new_article_title: 'Create a New Article',
      new_thang_title: 'Create a New Thang Type',
      new_level_title: 'Create a New Level',
      new_article_title_login: 'Log In to Create a New Article',
      new_thang_title_login: 'Log In to Create a New Thang Type',
      new_level_title_login: 'Log In to Create a New Level',
      new_achievement_title: 'Create a New Achievement',
      new_achievement_title_login: 'Log In to Create a New Achievement',
      new_poll_title: 'Create a New Poll',
      new_poll_title_login: 'Log In to Create a New Poll',
      new_course_title: 'Create a New Course',
      new_course_title_login: 'Log In to Create a New Course',
      new_resource_title: 'Create a New Resource',
      new_resource_title_login: 'Log In to Create a New Resource',
      new_chat_title: 'Create a New Chat',
      new_chat_title_login: 'Log In to Create a New Chat',
      new_ai_scenario_title: 'Create a New Scenario',
      new_ai_scenario_title_login: 'Log In to Create a New Scenario',
      new_ai_project_title: 'Create a New Project',
      new_ai_project_title_login: 'Log In to Create a New Project',
      new_ai_model_title: 'Create a New Model',
      new_ai_model_title_login: 'Log In to Create a New Model',
      new_ai_document_title: 'Create a New Document',
      new_ai_document_title_login: 'Log In to Create a New Document',
      new_ai_chat_message_title: 'Create a New Chat Message',
      new_ai_chat_message_title_login: 'Log In to Create a New Chat Message',
      new_ai_junior_scenario_title: 'Create a New Junior Scenario',
      new_ai_junior_scenario_title_login: 'Log In to Create a New Junior Scenario',
      new_ai_junior_project_title: 'Create a New Junior Project',
      new_ai_junior_project_title_login: 'Log In to Create a New Junior Project',
      article_search_title: 'Search Articles Here',
      concept_search_title: 'Search Concepts Here',
      standards_search_title: 'Search Standards Correlations Here',
      thang_search_title: 'Search Thang Types Here',
      level_search_title: 'Search Levels Here',
      achievement_search_title: 'Search Achievements',
      poll_search_title: 'Search Polls',
      course_search_title: 'Search Courses',
      resource_search_title: 'Search Resources',
      chat_search_title: 'Search Chats',
      ai_scenario_search_title: 'Search Scenarios',
      ai_project_search_title: 'Search Projects',
      ai_model_search_title: 'Search Models',
      ai_document_search_title: 'Search Documents',
      ai_chat_message_search_title: 'Search Chat Messages',
      ai_junior_scenario_search_title: 'Search Junior Scenarios',
      ai_junior_project_search_title: 'Search Junior Projects',
      read_only_warning2: "Note: you can't save any edits here, because you're not logged in.",
      no_achievements: 'No achievements have been added for this level yet.',
      achievement_query_misc: 'Key achievement off of miscellanea',
      achievement_query_goals: 'Key achievement off of level goals',
      level_completion: 'Level Completion',
      pop_i18n: 'Populate I18N',
      ai_translate: 'AI Translate',
      tasks: 'Tasks',
      clear_storage: 'Clear your local changes',
      add_system_title: 'Add Systems to Level',
      done_adding: 'Done Adding',
      product: 'Product',
      link: 'Link',
      clone_to_new_scenario: 'Clone to New Scenario',
      translate_warning_content: 'Make sure the doc already Populate the i18n and Saved.',
      translate_pick_langs: 'Pick the Languages you want to transalte.',
      translate_it: 'Translate it!',
      translating: 'Translating...',
    },

    article: {
      edit_btn_preview: 'Preview',
      edit_article_title: 'Edit Article',
    },

    polls: {
      priority: 'Priority',
    },

    contribute: {
      page_title: 'Contributing',
      intro_blurb: "CodeCombat is part of the open source community! Hundreds of dedicated players have helped us build the game into what it is today. Join us and write the next chapter in CodeCombat's quest to teach the world to code!",
      alert_account_message_intro: 'Hey there!',
      alert_account_message: "To subscribe for class emails, you'll need to be logged in first.",
      archmage_introduction: "One of the best parts about building games is they synthesize so many different things. Graphics, sound, real-time networking, social networking, and of course many of the more common aspects of programming, from low-level database management, and server administration to user facing design and interface building. There's a lot to do, and if you're an experienced programmer with a hankering to really dive into the nitty-gritty of CodeCombat, this class might be for you. We would love to have your help building the best programming game ever.",
      class_attributes: 'Class Attributes',
      archmage_attribute_1_pref: 'Knowledge in ',
      archmage_attribute_1_suf: ", or a desire to learn. Most of our code is in this language. If you're a fan of Ruby or Python, you'll feel right at home. It's JavaScript, but with a nicer syntax.",
      archmage_attribute_2: "Some experience in programming and personal initiative. We'll help you get oriented, but we can't spend much time training you.",
      how_to_join: 'How To Join',
      join_desc_1: 'Anyone can help out! Just check out our ',
      join_desc_2: 'to get started, and check the box below to mark yourself as a brave Archmage and get the latest news by email. Want to chat about what to do or how to get more deeply involved? ',
      join_desc_3: ', or find us in our ',
      join_desc_4: "and we'll go from there!",
      join_url_email: 'Email us',
      join_url_slack: 'public Slack channel',
      archmage_subscribe_desc: 'Get emails on new coding opportunities and announcements.',
      artisan_introduction_pref: 'We must construct additional levels! People be clamoring for more content, and we can only build so many ourselves. Right now your workstation is level one; our level editor is barely usable even by its creators, so be wary. If you have visions of campaigns spanning for-loops to',
      artisan_introduction_suf: ', then this class might be for you.',
      artisan_attribute_1: "Any experience in building content like this would be nice, such as using Blizzard's level editors. But not required!",
      artisan_attribute_2: 'A hankering to do a whole lot of testing and iteration. To make good levels, you need to take it to others and watch them play it, and be prepared to find a lot of things to fix.',
      artisan_attribute_3: 'For the time being, endurance en par with an Adventurer. Our Level Editor is super preliminary and frustrating to use. You have been warned!',
      artisan_join_desc: 'Use the Level Editor in these steps, give or take:',
      artisan_join_step1: 'Read the documentation.',
      artisan_join_step2: 'Create a new level and explore existing levels.',
      artisan_join_step3: 'Find us in our public Slack channel for help.',
      artisan_join_step4: 'Post your levels on the subreddit for feedback.',
      artisan_subscribe_desc: 'Get emails on level editor updates and announcements.',
      adventurer_introduction: "Let's be clear about your role: you are the tank. You're going to take heavy damage. We need people to try out brand-new levels and help identify how to make things better. The pain will be enormous; making good games is a long process and no one gets it right the first time. If you can endure and have a high constitution score, then this class might be for you.",
      adventurer_attribute_1: "A thirst for learning. You want to learn how to code and we want to teach you how to code. You'll probably be doing most of the teaching in this case, though.",
      adventurer_attribute_2: 'Charismatic. Be gentle but articulate about what needs improving, and offer suggestions on how to improve.',
      adventurer_join_pref: "Either get together with (or recruit!) an Artisan and work with them, or check the box below to receive emails when there are new levels to test. We'll also be posting about levels to review on our networks like",
      adventurer_forum_url: 'our forum',
      adventurer_join_suf: 'so if you prefer to be notified those ways, sign up there!',
      adventurer_subscribe_desc: 'Get emails when there are new levels to test.',
      scribe_introduction_pref: "CodeCombat isn't just going to be a bunch of levels. It will also include a resource for knowledge, a wiki of programming concepts that levels can hook into. That way rather than each Artisan having to describe in detail what a comparison operator is, they can simply link their level to the Article describing them that is already written for the player's edification. Something along the lines of what the ",
      scribe_introduction_url_mozilla: 'Mozilla Developer Network',
      scribe_introduction_suf: ' has built. If your idea of fun is articulating the concepts of programming in Markdown form, then this class might be for you.',
      scribe_attribute_1: 'Skill in words is pretty much all you need. Not only grammar and spelling, but able to convey complicated ideas to others.',
      contact_us_url: 'Contact Us',
      scribe_join_description: "tell us a little about yourself, your experience with programming and what sort of things you'd like to write about. We'll go from there!",
      scribe_subscribe_desc: 'Get emails about article writing announcements.',
      diplomat_introduction_pref: "So, if there's one thing we learned from the ",
      diplomat_introduction_url: 'open source community',
      diplomat_introduction_suf: "it's that there is sizeable interest in CodeCombat in other countries! We're building a corps of translators eager to turn one set of words into another set of words to get CodeCombat as accessible across the world as possible. If you like getting sneak peeks at upcoming content and getting these levels to your fellow nationals ASAP, then this class might be for you.",
      diplomat_attribute_1: "Fluency in English and the language you would like to translate to. When conveying complicated ideas, it's important to have a strong grasp in both!",
      diplomat_i18n_page_prefix: 'You can start translating our levels by going to our',
      diplomat_i18n_page: 'translations page',
      diplomat_i18n_page_suffix: ', or our interface and website on GitHub.',
      diplomat_join_pref_github: 'Find your language locale file ',
      diplomat_github_url: 'on GitHub',
      diplomat_join_suf_github: ', edit it online, and submit a pull request. Also, check this box below to keep up-to-date on new internationalization developments!',
      diplomat_subscribe_desc: 'Get emails about i18n developments and levels to translate.',
      ambassador_introduction: "This is a community we're building, and you are the connections. We've got forums, emails, and social networks with lots of people to talk with and help get acquainted with the game and learn from. If you want to help people get involved and have fun, and get a good feel of the pulse of CodeCombat and where we're going, then this class might be for you.",
      ambassador_attribute_1: "Communication skills. Be able to identify the problems players are having and help them solve them. Also, keep the rest of us informed about what players are saying, what they like and don't like and want more of!",
      ambassador_join_desc: "tell us a little about yourself, what you've done and what you'd be interested in doing. We'll go from there!",
      ambassador_join_step1: 'Read the documentation.',
      ambassador_join_step2: 'Find us in our public Slack channel.',
      ambassador_join_step3: 'Help others in the Ambassador category.',
      ambassador_subscribe_desc: 'Get emails on support updates and multiplayer developments.',
      teacher_subscribe_desc: 'Get emails on updates and announcements for teachers.',
      changes_auto_save: 'Changes are saved automatically when you toggle checkboxes.',
      diligent_scribes: 'Our Diligent Scribes:',
      powerful_archmages: 'Our Powerful Archmages:',
      creative_artisans: 'Our Creative Artisans:',
      brave_adventurers: 'Our Brave Adventurers:',
      translating_diplomats: 'Our Translating Diplomats:',
      helpful_ambassadors: 'Our Helpful Ambassadors:',
    },

    ladder: {
      title: 'Multiplayer Arenas',
      arena_title: '__arena__ | Multiplayer Arenas',
      my_matches: 'My Matches',
      simulate: 'Simulate',
      simulation_explanation: 'By simulating games you can get your game ranked faster!',
      simulation_explanation_leagues: 'You will mainly help simulate games for allied players in your clans and courses.',
      simulate_games: 'Simulate Games!',
      games_simulated_by: 'Games simulated by you:',
      games_simulated_for: 'Games simulated for you:',
      games_in_queue: 'Games currently in the queue:',
      games_simulated: 'Games simulated',
      games_played: 'Games played',
      ratio: 'Ratio',
      leaderboard: 'Leaderboard',
      battle_as: 'Battle as ',
      summary_your: 'Your ',
      summary_matches: 'Matches - ',
      summary_wins: ' Wins, ',
      summary_losses: ' Losses',
      rank_no_code: 'No New Code to Rank',
      rank_my_game: 'Rank My Game!',
      rank_submitting: 'Submitting...',
      rank_submitted: 'Submitted for Ranking',
      rank_failed: 'Failed to Rank',
      rank_being_ranked: 'Game Being Ranked',
      rank_last_submitted: 'submitted ',
      help_simulate: 'Help simulate games?',
      code_being_simulated: 'Your new code is being simulated by other players for ranking. This will refresh as new matches come in.',
      no_ranked_matches_pre: 'No ranked matches for the ',
      no_ranked_matches_post: ' team! Play against some competitors and then come back here to get your game ranked.',
      choose_opponent: 'Choose an Opponent',
      select_your_language: 'Select your language!',
      tutorial_play: 'Play Tutorial',
      tutorial_recommended: "Recommended if you've never played before",
      tutorial_skip: 'Skip Tutorial',
      tutorial_not_sure: "Not sure what's going on?",
      tutorial_play_first: 'Play the Tutorial first.',
      simple_ai: 'Simple CPU',
      warmup: 'Warmup',
      friends_playing: 'Friends Playing',
      log_in_for_friends: 'Log in to play with your friends!',
      social_connect_blurb: 'Connect and play against your friends!',
      invite_friends_to_battle: 'Invite your friends to join you in battle!',
      fight: 'Battle!',
      watch_victory: 'Watch your victory',
      defeat_the: 'Defeat the',
      watch_battle: 'Watch the battle',
      tournament_starts: 'Tournament starts __timeElapsed__',
      tournament_started: 'Tournament started __timeElapsed__',
      tournament_ends: ', will end __timeLeft__',
      tournament_ended: 'Tournament ended __timeLeft__',
      tournament_results_published: ', results published __timeLeft__',
      tournament_results_wait_publish: ', results will be published by owner',
      tournament_rules: 'Tournament Rules',
      tournament_blurb: 'Write code, collect gold, build armies, crush foes, win prizes, and upgrade your career in our $40,000 Greed tournament! Check out the details',
      tournament_blurb_criss_cross: 'Win bids, construct paths, outwit opponents, grab gems, and upgrade your career in our Criss-Cross tournament! Check out the details',
      tournament_blurb_zero_sum: 'Unleash your coding creativity in both gold gathering and battle tactics in this alpine mirror match between red sorcerer and blue sorcerer. The tournament began on Friday, March 27 and will run until Monday, April 6 at 5PM PDT. Compete for fun and glory! Check out the details',
      tournament_blurb_ace_of_coders: 'Battle it out in the frozen glacier in this domination-style mirror match! The tournament began on Wednesday, September 16 and will run until Wednesday, October 14 at 5PM PDT. Check out the details',
      tournament_blurb_blog: 'on our blog',
      rules: 'Rules',
      winners: 'Winners',
      league: 'League',
      red_ai: 'Red CPU', // "Red AI Wins", at end of multiplayer match playback
      blue_ai: 'Blue CPU',
      wins: 'Wins', // At end of multiplayer match playback
      losses: 'Losses',
      win_num: 'Wins',
      loss_num: 'Losses',
      win_rate: 'Win %',
      humans: 'Red', // Ladder page display team name
      ogres: 'Blue',
      live_tournament: 'Live Tournament',
      awaiting_tournament_title: 'Tournament Inactive',
      awaiting_tournament_blurb: 'The tournament arena is not currently active.',
      tournament_end_desc: 'The tournament is over, thanks for playing',
      age: 'Age',
      age_bracket: 'Age Bracket',
      bracket_0_11: '0-11',
      bracket_11_14: '11-14',
      bracket_14_18: '14-18',
      bracket_11_18: '11-18',
      bracket_open: 'Open',
      create_tournament: 'Create a Tournament',
      difficulty_beginner: 'Beginner',
      difficulty_intermediate: 'Intermediate',
      difficulty_advanced: 'Advanced',
      ai_league_ends: 'Global AI League ends at __time__',
    },

    user: {
      user_title: '__name__ - Learn to Code with CodeCombat',
      stats: 'Stats',
      singleplayer_title: 'Singleplayer Levels',
      multiplayer_title: 'Multiplayer Levels',
      achievements_title: 'Achievements',
      last_played: 'Last Played',
      status: 'Status',
      status_completed: 'Completed',
      status_unfinished: 'Unfinished',
      no_singleplayer: 'No Singleplayer games played yet.',
      no_multiplayer: 'No Multiplayer games played yet.',
      no_achievements: 'No Achievements earned yet.',
      favorite_prefix: 'Favorite language is ',
      favorite_postfix: '.',
      not_member_of_clans: 'Not a member of any clans yet.',
      certificate_view: 'view certificate',
      certificate_click_to_view: 'click to view certificate',
      certificate_course_incomplete: 'course incomplete',
      certificate_of_completion: 'Certificate of Completion',
      certificate_endorsed_by: 'Endorsed by',
      certificate_stats: 'Course Stats',
      certificate_lines_of: 'lines of',
      certificate_levels_completed: 'levels completed',
      certificate_for: 'For',
      for_ozaria_chapters_1_4: 'For Ozaria Chapters 1 - 4',
      certificate_number: 'No.',
      heroes_unlocked: 'Heroes Unlocked',
      current_items: 'Items Equipped',
      contributor_badges: 'Contributor Badges',
      contributions_title: 'Contributions',
      type_stat: 'Type', // As in, which type of contribution
      patches_submit: 'Patches Submitted',
      patches_approved: 'Patches Approved',
      patches_accepted: 'Patches Accepted',
      level_edits: 'Level Edits',
      total_translations: 'Total Translations',
      campaign_stats: 'Stats',
    },

    achievements: {
      last_earned: 'Last Earned',
      amount_achieved: 'Amount',
      achievement: 'Achievement',
      current_xp_prefix: '',
      current_xp_postfix: ' in total',
      new_xp_prefix: '',
      new_xp_postfix: ' earned',
      left_xp_prefix: '',
      left_xp_infix: ' until level ',
      left_xp_postfix: '',
    },

    account: {
      title: 'Account',
      settings_title: 'Account Settings',
      unsubscribe_title: 'Unsubscribe',
      payments_title: 'Payments',
      subscription_title: 'Subscription',
      invoices_title: 'Invoices',
      prepaids_title: 'Prepaids',
      payments: 'Payments',
      prepaid_codes: 'Prepaid Codes',
      purchased: 'Purchased',
      subscribe_for_gems: 'Subscribe for gems',
      subscription: 'Subscription',
      invoices: 'Invoices',
      service_apple: 'Apple',
      service_web: 'Web',
      paid_on: 'Paid On',
      service: 'Service',
      price: 'Price',
      gems: 'Gems',
      active: 'Active',
      subscribed: 'Subscribed',
      unsubscribed: 'Unsubscribed',
      active_until: 'Active Until',
      cost: 'Cost',
      next_payment: 'Next Payment',
      card: 'Card',
      status_unsubscribed_active: "You're not subscribed and won't be billed, but your account is still active for now.",
      status_unsubscribed: 'Get access to new levels, heroes, items, and bonus gems with a CodeCombat subscription!',
      not_yet_verified: 'Not yet verified.',
      resend_email: 'Please save first then Resend email',
      email_sent: 'Email sent! Check your inbox.',
      verifying_email: 'Verifying your email address...',
      successfully_verified: "You've successfully verified your email address!",
      verify_error: 'Something went wrong when verifying your email :(',
      unsubscribe_from_marketing: 'Unsubscribe __email__ from all CodeCombat marketing emails?',
      unsubscribe_button: 'Yes, unsubscribe',
      unsubscribe_failed: 'Failed',
      unsubscribe_success: 'Success',
      manage_billing: 'Manage Payments',
      payments_history: 'Payments History',
      no_payments_found: 'No payments found',
      create_a_free_account: 'Create a Free Account',
      individual_inspiration: 'Your new favorite game also happens to teach you real code',
      parent_inspiration: 'Safe, teacher-backed coding games that build real skills',
      individual_completion: 'Check your email to dive in! Open the link on your computer for the best way to learn and play while you code.',
      parent_completion: 'Check your email to get started! For the best results, open the link on a computer so your child can learn and play in the best coding environment.',
      all_set: 'You\'re all set!',
      date_of_birth: 'Date of Birth',
      unlock_next_level_with_sign_up: 'Create a free account to save your progress and continue your coding journey.',
    },

    account_invoices: {
      amount: 'Amount in US dollars',
      declined: 'Your card was declined',
      invalid_amount: 'Please enter a US dollar amount.',
      not_logged_in: 'Log in or create an account to access invoices.',
      pay: 'Pay Invoice',
      purchasing: 'Purchasing...',
      retrying: 'Server error, retrying.',
      success: 'Successfully paid. Thanks!',
    },

    account_prepaid: {
      purchase_code: 'Purchase a Subscription Code',
      purchase_code1: 'Subscription Codes can be redeemed to add premium subscription time to one or more accounts for the Home version of CodeCombat.', //
      purchase_code2: 'Each CodeCombat account can only redeem a particular Subscription Code once.',
      purchase_code3: 'Subscription Code months will be added to the end of any existing subscription on the account.',
      purchase_code4: 'Subscription Codes are for accounts playing the Home version of CodeCombat, they cannot be used in place of Student Licenses for the Classroom version.',
      purchase_code5: 'For more information on Student Licenses, reach out to',
      users: 'Users',
      months: 'Months',
      purchase_total: 'Total',
      purchase_button: 'Submit Purchase',
      your_codes: 'Your Codes',
      redeem_codes: 'Redeem a Subscription Code',
      prepaid_code: 'Prepaid Code',
      lookup_code: 'Lookup prepaid code',
      apply_account: 'Apply to your account',
      copy_link: "You can copy the code's link and send it to someone.",
      quantity: 'Quantity',
      redeemed: 'Redeemed',
      no_codes: 'No codes yet!',
      you_can1: 'You can',
      you_can2: 'purchase a prepaid code',
      you_can3: 'that can be applied to your own account or given to others.',
      prepaid_add_months: 'This prepaid code adds <strong>__months__ months of subscription</strong> to your account.',
      can_use_times: 'It can be used <strong>__unlocksLeft__ more</strong> times.',
      prepaid_applied_success: 'Prepaid applied to your account!',
      activation_code_used: 'The Activation code has been used.',
      redeem_code_error: 'Error: Could not redeem prepaid code. ',
    },

    ozaria_chrome: {
      sound_off: 'Mute',
      sound_on: 'Unmute',
      back_to_map: 'Back to Map',
      level_options: 'Level Options',
      restart_level: 'Restart Level',
      max_browser: 'Maximize Browser',
      ai_hint: 'AI Hint',
    },

    impact: {
      hero_heading: 'Building A World-Class Computer Science Program',
      hero_subheading: 'We Help Empower Educators and Inspire Students Across the Country',
      featured_partner_story: 'Featured Partner Story',
      partner_heading: 'Successfully Teaching Coding at a Title I School',
      partner_school: 'Bobby Duke Middle School',
      featured_teacher: 'Scott Baily',
      teacher_title: 'Technology Teacher Coachella, CA',
      implementation: 'Implementation',
      grades_taught: 'Grades Taught',
      length_use: 'Length of Use',
      length_use_time: '3 years',
      students_enrolled: 'Students Enrolled this Year',
      students_enrolled_number: '130',
      courses_covered: 'Courses Covered',
      course1: 'CompSci 1',
      course2: 'CompSci 2',
      course3: 'CompSci 3',
      course4: 'CompSci 4',
      course5: 'GameDev 1',
      fav_features: 'Favorite Features',
      responsive_support: 'Responsive Support',
      immediate_engagement: 'Immediate Engagement',
      paragraph1: 'Bobby Duke Middle School sits nestled between the Southern California mountains of Coachella Valley to the west and east and the Salton Sea 33 miles south, and boasts a student population of 697 students within Coachella Valley Unified’s district-wide population of 18,861 students.',
      paragraph2: 'The students of Bobby Duke Middle School reflect the socioeconomic challenges facing Coachella Valley’s residents and students within the district. With over 95% of the Bobby Duke Middle School student population qualifying for free and reduced-price meals and over 40% classified as English language learners, the importance of teaching 21st century skills was the top priority of Bobby Duke Middle School Technology teacher, Scott Baily.',
      paragraph3: 'Baily knew that teaching his students coding was a key pathway to opportunity in a job landscape that increasingly prioritizes and necessitates computing skills. So, he decided to take on the exciting challenge of creating and teaching the only coding class in the school and finding a solution that was affordable, responsive to feedback, and engaging to students of all learning abilities and backgrounds.',
      teacher_quote: 'When I got my hands on CodeCombat [and] started having my students use it, the light bulb went on. It was just night and day from every other program that we had used. They’re not even close.',
      quote_attribution: 'Scott Baily, Technology Teacher',
      read_full_story: 'Read Full Story',
      more_stories: 'More Partner Stories',
      partners_heading_1: 'Supporting Multiple CS Pathways in One Class',
      partners_school_1: 'Preston High School',
      partners_heading_2: 'Excelling on the AP Exam',
      partners_school_2: 'River Ridge High School',
      partners_heading_3: 'Teaching Computer Science Without Prior Experience',
      partners_school_3: 'Riverdale High School',
      download_study: 'Download Research Study',
      teacher_spotlight: 'Teacher & Student Spotlights',
      teacher_name_1: 'Amanda Henry',
      teacher_title_1: 'Rehabilitation Instructor',
      teacher_location_1: 'Morehead, Kentucky',
      spotlight_1: 'Through her compassion and drive to help those who need second chances, Amanda Henry helped change the lives of students who need positive role models. With no previous computer science experience, Henry led her students to coding success in a regional coding competition.',
      teacher_name_2: 'Kaila, Student',
      teacher_title_2: 'Maysville Community & Technical College',
      teacher_location_2: 'Lexington, Kentucky',
      spotlight_2: 'Kaila was a student who never thought she would be writing lines of code, let alone enrolled in college with a pathway to a bright future.',
      teacher_name_3: 'Susan Jones-Szabo',
      teacher_title_3: 'Teacher Librarian',
      teacher_school_3: 'Ruby Bridges Elementary',
      teacher_location_3: 'Alameda, CA',
      spotlight_3: 'Susan Jones-Szabo promotes an equitable atmosphere in her class where everyone can find success in their own way. Mistakes and struggles are welcomed because everyone learns from a challenge, even the teacher.',
      continue_reading_blog: 'Continue Reading on Blog...',
      ozaria_impact_title: 'Positive Impacts with Ozaria',
      ozaria_impact_blurb: 'CodeCombat\'s sister curriculum, Ozaria, has proven to have a positive impact on the student learning outcomes that matter most to both students and educators.',
      ozaria_impact_learn_more: 'Learn more about Ozaria\'s curriculum efficacy here.',
    },

    loading_error: {
      could_not_load: 'Error loading from server. Try refreshing the page.',
      connection_failure: 'Connection Failed',
      connection_failure_desc: 'It doesn’t look like you’re connected to the internet! Check your network connection and then reload this page.',
      login_required: 'Login Required',
      login_required_desc: 'You need to be logged in to access this page.',
      unauthorized: 'You need to be signed in. Do you have cookies disabled?',
      forbidden: 'Forbidden',
      forbidden_desc: 'Oh no, there’s nothing we can show you here! Make sure you’re logged into the correct account, or visit one of the links below to get back to programming!',
      user_not_found: 'User Not Found',
      not_found: 'Not Found',
      resource_not_found: '404 __resource__ Not Found',
      not_found_desc: 'Hm, there’s nothing here. Visit one of the following links to get back to programming!',
      not_allowed: 'Method not allowed.',
      timeout: 'Server Timeout',
      conflict: 'Resource conflict.',
      bad_input: 'Bad input.',
      server_error: 'Server error.',
      unknown: 'Unknown Error',
      error: 'ERROR',
      general_desc: 'Something went wrong, and it’s probably our fault. Try waiting a bit and then refreshing the page, or visit one of the following links to get back to programming!',
      too_many_login_failures: 'There have been too many unsuccessful login attempts.  Please try again later.',
      something_went_wrong: 'Oops! Something went wrong',
      back_to_dashboard: 'Back to Dashboard',
    },

    resources: {
      level: 'Level',
      patch: 'Patch',
      patches: 'Patches',
      system: 'System',
      systems: 'Systems',
      component: 'Component',
      components: 'Components',
      hero: 'Hero',
      campaigns: 'Campaigns',
    },

    concepts: {
      advanced_css: 'Advanced CSS',
      advanced_css_rules: 'Advanced CSS Rules',
      advanced_css_selectors: 'Advanced CSS Selectors',
      advanced_html: 'Advanced HTML',
      advanced_html_attributes: 'Advanced HTML Attributes',
      advanced_html_tags: 'Advanced HTML Tags',
      advanced_strings: 'Advanced Strings', // Rest of concepts are deprecated
      advanced_web_scripting: 'Advanced Web Scripting',
      algorithms: 'Algorithms',
      algorithm_average: 'Algorithm Average',
      algorithm_find_minmax: 'Algorithm Find Min/Max',
      algorithm_search_binary: 'Algorithm Search Binary',
      algorithm_search_graph: 'Algorithm Search Graph',
      algorithm_sort: 'Algorithm Sort',
      algorithm_sum: 'Algorithm Sum',
      alter_existing_web_pages: 'Alter existing web pages',
      arguments: 'Arguments',
      arithmetic: 'Arithmetic',
      array_2d: '2D Array',
      array_index: 'Array Indexing',
      array_iterating: 'Iterating Over Arrays',
      array_literals: 'Array Literals',
      array_searching: 'Array Searching',
      array_sorting: 'Array Sorting',
      arrays: 'Arrays',
      basic_css: 'Basic CSS',
      basic_css_rules: 'Basic CSS rules',
      basic_css_selectors: 'Basic CSS selectors',
      basic_event_handling: 'Basic Event Handling',
      basic_game_ai: 'Basic Game AI',
      basic_html: 'Basic HTML',
      basic_html_attributes: 'Basic HTML Attributes',
      basic_html_tags: 'Basic HTML Tags',
      basic_input_handling: 'Basic Input Handling',
      basic_javascript: 'Basic JavaScript',
      basic_syntax: 'Basic Syntax',
      basic_web_scripting: 'Basic Web Scripting',
      binary: 'Binary',
      boolean_and: 'Boolean And',
      boolean_equality: 'Boolean Equality',
      boolean_greater_less: 'Boolean Greater/Less',
      boolean_inequality: 'Boolean Inequality',
      boolean_logic: 'Boolean Logic',
      boolean_logic_shortcircuit: 'Boolean Logic Shortcircuiting',
      boolean_not: 'Boolean Not',
      boolean_operator_precedence: 'Boolean Operator Precedence',
      boolean_or: 'Boolean Or',
      boolean_with_xycoordinates: 'Coordinate Comparison',
      bootstrap: 'Bootstrap',
      break_statements: 'Break Statements',
      classes: 'Classes',
      comparators: 'Comparators',
      compound_conditionals: 'Compound Conditionals',
      conditionals: 'Conditionals',
      construct_mazes: 'Construct mazes',
      continue_statements: 'Continue Statements',
      create_playable_game: 'Create a playable, sharable game project',
      create_sharable_interactive_web_page: 'Create a sharable interactive web page',
      create_sharable_web_page: 'Create a sharable web page',
      data_and_analysis: 'Data & Analysis',
      data_types: 'Data Types',
      debugging: 'Debugging',
      dom_events: 'DOM Events',
      dynamic_styling: 'Dynamic Styling',
      events: 'Events',
      event_concurrency: 'Event Concurrency',
      event_data: 'Event Data',
      event_handlers: 'Event Handlers',
      event_spawn: 'Spawn Event',
      for_loops: 'For Loops',
      for_loops_nested: 'Nested For Loops',
      for_loops_range: 'For Loops Range',
      functions: 'Functions',
      functions_parameters: 'Parameters',
      functions_multiple_parameters: 'Multiple Parameters',
      game_ai: 'Game AI',
      game_design: 'Game Design',
      game_goals: 'Game Goals',
      game_spawn: 'Game Spawn',
      graphics: 'Graphics',
      graphs: 'Graphs',
      heaps: 'Heaps',
      if_condition: 'Conditional If Statements',
      if_else_if: 'If/Else If Statements',
      if_else_statements: 'If/Else Statements',
      if_statements: 'If Statements',
      if_statements_nested: 'Nested If Statements',
      indexing: 'Array Indexes',
      input_handling: 'Input Handling',
      input_handling_flags: 'Input Handling - Flags',
      input_handling_keyboard: 'Input Handling - Keyboard',
      input_handling_mouse: 'Input Handling - Mouse',
      intermediate_css: 'Intermediate CSS',
      intermediate_css_rules: 'Intermediate CSS Rules',
      intermediate_css_selectors: 'Intermediate CSS Selectors',
      intermediate_html: 'Intermediate HTML',
      intermediate_html_attributes: 'Intermediate HTML Attributes',
      intermediate_html_tags: 'Intermediate HTML Tags',
      intermediate_web_scripting: 'Intermediate Web Scripting',
      iteration: 'Iteration',
      jquery: 'jQuery',
      jquery_animations: 'jQuery Animations',
      jquery_filtering: 'jQuery Element Filtering',
      jquery_selectors: 'jQuery Selectors',
      length: 'Array Length',
      loops: 'Loops',
      math_coordinates: 'Coordinate Math',
      math_geometry: 'Geometry',
      math_operations: 'Math Library Operations',
      math_proportions: 'Proportion Math',
      math_trigonometry: 'Trigonometry',
      methods: 'Methods',
      nesting: 'Nesting',
      objects: 'Objects',
      object_literals: 'Object Literals',
      parameters: 'Parameters',
      place_game_objects: 'Place game objects',
      problem_solving: 'Problem Solving',
      programs: 'Programs',
      properties: 'Properties',
      property_access: 'Accessing Properties',
      property_assignment: 'Assigning Properties',
      property_coordinate: 'Coordinate Property',
      queues: 'Data Structures - Queues',
      reading_docs: 'Reading the Docs',
      recursion: 'Recursion',
      return_statements: 'Return Statements',
      sequences_algorithms: 'Sequences & Algorithms',
      stacks: 'Data Structures - Stacks',
      strings: 'Strings',
      strings_concatenation: 'String Concatenation',
      strings_substrings: 'Substring',
      student_code: 'Student Code',
      syntax: 'Syntax',
      trees: 'Data Structures - Trees',
      variables: 'Variables',
      vectors: 'Vectors',
      while_condition_loops: 'While Loops with Conditionals',
      while_loops: 'While Loops',
      while_loops_simple: 'While Loops',
      while_loops_nested: 'Nested While Loops',
      xy_coordinates: 'Coordinate Pairs',
    },

    anonymous_teacher: {
      notify_teacher: 'Notify Teacher',
      create_teacher_account: 'Create free teacher account',
      enter_student_name: 'Your name:',
      enter_teacher_email: "Your teacher's email:",
      teacher_email_placeholder: 'teacher.email@example.com',
      student_name_placeholder: 'type your name here',
      teachers_section: 'Teachers:',
      students_section: 'Students:',
      teacher_notified: "We've notified your teacher that you want to play more CodeCombat in your classroom!",
    },

    delta: {
      added: 'Added',
      modified: 'Modified',
      not_modified: 'Not Modified',
      deleted: 'Deleted',
      moved_index: 'Moved Index',
      text_diff: 'Text Diff',
      merge_conflict_with: 'MERGE CONFLICT WITH',
      no_changes: 'No Changes',
    },

    legal: {
      page_title: 'Legal',
      opensource_introduction: 'CodeCombat is part of the open source community.',
      opensource_description_prefix: 'Check out ',
      github_url: 'our GitHub',
      opensource_description_center: 'and help out if you like! CodeCombat is built on dozens of open source projects, and we love them. See ',
      archmage_wiki_url: 'our Archmage wiki',
      opensource_description_suffix: 'for a list of the software that makes this game possible.',
      practices_title: 'Respectful Best Practices',
      practices_description: 'These are our promises to you, the player, in slightly less legalese.',
      privacy_title: 'Privacy',
      privacy_description: 'We will not sell any of your personal information.',
      security_title: 'Security',
      security_description: 'We strive to keep your personal information safe. As an open source project, our site is freely open to anyone to review and improve our security systems.',
      email_title: 'Email',
      email_description_prefix: 'We will not inundate you with spam. Through',
      email_settings_url: 'your email settings',
      email_description_suffix: 'or through links in the emails we send, you can change your preferences and easily unsubscribe at any time.',
      cost_title: 'Cost',
      cost_description: 'CodeCombat is free to play for its introductory levels, with a $__price__ USD/mo subscription for access to extra levels and __gems__ bonus gems per month. You can cancel with a click, and we offer a 100% money-back guarantee.',
      copyrights_title: 'Copyrights and Licenses',
      contributor_title: 'Contributor License Agreement',
      contributor_description_prefix: 'All contributions, both on the site and on our GitHub repository, are subject to our',
      cla_url: 'CLA',
      contributor_description_suffix: 'to which you should agree before contributing.',
      code_title: 'Client-Side Code - MIT',
      client_code_description_prefix: 'All client-side code for codecombat.com in the public GitHub repository and in the codecombat.com database, is licensed under the',
      mit_license_url: 'MIT license',
      code_description_suffix: 'This includes all code in Systems and Components that are made available by CodeCombat for the purpose of creating levels.',
      art_title: 'Art/Music - Creative Commons ',
      art_description_prefix: 'All common content is available under the',
      cc_license_url: 'Creative Commons Attribution 4.0 International License',
      art_description_suffix: 'Common content is anything made generally available by CodeCombat for the purpose of creating Levels. This includes:',
      art_music: 'Music',
      art_sound: 'Sound',
      art_artwork: 'Artwork',
      art_sprites: 'Sprites',
      art_other: 'Any and all other non-code creative works that are made available when creating Levels.',
      art_access: 'Currently there is no universal, easy system for fetching these assets. In general, fetch them from the URLs as used by the site, contact us for assistance, or help us in extending the site to make these assets more easily accessible.',
      art_paragraph_1: 'For attribution, please name and link to codecombat.com near where the source is used or where appropriate for the medium. For example:',
      use_list_1: 'If used in a movie or another game, include codecombat.com in the credits.',
      use_list_2: "If used on a website, include a link near the usage, for example underneath an image, or in a general attributions page where you might also mention other Creative Commons works and open source software being used on the site. Something that's already clearly referencing CodeCombat, such as a blog post mentioning CodeCombat, does not need some separate attribution.",
      art_paragraph_2: "If the content being used is created not by CodeCombat but instead by a user of codecombat.com, attribute them instead, and follow attribution directions provided in that resource's description if there are any.",
      rights_title: 'Rights Reserved',
      rights_desc: 'All rights are reserved for Levels themselves. This includes',
      rights_scripts: 'Scripts',
      rights_unit: 'Unit configuration',
      rights_writings: 'Writings',
      rights_media: 'Media (sounds, music) and any other creative content made specifically for that Level and not made generally available when creating Levels.',
      rights_clarification: 'To clarify, anything that is made available in the Level Editor for the purpose of making levels is under CC, whereas the content created with the Level Editor or uploaded in the course of creation of Levels is not.',
      nutshell_title: 'In a Nutshell',
      nutshell_description: 'Any resources we provide in the Level Editor are free to use as you like for creating Levels. But we reserve the right to restrict distribution of the Levels themselves (that are created on codecombat.com) so that they may be charged for.',
      nutshell_see_also: 'See also:',
      canonical: 'The English version of this document is the definitive, canonical version. If there are any discrepancies between translations, the English document takes precedence.',
      third_party_title: 'Third Party Services',
      third_party_description: 'CodeCombat uses the following third party services (among others):',
      cookies_message: 'CodeCombat uses a few essential and non-essential cookies.',
      cookies_deny: 'Decline non-essential cookies',
      cookies_allow: 'Allow cookies',
    },

    ladder_prizes: {
      title: 'Tournament Prizes', // This section was for an old tournament and doesn't need new translations now.
      blurb_1: 'These prizes will be awarded according to',
      blurb_2: 'the tournament rules',
      blurb_3: 'to the top human and ogre players.',
      blurb_4: 'Two teams means double the prizes!',
      blurb_5: '(There will be two first place winners, two second-place winners, etc.)',
      rank: 'Rank',
      prizes: 'Prizes',
      total_value: 'Total Value',
      in_cash: 'in cash',
      custom_wizard: 'Custom CodeCombat Wizard',
      custom_avatar: 'Custom CodeCombat avatar',
      heap: 'for six months of "Startup" access',
      credits: 'credits',
      one_month_coupon: 'coupon: choose either Rails or HTML',
      one_month_discount: 'discount, 30% off: choose either Rails or HTML',
      license: 'license',
      oreilly: 'ebook of your choice',
    },

    calendar: {
      year: 'Year',
      day: 'Day',
      month: 'Month',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },

    code_play_create_account_modal: {
      title: 'You did it!', // This section is only needed in US, UK, Mexico, India, and Germany
      body: 'You are now on your way to becoming a master coder. Sign up to receive an extra <strong>100 Gems</strong> & you will also be entered for a chance to <strong>win $2,500 & other Lenovo Prizes</strong>.',
      sign_up: 'Sign up & keep coding ▶',
      victory_sign_up_poke: 'Create a free account to save your code & be entered for a chance to win prizes!',
      victory_sign_up: 'Sign up & be entered to <strong>win $2,500</strong>',
    },

    server_error: {
      email_taken: 'Email already taken',
      username_taken: 'Username already taken',
      easy_password: 'Password is too easy to guess',
      reused_password: 'Password cannot be reused',
    },

    esper: {
      line_no: 'Line $1: ',
      uncaught: 'Uncaught $1', // $1 will be an error type, eg "Uncaught SyntaxError"
      reference_error: 'ReferenceError: ',
      argument_error: 'ArgumentError: ',
      type_error: 'TypeError: ',
      syntax_error: 'SyntaxError: ',
      error: 'Error: ',
      x_not_a_function: '`$1` is not a function',
      x_not_defined: '`$1` is not defined',
      spelling_issues: 'Look out for spelling issues: did you mean `$1` instead of `$2`?',
      capitalization_issues: 'Look out for capitalization: `$1` should be `$2`.',
      py_empty_block: 'Empty $1. Put 4 spaces in front of statements inside the $2 statement.',
      fx_missing_paren: "If you want to call `$1` as a function, you need `()`'s",
      unmatched_token: 'Unmatched `$1`.  Every opening `$2` needs a closing `$3` to match it.',
      unterminated_string: 'Unterminated string. Add a matching `"` at the end of your string.',
      missing_semicolon: 'Missing semicolon.',
      missing_quotes: 'Missing quotes. Try `$1`',
      argument_type: "`$1`'s argument `$2` should have type `$3`, but got `$4`: `$5`.",
      argument_type2: "`$1`'s argument `$2` should have type `$3`, but got `$4`.",
      target_a_unit: 'Target a unit.',
      attack_capitalization: 'Attack `$1`, not `$2`. (Capital letters are important.)',
      empty_while: 'Empty while statement. Put 4 spaces in front of statements inside the while statement.',
      line_of_site: "`$1`'s argument `$2` has a problem. Is there an enemy within your line-of-sight yet?",
      need_a_after_while: 'Need a `$1` after `$2`.',
      too_much_indentation: 'Too much indentation at the beginning of this line.',
      missing_hero: 'Missing `$1` keyword; should be `$2`.',
      takes_no_arguments: '`$1` takes no arguments.',
      no_one_named: "There's no one named `\"$1\"` to target.",
      separated_by_comma: 'Function calls paramaters must be seperated by `,`s',
      protected_property: "Can't read protected property: $1",
      need_parens_to_call: "If you want to call `$1` as function, you need `()`'s",
      expected_an_identifier: "Expected an identifier and instead saw '$1'.",
      unexpected_identifier: 'Unexpected identifier',
      unexpected_end_of: 'Unexpected end of input',
      unnecessary_semicolon: 'Unnecessary semicolon.',
      unexpected_token_expected: 'Unexpected token: expected `$1` but found `$2` while parsing `$3`',
      unexpected_token: 'Unexpected token $1',
      unexpected_token2: 'Unexpected token',
      unexpected_number: 'Unexpected number',
      unexpected: "Unexpected '$1'.",
      escape_pressed_code: 'Escape pressed; code aborted.',
      target_an_enemy: 'Target an enemy by name, like `$1`, not the string `$2`.',
      target_an_enemy_2: 'Target an enemy by name, like `$1`.',
      cannot_read_property: 'Cannot read property `$1` of `undefined`',
      attempted_to_assign: 'Attempted to assign to readonly property.',
      unexpected_early_end: 'Unexpected early end of program.',
      you_need_a_string: 'You need a string to build; one of `$1`',
      unable_to_get_property: "Unable to get property '$1' of undefined or null reference", // TODO: Do we translate undefined/null?
      code_never_finished_its: "Code never finished. It's either really slow or has an infinite loop.",
      unclosed_string: 'Unclosed string.',
      unmatched: 'Unmatched `$1`.',
      error_you_said_achoo: 'You said: `$1`, but the password is: `$2`. (Capital letters are important.)',
      indentation_error_unindent_does: 'Indentation Error: unindent does not match any outer indentation level',
      indentation_error: 'Indentation error.',
      need_a_on_the: 'Need a `:` on the end of the line following `$1`.',
      attempt_to_call_undefined: 'attempt to call `$1` (a nil value)',
      unterminated: 'Unterminated `$1`',
      target_an_enemy_variable: 'Target an `$1` variable, not the string `$2`. (Try using `$3`.)',
      error_use_the_variable: 'Use the variable name like `$1` instead of a string like `$2`',
      indentation_unindent_does_not: 'Indentation unindent does not match any outer indentation level',
      unclosed_paren_in_function_arguments: 'Unclosed `$1` in function arguments.',
      unexpected_end_of_input: 'Unexpected end of input',
      there_is_no_enemy: 'There is no `$1`. Use `$2` first.', // Hints start here
      try_herofindnearestenemy: 'Try `$1`',
      there_is_no_function: 'There is no function `$1`, but `$2` has a method `$3`.',
      attacks_argument_enemy_has: "`$1`'s argument `$2` has a problem.",
      is_there_an_enemy: 'Is there an enemy within your line-of-sight yet?',
      target_is_null_is: 'Target is `$1`. Is there always a target to attack? (Use `$2`?)',
      hero_has_no_method: '`$1` has no method `$2`.',
      there_is_a_problem: 'There is a problem with your code.',
      did_you_mean: 'Did you mean `$1`? You do not have an item equipped with that skill.',
      missing_a_quotation_mark: 'Missing a quotation mark. ',
      missing_var_use_var: 'Missing `$1`. Use `$2` to make a new variable.',
      you_do_not_have: 'You do not have an item equipped with the `$1` skill.',
      put_each_command_on: 'Put each command on a separate line',
      are_you_missing_a: 'Are you missing a `$1` after `$2`? ',
      your_parentheses_must_match: 'Your parentheses must match.',
      missing_parentheses: 'Missing parentheses? Try `__suggestion__`',
      do_nothing_without_parentheses: "`__code__` doesn't do anything without `()`",
      error_index_empty: 'Cannot read property `__name__` of `__specTypeName__`',
      error_call_non_function: '`__name__` is not a function.',
      error_not_iterable: '`__var__` is not iterable.',
      error_assignment_invalid: 'Invalid reference in assignment.',
      error_invalid_array_length: 'Invalid array length.',
      error_didnt_make_generator: "`__name__` didn't make a generator.",
      error_undefined_variable: '`__name__` is not defined.',
      error_declared_identifier: 'Identifier `__name__` has already been declared.',
      error_declarations_cant_resolve: "Couldn't resolve declarations component: `__type__`.",
      error_strict_no_statement: 'Strict mode code may not include a `with` statement.',
      error_cant_resolve_ref_component: "Couldn't resolve ref component: `__type__`.",
      error_cant_convert_null: 'Cannot convert `undefined` or `null` to object.',
      error_need_object: 'Need an object.',
      error_illegal_object_prototype: 'Object prototype may only be an `Object` or `null`.',
      error_no_prototype: 'No prototype.',
      error_cant_write_property_to_undefined: "Can't write property of `undefined`: `__idx__`.",
      error_cant_write_property_to_non_obj: "Can't write property of non-object type: `__idx__`.",
      error_function_isnt_constructor: 'function is not a constructor',
      error_write_protected_property: "Can't write to protected property: `__name__`",
      error_read_protected_property: "Can't read protected property: `__name__`",
      error_convert_value_failed: 'Cannot convert `__orig__` value to `__new__` value.',
      error_convert_object_to_primitive: 'Cannot convert object to primitive value.',
      error_first_argument_to_be_function: 'First argument to `__fun__` must be a function.',
      error_write_non_writable: "Can't write to non-writable value.",
      error_delete_nonconfigurable_object: "Can't delete non configurable object.",
      error_cant_access_get: "Can't access get `__name__` of that type.",
      error_base_obj_not_invokable: 'Base object not invokable.',
      error_arg2_not_callable: 'Arg2 not callable.',
      error_reduce_empty_array_without_init: 'Reduce an empty array with no initial value.',
      error_realm_prototype_not_realm: 'Realm prototype not realm.',
      error_function_tostring_not_generic: 'Function.prototype.toString is not generic',
      error_regex_on_non_regex: 'Calling regex method on non regex.',
      error_call_string_on_null: 'called String function on null or undefined?',
      error_wrong_type: 'Wrong Type.',
      error_replace_callback_not_written: 'Replace with callbacks not written yet',
      error_right_hand_side_not_callable: 'Right-hand side of `__name__` is not callable',
      error_segmentation_fault: 'Segmentation Fault `__offset__`.',
      error_no_arg_to_reference: 'No argument to reference.',
      error_unimplemented_property: 'Unimplemented property type.',
      error_unimplemented: 'Unimplemented.',
      error_cant_call_reference: "Can't call reference like that.",
      error_no_arg_to_dereference: 'No argument to dereference.',
      error_try_dereference_non: 'Tried to dereference non pointer.',
      error_no_arg_to_alloc: 'No argument to alloc.',
    },

    apcsp: {
      title: 'AP Computer Science Principals | College Board Endorsed',
      meta_description: 'CodeCombat’s comprehensive curriculum and professional development program are all you need to offer College Board’s newest computer science course to your students.',
      syllabus: 'AP CS Principles Syllabus',
      syllabus_description: 'Use this resource to plan CodeCombat curriculum for your AP Computer Science Principles class.',
      computational_thinking_practices: 'Computational Thinking Practices',
      learning_objectives: 'Learning Objectives',
      curricular_requirements: 'Curricular Requirements',
      unit_1: 'Unit 1: Creative Technology',
      unit_1_activity_1: 'Unit 1 Activity: Technology Usability Review',
      unit_2: 'Unit 2: Computational Thinking',
      unit_2_activity_1: 'Unit 2 Activity: Binary Sequences',
      unit_2_activity_2: 'Unit 2 Activity: Computing Lesson Project',
      unit_3: 'Unit 3: Algorithms',
      unit_3_activity_1: "Unit 3 Activity: Algorithms - Hitchhiker's Guide",
      unit_3_activity_2: 'Unit 3 Activity: Simulation - Predator & Prey',
      unit_3_activity_3: 'Unit 3 Activity: Algorithms - Pair Design and Programming',
      unit_4: 'Unit 4: Programming',
      unit_4_activity_1: 'Unit 4 Activity: Abstractions',
      unit_4_activity_2: 'Unit 4 Activity: Searching & Sorting',
      unit_4_activity_3: 'Unit 4 Activity: Refactoring',
      unit_5: 'Unit 5: The Internet',
      unit_5_activity_1: 'Unit 5 Activity: How the Internet Works',
      unit_5_activity_2: 'Unit 5 Activity: Internet Simulator',
      unit_5_activity_3: 'Unit 5 Activity: Chat Room Simulation',
      unit_5_activity_4: 'Unit 5 Activity: Cybersecurity',
      unit_6: 'Unit 6: Data',
      unit_6_activity_1: 'Unit 6 Activity: Introduction to Data',
      unit_6_activity_2: 'Unit 6 Activity: Big Data',
      unit_6_activity_3: 'Unit 6 Activity: Lossy & Lossless Compression',
      unit_7: 'Unit 7: Personal & Global Impact',
      unit_7_activity_1: 'Unit 7 Activity: Personal & Global Impact',
      unit_7_activity_2: 'Unit 7 Activity: Crowdsourcing',
      unit_8: 'Unit 8: Performance Tasks',
      unit_8_description: 'Prepare students for the Create Task by building their own games and practicing key concepts.',
      unit_8_activity_1: 'Create Task Practice 1: Game Development 1',
      unit_8_activity_2: 'Create Task Practice 2: Game Development 2',
      unit_8_activity_3: 'Create Task Practice 3: Game Development 3',
      unit_9: 'Unit 9: AP Review',
      unit_10: 'Unit 10: Post-AP',
      unit_10_activity_1: 'Unit 10 Activity: Web Quiz',
    },

    apcsp_marketing: {
      course_outline_unit_1: 'Unit 1',
      course_outline_unit_2: 'Unit 2',
      course_outline_unit_3: 'Unit 3',
      course_outline_unit_4: 'Unit 4',
      course_outline_unit_5: 'Unit 5',
      course_outline_unit_6: 'Unit 6',
      course_outline_unit_7: 'Unit 7',
      course_outline_unit_8: 'Unit 8',
      course_outline_unit_9: 'Unit 9',
      course_outline_course_1: 'Computer Science 1',
      course_outline_course_2: 'Computer Science 2',
      course_outline_course_3: 'Computer Science 3',
      course_outline_course_4: 'Computer Science 4',
      course_outline_course_5: 'Creative Development',
      course_outline_course_6: 'Data',
      course_outline_course_7: 'Computer Systems and Networks',
      course_outline_course_8: 'Impact of Computing',
      course_outline_course_9: 'Exam Prep',
      course_outline_description_1: 'Students begin the course focusing on creativity, problem solving, and the basic syntax of Python.',
      course_outline_description_2: 'Students focus on designing and implementing algorithms using the building blocks of Python.',
      course_outline_description_3: 'Students explore the concept of abstraction by developing their own abstractions inside program code.',
      course_outline_description_4: 'Students apply their understanding of problem solving, algorithms, and abstractions to design and implement digital games.',
      course_outline_description_5: 'Students use all that they have learned about Python to complete and submit their Create Performance Task.',
      course_outline_description_6: 'Students learn how computers consume, transform, store, and produce new information in order to solve problems.',
      course_outline_description_7: 'Students experience the power of sharing information via computer networks by learning about the Internet.',
      course_outline_description_8: 'Students examine how computing has revolutionized our lives and society.',
      course_outline_description_9: 'Students prepare to take the multiple choice section of the AP CSP exam.',
      icons_coding_levels: '150+ CodeCombat Coding Levels',
      icons_lesson_slides: '60+ Turnkey Lesson Slides',
      icons_kahoot: '400+ Kahoot! Quiz Questions',
      icons_classroom_instructions: '100+ Hours of Classroom Instruction',
      icons_weeks_of_curriculum: '26 Weeks of Curriculum',
      icons_project_activities: '25+ Project-Based Activities',
      icons_game_learning: 'Game-Based Learning',
      icons_text_coding: 'Text-Based Coding',
      icons_chromebook_compatible: 'Chromebook Compatible',
      icons_standards_aligned: 'Standards-Aligned Lessons',
      page_title: 'AP Computer Science Principles',
      page_description: 'Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.',
      page_description_endorsed: 'Endorsed by the College Board, our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.',
      request_access: 'Request Access',
      game_based_learning: 'Game-Based Learning',
      game_based_learning_description: 'Our innovative game-based learning technology has transformed the way students prepare for the AP CSP exam. Through our browser-based games, students learn about important exam topics while exercising the critical thinking skills that are necessary for success on the exam.',
      fostering_confidence: 'Fostering Confidence in the AP Exam',
      fostering_confidence_description: 'With our curriculum, students will practice every stage of the Create Task through scaffolded and approachable capstone projects that can be adapted to a wide variety of student needs. We also provide curriculum and Kahoot! quizzes for students to practice multiple choice exam questions.',
      accessible_real_world: 'Accessible & Real-World Connections',
      accessible_real_world_description: 'For Data, Impacts of Computing, and additional Big Ideas, our turnkey lesson slides help students explore these topics through meaningful discussions and collaborative projects. Filled with real-world connections, our curriculum will allow students to fully understand how coding affects their everyday lives.',
      college_board: 'The College Board is currently reviewing our curriculum with an expected endorsement in March 2023.',
      our_curriculum_offers: 'Our curriculum offers engaging features so that students explore and learn Computer Science through...',
      course_outline: 'Course Outline',
      course_outline_description: 'The following descriptions are an overview of the content explored in the CodeCombat AP CSP course.',
      explore_our_curriculum: 'Explore Our Curriculum',
      syllabus: 'Syllabus',
      pacing_guide: 'Pacing Guide',
      flyer: 'Flyer',
      sample_lesson_slides: 'Browse through our sample lesson slides',
      introduction_to_cs: 'Introduction to Computer Science',
      introduction_to_cs_description: 'Syntax and Sequences',
      big_ideas: 'Big Ideas: Computer Systems and Networks',
      big_ideas_description: 'The Internet (Overview)',
      get_full_course: 'Get the full course here',
      professional_development: 'Professional Development',
      professional_development_description: 'CodeCombat offers an online, self-paced professional development course for educators of all levels of AP CSP expertise. Participants will explore the CodeCombat curriculum and learn how it can be used to prepare students to succeed on the AP CSP exam. Through asynchronous discussions with fellow teachers and video conferences with CodeCombat learning designers, you will be equipped with the tools and techniques you need to support all of your students in AP CSP. At the end of the course, you will earn a Certificate of Completion that can be used for the renewal of your teaching credential.',
      more_information: 'For More Information',
      contact_us: 'Contact Us',
      question_1: 'How can I learn more about the AP CSP Course?',
      answer_1: 'You can check out the College Board’s AP Computer Science Principles __course_overview__ and also explore the __outcomes__ for this course.',
      question_2: 'What are the technology requirements for CodeCombat’s AP CSP curriculum?',
      answer_2: 'We recommend at least 4GB of RAM and using a modern browser such as Chrome, Safari, Firefox, or Edge. For additional specifics, please visit __coco_requirements__.',
      question_3: 'What is the format of our lesson plans and lesson slides?',
      answer_3: 'All of our lesson slides are in the format of Google Slides and our lesson plans are in the format of Google Docs. These formats allow you to make copies of our curriculum so that you can adapt them to the needs of your students. Lesson slides and lesson plans can also be downloaded as Microsoft® PowerPoint and Word files.',
      course_overview: 'Course Overview',
      outcomes: 'outcomes',
      coco_requirements: 'CodeCombat’s system requirements',
      coco_recognized_blurb: 'CodeCombat is recognized by College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). This endorsement affirms that CodeCombat’s curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment. This affords schools access to resources including an AP CSP syllabus pre-approved by the College Board’s Course Audit, and officially recognized professional development that prepares teachers to teach this curriculum.',
      ap_csp_portal: 'AP CSP Portal',
    },

    apcsp_curriculum: {
      access_syllabus: 'Access our College Board approved __syllabus__',
      college_board_approved_syllabus: 'Syllabus',
      access_pacing_guide: 'Review our suggested __pacing_guide__',
      pacing_guide: 'Pacing Guide',
      resources: 'Professional Development Resources',
      professional_development_description: 'CodeCombat offers an online, self-paced professional development course for educators of all levels of AP CSP expertise. Participants will explore the CodeCombat curriculum and learn how it can be used to prepare students to succeed on the AP CSP exam. Through asynchronous discussions with fellow teachers and video conferences with CodeCombat curriculum developers, you will be equipped with the tools and techniques you need to support all of your students in AP CSP. At the end of the course, you will earn a Certificate of Completion that can be used for the renewal of your teaching credential. We offer our Curriculum on __edapp__.',
      contact: 'Contact __apcsp_email__ to get access.',
      role: 'Role',
      location: 'Location',
      state_and_country: 'state and country',
      no_license: "Our AP CSP curriculum requires a paid license to view. Learn more about CodeCombat's AP CSP curriculum by visiting our About page, linked below.",
      request_license: 'Join Pilot Program',
      page_title: 'AP Computer Science Principles Curriculum',
      explore_each_unit: 'Explore each unit, including <br> <strong>lesson plans</strong> and <strong>lesson slides</strong>',
      about_apcsp_curriculum: 'About AP CSP Curriculum',
      step_1_title: 'Get Started Today',
      step_1_subtitle: 'Upload CodeCombat’s AP CSP syllabus to College Board’s Course Audit.',
      step_1_button_1: 'View the Syllabus',
      step_1_button_2: 'Complete the Audit',
      join_the_community: 'Join the AP Community',
      ap_teachers: 'Teacher Central',
      ap_classroom: 'AP Classroom',
      slack: 'AP Workspace',
      join: 'Join',
    },

    hoc_2019: {
      heading: 'Hour of Code',
      start: 'Start Your Journey',
      create_a_class: "Create a class to track your students' progress and ensure their hour of code games are saved!",
      choose_language: '1. CHOOSE LANGUAGE',
      programming_language: 'Language',
      sign_up: '2. SIGN UP',
      already_have_account: 'Already have a CodeCombat or Ozaria account? Login.',
      download_lesson_plan: 'Download Lesson Plan',
      try_activity_without_class: 'Try activity without creating a class',
      invite_students: 'Invite Students to Your Class By Sending Them',
      class_code: 'CLASS CODE',
      enter_code: 'Students can enter this code at www.ozaria.com/hoc',
      class_url: 'CLASS URL',
      share_url: 'Share URL to have students automatically join your class.',
      start_activity: 'Start Activity',
      save_progress_modal: 'Save your progress and keep playing later',
      want_to_save: 'Want to save your Hour of Code progress?',
      ask_teacher_class_code: 'Ask your teacher for your Class Code',
      dont_have: "I don't have one, but want to Try the Activity!",
      hoc_activity: 'Hour of Code Activity',
      save_progress: 'Save Progress',
      err_google_exists: "An account already exists for the Google account you've selected. Please choose another Google account or sign up with a username and password.",
      err_username_taken: "An account already exists for the username you've entered. Please choose another username.",
      enter_it_here: 'Enter it here to save your progress as you play:',
      have_a_class_code: 'Have a class code?',
      create_class_and_try_activity: 'Create Class and Try Activity',
    },

    parents_landing_1: {
      online_coding_classes: 'Live Online Coding Classes',
      powered_by_play: 'Powered by Play',
      partnership: 'in partnership with',
      kids_message: 'Kids: show this to your parents to get your free coding class and premium heroes!',
      codecombat_intro: 'CodeCombat combines the power of gameplay and personalized instruction to deliver online coding classes that your child will look forward to every week!',
      remote_learning_works: 'Remote Learning That Works',
      invest_in_future: 'Invest in Your Child’s Future While They Have Fun!',
      personalized_learning_header: 'Personalized Learning',
      personalized_learning_details: 'Our dedicated teachers offer individualized attention through a structured curriculum.  Your child will become a confident life-long coder as they conquer challenges and celebrate successes together!',
      power_of_play_header: 'The Power of Play',
      power_of_play_details: 'Our students type real Python and JavaScript while playing a game from beginning to end! Our engaging curriculum ensures that you’ll never have to force your child to show up to class. We promise.',
      early_coding_exposure: 'Early Exposure to Coding',
      early_coding_exposure_details: 'Coding is a highly sought-after job skill, and this demand will only grow. Exposing your child to coding at an early age increases the chance that they’ll pursue Computer Science later in life.',
      quote_1: 'Even though the class starts every Saturday at 7am, my son is so excited that he wakes up before me! CodeCombat creates a pathway for my son to advance his coding skills.',
      parent_name: 'Latthaphon Pohpon, Parent',
      course_offering: 'Course Offerings',
      flexible_scheduling: 'With individual or small group class options and flexible scheduling available, this is the easiest way to get started in computer science.',
      private_instructions: 'All classes feature private, individualized instruction. To enroll a group of students, contact <a href="mailto:classes@codecombat.com">classes@codecombat.com</a> for a custom plan.',
      most_popular: 'Most popular',
      best_value: 'Best Value',
      self_paced: 'Self-Paced',
      private: 'Private',
      subscription_plan: 'Subscription plan',
      per_year: 'per year',
      price_per_year_1: '$219 per month',
      price_per_year_2: '$399 per month',
      not_available: 'N/A',
      one_to_one: '1:1',
      private_sessions_1: '1 private session per week',
      private_sessions_2: '2 private sessions per week',
      benefit_1: '60-minute sessions via Zoom',
      benefit_2: 'Student to Instructor Ratio',
      benefit_3: 'CodeCombat premium license included',
      benefit_4: 'Immediate and personalized feedback',
      benefit_5: 'Bonus activities, rewards, and course completion certificates',
      benefit_6: 'End of course projects that demonstrate concepts learned',
      benefit_7: 'Monthly progress updates from instructor',
      benefit_8: "Flexible schedule adapted to each student's learning needs",
      benefit_9: '1:1 support in tackling difficult coding concepts',
      benefit_10: 'Automatic qualification into AI League coding tournaments',
      subscription_details: 'All subscriptions are billed on a monthly basis and may be paused, cancelled, or resumed with no fees. Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply <a href="mailto:classes@codecombat.com">contact us</a> within 30 days of purchase and we will promptly refund 100% of your payment, no questions asked. All plans are automatically renewed at the same level and billing cycle unless otherwise changed or canceled.',
      curriculum: 'Our Curriculum',
      curriculum_description: 'Trusted by over 140,000 educators worldwide, our scaffolded curriculum is critical to helping students persevere. Our students type real code from the start, become more confident with each class, and learn how Computer Science is relevant to their daily lives.',
      student_outcomes: 'Student Outcomes',
      grit_header: 'Grit',
      grit_description: 'CodeCombat challenges students to embrace and learn from their mistakes. Built-in hints help students identify and fix bugs, leading to greater coding confidence.',
      problem_solving_header: 'Problem Solving Skills',
      problem_solving_description: 'Through an iterative problem solving process, our students solve coding challenges and flex their creativity to build their own games, websites, and apps for end-of-course projects.',
      technological_literacy: 'Technological Literacy',
      technological_literacy_description: 'Students gain a deep understanding of Computer Science and technological literacy skills that will transfer to other disciplines as well as future careers.',
      concepts_covered: 'Concepts Covered',
      beginner: 'Beginner',
      beginner_description: 'For students with little to no text-based coding experience.',
      beginner_concepts_1: 'Sequences',
      beginner_concepts_2: 'Algorithms',
      beginner_concepts_3: 'Syntax',
      beginner_concepts_4: 'Strings',
      beginner_concepts_5: 'Arguments',
      beginner_concepts_6: 'Loops',
      beginner_concepts_7: 'Variables',
      beginner_concepts_8: 'Cartesian coordinates',
      intermediate_header: 'Intermediate',
      itermediate_details: 'For students with some text-based coding experience.',
      intermediate_concepts_1: 'Boolean logic',
      intermediate_concepts_2: 'Properties',
      intermediate_concepts_3: 'Advanced loops',
      intermediate_concepts_4: 'Conditionals',
      intermediate_concepts_5: 'Nested conditionals',
      intermediate_concepts_6: 'Functions',
      intermediate_concepts_7: 'Events',
      intermediate_concepts_8: 'Basic game AI',
      advanced_header: 'Advanced',
      advanced_details: 'For students with substantial experience in text-based code and a good grasp of complex concepts.',
      advanced_concepts_1: 'Advanced strings',
      advanced_concepts_2: 'Computer arithmetic',
      advanced_concepts_3: 'Functions with returns',
      advanced_concepts_4: 'Complex conditionals',
      advanced_concepts_5: 'Arrays',
      advanced_concepts_6: 'Break/continue statements',
      advanced_concepts_7: 'Recursion',
      advanced_concepts_8: 'Stacks and Queues',
      ai_hints: 'AI Hints',
      ai_hints_details: 'Our instructors offer the guidance and support your child needs, but can’t always be there. That’s where our innovative AI hints feature helps the learning continue between sessions. This support feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available students will still need to work through each level\'s coding challenge. Subscribers receive an allocation of <b>20 AI hints per day</b> to ensure they always have the support they need.',
      faq_header: 'FAQs',
      faq_q_1: 'How are instructors matched with my child?',
      faq_a_1_trial_class: 'After the initial trial class, our team carefully matches our online instructors to each student based on their experience level, personality, interests, and schedule. Our team will work with you to improve your experience if you or your child doesn’t love learning with your instructor.',
      faq_a_1: 'Each of our instructors were hand-picked to represent CodeCombat and provide a fun and personalized learning experience tailored to each student. We believe that your child will enjoy learning with any of our instructors, but if for any reason you would like to change teachers, we are happy to accommodate.',
      faq_q_2: 'Are there any student age limits?',
      faq_a_2: 'We recommend our online classes for students aged 7 through 16. However, if your child can type, use a mouse, and is comfortable using a computer, they are welcome to join our class.',
      faq_q_3: 'What kind of technology do I need to join the class?',
      faq_a_3: 'Any internet-connected device with a full keyboard. Laptops, PCs, and Chromebooks are recommended, however iPads will work with an external keyboard.',
      faq_q_4: 'What is the cancellation policy?',
      faq_a_4: 'Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply <a href="mailto:classes@codecombat.com">contact us</a> within 30 days of purchase and we will promptly refund 100% of your purchase, no questions asked. You can also freeze your subscription at any time and re-activate when it works for you.',
      faq_q_5: 'What if I need to reschedule a class?',
      faq_a_5: 'Once you have booked a weekly class with us, we have reserved time in our schedule exclusively for you, so we require 48 hours\' advance notice for rescheduling classes. You can reschedule your class by emailing <a href="mailto:classes@codecombat.com">classes@codecombat.com</a>. Classes missed or canceled with less than 48 hours\' notice will not be rescheduled or refunded.',
      faq_q_6: 'What should I expect in the trial class?',
      faq_a_6: 'Each trial class is a private 60 minute session with <strong>45 minutes of instruction</strong> for the student followed by <strong>15 minutes for discussion with a parent or guardian</strong>. These 15 minutes are important and are set aside to answer any questions, provide insight into how the ongoing curriculum progresses, and help you select the right skill level and coding language for your child. If available, one of our remote learning advisors may join for this part of the session.',
      other_questions: 'If you have any other questions about our online classes, please <a href="mailto:classes@codecombat.com">contact us.</a>',
    },

    parents_landing_2: {
      splash_title: 'Discover the magic of coding at home.',
      learn_with_instructor: 'Learn with an Instructor',
      live_classes: 'Live Online Classes',
      live_classes_offered: 'CodeCombat now offers live online computer science classes for students learning at home. Great for students who work best in 1:1 or small-group settings where learning outcomes are tailored to their needs.',
      live_class_details_1: 'Small group or private lessons',
      live_class_details_2: 'JavaScript and Python coding, plus core Computer Science concepts',
      live_class_details_3: 'Taught by expert coding instructors',
      live_class_details_4: 'Individualized and instant feedback',
      live_class_details_5: 'Curriculum trusted by 80,000+ educators',
      try_free_class: 'Try a free 60 minute class',
      pricing_plans: 'Pricing Plans',
      choose_plan: 'Choose Plan',
      per_student: 'per student',
      sibling_discount: '15% Sibling Discount!',
      small_group_classes: 'Small Group Coding Classes',
      small_group_classes_detail: '4 Group Sessions / Mo.',
      small_group_classes_price: '$159/mo',
      small_group_classes_detail_1: '4:1 student to instructor ratio',
      small_group_classes_detail_2: '60 minute classes',
      small_group_classes_detail_3: 'Build projects and give feedback to other students',
      small_group_classes_detail_4: 'Screen sharing to get live feedback on coding and debugging',
      private_classes: 'Private Coding Classes',
      four_sessions_per_month: '4 Private Sessions / Mo.',
      eight_sessions_per_month: '8 Private Sessions / Mo.',
      four_private_classes_price: '$219/mo',
      eight_private_classes_price: '$399/mo',
      private_classes_detail: '4 or 8 Private Sessions / Mo.',
      private_classes_price: '$219/mo or $399/mo',
      private_classes_detail_1: '1:1 student to instructor ratio',
      private_classes_detail_2: '60 minute classes',
      private_classes_detail_3: 'Flexible schedule tailored to your needs',
      private_classes_detail_4: "Lesson plans and live feedback tailored to students' learning style, pace, and ability level",
      best_seller: 'Best Seller',
      best_value: 'Best Value',
      codecombat_premium: 'CodeCombat Premium',
      learn_at_own_pace: 'Learn at Your Own Pace',
      monthly_sub: 'Monthly Subscription',
      buy_now: 'Buy now',
      per_month: ' / mo',
      lifetime_access: 'Lifetime Access',
      premium_details_title: 'Great for self-driven learners who thrive with complete autonomy.',
      premium_details_1: 'Access to subscriber-only heroes, pets and skills',
      premium_details_2: 'Receive bonus gems to buy gear, pets and more heroes',
      premium_details_3: 'Unlock a deeper understanding of core concepts and skills like web and game development',
      premium_details_4: 'Premium support for subscribers',
      premium_details_5: 'Create private clans to invite friends and compete on a group leaderboard',
      premium_need_help: 'Need help or prefer Paypal? Email <a href="mailto:support@codecombat.com">support@codecombat.com</a>',
      not_sure_kid: 'Not sure if CodeCombat is right for your kid?  Ask them!',
      share_trailer: 'Share our game trailer with your kid and have them create an account to get started.',
      why_kids_love: 'Why Kids Love CodeCombat',
      learn_through_play: 'Learning Through Play',
      learn_through_play_detail: 'Students grow their coding skills, and also use problem-solving skills to progress through levels and power up their heroes.',
      skills_they_can_share: 'Skills They Can Share',
      skills_they_can_share_details: 'Students build real-world skills and create projects, such as games and webpages, that they can share with friends and family.',
      help_when_needed: 'Help When They Need It',
      help_when_needed_detail: 'Using data, every level has been built to be challenging, but never discouraging.  Students are supported with hints when they get stuck.',
      book_first_class: 'Book your first class',
      why_parents_love: 'Why Parents Love CodeCombat',
      most_engaging: 'The most engaging way to learn typed code',
      most_engaging_detail: 'Your child will have everything they need at the tip of their fingers to program algorithms in Python or JavaScript, build websites and even design their own games, while learning material aligned with national curriculum standards.',
      critical_skills: 'Building critical skills for the 21st century',
      critical_skills_detail: 'Your child will learn how to navigate and become citizens in the digital world. CodeCombat is a solution that enhances your child’s critical thinking, creativity, and resilience, empowering them with the skills they need for any industry.',
      parent_support: 'Supported by parents like you',
      parent_support_detail: 'At CodeCombat, we’re parents. We’re coders. We’re educators. But most of all, we’re people who believe in giving our kids the best opportunity for success in whatever it is they decide to do.',
      everything_they_need: 'Everything they need to start typing code on their own',
      beginner_concepts: 'Beginner Concepts',
      beginner_concepts_1: 'Basic syntax',
      beginner_concepts_2: 'While loops',
      beginner_concepts_3: 'Arguments',
      beginner_concepts_4: 'Strings',
      beginner_concepts_5: 'Variables',
      beginner_concepts_6: 'Algorithms',
      intermediate_concepts: 'Intermediate Concepts',
      intermediate_concepts_1: 'If statements',
      intermediate_concepts_2: 'Boolean comparisons',
      intermediate_concepts_3: 'Nested conditionals',
      intermediate_concepts_4: 'Functions',
      intermediate_concepts_5: 'Basic input handling',
      intermediate_concepts_6: 'Basic game artificial intelligence',
      advanced_concepts: 'Advanced Concepts',
      advanced_concepts_1: 'Event handling',
      advanced_concepts_2: 'Conditional while loops',
      advanced_concepts_3: 'Object literals',
      advanced_concepts_4: 'Parameters',
      advanced_concepts_5: 'Vectors',
      advanced_concepts_6: 'Math library operations',
      advanced_concepts_7: 'Recursion',
      get_started: 'Get Started',
      quotes_title: 'What parents and kids are saying about CodeCombat',
      quote_1: '"This is next level coding for kids and it’s pretty fun. I am going to learn a thing or two from this too."',
      quote_2: '"I liked learning a new skill that I haven’t done before. I liked that when I was struggling, I could find the goals. I also liked that you could see the code work correctly."',
      quote_3: '"Oliver’s Python is coming along. He’s using CodeCombat to make his own video games. He challenges me to play his games, then laughs when I lose."',
      quote_4: '"This is one of my favorite things to do. Every morning I wake up and play CodeCombat. If I had to give CodeCombat a rating from 1 to 10, I would give it a 10!"',
      parent: 'Parent',
      student: 'Student',
      grade: 'Grade',
      subscribe_error_user_type: "Looks like you've already signed up for an account. If you're interested in CodeCombat Premium, please contact us at team@codecombat.com.",
      subscribe_error_already_subscribed: "You've already signed up for a Premium account.",
      start_free_trial_today: 'Start free trial today',
      live_classes_title: 'Live coding classes from CodeCombat!',
      live_class_booked_thank_you: 'Your live class has been booked, thank you!',
      book_your_class: 'Book Your Class',
      call_to_book: 'Call now to book',
      student_journey_start: "Congratulations! Your student's coding journey is about to begin!",
      enter_email_address: 'Please provide your email address to get started:',
      enter_parent_email_address: "If you are a student under 18 years of age, please enter your parent or guardian's email address.",
      email_sent_success: 'Awesome! An email has been sent to the address you provided.',
      email_schedule_info: 'Please open and click the link to access our trial class scheduling portal and select any available time that works best for you.',
      personalized_coding: 'Personalized Coding Instruction',
      premium_access: 'Premium Access',
      focus_choice: 'Your Focus, Your Choice',
      get_free_coding_class: 'You Get a Free Coding Class',
      tailored_guidance: 'Tailored guidance in Python, Javascript, Lua, and more',
      enjoy_all_games: 'Enjoy all our web games and Roblox experiences',
      choice_of_path: 'Select from Coding Fundamentals, Game Development, AI Applications, AP CSP Prep, and more for a personalized learning path',
      classes_in_spanish_english: 'Classes are available in English or Spanish',
      free_class: 'Free Class',
    },

    modal_timetap_confirmation: {
      congratulations: 'Congratulations!',
      paragraph_1: 'Your student’s coding adventure awaits.',
      paragraph_2: 'We have your child booked for an online class and we’re so excited to meet them!',
      paragraph_3: 'Soon you should be recieving an email invitation with the class schedule details as well as your class instructor’s name and contact information.',
      paragraph_4: 'If for whatever reason you need to modify your class selections, reschedule or just want to talk with a customer care specialist, simply reach out using the contact information provided in your email invitation.',
      paragraph_5: 'Thank you for choosing CodeCombat and good luck on your computer science journey!',
      back_to_coco: 'Back to CodeCombat',
    },

    hoc_2018: {
      banner_coco: 'Welcome to Hour of Code!',
      banner_ozar: 'Happy Computer Science Education Week!',
      page_heading: 'Your students will learn to code by building their own game!',
      page_heading_ai_league: 'Your students will learn to code their own multiplayer AI!',
      page_heading_goblins: 'Your students will learn coding by saving a village from goblins!',
      step_1: 'Step 1: Watch Video Overview',
      step_2: 'Step 2: Try it Yourself',
      step_3: 'Step 3: Download Lesson Plan',
      try_activity: 'Try Activity',
      download_pdf: 'Download PDF',
      solutions: 'Solutions',
      teacher_signup_heading: 'Turn Hour of Code into a Year of Code',
      teacher_signup_blurb: 'Everything you need to teach computer science, no prior experience needed.',
      teacher_signup_input_blurb: 'Get first course free:',
      teacher_signup_input_placeholder: 'Teacher email address',
      teacher_signup_input_button: 'Get CS1 Free',
      activities_header: 'More Hour of Code Activities',
      activity_label_1: 'Beginner CS: Escape the Dungeon!',
      activity_label_2: ' Beginner GD: Build a Game!',
      activity_label_3: 'Advanced GD: Build an Arcade Game!',
      activity_label_hoc_2018: 'Intermediate GD: Code, Play, Create',
      activity_label_ai_league: 'Beginner CS: Esports Bootcamp: AI League',
      activity_label_goblins: "Beginner CS: Goblins 'n' Glory",
      activity_button_1: 'View Lesson',
      about: 'About CodeCombat',
      about_copy: 'A game-based, standards-aligned computer science program that teaches real, typed Python and JavaScript.',
      point1: '✓ Scaffolded',
      point2: '✓ Differentiated',
      point3: '✓ Assessments',
      point4: '✓ Project-based courses',
      point5: '✓ Student tracking',
      point6: '✓ Full lesson plans',
      title: 'HOUR OF CODE',
      acronym: 'HOC',
      play_video: 'Play Video',
      featured_title_1: "CodeCombat: Goblins 'n' Glory",
      featured_subtitle_1: 'Grades 6-8 | JavaScript, Python',
      featured_blurb_1: 'We need your help! Embark on an epic quest where you take control of the game through your powers of programming.',
      featured_title_2: 'Esports Bootcamp: AI League',
      featured_subtitle_2: 'Grades 6-8 | JavaScript, Python',
      featured_blurb_2: 'Competitive coding has never been so epic! Learn the skills you need to play like the pros in our Esports Bootcamp. No coding experience needed',
      featured_title_3: 'Ozaria: Your Journey Begins',
      featured_subtitle_3: 'Grades 6-8 | JavaScript, Python',
      featured_blurb_3: 'Enter the world of Ozaria where you must use the power of coding to defeat a darkness that has taken over the world!',
      page_heading_latest_activities: 'Our latest activities are easy to implement and fun to play',
    },

    hoc_2018_interstitial: {
      welcome: "Welcome to CodeCombat's Hour of Code!",
      educator: "I'm an educator",
      show_resources: 'Show me teacher resources!',
      student: "I'm a student",
      ready_to_code: "I'm ready to code!",
    },

    hoc_2018_completion: {
      congratulations: 'Congratulations on completing <b>Code, Play, Share!</b>',
      send: 'Send your Hour of Code game to friends and family!',
      copy: 'Copy URL',
      get_certificate: 'Get a certificate of completion to celebrate with your class!',
      get_cert_btn: 'Get Certificate',
      first_name: 'First Name',
      last_initial: 'Last Initial',
      teacher_email: "Teacher's email address",
    },

    school_administrator: {
      title: 'School Administrator Dashboard',
      my_teachers: 'My Teachers',
      last_login: 'Last Login',
      licenses_used: 'licenses used',
      total_students: 'total students',
      active_students: 'active students',
      projects_created: 'projects created',
      other: 'Other',
      notice: 'The following school administrators have view-only access to your classroom data:',
      add_additional_teacher: 'Need to add an additional teacher? Contact your CodeCombat Account Manager or email support@codecombat.com. ',
      license_stat_description: 'Licenses available accounts for the total number of licenses available to the teacher, including Shared Licenses.',
      students_stat_description: 'Total students accounts for all students across all classrooms, regardless of whether they have licenses applied.',
      active_students_stat_description: 'Active students counts the number of students that have logged into CodeCombat in the last 60 days.',
      project_stat_description: 'Projects created counts the total number of Game and Web development projects that have been created.',
      no_teachers: 'You don’t have any schools tied to your account yet. Please contact your <strong>District Success Manager</strong> or <a href="mailto:schools@codecombat.com">schools@codecombat.com</a> to get your dashboard set up.',
      totals_calculated: 'How are these totals calculated?',
      totals_explanation_1: 'How are these totals calculated?',
      totals_explanation_2: 'Licenses used',
      totals_explanation_3: 'Counts total licenses applied to students out of total licenses available.',
      totals_explanation_4: 'Total students',
      totals_explanation_5: 'Counts teacher’s students across all of their active classrooms. To see total students enrolled in both active and archived classrooms, go to the Student Licenses page.',
      totals_explanation_6: 'Active students',
      totals_explanation_7: 'Counts all students who were active within the past 60 days.',
      totals_explanation_8: 'Projects created',
      totals_explanation_9: 'Counts total games and web pages created.',
      date_thru_date: '__startDateRange__ thru __endDateRange__',
      teachers: 'Teachers',
      students_enrolled: 'Students Enrolled',
      select_time_range: 'Select the time range:',
      export: 'Export',
      preview: 'Here is a preview for top 200 lines, Click the Export to get full stats',
      empty_results: 'Empty Results.',
      roster: 'Roster',
      licenses_total_label: 'Licenses',
      enrolled_label: 'Students Enrolled',
      active_classes: 'active classes',
      licenses_class_label: 'Licenses in use',
      license_details: 'License Details',
      view_classes: 'View Classes',
      my_schools: 'My Schools',
      admin_licenses: 'Admin Licenses',
      class_membership_history: 'Classroom Membership History',
      membership_tooltip: '<p><b>The Classroom Membership History</b> displays the total number of unique students who were enrolled across all classrooms.</p><p><b>Remember:</b> Classes may be archived and licenses may be reused throughout the school year, so these numbers represent how many students truly participated in the program.</p>',
      have_license_question: 'Have license related questions?',
    },

    interactives: {
      phenomenal_job: 'Phenomenal Job!',
      try_again: 'Whoops, try again!',
      select_statement_left: 'Whoops! Select a code statement before pressing Submit.',
      fill_boxes: 'Whoops, make sure to fill all boxes before hitting "Submit."',
      cannot_play_video: 'Sadly, this video cannot be played in your area.',
      console_instructions: 'See why by opening your browser console: 1) Right click 2) Choose "Inspect" 3) Click the console tab.',
      skip_video: 'Skip video',
      unavailable: 'Unavailable',
    },

    browser_recommendation: {
      title: 'CodeCombat works best on Chrome!',
      pitch_body: 'For the best CodeCombat experience we recommend using the latest version of Chrome. Download the latest version of chrome by clicking the button below!',
      download: 'Download Chrome',
      ignore: 'Ignore',
    },

    admin: {
      license_type_full: 'Full Courses',
      license_type_hackstack: 'Hackstack',
      license_type_customize: 'Customize Courses',

    },

    events: {
      title: 'CodeCombat Events',
      main_title: 'CodeCombat Events',
      main_description: 'The important events of codecombat China',
      dashboard: 'Events Dashboard',
      online_classes: 'Online Classes',
      my_classes: 'My Online Classes',
      classes_stats: 'Online Classes Stats',
      name: 'Name',
      class_name: 'Class Name',
      description: 'Description',
      owner: 'Owner',
      type: 'Type',
      members: 'Members',
      start_date: 'Start Date',
      end_date: 'End Time',
      time_range: 'Time Range',
      rrule: 'Recurrence Rules',
      add_member: 'Add Member',
      class_count: 'Lessons Count',
      done: 'Finished Lesson',
      attendance: 'Attendance',
      course_description: 'Teacher Notes',
      teacher_notes: 'Teacher Notes',
      levels_completed: 'Levels Completed',
      no_levels_completed: 'No Completed Levels Found',
      no_teacher_notes: 'No Teacher Notes Found',
      no_video_recording: 'No Video Recording Found',
      reply: 'Reply',
      video_recording: 'Video Recording',
      import_from_class: 'Import from Class',
      link_google_calendar: 'Link with Google Calendar',
      sync_to_google: 'Sync to Google Calendar',
      synced_to_google: 'Synced to Google Calendar',
      google_calendar_attendees: 'Google Calendar Attendees',
      calendar: 'Calendar',
      edit_instance_tab_desc: 'Edit the single instance of this event, for editing whole events, see edit tab',
      edit_event_tab_desc: 'Edit the whole event, for editing single instance of this event, see instance tab',
      edit_members_tab_desc: 'Edit the member of this event, the startDate is depends on the instance date, so select the first instance for the new member',
      lessons_count_desc: 'The total lessons count of this member, normally it is the same as the event instances count, but it can be different if the member is added after the event started or ended before the event ended',
      sync_to_google_desc: 'Sync this event to YOUR google calendar, instead of the owner\'s calendar. And can only work on CodeCombat gmail',
      no_data_display: 'No data to display',
      meetingLink: 'Meeting Link',
      time_zone: 'Time Zone',
      timezone_tips: 'Note - Your timezone: ',
    },

    teacher_dashboard: {
      lock: 'Lock',
      unlock: 'Unlock',
      lock_until_date: 'Lock until date',
      skip: 'Skip',
      unskip: 'Unskip',
      make_optional: 'Make optional',
      remove_optional: 'Remove Optional',
      until_date: 'until __date__',
      unassign: 'Unassign',
      locked: 'Locked',
      locked_by_previous: 'Locked by previous level',
      locked_with_timeframe: 'Locked',
      skipped: 'Skipped',
      skipped_desc: 'Students cannot play skipped levels. They are marked optional so students can still progress.',
      optional: 'Optional',
      optional_desc: 'Students may play these but are not required to complete them.',
      assigned: 'Assigned',
      unlocked: 'Unlocked',
      unassigned: 'Unassigned',
      complete: 'Complete',
      progress: 'In Progress',
      choose_course: 'Click to Select from Dropdown',
      teacher_locked_message: 'Your teacher has locked the next level',
      plan_your_class_title: 'Plan your first class by',
      plan_your_class1: 'Viewing course progression info',
      plan_your_class2: 'Previewing lesson slides & extension activities',
      plan_your_class3: 'Trying the first chapter for free',
      click_dismiss: 'Click to Dismiss',
      track_progress: 'Track Progress',
      track_progress_desc: 'Click into the class you just created to view detailed student progress.',
      add_classes_title: 'Add Classes Here',
      add_classes: 'Add classes and get students started with the first free chapter!',
      all_classes: 'All Classes',
      my_licenses: 'My Licenses',
      resource_hub: 'Teacher Toolkit',
      pd: 'Professional Development',
      pd_short: 'PD',
      apcsp: 'APCSP',
      curriculum_guide: 'Curriculum Guide',
      curriculum: 'Curriculum',
      coming_soon: 'Coming Soon!',
      add_class: 'Add New Class',
      no_licenses_yet: 'No licenses yet',
      req_licenses: 'Request Licenses',
      license_ratio_used: '__totalUsedLicenses__ out of __totalSpots__',
      licenses_applied: 'Licenses Applied',
      student_projects: 'Student Projects',
      no_classes_yet: 'No classes yet',
      exemplar_project: 'Exemplar Project',
      capstone_proj_for: 'Capstone Project for __courseName__',
      project_rubric: 'Project Rubric',
      select_chapter: 'Select Chapter',
      select_course: 'Select Course',
      concept_flag: 'Concept Flag',
      support_learning: 'Support Learning',
      concept_flag_desc: 'More than 50% of the class attempted a Concept Check 3 or more times.',
      concept_flag_desc2: 'Student attempted a Concept Check 3 or more times.',
      click_progress_dot_tip: 'Tip: Click on the progress bubbles for more details',
      color_code: 'Color Code',
      content_guide: 'Content Guide',
      story: 'Story',
      cutscenes: 'Cutscenes',
      cutscenes_tooltip: '<h3>Cutscene</h3><p>Short videos that explain parts of the epic Ozaria narrative.</p>',
      cinematics: 'Cinematics',
      cinematics_tooltip: '<h3>Cinematic</h3><p>Expositional dialogue that introduces concepts in an engaging back-and-forth between characters.</p><p class="small">Part of an <b>intro</b>, which introduce new concepts in a scaffolded way.</p>',
      concepts_tooltip: '<h3>Concept Check</h3><p>Formative checks for student understanding presented in varied formats, including drag-and-drop and code ordering questions.</p><p class="small">Part of an <b>intro</b>, which introduce new concepts in a scaffolded way.</p>',
      ozaria_practices_tooltip: '<h3>Practice Level</h3><p>Game-play in which students are practicing concepts while solving puzzles to complete their hero\'s quest.</p>',
      challenges_tooltip: '<h3>Challenge Level</h3><p>Game-play that combines key concepts students have practiced previously.</p>',
      capstones_tooltip: '<h3>Capstone Level</h3><p>Students create games and stories using key concepts they learned from the chapter.</p>',
      coco_practices_tooltip: '<h3>Practice Level</h3><p>They are optional and only appears for the students that the system think needs extra practice.</p>',
      multiplayers_tooltip: '<h3>Multiplayer Level</h3><p>Levels which students can play against others.</p>',
      mains_tooltip: '<h3>Core Level</h3><p>Game-play in which students are practicing concepts while solving puzzles to complete their hero\'s quest.</p>',
      learn_to_use_tooltip: '<h3>Learn</h3><p>Students follow guided steps to learn how to craft effective AI prompts, building skills through structured practice.</p>',
      practice_tooltip: '<h3>Practice</h3><p>Students apply their prompting skills with light teacher guidance, bridging structured learning and open-ended creation.</p>',
      use_tooltip: '<h3>Create</h3><p>Students freely apply their prompting skills with open-ended access to the AI model.</p>',
      ai_capstone_tooltip: '<h3>AI Capstone</h3><p>A summative assessment at the end of each module where students build a project from scratch using all the prompting skills from the module.</p>',
      concept_checks: 'Concept Checks',
      practice_level: 'Practice Level',
      practice_levels: 'Practice Levels',
      extra_practice: 'Extra Practice',
      challenge_levels: 'Challenge Levels',
      capstone_levels: 'Capstone Levels',
      main_levels: 'Core Levels',
      multiplayer_levels: 'Multiplayer Levels',
      learn_levels: 'Learn',
      use_levels: 'Create',
      intro: 'Intro',
      practice: 'Practice',
      assess: 'Assess',
      multiplayer: 'MultiPlayer',
      main: 'Main',
      type: 'Type',
      view_options: 'View Options',
      manage_class: 'Manage Class',
      assign_content: 'Assign Content',
      remove_students: 'Remove Students',
      revoke_licenses: 'Revoke Licenses',
      remaining_licenses: '__remaining__ license(s) remaining',
      start_date: 'Start: __date__',
      end_date: 'End: __date__',
      license_questions: 'Have questions about applying or revoking licenses?',
      need_more_licenses: "Need more licenses? We'll help you build a solution that meets your needs.",
      see_also_our: 'See also our',
      for_more_funding_resources: 'for how to leverage CARES Act funding sources like ESSER and GEER.',
      support_oz: 'support@ozaria.com',
      standards_alignment: 'Standards Alignment',
      standards_sample: 'A sample of the standards covered in this Chapter:',
      add_course_to_classroom: 'Add Course',
      play_chapter: 'Play Chapter',
      play_course: 'Play Course',
      class_time_range: 'Class Time (Range):',
      in_game_play_time: 'In-Game Play Time:',
      class_time: 'Class Time',
      solution_guide: 'Solution Guide',
      module: 'Module',
      need_licenses_tooltip: "<h3>You need licenses to access this content!</h3><p>Please visit the <a href='/teachers/licenses'>My Licenses</a> page for more information.</p>",
      lesson_slides_tooltip: '<h3>Lesson Slides</h3><p>Downloadable, step-by-step presentation slides for guiding students through module learning objectives</p>',
      project_rubric_tooltip: '<h3>Project Rubric</h3><p>Downloadable and modifiable scoring rubric for the Capstone Project</p>',
      exemplar_projects_tooltip: '<h3>Exemplar Project</h3><p>Live view of the exemplar Capstone Project</p>',
      add_course_to_classroom_tooltip: '<h3>Add Course to Classroom</h3><p>This course is not yet in your classroom. To add it, click this button.</p>',
      want_to_save_tooltip: '<h3>Want to save your progress?</h3><p>Please create a student account, or go to <i>My Account / Test as Student</i> and play Ozaria as a student if you would like to save your progress.</p>',
      want_to_save_tooltip_coco: '<h3>Want to save your progress?</h3><p>Please create a student account, or go to <i>My Account / Test as Student</i> and play CodeCombat as a student if you would like to save your progress.</p>',
      intro_explain_tooltip: '<b>"Intros"</b> introduce new concepts or further the storyline in a scaffolded way. They typically include Cinematics and/or Concept Checks.',
      chapter_num: 'Chapter __num__',
      read: 'View Only',
      write: 'Full Access',
      read_blurb: 'View Only permits the added teacher to view your class and student progress without the ability to make changes to your class.',
      write_blurb: 'Full Access grants the added teacher the ability to make modifications to your class (add/remove students, assign chapters, modify licensure)',
      shared_with_none: 'This class is not currently shared with any other teachers.',
      shared_with: 'Shared with',
      share_info: 'To give other teachers access to the class, add their emails below.',
      class_owner: 'Class Owner',
      share: 'Share',
      add: 'Add',
      note: 'Note',
      lock_or_skip_levels: 'Lock or Skip Levels',
      level_access_status_blurb: "When you choose to skip a level, it will have both the 'locked' and 'optional' status. Unskipping the level will remove both the 'locked' and 'optional' statuses.",
      reset_progress: 'Reset Progress',
      export_progress: 'Export Progress',
      assessments_tab: 'Assessments',
      ai_hackstack_junior_tab: 'AI Junior',
      switch_on: 'On',
      switch_off: 'Off',
      ai_league: 'AI League',
      version_old: 'Old',
      version_new: 'New',
      dashboard_version: 'Dashboard Version',
      arena_days_left: 'Days left in Season __season__, __arenaName__:',
      arena_days_elapse: 'Season __season__, __arenaName__ ended __time__',
      global_stats_vs_team_stats: 'Global stats vs team stats',
      global_stats: 'Global stats',
      show_stats_for_all_players_and_teams: 'show stats for all players and teams.',
      team_stats: 'Team stats',
      show_stats_for_individuals_playing_on_the_same_team: 'show stats for individuals playing on the same team.',
      for_each_class_you_add_a_team_will_be_automatically_created_for_the_students_in_that_class: 'For each class you add, a team will be automatically created for the students in that class.',
      view_team_page: 'Team Page',
      no_modifiers_changed: 'Levels already modified for these students',
      no_modifiers_changed_unlocks_skipped: 'It appears you attempted to unlock levels that aren\'t currently locked. Please note, if your selected level appears as locked, it might be due to a preceding level being locked. To proceed, ensure to unlock the prior level first.',
      view_custom_league: 'View Custom League',
      view_global_league: 'View Global League',
      refresh_progress: 'Refresh Progress',
      assign_content_first: 'Please ensure that content is assigned to students before adjusting access levels',
      failed_attempts: 'Failed Attempts',
      no_failed_attempts: 'No Failed Attempts',
      failed_attempts_subtext: 'Number of times incorrect option was selected',
      open_project: 'Open Project',
      create_class_hackstack: 'Please create a New Class to access AI HackStack',
      add_club: 'Add New Club / Camp / Annual',
      test_student_only: '(Test Student Only)',
      ready_to_review: 'Ready to Review',
      ozaria_hs_modal_title: 'Access AI Hackstack Exclusively on CodeCombat',
      ozaria_hs_modal_blurb: 'Educators can now access AI Hackstack directly on **[https://codecombat.com/teachers/ai-league]CodeCombat** using the same credentials as Ozaria. For added convenience, you can easily import your classes from Ozaria into CodeCombat.',
      ozaria_ai_league_modal_title: 'Access AI League Exclusively on CodeCombat',
      ozaria_ai_league_modal_blurb: 'Educators can now access AI League directly on **[https://codecombat.com/teachers/ai-league]CodeCombat** using the same credentials as Ozaria. For added convenience, you can easily import your classes from Ozaria into CodeCombat.',
      completed_all_practice_levels: 'The student has successfully completed all practice levels.',
      played_some_practice_levels: 'The student has started working on the practice levels.',
      ai_league_start_title: 'Welcome to AI League!',
      ai_league_start_blurb: 'Our Getting Started guide walks you through everything you need to know - from setting up your first class to running your first tournament.',
      ai_league_curriculum_title: 'AI League Curriculum',
      ai_league_curriculum_blurb: 'Access our comprehensive curriculum guides designed specifically for AI League arenas. These resources help you introduce competitive coding concepts and teach strategic thinking.',
      ai_league_custom_title: 'Custom AI League Tournaments',
      ai_league_custom_blurb: "Create your own customized tournaments to engage your students! Select from our library of coding arenas and set competition dates, whether it's a classroom challenge or a school-wide competition.",
      this_project_is_remixed: 'This project is remixed.',
      view_original_project: 'View Original Project',
      activate_license: 'Activate License',
      violation: 'Violation',
      safety_violations: 'Safety Violations',
      warning: 'Warning',
      collapse: 'Collapse',
      num_student: '__num__ Students',
      one_student: '__num__ Student',
      sort_by_last_name: 'Last Name',
      sort_by_first_name: 'First Name',
      sort_by_progress_desc: 'Progress (High to Low)',
      sort_by_progress_asc: 'Progress (Low to High)',
      no_write_permission: 'You do not have a write permission on this class',
      select_student_first: 'You need to select student(s) first before performing that action.',
      no_progress_to_delete: 'No progress to delete',
      deleting_progress: 'Deleting progress',
      delete_progress_warning: 'Warning: student progress for __courseName__ will be deleted and cannot be recovered. Are you sure?',
      error_adding_teacher: 'Error in adding teacher',
      error_occurred: 'Error occurred: __err__',
      password_changed_successfully: 'Password Changed successfully!',
      remove_students_title: 'Remove Students from Class',
      remove_confirm_title: 'Are you sure you want to remove (this student / these students) from your class?',
      remove_list_1: 'If licenses are applied, remember to revoke them before removing students in order to apply them to other students.',
      remove_list_2: 'Student(s) will lose access to this classroom and assigned chapters.',
      remove_list_3: 'Student progress will not be lost and can be viewed if the student can be added back to the classroom at any time.',
      pick_a_license: 'Pick a License',
      having_access: 'Having Access',
      course_preview: 'Course Preview',
      curriculum_coco: 'CodeCombat',
      curriculum_ozaria: 'Ozaria',
      curriculum_beta: 'Beta',
      progress_last_fetched: 'Progress last fetched',
      refresh_progress_helptext: 'Student progress may take 2–3 minutes to sync after completion.',
      ai_evaluation: 'AI Evaluation',
      ai_evaluated_on: 'AI Evaluated On',
      ai_eval_yes: 'AI Passed',
      ai_eval_no: 'AI Failed',
      ai_eval_unsure: 'AI Unsure',
      ai_eval_unsure_desc: 'The AI evaluator could not confidently determine if the student completed the objective.',
      ai_struggling: 'Struggling',
      ai_struggling_desc: 'The student picked the wrong option more than once.',
      ai_unsafe_desc: 'The student\'s conversation with the AI was flagged as unsafe, such as attempting to cheat, bypass the AI, or use abusive language.',
      ai_eval_status: 'AI Evaluation Status',
      ai_model: 'AI Model',
      welcome_tour_title: 'A 60-second tour',
      welcome_tour_desc: "This page can feel busy at first. Let's walk through the handful of things you'll actually use — finding students, reading progress, and assigning work — in order.",
      all_students_title: 'Your students',
      all_students_desc: 'Everyone in this class appears in this column. Click any student to open their individual details and progress.',
      content_symbol_title: "What's in each lesson",
      content_symbol_desc: 'Each symbol is one piece of content. Hover to preview it or play the level yourself. The icon shape tells you the type — see the Content Guide above for what each one means.',
      progress_dot_title: 'How each student is doing',
      progress_dot_desc: "Each dot is one student's progress on that level. Its color shows their status (key is above). Click a dot to open exactly where that student is stuck or succeeding.",
      assign_content_title: 'Assign work',
      assign_content_desc: 'Select the students you want, then click here to assign them a new course. This is how you give students access to start.',
      apply_licenses_title: 'Give access to paid courses',
      apply_licenses_desc: 'Select students and apply a license so they can unlock and play paid content.',
      lock_content_title: 'Lock content to set the pace',
      lock_content_desc: "Hover any module name to reveal its yellow lock icon — click it to stop students moving past that module until you're ready. Need to lock the whole course at once? Use the Lock or Skip Levels button instead.",
      tour_replay_title: 'Need a refresher?',
      tour_replay_desc: 'Lost track? Replay this tour anytime by clicking here.',
      replay_tour: 'Play Tour',
      test_student_step_title: 'Try It as a Student',
      test_student_step_desc: 'Switch into a free test student account to experience the class exactly as your students do — assign content, play levels, and check progress. When you\'re done, click Stop Switching in the navigation bar to return to your teacher account.',
      add_students_step_title: 'Invite Students to Your Class',
      add_students_step_desc: 'Share a class code, send a join link, invite by email, or sync with Google Classroom — click here to find every way students can join and start learning.',
      teacher_toolkit_tour_desc: 'Find Getting Started guides, educator resources, and FAQs here — everything you need to get comfortable before your first class.',
      teacher_toolkit_tour_title: 'Your Teaching Toolkit',
      curriculum_glossary: 'Curriculum Glossary',
      curriculum_glossary_desc: '💡 New to this curriculum? Here is a quick key to the courses below:',
      curriculum_glossary_desc_hackstack: 'Intro: Intro to AI, AI: Artificial Intelligence, ALG: Algebra, CR: Career Readiness, CYB: Cyber, ELA: English Language Arts, CS: Computer Science, EXP: Explorations, SBOX: Sandbox',
      curriculum_glossary_desc_ozaria: 'CH: Chapter',
      curriculum_glossary_desc_codecombat: 'CS: Computer Science, GD: Game Development, WD: Web Development',
      curriculum_glossary_desc_junior: 'JR: Junior',
      curriculum_glossary_close: 'Got it, hide this',
      assign_to_class: 'Assign to Class',
    },

    outcomes: {
      outcomes_report: 'Outcomes Report',
      customize_report: 'Customize Report',
      done_customizing: 'Done Customizing',
      start_date: 'Start date',
      end_date: 'End date',
      country: 'Country',
      school_admin: 'School Administrator',
      school_network: 'School Network',
      school_subnetwork: 'School Subnetwork',
      classroom: 'Classroom',
      view_outcomes_report: 'View Outcomes Report',
      key_concepts: 'Key Concepts',
      code_languages: 'Code Languages',
      using_codecombat: "Using CodeCombat's personalized learning engine...",
      wrote: 'wrote...',
      across_an_estimated: 'across an estimated...',
      in: 'in...',
      include: 'Include ',
      archived: 'Archived',
      max: 'Max ',
      multiple: 's',
      computer_program: 'computer program',
      computer_programs: 'computer programs',
      line_of_code: 'line of code',
      lines_of_code: 'lines of code',
      coding_hours: 'coding hours',
      expressed_creativity: 'and expressed creativity by building',
      report_content_1: 'standalone game and web ',
      project: 'project',
      projects: 'projects',
      progress_stats: 'Progress stats based on sampling __sampleSize__ of __populationSize__ students.',
      standards_coverage: 'Standards Coverage',
      coverage_p1_coco: 'The full CodeCombat curriculum covers major programming standards in several widely-adopted frameworks, including those of the International Society for Technology in Education (ISTE), the Computer Science Teacher Association (CSTA), and the K-12 Computer Science Framework.',
      coverage_p1_ozar: 'The full Ozaria curriculum covers major programming standards in several widely-adopted frameworks, including those of the International Society for Technology in Education (ISTE), the Computer Science Teacher Association (CSTA), and the K-12 Computer Science Framework.',
      coverage_p2_coco: 'At CodeCombat, we believe that students will be most prepared for both real-world computing jobs and further study of computer science by using real, typed code in full programming languages, so instead of using block-based visual programming languages for beginners, we teach Python and JavaScript – the same languages used widely today by companies ranging from Google to the New York Times.',
      coverage_p2_ozar: 'Ozaria is created by the CodeCombat, the game-based learning company. We believe that students will be most prepared for both real-world computing jobs and further study of computer science by using real, typed code in full programming languages, so instead of using block-based visual programming languages for beginners, we teach Python and JavaScript – the same languages used widely today by companies ranging from Google to the New York Times.',
      questions: "Have questions or want more information? We'd be happy to help.",
      reach_out_manager: 'Reach out to your Account Manager __name__ at ',
      stats_include: 'Stats include __number__ other __name__',
      include_other_product: 'Show __product__ stats', // keep these 2 strings the same so that not confused the user
      show_other_product: 'Show __product__ stats',
      show_license_stats: 'Show Detail License Stats',
      show_license_summary: 'Show License Summary',
      license_stats: 'License Stats',
      license_template: '<b>Licenses</b>: __used__ used, __available__ available',
      licensed_teachers: '<b>Teachers with licenses</b>: __teachers__',
      licensed_schools: '<b>Schools with licenses</b>: __schools__',
      students: 'Students',
      teachers: 'Teachers',
      licensesUsed: 'Licenses Used',
      schools: 'Schools',
      top_teacher_info: 'Teacher __A__, __B__ and __n__ other teachers use our platform',
      top_teacher_info_1: 'Teacher __A__ and __B__ use our platform',
      top_teacher_info_2: 'Teacher __A__ uses our platform',
      ai_league: 'AI League',
      ai_league_stats: '__n__ players played in AI League arenas',
    },

    efficacy: {
      ozaria_efficacy: 'Ozaria Efficacy',
      header_subtitle: 'Ozaria has proven to have a positive impact on the student learning outcomes that matter most to both students and educators.',
      pathway_dialog_line1: 'while True:',
      pathway_dialog_line2: 'hero.moveDown(1)',
      pathway_dialog_line3: 'hero.moveRight(2)',
      exploring_creativity: 'Exploring Creativity',
      exploring_creativity_description: 'Almost all students surveyed said they really enjoyed being able to create their own game at the end of each Chapter.',
      essential_skills: 'Essential Skills',
      essential_skills_description: 'Teachers found Ozaria to be a superior curriculum for teaching complex coding concepts as well as essential 21st century skills, such as problem solving and reasoning, critical and computational thinking skills.',
      fun_engaging: 'Fun & Engaging',
      fun_engaging_description: 'Ozaria was reported to be a fun and engaging curriculum. Students especially noted how effective it was in teaching text-based coding, and how the tutorials, hints, and error messages provided the appropriate amount of support.',
      easy_to_use: 'Easy to Use',
      easy_to_use_description: 'Both teacher and students found the platform easy to implement and use.',
      mcintosh_study_title: 'Increasing Score Gains on Assessments',
      mcintosh_middle_school: 'McIntosh Middle School',
      mcintosh_study_description: 'A novice teacher with advanced level coding experience taught three cohorts of students. Each cohort was studied across a full semester.',
      study_highlights_title: 'Highlights from the study results:',
      mcintosh_study_highlight_1: '98% of students rated their level of enthusiasm for Ozaria as high or extremely high',
      mcintosh_study_highlight_2: '100% of students scored above 70% on both the mid-term and final assessments',
      read_the_study: 'Read the Study (PDF)',
      mrms_study_title: 'Gaining Confidence in Computer Science',
      mountain_ridge_middle_school: 'Mountain Ridge Middle School',
      mrms_study_description: 'An experienced teacher with beginning level coding experience taught two cohorts of students. Each cohort was studied across a full semester.',
      mrms_study_highlight_1: 'Students made an average gain score of 33% between the pre-assessment and the final assessment',
      mrms_study_highlight_2: ' Both the teacher and students found Ozaria to be fun, engaging, and easy to use.',
      graph1_description: 'Students made a 47% average gain score between the pre-assessment and the final assessment.',
      graph2_description: 'More than 90% of students rated their coding confidence level as Confident or Extremely Confident after using Ozaria.',
      quote_section_content: 'One thing I am able to do now that I could not do before is actually believe I can code.',
      quote_section_footer: 'Student, Mountain Ridge Middle School',
      teacher_quote1_content: "The curriculum had students thoroughly engaged. They enjoyed the story and the characters. More importantly, they gained confidence in their ability to solve complex problems with concepts they'd learned in Ozaria.",
      teacher_quote1_footer1: 'Ronnie Cox, Teacher',
      teacher_quote1_footer2: 'McIntosh Middle School',
      student_quote_content: "I like that you can make a mistake and the game corrects it or tells you that there's an error. A lot of beginners make a lot of mistakes when coding and sometimes don't know how to code, so they can't correct their mistakes because they don't know what's wrong. Ozaria is the perfect coding game for beginners.",
      student_quote_footer: 'Student, McIntosh Middle School',
      teacher_quote2_content: 'I have absolutely loved using Ozaria in my class for the past three years. My students have thoroughly enjoyed the storyline as they learned Python in a self-paced learning environment. I would highly recommend Ozaria for teachers that know little to nothing about coding, as the support for teachers is very in-depth.',
      teacher_quote2_footer1: 'Lynette Personett, Teacher',
      teacher_quote2_footer2: 'Mountain Ridge Middle School',
      commitment_title: 'CodeCombat’s Commitment to Efficacy',
      commitment_description: 'We are committed to ensuring our products have a positive and measurable impact on learning outcomes. We create meaningful learning experiences, and use evidence-based practices to design content that will realize the outcomes that matter the most to teachers and students.',
      commitment_question: 'Interested in implementing an effective and impactful CS curriculum at your school?',
      teachers_love_codecombat: 'Teachers Love CodeCombat',
      teachers_love_description: 'Explore the impact of our sister product, CodeCombat, on Computer Science teaching & learning!',
      teachers_love_box1: 'Report that their students enjoy using CodeCombat to learn how to code',
      teachers_love_box2: 'Would recommend CodeCombat to other computer science teachers',
      teachers_love_box3: 'Say that CodeCombat helps them support students’ problem solving abilities',
      classroom_image: 'Classroom',
      ozaria_branding_logo: 'Ozaria branding logo',
      dog: 'Dog',
      hero: 'Hero',
      teacher: 'Teacher',
    },

    league: {
      student_register_1: 'Become the next AI Champion!',
      student_register_2: 'Sign up, create your own team, or join other teams to start competing.',
      student_register_3: 'Provide the information below to be eligible for prizes.',
      teacher_register_1: 'Sign up to access your class league profile page and get your class started.',
      general_news: 'Get emails on the latest news and updates regarding our AI Leagues and tournaments.',
      how_it_works1: 'Join a __team__',
      seasonal_arena_tooltip: 'Battle against your teammates and others as you use your best programming skills to earn points and rank up the AI League leaderboard before taking on the Championship arena at the end of the season.',
      summary: 'The CodeCombat AI League is uniquely both a competitive AI battle simulator and game engine for learning real Python and JavaScript code.',
      join_now: 'Join Now',
      tagline: 'The CodeCombat AI League combines our project-based standards-aligned curriculum, engaging adventure-based coding game, and our annual AI coding global tournament into an organized academic competition unlike any other.',
      ladder_subheader: 'Use your coding skills and battle strategies to rise up the ranks!',
      earn_codepoints: 'Earn CodePoints by completing levels',
      codepoints: 'CodePoints',
      free_1: 'Access competitive multiplayer arenas, leaderboard, and global coding championships',
      free_2: 'Earn points for completing practice levels and competing in head-to-head matches',
      free_3: 'Join competitive coding teams with friends, family, or classmates',
      free_4: 'Showcase your coding skills and take home great prizes',
      compete_season: 'Put all the skills you’ve learned to the test! Compete against students and players from across the world in this exciting culmination to the season.',
      season_subheading1: 'For both Season and Championship arenas, each player programs their team of “AI Heroes” with code written in Python, JavaScript, C++, Lua, or Java.',
      season_subheading2: 'Their code informs the strategies their AI Heroes will execute in a head-to-head battle against other competitors.',
      team_derbezt: 'Learn coding and win prizes sponsored by superstar Mexican actor, comedian, and filmmaker Eugenio Derbez.',
      invite_link: 'Invite players to this team by sending them this link:',
      public_link: 'Share this team leaderboard with its public link:',
      end_to_end: 'Unlike other esports platforms serving schools, we own the structure top to bottom, which means we’re not tied to any game developer or have issues with licensing. That also means we can make custom modifications in-game for your school or organization.',
      path_success: 'The game platform fits into a regular Computer Science curriculum, so as students play through the game levels, they’re completing course work. Students learn coding and computer science while they play, then use these skills in arena battles as they practice and play on the same platform.',
      unlimited_potential: 'Our tournament structure is adaptable to any environment or use case. Students can participate at a designated time during regular learning, play at home asynchronously, or participate on their own schedule.',
      team: 'Team',
      edit_team: 'Edit Team',
      start_team: 'Start a Team',
      leave_team: 'Leave Team',
      join_team: 'Join Team',
      view_team: 'View Team',
      join_team_name: 'Join Team __name__',
      features: 'Features',
      built_in: 'Built-in Competitive Infrastructure',
      built_in_subheader: 'Our platform hosts every element of the competitive process, from leaderboards to the game platform, assets, and tournament awards.',
      custom_dev: 'Custom Development',
      custom_dev_subheader: 'Customization elements for your school or organization are included, plus options like branded landing pages and in-game characters.',
      comprehensive_curr: 'Comprehensive Curriculum',
      comprehensive_curr_subheader: 'CodeCombat is a standards-aligned CS solution that helps educators teach real coding in JavaScript and Python, no matter their experience.',
      roster_management: 'Roster Management Tools',
      roster_management_subheader: 'Track student performance within the curriculum and within the game, and easily add or remove students.',
      share_flyer: 'Share our AI League flyer with educators, administrators, parents, esports coaches or others that may be interested.',
      download_flyer: 'Download Flyer',
      championship_summary: 'The __championshipArena__ championship arena is now open! Battle it out for the month of __championshipMonth__ to win prizes in the __championshipArena__ __championshipType__.',
      arcade_summary: 'The __championshipArena__ arcade arena is now open! Enjoy the break from the competition until __championshipMonth__ to prepare for the next season.',
      play_arena_full: 'Play __arenaName__ __arenaType__',
      play_arena_short: 'Play __arenaName__',
      view_arena_winners: 'View __arenaName__ __arenaType__ winners',
      arena_type_championship: 'Championship Arena',
      arena_type_regular: 'Multiplayer Arena',
      arena_type_arcade: 'Arcade Arena',
      blazing_battle: 'Blazing Battle',
      infinite_inferno: 'Infinite Inferno',
      mages_might: "Mages' Might",
      sorcerers: 'Sorcerers',
      giants_gate: "Giants' Gate",
      colossus: 'Colossus',
      iron_and_ice: 'Iron and Ice',
      tundra_tower: 'Tundra Tower',
      magma_mountain: 'Magma Mountain',
      lava_lake: 'Lava Lake',
      desert_duel: 'Desert Duel',
      sandstorm: 'Sandstorm',
      frozen_fortress: 'Frozen Fortress',
      equinox: 'Equinox',
      farmers_feud: "Farmer's Feud",
      farmscape: 'Farmscape',
      storm_siege: 'Storm Siege',
      snowhold: 'Snowhold',
      fierce_forces: 'Fierce Forces',
      anti_gravity: 'Anti-Gravity',
      solar_skirmish: 'Solar Skirmish',
      sunfire: 'Sunfire',
      system_shock: 'System Shock',
      supercharged: 'Supercharged',
      pawns_passage: "Pawn's Passage",
      kings_gambit: "King's Gambit",
      strikers_stadium: "Striker's Stadium",
      golden_goal: 'Golden Goal',
      turbo_track: 'Turbo Track',
      grand_prix: 'Grand Prix',
      season_label: 'Season __seasonNumber__: __seasonName__',
      devour_dash: 'Devour Dash',
      gridlock_practice: 'Gridlock Practice',
      chaotic_crossing: 'Chaotic Crossing',
      season_1: 'Forged in Flame',
      season_2: 'Spells of Fortune',
      season_3: 'Titan Age',
      season_4: 'Frosts of War',
      season_5: 'Sands of Time',
      season_6: 'Molten Mayhem',
      season_7: 'Melting Point',
      season_8: "Coder's Harvest",
      season_9: 'Reign of Code',
      season_10: 'Gravity Games',
      season_11: 'Summer Smash',
      season_12: 'Spark of Power',
      season_13: 'Checkmate Challenge',
      season_14: 'Racing Rivals',
      season_15: 'Soccer Showdown',
      season_16: 'Chomp and Charge',
      season_17: 'Zone Control',
      season_18: 'Paths of Peril',
      cup: 'Cup',
      blitz: 'Blitz',
      clash: 'Clash',
      arena: 'Arena',
      season15_announcement_1: 'Welcome to Golden Goal Blitz! ⚽ Where soccer meets strategy — and every shot is scripted. No feet. No players. Just code and chaos.',
      season15_announcement_2: 'Note: this arena is getting updates and new features regullary during the season and the big twist mechanics one month ahead of the final simulation.',
      season13_announcement_1: 'In the depths of ancient ruins, a magical checkerboard arises and the towers comes alive. Get as many pieces to the end of the line!',
      season13_announcement_2: 'Note: arena balance adjustments may occur up until May 15th. So be sure to come back often to test your code against the global leaderboard.',
      season12_announcement_2: 'Collectors fly high, control points emerges, mythical crystals stand tall, as the dungeon expands, the battle is getting fiercer, only the righteous shall be the victor.',
      season12_announcement_1: 'Deep in the dungeons, mythical crystals stand tall, collecting energy and mana from abandoned ruins. Summon units, cast spells, and claim victory!',
      season11_announcement_1: 'The competition is getting more heated! As the sun shines above, place down and upgrade your solar panels, avoid shock traps, place down robot crabs, and phase through portals, get as much solar as possible and claim victory!',
      season10_announcement_1: "It's fiery hot, and magma boulders are radiating powerful energies! Summon units and cast spells to push the magma boulders to your opponent's area. Adapt to the ever-changing gravity of the battlefield!",
      season9_announcement_1: 'An epic battle is being waged atop the wintry peaks of Snowhold Clash for the Season 9 championship arena! Draw your cloak close and your code closer as you wield strategy and algorithms to achieve victory in this land beyond the sky.',
      season8_announcement_1: "It's harvesting season in Farmscape Blitz Season 8! As the leaves change, it's time to code your way around wild and impenetrable obstacles on the farm. Strategically collect vital boosts to empower your robot worker and utilize special abilities to boost productivity and out-farm your opponents!",
      season8_announcement_2: 'Note: arena balance adjustments may occur up until August 15th. So be sure to come back often to test your code against the global leaderboard.',
      season7_announcement_1: "Witness the dawn of a new challenge in the Equinox Cup! Season 7's tower defense arena offers a unique blend of strategy, monsters, and boss battles for you to conquer.",
      season6_announcement_1: 'It’s absolute Molten Mayhem with the launch of the Lava Lake Clash finals! Outlast and outwit the competition in this hot take on classic Snake gameplay.',
      season6_announcement_2: 'Note: arena balance adjustments may occur up until December 15th. So be sure to come back often to test your code against the global leaderboard.',
      season5_announcement_1: 'The Sandstorm Blitz Final is on. In this basketbrawl of an arena, you must summon the right heroes, call the right plays, and outscore your opponent to take the victory!',
      season5_announcement_2: 'Note: arena balance adjustments may occur up until September 15th. So be sure to come back often to test your code against the global leaderboard.',
      season4_announcement_1: 'The Tundra Tower Cup Final is on. In this all new take on the classic tower defense gameplay, you must protect your base from the horde of monsters by building towers and using gravitational anomalies.',
      season4_announcement_2: 'Note: arena balance adjustments may occur up until April 15th. So be sure to come back often to test your code against the global leaderboard.',
      season3_announcement_1: 'Time to put your coding skills to the test in our season 3 final arena. The Colossus Clash is live and offers a new challenge and a new leaderboard to climb.',
      season3_announcement_2: "Need more practice? Stick with the Giant's Gate Arena to refine your skills. You have until December 14th to play both arenas. Note: arena balance adjustments may occur until December 6th.",
      season3_announcement_3: 'Great prizes available for top performers in the Colossus Clash:',
      season2_announcement_1: 'Time to put your coding skills to the test in our season 2 final arena. The Sorcerers Blitz is live and offers a new challenge and a new leaderboard to climb.',
      season2_announcement_2: "Need more practice? Stick with the Mage's Might Arena to refine your skills. You have until August 31st to play both arenas. Note: arena balance adjustments may occur until August 23rd.",
      season2_announcement_3: 'Great prizes available for top performers in the Sorcerers Blitz:',

      new_season_prize_1: '$500 Scholarship',
      new_season_prize_2: '$300 Scholarship',
      new_season_prize_3: '$200 Scholarship',
      season1_prize_1: '$1,000 Scholarship',
      season1_prize_2: 'RESPAWN Gaming Gear',
      season1_prize_3: 'Custom CodeCombat Avatar',
      season1_prize_4: 'And more!',
      season1_prize_hyperx: 'HyperX Premium Peripherals',
      codecombat_ai_league: 'Join AI League',
      register: 'Register',
      not_registered: 'Not Registered',
      register_for_ai_league: 'Register for AI League',
      world: 'World',
      quickstart_video: 'Quickstart Video',
      arena_rankings: 'Arena Rankings',
      arena_rankings_blurb: 'Global AI League arena rankings',
      arena_rankings_title: 'Global leaderboard rank for all players in this team across AI League arenas in the open age bracket.',
      competing: 'Competing:', // Competing: 3 students
      count_student: 'student', // 1 student
      count_students: 'students', // 2 students
      top_student: 'Top:', // Top: Jane D
      top_percent: 'top', // - top 3%)
      top_of: 'of', // (#8 of 35). Perhaps just use "/" if this doesn't translate naturally.
      arena_victories: 'Arena Victories',
      arena_victories_blurb: 'Global AI League arena recent wins',
      arena_victories_title: 'Win count is based on the last 1000 matches played asynchronously by each player in each of their AI League arenas.',
      count_wins: 'wins', // 100+ wins or 974 wins
      codepoints_blurb: '1 CodePoint = 1 line of code written',
      codepoints_title: 'One CodePoint is earned for every non-whitespace line of code needed to beat the level. Each level is worth the same amount of CodePoints according to its standard solution, regardless of whether the student wrote more or fewer lines of code.',
      count_total: 'Total:', // Total: 300 CodePoints, or Total: 300 wins
      join_teams_header: 'Join Teams & Get Cool Stuff!',
      join_team_hyperx_title: 'Join Team HyperX, Get 10% Off',
      join_team_hyperx_blurb: '30 team members will be chosen at random for a free gaming mousepad!',
      join_team_derbezt_title: 'Join Team DerBezt, Get Exclusive Hero',
      join_team_derbezt_blurb: 'Unlock the Armando Hoyos hero from Mexican superstar Eugenio Derbez!',
      join_team_ned_title: "Join Team Ned, Unlock Ned's Hero",
      join_team_ned_blurb: 'Get the exclusive spatula-wielding hero from YouTube star, Try Guy Ned Fulmer!',
      check_out_all: 'Check out all the',
      pick_best_tournaments: 'pick the ones that will work best for your custom tournament!',
      final_arena: 'Final Arena',
      rest_season: 'Practice Season',
      no_prizes: 'No Prizing',
      prizing_top_3: 'Prizing Awarded to Top 3 Champions',
      package_options_and_guide: 'Package Options & Implementation Guide',
      custom_tournament: 'For a Custom Tournament',
      you_win: 'You can win',
      great_prizes: 'great prizes',
      powered_by: 'Powered by',
      grand_prize: 'Grand Prize',
      second_prize: '2nd Place Overall',
      third_prize: '3rd Place Overall',
      scholarship: 'Scholarship',
      top_players_win: 'Top three players in each division win: HyperX pro peripherals',
      team_hyperx: 'Team HyperX',
      earn_more_gear: 'you could earn even more gear!',
      prize_footer1: 'Awarded to the top performing player across all age groups.',
      prize_footer2: 'Specific products and models subject to change.',
      prize_footer3: 'Prizes will be awarded to players who reach the top of the leaderboard in the Finals arena.',
      prize_footer4_1: 'Age verification necessary to be eligible. Some prizes are limited to US participants only.',
      coco_reserves: 'CodeCombat reserves',
      prize_footer4_2: 'the right to determine in its sole discretion if a player qualifies and will receive a prize.',
      place: 'Place', // as in 1st place
      arena_under_construction: "Next season's arena is under construction. Check back soon!",
      unlock_ai_league: 'Unlock the full potential of the AI League.',
      esports_anonymous_changing: 'Esports player name visibility changing September 1',
      esports_get_full_access: 'Get Full Access',
      click_to_unlock_now: 'Click to dismiss for now',
      click_to_unlock_before_sep: 'Click to make the anonymizing go away before Sep.1',
      unlock_content_padding: "Contact our team today to see your student's scoress, ranks, code and more!",
      unlock_leaderboard: 'Contact Us to unlock the leaderboard',
      without_license_blurb: 'Unlock the full potential of AI League. Purchase a custom tournament package to access your students’ scores, ranks, code and experience more tournament customization options. See our',
      custom_pricing: 'Custom Options and Implementation Guide',
      more_details: 'for more details.',
      contact_sales_custom: 'Your custom tournament awaits. Choose the arena that you’d like to use for your custom tournament and contact your CodeCombat sales representative to confirm set up and scheduling details.',
      create_custom: 'Create Custom Tournament',
      custom_tournament_text: 'Custom Tournament',
      promotion_blurb: 'Competitive Coding - Free to Get Started',
      promotion_part1: 'Join coding teams with friends and family',
      promotion_part2: 'Access global coding arenas and leaderboards',
      promotion_part3: 'Showcase your coding skills and win prizes',
      promotion_part4: 'Earn points through practice and head-to-head matches',
      codecombat_ai_league_description: 'The CodeCombat AI League combines our project-based standards-aligned curriculum, engaging adventure-based coding game, and our annual AI coding global tournament into an academic competition unlike any other.',
      teacher_getting_started_guide: 'Teacher Getting Started Guide',
      try_ai_league_as_a_teacher: 'Try AI League as a Teacher',
      ai_league_curriculum: 'AI League Curriculum',
      current_season: 'Current Season',
      all_time: 'All Time',
      view_leaderboards_for_team: 'Team Leaderboard:',
      global_stats: 'GLOBAL STATS',
      code_your_way: 'Code your way',
      to_win_the_price: 'to first place to win',
      regular: 'Regular',
      championship: 'Championship',
      global: 'Global',
      custom: 'Custom',
    },
    league_v2: {
      headline: 'Where Future **Coders** Train and **AI** Levels Up the Game',
      subhead: 'Welcome to AI League 2.0, where we’ve put the AI into AI League! Now you can[NEWLINE]choose to compete solo or team up with AI to outsmart opponents and level up your[NEWLINE]coding skills.',
      join_cta: 'Join Global Tournament',
      free_to_play: 'Free to play now',
      create_cta: 'Create Custom Tournament',
      for_educators: 'For educators with paid licenses',
      ai_league_desc: 'The CodeCombat AI League is uniquely both a competitive AI battle simulator and game engine for learning real Python or JavaScript code.',
      get_start: 'Free to Get Started',
      get_start_list_1: 'Join global coding[NEWLINE]championships',
      get_start_list_2: 'Earn codepoints in[NEWLINE]matches',
      get_start_list_3: 'Team up with friends[NEWLINE]or classmates',
      get_start_list_4: 'Showcase your skills[NEWLINE]and win prizes',
      compete_to_win: 'Code Your Way to First Place to Win!',
      code_to_compete: '**Esports:** Code to Compete',
      compete_desc: 'AI League is the ultimate coding arena where players battle using real Python, JavaScript, C++, and more. You can write your own logic or vibe code with an AI assistant to learn the ropes. Every match builds your skills, sharpens your strategy, and brings the heat. This is where smart code wins the game.',
      codecombat_reserves: 'CodeCombat reserves',
      reserved_right: 'the right to determine in its sole discretion if a player qualifies and will receive a prize.',
      grand_prize: 'Grand Prize:[NEWLINE]$500 Scholarship',
      second_place: '2nd Place Overall:[NEWLINE]$300 Scholarship',
      third_place: '3rd Place Overall:[NEWLINE]$200 Scholarship',
      set_up_tournament: 'Set Up Your Classroom Tournament',
      set_up_desc: 'Your first few classroom tournaments are on us. Customize a private esports competition for your students today!',
      create_team: 'Create a Team/Classroom',
      invite_players: 'Invite Players',
      select_arena: 'Select an Arena',
      refer_guide: 'Refer to the <a href="https://docs.google.com/presentation/d/1ouDOu2k-pOxkWswUKuik7CbrUCkYXF7N_jNjGO0II6o/edit#slide=id.gb06b5c7fa4_0_10">Educator Getting Started Guide</a> to see how easy it can be to bring competitive coding to your school.',
      having_question: 'Still have questions? Check out our <a target="_blank" href="https://codecombat.zendesk.com/hc/en-us/categories/1500000915842-AI-League">FAQs</a> or <a href="https://docs.google.com/forms/d/1rO__VvhM1yCuUHrtHJKXXj3RYA2vCzpRKzMCMaMS6SE" target="_blank">Contact Us</a> to learn more.',
      global_rankings: 'Global Ranking',
      team_rankings: 'Team Ranking',
      inspiration_title: 'Are you an educator or esports coach?',
      inspiration_desc: 'This game-based competitive coding competition delivers high engagement with a turn-key approach.',
      season_arenas: 'Season Arenas',
      ranking_desc: 'Use your coding skills and battle strategies to rise up the ranks!',
      step_1: 'Step 1',
      step_2: 'Step 2',
      step_3: 'Step 3',
      academic_rigor: 'Academic Rigor',
      asynchronous_competition: 'Asynchronous Competition',
      greater_accessibility: 'Greater Accessibility',
      academic_rigor_desc: 'The open-ended objective encourages creativity and iteration as players apply what they’ve learned from the core curriculum. The AI assistant offers a more realistic coding experience, but success still depends on strategy, mechanics, and writing solid code.',
      asynchronous_competition_desc: 'Unlike other esports, our platform allows players to compete anytime/anywhere with no need to coordinate schedules. ',
      greater_accessibility_desc: 'Since AI League is an academic esport focused on knowledge and strategy, fast reactions or hand-eye coordination are not required. Anyone can compete using a basic computer with internet access, and players can also choose to use the AI assistant to support their coding along the way.',
      earn_codepoints: 'Earn CodePoints',
      earn_by: 'By Completing Levels',
      search_teams: 'Search team',
      global_clan_name: '-- Global --',
    },

    tournament: {
      tournament_title: 'Tournament Title',
      mini_tournaments: 'Mini Tournaments',
      usable_ladders: 'All Usable Ladders',
      make_tournament: 'Make a mini tournament',
      go_tournaments: 'Go to mini tournaments',
      class_tournaments: 'Class mini tournaments',
      class_tournaments_more: 'More Class mini tournaments',
      no_tournaments_owner: 'There is no tournament now, please create one',
      no_tournaments: 'There is no tournament now',
      edit_tournament: 'Edit Tournament',
      create_tournament: 'Create a Tournament',
      view_tournament: 'View Tournament',
      upcoming: 'Upcoming',
      starting: 'Starting',
      ended: 'Ended',
      view_results: 'View Results',
      estimate_days: 'In __time__ Days',
      team_name: 'Team: __name__',
      status: 'Status: __state__',
      from_start: 'Start __time__',
      from_end: 'End __time__',
      start_date_time: 'Start Time',
      end_date_time: 'End Time',
      results_date_time: 'Results Time',
      start_date_description: '(PT) The start time of tournament',
      end_date_description: '(PT) The end time of tournament',
      results_date_description: 'Select a time to publish results.',
      results_date_suggestion_0: 'Note: Tournament may need some time to generate final leaderboard, so you need to allow enough time for the results.',
      results_date_suggestion_1: 'i.e. 0-50 players: 5 mins',
      results_date_suggestion_2: '     50-100 players: 20 mins',
      results_date_suggestion_3: '     100-500 players: 10 hours',
      select_team_desc: 'select your team to creat/edit your tournaments',
      already_create_tournaments_num: 'You already created __num__ tournaments here:',
      can_create_tournaments_num: 'You can create __num__ more tournament(s) from below:',
      my_teams: 'My Teams:',
      team: 'Team',
      team_description: '(Required) Only the players in the team can join this tournament',
      review_results: 'Review Results',
      review_description: 'We will email you the results of tournament and wait for you to publish for participants.',
      publish_immediately: 'Publish Immediately',
      publish_description: 'The result of tournament will be published immediately once ready.',
      error_end_date_too_early: 'The End Time cannot be earlier than Start Time',
      error_results_date_too_early: 'The Results Time cannot be earlier than End Time',
      publish_results: 'Publish Results',
      publish_options: 'Publish Options',
      anonymize_players: 'Anonymize Players',
      anonymize_players_description: 'Players cannot see each other\'s name until tournament published.',
    },

    payments: {
      student_licenses: 'Student Licenses',
      computer_science: 'Computer Science',
      web_development: 'Web Development',
      game_development: 'Game Development',
      per_student: 'Per Student',
      just: 'Just',
      teachers_upto: 'Teacher can purchase upto',
      great_courses: 'Great Courses included for',
      studentLicense_successful: 'Congratulations! Your licenses will be ready to use in a min. Click on the Getting Started Guide in the Teacher Toolkit to learn how to apply them to your students.',
      onlineClasses_successful: 'Congratulations! Your payment was successful. Our team will reach out to you with the next steps.',
      homeSubscriptions_successful: 'Congratulations! Your payment was successful. Your premium access will be available in few minutes.',
      failed: 'Your payment failed, please try again',
      session_week_1: '1 session/week',
      session_week_2: '2 sessions/week',
      month_1: 'Monthly',
      month_3: 'Quarterly',
      month_6: 'Half-yearly',
      year_1: 'Yearly',
      most_popular: 'Most Popular',
      best_value: 'Best Value',
      purchase_licenses: 'Purchase Licenses easily to get full access to CodeCombat and Ozaria',
      homeschooling: 'Homeschooling Licenses',
      recurring_month_1: 'Recurring billing every month',
      recurring_month_3: 'Recurring billing every 3 months',
      recurring_month_6: 'Recurring billing every 6 months',
      recurring_year_1: 'Recurring billing every year',
      purchase_licenses_2: 'Purchase licenses for your students to access paid curriculum after the first course',
      applying_licenses: 'applying licenses',
      about: 'about',
      school_district_heading: 'Schools or Districts',
      school_district_subheading: 'For classrooms, schools and districts with 10 or more students',
      classroom_heading: 'Small Classroom',
      classroom_subheading: 'For clubs, after-school programs and small classrooms with 5-9 students.',
      customer_support_info_1: 'Customer support via email or chat',
      customer_support_info_2: 'Customer support via email or chat, plus a dedicated school success manager available via phone or email for implementation support',
      self_serve_credit: 'Self-serve credit card purchase',
      multiple_payment_options: 'Variety of payment options available, including: purchase order, site licenses, & multi-year discounts.',
      admin_dashboard: 'Administrator dashboard with actionable data and insights',
      pd_info: 'Comprehensive 40-hour online course that allows you to learn anytime, anywhere and at any pace.',
      implementation_info: '60 min Onboarding Training on how to use CodeCombat and Ozaria to support specific institutional and instructional goals.',
      ai_league_info: 'Engage students in an exciting esports competition that allows them to showcase their understanding of concepts in a new environment and practice creative problem-solving strategies!',
      ai_custom_tournament: 'AI League Custom Tournament',
      implementation_training: 'Implementation Training',
      full_access_coco: 'Full Access to both CodeCombat',
      and_oz: 'And Ozaria',
      cs_info: 'Computer Science 1-6: 65 sessions',
      wd_info: 'Web Development 1-2: 10 sessions',
      gd_info: 'Game Development 1-3: 20 sessions',
      chap1_info: 'Chapter 1: 10 class sessions',
      chap2_info: 'Chapter 2: 30 class sessions',
      chap3_info: 'Chapter 3: 25 class sessions',
      chap4_info: 'Chapter 4: 20 class sessions',
      includes: 'Includes:',
      show_plan_features: 'Show Plan Features',
      purchase_annually: 'Available for purchase one time annually.',
      class_school_solution: "We'll help you build a solution that meets the needs of your class, school or district.",
      bulk: 'Bulk',
      discounts: 'discounts',
      available: 'available',
      request_quote: 'Request a Quote',
      business_partner_licenses: 'Business Partner Licenses',
      bd_subheading: 'For Business Partners with at least 10 students, get premium access to CodeCombat’s computer science and coding games:',
      bd_info_list_heading: 'CodeCombat is the preferred partner for dozens of coding education businesses because:',
      bd_info_list_1: 'students love our game-based curriculum based in fantasy and adventure and keep coming back for more sessions',
      bd_info_list_2: 'anyone can teach coding with CodeCombat; the game is the primary teacher and we provide extensive support resources',
      bd_info_list_3: 'you will receive over 200 hours of curriculum, providing years of educational content for your business',
      bd_includes_1: 'Full access to CodeCombat and Ozaria with over 200 hours of premium game-based content',
      bd_includes_2: 'Teacher dashboard for record keeping and progress tracking ',
      bd_includes_3: 'Online Resource Hub with walkthroughs and tutorials',
      bd_help: 'For any help, contact',
      manage_stripe: 'Manage Stripe Billing',
      manage_billing_info: 'This will take you to Stripe, where you can handle subscription-related tasks such as reviewing your billing history and updating your payment method.',
      billing_portal: 'Customer Billing Portal',
      email_not_verified: 'Your email is not verified, please verify it from the account settings!',
      stripe_no_data: 'You do not have any data to manage on Stripe portal',
      manage_payment_and_subscription: 'Manage Payment & Subscription',
      discover_more_title: 'Discover More',
      discover_more_desc: 'See everything you have access to with your premium account!',
      billing_portal_desc: 'Manage your subscription, update your payment method, view invoices and more in Stripe.',
      billing_portal_btn: 'Manage billing with Stripe',
      payment_history: 'Payment History',
      payment_history_btn_all: 'View all Invoices',
      payment_history_btn_less: 'View recent Invoices',
    },

    form_validation_errors: {
      required: 'Field is required',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone number',
      emailExists: 'Email already exists',
      nameExists: 'Username already exists',
      numberGreaterThanZero: 'Should be a number greater than 0',
      requireValidEmail: 'Please enter a valid email address.',
      requireValidPhone: 'Please enter a valid phone number, including area code.',
    },

    partners: {
      for: 'for',
      business_partners: 'Business Partners',
      headline: 'Join us in our mission to make coding engaging and accessible to all',
      below_headline_blurb: 'At CodeCombat we’ve developed comprehensive tools that make learning to code fun and teaching programming easy. Our turnkey solutions can be leveraged in many executions.',
      coding_title: 'Coding & STEAM Education Businesses:',
      coding_blurb: 'Valued partners like Code Ninjas and IDEA Lab Kids use our game to teach real Python and JavaScript coding to students in their franchise locations. We offer an easy to use program, implementation resources and training options to ensure an amazing student experience.',
      esports_title: 'Educational Esports Sponsors:',
      esports_blurb: 'We are reinventing what an esport can be while engaging thousands of students to learn to code. Endemic esports mainstay __hyperx__ supported the CodeCombat AI League from its inaugural season, building compelling promotional programs around this unique esport.',
      hyperx: 'HyperX',
      respawn: 'RESPAWN',
      distribution_title: 'International Distribution:',
      distribution_blurb: 'Our programs have served students in over 190 countries and our content is translated into over __forty_languages__. While the US and China are markets where we sell directly, we work closely with local SaaS and EdTech distribution partners around the world to expand our reach',
      forty_languages: '40 languages',
      equity_social_title: 'Tech Equity & Social Impact:',
      equity_social_blurb: 'Not every partnership is built on the bottom line. As a mission-based organization we seek ways to give back as well. We work closely with foundations and other philanthropy partners to expand access to high-quality coding education.  ',
      latin_superstar_blurb: 'Additionally, Latin superstar __eugenio_derbez__ has helped us reach the Latinx community with a partnership to engage students in this often underserved and underrepresented group.',
      reach_latinx: 'reach the Latinx community',
      eugenio_derbez_blurb: '"It is important to me to see Latino boys and girls represented in this space," said Eugenio Derbez. "Coding is the language of the future and if we want to be a part of that future then we need to get our kids coding."',
      seek_relationships_blurb: 'We seek relationships with nonprofits and community-based organizations working with groups underrepresented in computer science and technology careers. Our partnership with __seeds_of_light__ will fund CS educational opportunities for thousands of young learners.',
      seeds_of_light: 'Seeds of Light',
      corporate_team_building_title: 'Corporate Team Building',
      corporate_team_building_blurb: 'Need to engage your employees with a turnkey activity that will inspire their competitive spirit and challenge them to creatively problem solve? Work with us to build a custom competitive coding tournament that will have your team programming their own strategies while playing a game. __see_how__',
      footer_blurb: 'These are just a few of the partnership structures we have successfully supported. If you would like to initiate a discussion with our business development team on any of these models or have a different partnership opportunity, please reach out today.',
      talk_with_us: 'Talk with Us',
      our_partners: 'Our Partners',
      see_how: 'See How',
    },

    podcast: {
      learning_adventure: 'Where learning is always an adventure.',
      explores_stem: 'Our podcast explores the role of technology, STEM, and creative play in education. With expert guests, we discover how learning is always an adventure.',
      listen: 'Listen',
      download: 'Download',
      transcript: 'Transcript',
      learn_more_coco: 'Want to learn more about CodeCombat coding experiences?',
      subscribe: 'Subscribe',
      explore_coco: 'Explore CodeCombat',
      interested_in_being_guest: 'Interested in being a guest on EdTech Adventures?',
      lets_chat: "Let's Chat",
      air_date: 'Air date', // upload date
      play_episode: 'Play Episode',
      about_guest: 'About Our Guest',
      about_guests: 'About Our Guests',
      all_episodes: 'View All Episodes',
      no_permission: "You don't have permission to view this podcast",
      listen_now: 'Listen Now',
      show_all_episodes: 'Show all episodes',
    },

    library: {
      enter_library_card: 'Enter your Library Card Number:',
      access_coco: 'Access CodeCombat',
      already_using_library_id: 'Already using library id',
      play_coco: 'to play CodeCombat',
      not_library_id: 'Not your library id',
      access_using_id: 'to access using your id!!',
      network_detected: 'Library network detected, redirecting you to play CodeCombat',
      not_redirect_auto: "if redirect doesn't happen automatically",
      engage_members: 'Give your members access to the most engaging way to learn coding.',
      importance_blurb: 'Libraries play an important role in advancing educational equity in their communities. Many young learners do not have access or exposure to computer science, and libraries can provide important resources to these underserved groups. That is why we are partnering with libraries across the country to provide access to our game-based learning tools and educational resources.',
      games_teach_blurb: 'Our games teach real typed Python, JavaScript and C++ coding languages through the power of play. The gameplay is paired with a scaffolded curriculum to allow self-paced learners the ability to master foundational programming concepts before moving on to the more complex. Each level challenges the player to type the code necessary to advance their hero and achieve the level goal.',
      platform_built: 'Our platform is built to address the specific needs of libraries and their patrons:',
      accessible: 'Accessible',
      accessible_blurb: 'A basic computer with internet access is all you need to sign-in and start playing. The content is intended for beginners with no prior coding experience.',
      self_paced_intuitive: 'Self-Paced and Intuitive',
      self_paced_intuitive_blurb: 'Teachers are not required as players can dictate the pace at which they move through the curriculum. Our custom code engine and interpreter is designed for beginners, it understands the mistakes kids make and speaks to them using human, beginner-friendly terms.',
      engaging_content: 'Engaging Content',
      engaging_content_blurb: 'Game-based learning drives engagement from the start but perhaps even more importantly keeps students engaged when the concepts get more challenging. In a game environment failure and success are expected and embraced as part of the play experience.',
      api_integrate: 'API integration',
      api_integrate_blurb: 'Our games can be easily incorporated into your digital library interface through EZProxy or other popular systems. This structure provides instant access with the members’ existing log in and no staff is needed to manage any logistics of licensing or access.',
      privacy: 'Privacy',
      privacy_blurb: 'We take user safety, cybersecurity, and data privacy seriously, following many stringent privacy regulations, like COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, and GDPR. These policies and protective measures have let us securely serve over twenty million users around the world.',
      privacy_policy: 'our full privacy policy.',
      see: 'See',
      communication_limit: 'Communication Limits',
      communication_limit_blurb: 'To ensure the security of your members, we do not offer in-game chat or other communication features between players, however we do allow members to safely share their coding projects with friends, family and the CodeCombat community. We restrict any upsell or marketing messaging to provide an uninterrupted experience for your patrons.',
      usage_stats: 'Usage Stats',
      usage_stats_blurb: 'Gain insight to your members’ usage with our snapshot reporting tool. It provides access to usage stats at any time, including monthly active users, licensed days used and more valuable data points.',
      esports: 'Academic Esports',
      esports_blurb: 'Our esports program offers an opportunity to further engage your members through a fun and exciting competition. The AI League allows members to showcase their understanding of coding concepts in a new environment and practice problem solving strategies as they go head to head in battle against the global community.',
      work_with_us_blurb: 'Work with us to unlock the next generation of engineers, programmers and CS professionals in your community.',
      schedule_demo: 'Schedule a Demo',
      license_modal_subtitle: 'Please complete this short form and one of our library specialists will reach out to provide a demo and custom pricing options!',
      license_modal_members: 'Members Needing Access',
      license_modal_members_placeholder: 'Approximately how many members will need access?',
      license_modal_contact: 'Contact Our Team',
      license_days_used: 'License days used',
      licenses_used: 'Licenses used',
      users_active_licenses: 'Users with active licenses',
      lines_code: 'Lines of Code',
      programs_written: 'Programs written',
      time_spent_min: 'Time spent (in min)',
      month: 'Month',
      teacher_classroom_name: 'Teacher or classroom name',
      already_logged_in: 'Already logged in, please logout from the top navigation bar to login again.',
      search_box_option: "If search box doesn't load, login by clicking",
      new_signups: 'New Signups',
      heading_for: 'for',
      heading_libraries: 'Libraries',
      educational_equity: 'Educational Equity',
      power_of_play: 'Power of play',
      library_card: 'Library Card Number',
      library_signup_promotion: 'Sign Up to save progress and continue from where you left off on CodeCombat!!',
      welcome_dashboard: 'Welcome to your dashboard',
      total_licenses_used: 'Total Licenses Used',
      from_launch_date: 'from the date of launch',
      renewal_date: 'Renewal Date',
      access_old_dashboard: 'If you want to access the old dashboard, visit',
      loading_from: 'loading data from',
      user_activities: 'User Activities',
      total_users: 'Total Users',
      lines_of_code_written: 'Lines of Code Written',
      hours_spent: 'Hours spent',
      time_spent: 'Time spent (in minutes)',
      new_users: 'New Users',
      age_demographics: 'Age demographics',
      levels_completed: 'Levels Completed',
      adjust_dates_explore: 'Adjust the dates below to explore patron usage trends over time.',
    },

    related_accounts: {
      subtitle: 'Add connections between different CodeCombat accounts to be able to quickly switch between them. For example, as a parent, you could switch to viewing CodeCombat from your kids’ accounts. Or, as a teacher, you could add a test student account for yourself to see what your students see.',
      wrong_account: 'Please log in to the correct account to confirm the account linking. Log In to the account and open link from email again.',
      link_account: 'Link your account to',
      link_successful_redirect: 'Account linked successfully, redirecting',
      add_related_user: 'Add Related User',
      adding: 'Adding',
      removing: 'Removing',
      added: 'Account added',
      related_email: 'Related User Email',
      relation: 'Relation',
      bi_directional: 'Bi-directional',
      account_exists: 'Account exists',
      link_using_email: 'Link account using confirmation email',
      link_using_email_blurb: 'User will receive a mail on __email__. Please ask the user to confirm linking by pressing on link present in email.',
      account_not_exist: 'Account does not exist',
      account_type: 'Account Type',
      create_account_and_email: 'Create account and send email to link',
      authenticate: 'Authenticate',
      invite: 'Invite',
      auth_using_pass: 'Authenticate using __email__ password',
      related_users: 'Related Users',
      no_related_users: 'No related users right now',
      send_verify_email: 'Send Verify Email',
      verified: 'Verified',
      switch: 'Switch',
      title: 'Related Accounts',
      bi_directional_help_text: 'Allow added user to switch to your account?',
    },

    modal_free_class: {
      paragraph_1: 'Thank you for choosing CodeCombat.',
      paragraph_2: 'Our team is eager to connect with you to get your child scheduled for a free trial class.',
      paragraph_3: 'Please provide your contact information and one of our learning advisors will call you to gather student information, identify a teacher based on your child’s preferred learning style and to schedule the trial class.',
      name: 'Name',
      phone_number: 'Phone Number',
      available: 'Are you available to talk now?',
      yes: 'Yes',
      no: 'No',
      preferred_time: "Preferred time for call if we can't connect now",
      anytime: 'Anytime',
      morning: 'Morning (8AM - 12PM)',
      afternoon: 'Afternoon (12PM - 4PM)',
      evening: 'Evening (4PM - 8PM)',
      time_zone: 'Your Time Zone',
      email: 'Email',
    },

    mobile_landing: {
      subtitle: 'Get free access to the most engaging way to teach CS',
      you_re_set: "YOU'RE SET!",
      done_blurb: 'Check your email for instructions on accessing your teacher account. For the best experience, we suggest using a device with an external keyboard and larger screen.',
      step_email: 'STEP 1',
      step_name: 'STEP 2',
      step_done: 'DONE',
      video_title: 'GET A SNEAK PEEK HERE',
      email_confirm: 'The email address "__email__" is already registered. Would you like to login?',
    },

    roblox_landing: {
      meta_title: 'CodeCombat Worlds on Roblox: Play, Code and Create',
      headline: 'Empowering Every Player to Become a Creator!',
      subhead: 'Experience the easiest and most enjoyable way to code and create your own Roblox games',
      join_the_beta: 'Join the Beta',
      sign_up: 'Sign Up',
      box_play_subhead: 'Play',
      box_code_subhead: 'Code',
      box_create_subhead: 'Create',
      box_headline: 'Play, Code and Create on Roblox',
      box_play_blurb_teacher: 'In partnership with Roblox Education, we are combining our proven coding-as-gameplay approach with the creative and social power of the Roblox platform to make a new Roblox experience that teaches coding and game development in-game.',
      box_code_blurb_teacher: 'The experience will be personalized and differentiated, offering structured and unstructured intuitive practice that allows the player to learn as they like, while still aligning with CSTA and ISTE computer science standards.',
      box_create_blurb_teacher: 'This engaging play experience will provide the foundational instruction needed to take players from zero coding knowledge to publishing full Roblox games. Our Creative Mode lets players build while playing, without requiring switching modes to the full desktop Roblox Studio IDE.',
      box_play_blurb_player: 'Explore the 3D immersive experience of CodeCombat Worlds. Program your pets and adventure into a universe of creativity and shared experiences with friends.',
      box_code_blurb_player: 'Learn real Lua coding, from beginner to advanced. Use code to explore, gather resources, build, and discover your path to glory.',
      box_create_blurb_player: 'No Roblox Studio? No problem. Code in-game in Creative Mode to make full Roblox games to share with your friends.',
      box_play_blurb_parent: 'Through our proven game-based learning approach, we engage young learners through play, while teaching coding and game development.',
      box_code_blurb_parent: 'Coding from the very start of their adventure, the experience is personalized and differentiated, offering structured and unstructured intuitive practice that allows your child to learn as they like.',
      box_create_blurb_parent: 'Many kids want to create games but don’t know where to start. This engaging play experience will provide the foundational instruction needed to take players from zero coding knowledge to publishing full Roblox games.',
      box_play_blurb_partner: 'Engage young learners with a next-generation Roblox experience. With support from Roblox Education, we are combining our proven coding-as-gameplay approach with the creative and social power of the Roblox platform to make a new Roblox experience that teaches coding and game development in-game.',
      box_code_blurb_partner: 'The experience will be personalized and differentiated, offering structured and unstructured intuitive practice that allows the player to learn as they like. We make it easier than ever to teach real coding to your students in either self-paced or instructor-directed contexts.',
      box_create_blurb_partner: 'Instead of building a standalone curriculum tied to Roblox Studio, take advantage of our in-game Creative Mode and its scaffolded instruction to easily ramp your students from no coding experience to publishing full Roblox games.',
      role_teacher: 'Teacher',
      role_player: 'Player',
      role_parent: 'Parent',
      role_partner: 'Partner',
      select_role: 'Please select your role',
      question_1: 'Do I need to know Lua or Roblox Studio?',
      answer_1: 'No. This experience will allow anyone to play, code and create from the very start of their adventure, without any coding experience.',
      question_2: 'Can I create my own games?',
      answer_2: 'Yes. Game development is at the core of this experience and after completing the core learning levels you will have the opportunity to create your own.',
      question_3: 'Will my creations be available on Roblox?',
      answer_3: 'Yes. Anything you create in this experience, you will be able to import into Roblox Studio and then publish to the platform for anyone to play.',
      bottom_blurb_parent: 'No need to wait - __sign-up__ for our live online classes to get your child coding today! Get them started with CodeCombat web to be the first to get access to the CodeCombat Worlds Roblox experience.',
      bottom_blurb_sign_up: 'Sign up',
      bottom_blurb_partner: 'Want to use the new CodeCombat Worlds Roblox experience for your education business, social impact initiative or international distribution opportunity? __reach-out__ to discuss partnering today.',
      bottom_blurb_reach_out: 'Reach out',
      boxes_title: 'Play, Code and Create on Roblox',
      login_message: 'You need to login before connecting your account to Roblox',
      connect_button_header: 'Account Linking Rewards',
      connect_button_linker_badge: 'Linker Badge',
      connect_button_accounts_linked: 'Accounts Linked',
      connect_button_pet_chroma: 'Pet Chroma',
      connect_button_exclusive_pet: 'Exclusive Pet',
      connect_button_blurb: 'Link your CodeCombat and Roblox accounts for a seamless experience!',
      connect_button_list_item_1: 'Manage subscriptions',
      connect_button_list_item_2: 'Unlock additional content',
      connect_button_list_item_3: 'Track progress',
      connect_button_list_item_4: 'Receive exclusive rewards',
      connect_button_list_item_5: 'Access curricular resources',
      connect_button_list_item_6: 'Parent and teacher dashboard access',
      connect_button_list_item_7: 'Unlock generative AI features',
      connect_button_list_item_8: 'Creative mode publishing and exporting',
      connect_button_connected_blurb: 'Congratulations, you have linked your accounts! Invite your friends to help reach the community linking goals.',
      connect_button_not_connected_blurb: "The more people link their accounts, the more rewards you'll receive!",
      faq_bottom: 'See more <a href="https://codecombat.zendesk.com/hc/en-us/categories/18084251471383-CodeCombat-Worlds-Roblox-" target="_blank">frequently asked questions in our help center</a>. <br />If you have any other questions, please <a href="mailto:support@codecombat.com">Contact Us</a>.',
      modal_title: 'CodeCombat Worlds<br> Now Live on Roblox!',
      modal_play_now: 'PLAY NOW!',
      modal_button_link_roblox_account: 'Link Roblox Account',
      age_restriction: 'You must be 13 years or older to link your Roblox account.',
    },

    ai: {
      prompt_level_chat_1: 'What does this error mean?',
      prompt_level_chat_2: 'Please explain this error.',
      prompt_level_chat_3: 'What\'s wrong?',
      prompt_level_chat_4: 'Please help explain this.',
      prompt_level_chat_5: 'How can I fix it?',
      prompt_level_chat_6: 'Help, please.',
      prompt_level_chat_7: 'What do I do?',
      prompt_level_chat_8: 'What does this mean?',
      prompt_level_chat_9: 'Please explain.',
      prompt_level_chat_10: 'What is this error?',
      prompt_level_chat_11: 'What is the problem?',
      prompt_level_chat_12: '???',
      prompt_level_chat_13: 'Dear AI, I beseech you, explain my error, in verse.',
      prompt_level_chat_hint_1: 'Can I get a hint?',
      prompt_level_chat_hint_2: "What's the next thing I should do?",
      prompt_level_chat_hint_3: 'Please help me with the next part of my code.',
      prompt_level_chat_hint_4: 'Coding hint, please.',
      prompt_level_chat_hint_5: 'I need a hint on the next step.',
      hackstack_promotion: 'Unlock the Full Potential of Generative AI',
      try_it_free: 'Try it free',
      hackstack_promotion_blurb: 'New to AI? Explore <b>CodeCombat AI HackStack</b> – the simplest route to AI literacy. Unlock the potential of ChatGPT-4, Claude, Stable Diffusion, and DALL-E. This innovative tool offers hands-on AI training, making creation effortless.',
      generate: 'Generate',
      games: 'Games',
      art: 'Art',
      websites: 'Websites',
      code_more: 'Code and more',
      ideal_endeavour: "It's the ideal companion for any endeavor.",
      ai_made_ss: 'AI Made Simple & Safe -- Start Today!',
      aiss_body: 'Built as the simplest path to AI literacy, this tool empowers learners to harness top LLMs with hands-on AI training, making creation easy—whether it’s games, art, writing, code, or more. Together, we help learners safely bring their ideas to life across any subject.',
      learn_more: 'Learn More!',
    },
    user_credits: {
      level_chat_left_in_duration: '__credits__ AI Bot queries left for the __duration_key__',
      level_chat_left_in_duration_multiple: '__credits__ AI Bot queries left for __duration_amount__ __duration_key__',
      level_chat_no_credits_left_duration: 'No AI Bot queries left for the __duration_key__',
      level_chat_no_credits_left_duration_multiple: 'No AI Bot queries left for __duration_amount__ __duration_key__',
      level_chat_no_credits_left: 'No AI Bot queries left',
      level_chat_duration_hour: 'hour',
      level_chat_duration_day: 'day',
      level_chat_duration_week: 'week',
      level_chat_duration_month: 'month',
      level_chat_duration_year: 'year',
    },
    home_v3: {
      mission_title: 'Join us in our mission to make coding and AI accessible to all.',
      mission_supporting_text: 'We’re committed to delivering high quality education solutions that empower everyone to realize their potential and help shape a better future.',
      stat_card_1_text: '20 Million',
      stat_card_1_description: 'Engaged Students',
      stat_card_2_text: '1 Billion',
      stat_card_2_description: 'Lines of Code',
      stat_card_3_text: '320,000',
      stat_card_3_description: 'Supported Teachers',
      stat_card_4_text: '75,000',
      stat_card_4_description: 'Schools Reached',
      stat_card_5_text: '190+',
      stat_card_5_description: 'Countries',
      stat_card_6_text: '5.2 Million',
      stat_card_6_description: 'ESports Players',
      learn_to_code: 'Learn to **code** and use **AI**, all through the **power of play**.',
      innovative_play_experiences: 'We create innovative play experiences to make computer science engaging and accessible to all.',
      sign_up_today: 'Sign-up today to play for free and explore our games and resources.',
      im_an_educator: 'I’m an Educator',
      im_a_parent: 'I’m a Parent',
      im_a_student: 'I’m a Student',
      programming_languages: 'Programming Languages & AI Tools',
      engaging_play_experiences: 'Engaging Play Experiences',
      for_younger_learners: 'For Younger Learners',
      your_turnkey_solutions: 'Your Turnkey Solutions',
      trends_insights: 'Trends & Insights',
      awards_partners: 'Awards & Partners',
      faq_visit_help_center: 'For answers to frequently asked questions visit our **help center**.',
      contact_us: 'Contact Us',
      for_further_questions: 'For further questions',
      education_partner: 'Education[NEWLINE]Partner',
      official_member: 'Official[NEWLINE]Member',
      best_creativity_tool_for_students: 'Best Creativity[NEWLINE]Tool for Students',
      official_partner: 'Official[NEWLINE]Partner',
      hour_of_code_activity_partner: 'Hour of Code[NEWLINE]Activity Partner',
      top_pick_for_learning: 'Top Pick for[NEWLINE]Learning',
      testimonals_1_title: '“One thing I am able to do now, that I could not do before, is actually believe I can code.”',
      testimonals_1_name: 'Mountain Ridge Middle School Student',
      testimonals_2_title: '"Name any program online, I’ve tried it. None of them match up to CodeCombat & Ozaria. Any teacher who wants their students to learn how to code... start here!"',
      testimonals_2_name: 'Scott Baily, Bobby Duke Middle School',
      testimonals_3_title: '"I’ve always had aspirations of designing video games and learning how to code ... this is giving me a great starting point."',
      testimonals_3_name: 'Joey, 10th Grade',
      testimonals_4_title: '"What I love the most about CodeCombat is that it does not simplify coding. The students are learning to write actual code, yet doing it in such a way that they are having fun.”',
      testimonals_4_name: 'Sandra Ahlstrom, Teacher, Sheridan County School District #2',
      carousel_1_title: 'Game-Based[NEWLINE]Learning',
      carousel_1_text: 'With our unique approach, students embrace learning as they play and write code from the very start of their adventure, promoting active learning and a growth mindset.',
      carousel_2_title: 'Text-Based[NEWLINE]Coding',
      carousel_2_text: 'Our custom code engine and interpreter is designed for beginners, teaching true Python, JavaScript, and C++ programming languages using human, beginner-friendly terms.',
      carousel_3_title: 'Project-Based[NEWLINE]Assessments',
      carousel_3_text: 'These projects are an opportunity for students to code their own shareable games. We provide evaluation rubrics so that you can use Capstone projects as your primary summative assessments.',
      carousel_4_title: 'AI[NEWLINE]Acceleration',
      carousel_4_text: 'We teach students how to use AI to expedite learning and advance their coding abilities. This powerful combination unlocks the creative potential of those at every skill level.',
      carousel_5_title: 'Educator[NEWLINE]Empowerment',
      carousel_5_text: 'Our classroom solutions are built with all the support and resources any educator would need to implement the curriculum and drive successful outcomes.',
      carousel_6_title: 'Student[NEWLINE]Impact',
      carousel_6_text: 'Our products have helped over 20 million students enjoy learning Computer Science, teaching them to be critical, confident, and creative learners. We engage all students, regardless of experience, helping them to realize a pathway to success in Computer Science.',
      engaging_boxes_1_title: 'Ozaria Classroom',
      engaging_boxes_1_text: 'A narrative coding adventure that establishes the fundamentals of computer science.',
      engaging_boxes_2_title: 'CodeCombat Classroom',
      engaging_boxes_2_text: 'A full CS curriculum that builds from core concepts all the way through web development, game development and **[https://codecombat.com/apcsp]AP CSP**.',
      engaging_boxes_3_title: 'CodeCombat Worlds on Roblox',
      engaging_boxes_3_text: 'In partnership with Roblox Education, this AI enabled experience super-charges student coding abilities and provides a real-world platform to create amazing games and experiences.',
      engaging_boxes_4_title: 'CodeCombat AI League Esports',
      engaging_boxes_4_text: 'An epic competitive coding esports platform that encourages creative programming in a game-based environment.',
      engaging_boxes_5_title: 'CodeCombat AI HackStack',
      engaging_boxes_5_text: 'The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety. Blending simplicity and power, the platform accelerates student abilities and unleashes their creative potential.',
      engaging_boxes_6_title: 'CodeCombat Home',
      engaging_boxes_6_text: 'With access to over 530 levels and exclusive features like pets, premium-only items, and heroes, your child can fully immerse themselves in the world of coding. They can even design games to challenge their friends, build websites and apps to share.',
      young_learners_1_title: 'CodeCombat Junior',
      young_learners_1_text: 'Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.',
      young_learners_1_linkText: 'Sign up for Beta Access',
      young_learners_2_title: 'AI Junior',
      young_learners_2_text: 'Introduces multi-modal generative AI in a simple and intuitive platform designed specifically for K-5 students.',
      young_learners_2_linkText: 'Sign up for Beta Access',
      solutions_1_title: 'Professional Development',
      solutions_1_text: 'Built to empower all teachers with the skills, knowledge, and confidence to effectively teach computer science.',
      solutions_1_middleText: 'Earn up to 6 graduate credits.',
      solutions_1_linkText: 'Try it now',
      solutions_2_title: 'AP CSP Exam Preperations',
      solutions_2_text: 'We are recognized by the College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.',
      solutions_2_linkText: 'Try it now',
      solutions_3_title: 'Grant and Funding Sources',
      solutions_3_text: 'We understand the funding hurdles that schools encounter and are passionate about helping to overcome these obstacles. Check out our comprehensive guide to grant funding or speak with our team to learn more.',
      solutions_4_title: 'District-Level Solutions',
      solutions_4_text: 'Our innovative solutions have helped districts across the country expand or start their computer science programs. Designed with feedback from our community of over 320,000 educators, our comprehensive solution provides a responsive and flexible curriculum that meets the needs of all students and educators. It’s easy to implement and scale with our team providing the training and support your teachers need.',
      solutions_5_title: 'Live Online Classes',
      solutions_5_text: 'Our online coding classes combine the power of gameplay and personalized instruction for an experience your child will love. From coding and publishing their own Roblox games, to building a website for a new business, your child will explore all that is possible with AI and coding.',
      solutions_6_title: 'CodeQuest',
      solutions_6_text: 'Join us for an immersive educational experience like no other, designed to inspire and empower the next generation of computer science innovators. This rare opportunity brings together students from around the globe to participate in a series of coding hackathons, learn from notable speakers and visit top universities and technology organizations.',
      solutions_6_linkText: 'Discover More',
      solutions_7_title: 'Partner Solutions',
      solutions_7_text: 'Join our mission to make coding accessible and engaging for all by becoming a valued partner. Our flexible partnership structures include educational businesses, esports sponsors, international distributors, and social impact organizations. Partners receive access to our easy-to-use programs, implementation resources, and training options for a successful and enjoyable experience.',
      solutions_8_title: 'Library Solutions',
      solutions_8_text: 'As an entirely self-paced and self-directed digital resource, CodeCombat is the best integration for libraries that want to empower their members of all ages to learn how to code. Our platform offers everything learners need to experience a high-level coding education through a uniquely exciting, game-based curriculum. Perfect for beginners all the way up to those who want to master college-level coding concepts.',
      learn_more_text: 'Discover More',
      best_homeschool_curriculum: 'Best Homeschool[NEWLINE]Curriculum',
      sign_up_free: 'Sign Up Free',
      try_it_now: 'Try it now',
      junior_modal_header: 'Try Our New K-5 Curriculum Today!',
      junior_modal_body: 'Perfect for K-5 classrooms, this new curriculum features real coding with icons, drag-and-drop blocks, parallel blocks with text, or purely text-based options. Plus, it’s fully accessible on tablets making it easy to support all learners.',
      hs_modal_header: 'Unlock Free AI Access This Summer',
      hs_modal_body: 'Discover how educators innovate with our AI -- watch the quick demo! This summer, explore Claude, DALL-E, Stable Diffusion, and more. Book a brief meeting by August 15 to claim your free 90-day AI educator license -- We\'ll handle the setup so you can dive right in.',
      get_started: 'Get Started!',
    },
    schools_page: {
      meta_title: 'CodeCombat: the most effective computer science solution for schools',
      most_effective_computer_science_solution: 'The most effective computer science solution for **schools**',
      our_comprehensive_implementation: 'Our comprehensive implementation empowers teachers, engages students and delivers successful outcomes.',
      start_teach_trial: 'Start teaching today with free trial access to all games and teaching resources.',
      get_my_solution: 'Get My Solution',
      flexible_standards_aligned_curriculum_title: 'A Flexible Standards Aligned Curriculum',
      flexible_standards_aligned_curriculum_text: 'Our scaffolded approach covers computer science fundamentals up through advanced courses and features **[https://codecombat.com/apcsp]College Board endorsed AP CSP**, web and game development. We build customized pathways to deliver a personalized learning experience that meets **[https://codecombat.com/standards]CSTA, ISTE and Common Core State Standards**. The flexible curriculum offers the ability to teach Python, JavaScript, C++, Luau and more.',
      comprehensive_tools_resources_title: 'Comprehensive Tools & Resources',
      comprehensive_tools_resources_text: 'The teacher resource hub empowers all educators to teach on day one. Easily access lesson plans, student-facing lesson slides, rubrics, extension activities, capstone projects and assessments. Our safe AI integrations accelerate student potential and allow educators to optimize class time. For real-world practice and application, we offer competitive coding esports, Roblox game design and web design options. Additionally, educators can control student pacing with content assignment and locking features.',
      accessible_data_insights_title: 'Accessible Data & Insights',
      accessible_data_insights_text: 'We provide administrators the insight they need with real-time usage data and progress reports at the class, school, district and state level. Student level progress tracking enables educators to easily identify when intervention is needed and the built in pre and post module assessments measure student comprehension.',
      high_quality_professional_development_title: 'High Quality Professional Development',
      high_quality_professional_development_text: '**[https://csteachers.org/pd-opportunities/accredited-pd/]Endorsed by the Computer Science Teachers Association (CSTA)**, the course provides 44+ hours of self-directed, web-based, and on-demand learning. The program is self-paced and designed to fit any busy schedule. The course prepares anyone with or without teaching experience to successfully implement a CS curriculum.',
      earn_up_to_3_graduate_credits: 'Earn up to 6 graduate credits with this course.',
      request_a_demo: 'Request a Demo',
      maximize_your_impact: 'All the tools to maximize learning outcomes',
      core_curriculum: 'Core Curriculum',
      practice_enrichment: 'Practice & Enrichment',
      student_acceleration_ap_csp: 'Student Acceleration & AP CSP',
      ai_enhanced_core_curriculum: 'AI-Enhanced Core Curriculum',
      young_learners: 'Young Learners',
      funding_solutions: 'Funding Solutions',
      support_development: 'Support & Development',
      ai_support_acceleration_title: 'AI Support & Acceleration',
      ai_support_acceleration_text: 'We use AI to make teaching time more effective. CodeCombat now supports an AI hints feature that evaluates code, points out errors, and explains how to fix them. Most importantly, it provides all the context needed to understand the why, without revealing the entire solution. Students will still need to work through each level’s coding challenge but now you don’t need to stop class to address individual needs. **Teachers receive an allocation of 100 AI hints per day** and **each student gets 5 AI hints per day**, to ensure they always have the support they need.',
      codecombat_ai_hackstack_text: 'For those new to AI, we offer **CodeCombat AI HackStack**. This innovative tool not only teaches students how to use AI but provides secure access to many of the latest LLMs including ChatGPT-4, Claude, Stable Diffusion, DALL-E and others. After just a short time working through the training mode, users unlock the full creative potential of the tool, allowing prompt-to-code-to-published projects in minutes. This AI-powered application enables users to generate games, art, websites, code and more. **Teachers receive an allocation of 100 AI prompts per month** and **each student gets 10 AI prompts per week**, to create multiple AI projects.',
      pathways_for_success: 'Pathways for Success',
      for_your_custom_pathway: 'For Your Custom Pathway',
      elementary_school: 'Elementary School',
      codecombat_jr: 'CodeCombat Junior',
      ai_hacksstack_jr: 'AI Junior',
      codecombat_worlds: 'CodeCombat Worlds',
      k: 'K',
      icons_block_based: 'Icons & Block-Based',
      introduction_to_ai: 'Introduction to AI',
      grade_1: 'Grade 1',
      simple_ai_templates: 'Simple AI Templates',
      grade_2: 'Grade 2',
      complex_ai_templates: 'Complex AI Templates',
      explorations: 'Explorations',
      grade_3: 'Grade 3',
      block_based: 'Block-Based',
      grade_4: 'Grade 4',
      block_based_text: 'Block-Based & Text',
      grade_5: 'Grade 5',
      text: 'Text',
      our_k_5_implementation_pathway: 'Our K-5 Implementation Pathway will introduce two new **beginner friendly** platforms which include CodeCombat Junior, our flagship elementary level curriculum features a progression of learning levels that **teach basic coding concepts at a slower pace**, and AI Junior, a **multimodal  AI tool** that allows students to sketch, write, and design their own digital products.This scaffolded progression will let students grow with our immersive content and explore a wide variety of computational thinking and computer science concepts',
      middle_school: 'Middle School',
      high_school: 'High School',
      ozaria: 'Ozaria',
      ai_hackstack: 'AI HackStack',
      ai_league: 'AI League',
      grade_6: 'Grade 6',
      introduction_to_coding: 'Introduction to Coding',
      introduction_to_luau_coding: 'Introduction to Lua Coding',
      introduction_to_coding_esports: 'Introduction to Coding Esports',
      grade_7: 'Grade 7',
      loops_structures: 'Loops & Structures',
      introduction_to_creative_mode: 'Introduction to Creative Mode',
      ai_scenarios: 'AI Scenarios',
      competitive_coding_arenas: 'Competitive Coding Arenas',
      grade_8: 'Grade 8',
      functions_data: 'Functions & Data',
      game_development: 'Game Development',
      open_ended_ai_projects: 'Open-Ended AI Projects',
      middle_school_implementation: 'Our middle school implementation establishes a **foundation of coding concepts** with Ozaria, our core Computer Science curriculum. This eventually expands to more voice and choice, where students will **explore coding and AI** across three diverse platforms. The **educator and students can choose** how deeply they will explore each of these additional platforms.',
      codecombat: 'CodeCombat',
      ap_csp: 'AP CSP',
      cs1_4_data_science_cybersecurity_exam_content: 'CS1-4 [NEWLINE] Data Science [NEWLINE] Cybersecurity [NEWLINE] Exam Content',
      advanced_cs: 'Advanced CS',
      cs5_6_gd1_3_wd1_2: 'CS 5-6 [NEWLINE] GD 1-3 [NEWLINE] WD 1-2',
      advanced_game_development: 'Advanced Game Development',
      advanced_ai_projects: 'Advanced AI Projects',
      global_esports_tournament: 'Global Esports Tournament',
      first_year_high_school_curriculum: 'The first year of our high school curriculum focuses on **AP CS Principles**, which includes our CodeCombat courses, CS1−CS4 and exam curriculum content such as **Data Science** and **Computing Systems**. The more advanced year allows students to explore more of our **advanced CS courses** and offers voice and choice across our three platforms.',
      accessibility_representation_title: 'Accessibility & Representation',
      accessibility_representation_text: 'Our student-centric design meets students where they are and provides them with the support they need. In-person and remote learning capabilities allow students to learn anywhere, anytime. Keyboard accessibility, full-screen reader compatibility and colorblind-friendly color scheme ensures everyone can learn to code.',
      accessibility_acr_prefix: 'We meet WCAG 2.1 Level AA and Revised Section 508 Standards. See our',
      accessibility_acr_link_text: 'Accessibility Compliance Report (ACR) / VPAT',
      accessibility_acr_suffix: 'for more information.',
      privacy_security_title: 'Privacy & Security',
      privacy_security_text: 'We take student safety, cybersecurity, and data privacy seriously, and follow the stringent school-grade privacy regulations including COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, as well as GDPR. All data is stored securely on Amazon Web Services in the US. our AI integrations have guardrails to protect Personal Identifiable Information and restrict sensitive content. Project sharing is controlled and peer-to-peer communication is restricted. Data Processing Agreements are available, visit **https://codecombat.com/privacy** for more information.',
      contact_our_team: 'Contact Our Team',
      for_turnkey_solutions: 'For your turnkey solution',
      testimonials_1_quote: '“Let me make this clear first. I recommend your product because it is the best programming teaching tool currently on Earth.”',
      testimonials_1_name: 'Seth Reichelson',
      testimonials_1_title: 'AP Computer Science Teacher, Lake Brantley High School. White House Champion of Change Winner',
      testimonials_2_quote: "“[Ozaria] is a full curriculum for computer science education, it’s super impressive, very extensive [...] It’s got everything you need [...] I don't know that we've seen anything with this much extra stuff to help you teach it well.”",
      testimonials_2_name: 'Tanner Higgin',
      testimonials_2_title: 'Editorial Director - Learning Content, Common Sense Education',
      testimonials_2_full_review_text: 'Full Review Here',
      testimonials_3_quote: '“CodeCombat was one of the easiest to implement programs we’ve piloted and student engagement was extremely high. The way the content is designed, scaffolds perfectly and allows students to quickly move into high level programming skills far beyond anything we could have hoped for.”',
      testimonials_3_name: 'Steve Kong',
      testimonials_3_title: 'Instructional Services Specialist, Riverside Unified School District',
      testimonials_4_quote: '“One thing I am able to do now that I could not do before is actually believe I can code.”',
      testimonials_4_name: '',
      testimonials_4_title: 'Mountain Ridge Middle School Student',
      testimonials_5_quote: '“CodeCombat has transformed how I teach coding...I utilize the great teacher resources including Curriculum Guides, Project Guides, and Solutions. Using CodeCombat has helped me to teach fairly advanced concepts in a way the students enjoy and understand. What I love the most about CodeCombat is that it does not simplify coding. The students are learning to write actual code, yet doing it in such a way that they are having fun.”',
      testimonials_5_name: 'Sandra Ahlstrom',
      testimonials_5_title: 'Teacher, Sheridan County School District #2',
      faq_1_question: 'What you need to know about certification exams and AP CSP',
      faq_1_answer: 'Career Technical Education (CTE) programs in the U.S. focus on equipping students with industry-valued skills and can lead to trade school or college education. Mandated by state and federal laws, CTE programs must offer students postgraduate credit, industry certifications, or internship hours. While some fields, like cybersecurity, offer valued certification exams, others such as software engineering prioritize four-year degrees over such exams. However, passing the AP Computer Science Principles exam serves as a recognized avenue to postsecondary credit, enabling students to bypass costly and time-consuming college requirements. To help prepare students CodeCombat provides an **[https://codecombat.com/apcsp]AP CSP course**, endorsed by the College Board.',
      faq_2_question: 'How we use AI to support educators',
      faq_2_answer: "We use AI to make teaching time more effective. With growing class sizes and limited time for personalized instruction our AI-powered level chat assistant is the perfect tool to take care of your students' individual questions. This powerful helper can evaluate code, point out errors, explain how to fix them, and provide all the context they need to understand the “why”. And most importantly it will not give them the solution. With only next line assistance available students will still need to work through each level's coding challenge but now you don’t need to stop class to address individual needs.",
      faq_3_question: 'How we integrate AI safely and responsibly',
      faq_3_answer: 'Our AI technology adheres to safety-first principles, providing confidence to both students and educators. We do not allow our backend LLM providers to train your chats and have established protective measures against inappropriate content. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating students about potential AI pitfalls. Moreover, we log AI chat activity for teacher monitoring and uphold stringent data privacy and security protocols.',
      faq_4_question: 'Why computer science is important',
      faq_4_answer: "Computer science education provides the immediate benefits of boosting problem-solving competencies, sharpening mathematical abilities, and encourages the logical thinking necessary for success across other core school subjects. The learning extends far beyond the code, enhancing students' capability to solve complex problems and adapt to different situations. See how Ozaria helps make those **[https://docs.google.com/presentation/d/1xcc1tw4k8oY9basXuxO0v_RU9z-Dr8ImvbvbuNvJeHA/edit#slide=id.g134a7e7c8f1_0_3]cross curricular connections**. Our curriculum is designed to equip students today with the crucial computer science skills that will prepare them for the digital jobs of tomorrow.",
      faq_5_question: 'Why game-based learning works',
      faq_5_answer: 'Game-based learning is so effective because it provides a safe environment where failure is not feared but expected, offering an opportunity for growth and understanding. This approach encourages students to learn from their mistakes and adapt their strategies for success. Furthermore, the interactive and dynamic nature of games helps students retain information more effectively, as they are learning through practical, hands-on experiences. It actively engages students in the learning process, increasing their motivation and enjoyment.',
      faq_6_question: 'How to find alternative funding sources',
      faq_6_answer: "Computer science education has become a vital component of a student's academic journey, however, many schools face challenges in securing the necessary resources to provide their students with comprehensive computer science programs. At CodeCombat, we understand the funding hurdles that schools encounter and are passionate about helping them overcome these obstacles. Grants can be a valuable resource but difficult to discover and apply for. Check out our comprehensive **[https://codecombat.com/grants]guide to grant funding** or speak with our team to learn more.",
      faq_7_question: 'How to get started',
      faq_7_answer_1: 'Create your Teacher or Admin Account',
      faq_7_answer_2: 'Create a class',
      faq_7_answer_3: 'Add students',
      faq_7_answer_4: 'Sit back and watch your students have fun learning to code',
      faq_8_question: 'Support for Clever and Google login',
      faq_8_answer: 'We offer both Clever and Google Classroom integration. Check out our **[https://codecombat.com/teachers/resources/clever-faq]Clever Integration FAQ** for more details on how to get started.  If you are using Google Classroom be sure to use the Google Single Sign-On (SSO) Modal to sign up for your teacher account. If you already have an account using your Google email, use the Google SSO modal to log in next time. In the Create Class modal, you will see an option to Link Google Classroom. We only support rostering via Google Classroom at this time. Note: you must use Google SSO to sign up or log in at least once in order to see the Google Classroom integration option.',
      faq_9_question: 'Recommended browser and operating system',
      faq_9_answer: 'CodeCombat and Ozaria run best on computers with at least 4GB of RAM, on a modern browser such as Chrome, Safari, Firefox, or Edge. Chromebooks with 2GB of RAM may have minor graphics issues in later courses. A minimum of 200 Kbps bandwidth per student is required, although 1+ Mbps is recommended.',
      core_curriculum_1_title: 'Ozaria Classroom',
      core_curriculum_1_text: 'A narrative coding adventure that establishes the fundamentals of computer science.',
      core_curriculum_1_link_text: 'Try it now',
      core_curriculum_2_title: 'CodeCombat Classroom',
      core_curriculum_2_text: 'A full CS curriculum that builds from core concepts all the way through web development, game development and **[http://codecombat.com/apcsp]AP CSP**.',
      core_curriculum_2_link_text: 'Try it now',
      practice_enrichment_1_title: 'CodeCombat AI League Esports',
      practice_enrichment_1_text: 'An epic competitive coding esports platform that encourages creative programming in a game-based environment.',
      practice_enrichment_1_link_text: 'Try it now',
      practice_enrichment_2_title: 'CodeCombat Worlds on Roblox',
      practice_enrichment_2_text: 'In partnership with Roblox Education, this AI enabled experience super-charges student coding abilities and provides a real-world platform to create amazing games and experiences.',
      practice_enrichment_2_link_text: 'Try it now',
      student_acceleration_1_title: 'CodeCombat AI HackStack',
      student_acceleration_1_text: 'The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety. Blending simplicity and power, the platform accelerates student abilities and unleashes their creative potential.',
      student_acceleration_1_link_text: 'Try it now',
      student_acceleration_2_title: 'AP CSP Exam Preperations',
      student_acceleration_2_text: 'We are recognized by the College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.',
      student_acceleration_3_title: 'AI Algebra',
      student_acceleration_3_text: 'A classroom-ready Algebra + AI curriculum focused on deep reasoning and hands-on exploration before introducing AI. Students compare methods, verify AI outputs, and solve larger problems — with teachers guiding the instruction every step of the way.',
      young_learners_1_title: 'CodeCombat Junior',
      young_learners_1_title_classroom: 'CodeCombat Junior Classroom',
      young_learners_1_text: 'Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.',
      young_learners_1_link_text: 'Sign up for Beta Access',
      young_learners_2_title: 'AI Junior',
      young_learners_2_text: 'Introduces multi-modal generative AI in a simple and intuitive platform designed specifically for K-5 students.',
      young_learners_2_link_text: 'Sign up for Beta Access',
      funding_solutions_1_title: 'Grant and Funding Sources',
      funding_solutions_1_text: 'We understand the funding hurdles that schools encounter and are passionate about helping to overcome these obstacles. Check out our comprehensive guide to grant funding or speak with our team to learn more.',
      funding_solutions_1_link_text: 'Discover More',
      support_development_1_title: 'Live Online Classes',
      support_development_1_text: 'Want to provide high-quality CS instruction, but don’t have the staff to execute? Our team of master instructors can provide engaging virtual lessons perfect for in-class or after school programs.',
      support_development_1_link_text: 'Sign up for Beta Access',
      faq_header: 'Frequently Asked Questions',
      faq_see_more: 'See more frequently asked questions in our **[https://codecombat.zendesk.com/hc/en-us]help center**.',
      trends_1_title: 'AI isn’t Replacing Coding, It’s Accelerating it!',
      trends_1_text: "We've officially entered the AI era. Along with hype and hyperbole comes a wave of fear and uncertainty concerning the future of computer science. Videos of AI writing code with simple inputs and stories of engineers replaced by AI bots fueled a dramatic yet ultimately flawed narrative. The truth is, AI isn’t replacing coding; it’s accelerating it!",
      trends_1_linkText: 'Read the Blog',
      trends_2_title: 'Career Technical Education with Pat Keeney',
      trends_2_text: 'Career Technical Education (CTE) prepares students to become lifelong learners and provides them with the skills and knowledge they need to succeed in their future careers. In this episode, Pat Keeney, CTE Champion at McGraw Hill, shares his experience',
      trends_2_linkText: 'Listen to the Podcast',
      learn_more_text: 'Discover More',
      your_turnkey_solutions: 'Your Turnkey Solutions',
      free_teacher_account: 'Free Teacher Account',
      trial_the_curriculum: 'Trial the curriculum with your students today!',
      try_it_free: 'Try It Free',
    },

    hackstack_page: {
      header: 'Learn, create, and accelerate with **AI HackStack**',
      header_details: 'Together, we empower learners to safely bring their ideas to life across any subject.',
      header_details_teacher: 'With a license, unlock 100 monthly prompts for yourself and 30 weekly for students to bring your ideas to life across any subject.',
      accessible_safe_use: 'Accessible, safe, and responsible use of AI',
      learn_title: 'Learn',
      learn_description: 'From **English Language Arts** to **Mathematics** and **Science**, students discover how to craft safe and effective prompts for generating output in each discipline. Learn essential prompt engineering skills in a **wide range of subjects** using Al HackStack\'s Learning Scenarios. Along the way, your students will gain hands-on experience with popular Al models like Claude, DALL-E, and Stable Diffusion.',
      create_title: 'Create',
      create_description: 'Bring your wildest ideas to life with HackStack\'s Al **sandbox environment**. Here, students will be able to quickly prototype interdisciplinary projects of all kinds. Use our turnkey curriculum to help your students engage in meaningful discussions about the **responsible use** of Al and the **ethical implications** of their creations. This holistic approach not only sparks innovation but also cultivates digital citizenship, equipping students with the skills and awareness needed to thrive in the digital age.',
      remix_title: 'Remix',
      remix_description: 'Supercharge the creative process by customizing one of the many projects found in Al HackStack\'s **community library**. The remix feature not only accelerates individual progress but also fosters a **collaborative ecosystem** where ideas evolve rapidly. As students remix and build upon each other\'s work, the collective output of your classroom will reach new creative heights, resulting in an impressive showcase of student-driven innovation.',
      privacy_title: 'Safety and Privacy',
      privacy_subtitle: 'Our AI platforms fuel student curiosity and creativity, with the privacy and security you need.',
      data_title: 'Your Data is Safe',
      data_description: 'We carefully vet Al tools before they are added to Al HackStack. If they\'re not safe, we don\'t include them. We also screen user prompts to make sure they don\'t contain any Personally Identifiable Information. If they do, we replace it with a placeholder value before giving it to an external Al model. Additionally, you have the power to lock specific Al tools so that your students cannot access the ones you don\'t feel comfortable using.',
      moderation_title: 'Our Moderation Practices',
      moderation_description: 'We monitor user prompts and Al output to make sure they don\'t contain any inappropriate content. You can review every prompt that your student has written in the Al HackStack teacher dashboard. We also provide turnkey resources to help you and your students navigate the complexity of using Al, and provide professional development opportunities for those who want more guidance on what to look for when students are using Al.',
      professional_development: 'High Quality Professional Development',
      professional_development_text: 'We offer professional development opportunities for those who want more guidance on how to use AI in the classroom. These professional development workshops were modeled after **[https://www.teachai.org/toolkit]Teach AI**, **[https://www.edsafeai.org/safe]EdSafe**, **[https://csteachers.org/k12standards/]CSTA**, and **[https://ai4k12.org/]AI4K12’s** AI standards, which focus on the safe and responsible use of AI.',
      ask_pd: 'Ask about AI PD',
      testimonials_1_quote: 'The energy and excitement... in experimenting with different models and brainstorming and pitching their first Al programs were truly uplifting! I can\'t wait to check out these programs. Here\'s to making Al accessible to everyone!',
      testimonials_1_name: 'Vivienne Byrd',
      testimonials_1_title: 'STEAM Librarian & Program Lead of Citizen Science Initiative, Los Angeles Public Library',
      try_it_free: 'Try It Free',
      faq_1_question: 'How old should my students be to use AI HackStack?',
      faq_1_answer: 'AI HackStack is great for middle school and high school-aged students. Our safety and privacy practices allow us to help younger users, like your students, interface safely with AI.  Do you teach elementary-aged students? If so, **[mailto:team@codecombat.com]connect with our team** to learn more about CodeCombat AI Junior, which introduces multimodal generative AI in a simple and intuitive platform designed specifically for K-5 students."',
      faq_2_question: 'How we integrate AI safely and responsibly?',
      faq_2_answer: 'Our AI technology adheres to safety-first principles, providing confidence to both students and educators. We do not allow our backend LLM providers to train your chats and have established protective measures against inappropriate content. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating students about potential AI pitfalls. Moreover, we log AI chat activity for teacher monitoring and uphold stringent data privacy and security protocols.',
      faq_3_question: 'What LLMs is AI HackStack using?',
      faq_3_answer_1: 'ChatGPT-4: A model designed for natural language understanding and generation tasks.',
      faq_3_answer_2: 'Claude: A language model that focuses on performance and safety in AI interactions.',
      faq_3_answer_3: 'Stable Diffusion: A model that generates images from text descriptions.',
      faq_3_answer_4: 'DALL-E: An image generation model that creates visuals based on text prompts.',
      faq_3_answer_5: 'We continuously evaluate these models for performance and safety, ensuring we update to the latest versions available.',
      faq_4_question: 'How to find alternative funding sources?',
      faq_4_answer: "Computer science education has become a vital component of a student's academic journey, however, many schools face challenges in securing the necessary resources to provide their students with comprehensive computer science programs. At CodeCombat, we understand the funding hurdles that schools encounter and are passionate about helping them overcome these obstacles. Grants can be a valuable resource but difficult to discover and apply for. Check out our comprehensive **[https://codecombat.com/grants]guide to grant funding** or **[mailto:team@codecombat.com]speak with our team** to learn more.",
      faq_5_question: 'How to get started',
      faq_5_answer_1: 'Create your Teacher or Admin Account',
      faq_5_answer_2: 'Create a class',
      faq_5_answer_3: 'Add students',
      faq_5_answer_4: 'Unlock AI HackStack for your class',
      faq_5_answer_5: 'Sit back and watch your students have fun learning about AI',
      faq_6_question: 'Support for Clever and Google login',
      faq_6_answer: 'We offer both Clever and Google Classroom integration. Check out our **[https://codecombat.com/teachers/resources/clever-faq]Clever Integration FAQ** for more details on how to get started. If you are using Google Classroom be sure to use the Google Single Sign-On (SSO) Modal to sign up for your teacher account. If you already have an account using your Google email, use the Google SSO modal to log in next time. In the Create Class modal, you will see an option to Link Google Classroom. We only support rostering via Google Classroom at this time. Note: you must use Google SSO to sign up or log in at least once in order to see the Google Classroom integration option.',
      faq_7_question: 'Recommended browser and operating system',
      faq_7_answer: 'TBA',
      faq_8_question: 'How many prompts do I get?',
      faq_8_answer: 'With a license, you get 100 monthly prompts for teacher and 30 weekly for students. Individual premium users get 50 prompts per month.',
      learn_more: 'Learn More',
      promo_modal_title: 'Explore AI HackStack',
      promo_modal_subtitle: 'Unlock the Full Potential of Generative AI',
      promo_modal_text: '**New to AI? Explore CodeCombat AI HackStack** — the easiest way to dive into AI literacy. Unlock the power of top models like **ChatGPT-4**, **Claude**, **Stable Diffusion**, and **DALL-E**. With hands-on tools, creating games, art, websites, code, and more has never been simpler. It’s the perfect companion for any creative project, no experience required!',
      explore_hackstack: 'Explore Hackstack',
      learn_1_text: 'Play in a safe[NEWLINE]AI sandbox',
      learn_2_text: 'Cross-[NEWLINE]Curricular[NEWLINE]Lessons',
      learn_3_text: 'Prompt[NEWLINE]Engineering',
      learn_4_text: 'Remix AI[NEWLINE]Project',
      learn_5_text: 'Ethics-Centered[NEWLINE]Reflection',
      learn_6_text: 'Actionable[NEWLINE]Data',
      learn_7_text: 'Professional[NEWLINE]Development[NEWLINE]for AI',
    },

    hackstack_algebra_page: {
      // Hero
      header: 'Algebra + AI Curriculum',
      header_powered_by: 'Powered By',
      header_details: 'A classroom-ready Algebra + AI curriculum focused on deep reasoning and hands-on exploration before introducing AI. Students compare methods, verify AI outputs, and solve larger problems, with teachers guiding the instruction.',
      header_details_teacher: 'With a license, your students get a classroom-ready Algebra + AI curriculum focused on deep reasoning and hands-on exploration.',
      cta_get_solution: 'Get My Solution',
      cta_explore: 'Explore AI Algebra',

      // Core features strip
      features_title: 'A Core Algebra Curriculum Enhanced With AI',
      feature_1_title: 'Foundations First\nAI Second',
      feature_2_title: 'Teaches to Critically\nEvaluate AI',
      feature_3_title: 'Teacher-Guided\nReal-World Modeling',

      // Lesson flow
      lesson_flow_title: 'Inside a Module: Lesson Flow in Action',
      step: 'Step',
      step_1_title: 'Mathematical Reasoning Without AI',
      step_1_desc: 'Students first solve problems with pen, paper or a calculator to build a strong foundation in algebra and learn to reason through equations independently before introducing AI.',
      step_1_tag: 'Traditional',
      step_2_title: 'Mathematical Reasoning With AI',
      step_2_desc: 'Students then use an AI tool to solve the same problems and compare its process and results to their own, helping them see how AI approaches problem solving and where it differs.',
      step_2_tag: 'AI + Traditional',
      step_3_title: 'Practice',
      step_3_desc: 'By working through more problems with both traditional and AI methods, students learn to verify AI outputs, identify errors or misinterpretations and refine prompts to improve accuracy.',
      step_3_tag: 'AI + Traditional',
      step_4_title: 'AI Modeling',
      step_4_desc: 'Students move beyond simple calculations by using AI to model equations across larger or more complex datasets, showing how AI can scale problem solving in ways not possible by hand.',
      step_4_tag: 'AI Enabled',
      step_5_title: 'Checking AI Modeling',
      step_5_desc: 'Finally, students use alternative AI tools or verification methods to cross-check their models for accuracy, reinforcing the importance of validation and accountability when working with AI.',
      step_5_tag: 'AI Enabled',

      // Module structure
      module_structure_title: 'Algebra + AI Module Structure',
      module_1_title: 'Mathematical Reasoning Without AI',
      module_1_desc: 'Students first solve problems with pen, paper or a calculator to build a strong foundation in algebra and learn to reason through equations independently before introducing AI.',
      module_1_tag: 'Traditional',
      module_2_title: 'Mathematical Reasoning With AI',
      module_2_desc: 'Students then use an AI tool to solve the same problems and compare its process and results to their own, helping them see how AI approaches problem solving and where it differs.',
      module_2_tag: 'AI + Traditional',
      module_3_title: 'Practice',
      module_3_desc: 'By working through more problems with both traditional and AI methods, students learn to verify AI outputs, identify errors or misinterpretations and refine prompts to improve accuracy.',
      module_3_tag: 'AI + Traditional',
      module_4_title: 'AI Modeling',
      module_4_desc: 'Students move beyond simple calculations by using AI to model equations across larger or more complex datasets, showing how AI can scale problem solving in ways not possible by hand.',
      module_4_tag: 'AI Enabled',
      module_5_title: 'Checking AI Modeling',
      module_5_desc: 'Finally, students use alternative AI tools or verification methods to cross-check their models for accuracy, reinforcing the importance of validation and accountability when working with AI.',
      module_5_tag: 'AI Enabled',

      // Trusted standards
      trusted_standards_title: 'Built on Trusted Standards',
      trusted_standards_text: 'Our curriculum aligns with Common Core Math standards and practices, strengthening students\' skills in algebra, functions, modeling, and statistics. Additionally they\'ll develop AI literacy skills, such as prompt engineering, evaluating accuracy, using appropriate LLMs, understanding data, and considering human impact and design, all within teacher-guided instruction.',
      trusted_standards_link: 'Learn More',

      // Curriculum path
      curriculum_path_title: 'A Structured Path from Algebra Foundations to AI Application',
      curriculum_path_cta: 'Free Teacher Account',
      curriculum_path_subtitle: 'Trial the curriculum with your students today!',

      // Testimonial
      testimonial_1_quote: 'It shifted learning from just finding the final answer to understanding the step-by-step logic behind each problem.',
      testimonial_1_name: 'Montebello High School Student',
    },

    standards_page: {
      standards_aligned_curriculum: '**Standards Aligned Curriculum**',
      curriculum_description: 'CodeCombat offers robust course pathways aligned with several national and state standard frameworks across grades K-12 including AP level programming courses in many languages. Our curriculum engages students to explore and learn computer science through standards-aligned lessons.',
      most_effective_computer_science_solution: 'The most effective computer science solution for **[https://codecombat.com/schools]schools**',
      comprehensive_implementation: 'Our comprehensive implementation empowers teachers, engages students and delivers successful outcomes.',
      carousel_1_title: 'Computer Science Teachers Association (CSTA)',
      carousel_1_text: 'The **[https://csteachers.org/k12standards/]Computer Science Teachers Association K-12 Computer Science Standards** outline a core set of learning objectives that are designed to provide the foundation for a complete computer science curriculum and its implementation in K-12.[NEWLINE]CodeCombat is recognized by CSTA as an endorsed provider of curriculum and professional development. Learn the skills to effectively teach computer science with our self-directed, CSTA-accredited **[https://www.ozaria.com/professional-development]Professional Development** course. Earn up to 40 credit hours any time, from any device.[NEWLINE]Learn about the detailed CSTA Standards Alignment below:',
      carousel_1_button_1_text: 'CSTA Alignment',
      carousel_1_button_2_text: 'CodeCombat',
      carousel_2_title: 'AP Computer Science Principles (AP CSP)',
      carousel_2_text: 'CodeCombat is recognized by College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). This endorsement affirms that CodeCombat’s curriculum is aligned to all of the AP Curriculum Framework standards and the AP CSP assessment. This affords schools access to resources including an AP CSP syllabus pre-approved by the College Board’s Course Audit, and officially recognized professional development that prepares teachers to teach this curriculum.[NEWLINE]Learn more about our CodeCombat AP CSP curriculum below:',
      carousel_2_button_1_text: 'CodeCombat AP CSP',
      carousel_3_title: 'International Society for Technology in Education (ISTE)',
      carousel_3_text: 'Focused on pedagogy, not tools, the **[https://iste.org/standards]ISTE Standards** are a framework that guides educators in using technology to create high-impact, sustainable, and scalable learning experiences for all students.[NEWLINE]CodeCombat’s curriculum is designed to meet the needs of all ISTE standards, for both students and teachers.[NEWLINE]Learn about the detailed ISTE Standards Alignment below:',
      carousel_3_button_1_text: 'Ozaria',
      carousel_3_button_2_text: 'CodeCombat',
      carousel_4_title: 'Common Core State Standards',
      carousel_4_text: 'The **[https://corestandards.org/]Common Core State Standards** are a set of uniform academic standards for K–12 Mathematics and English Language Arts.[NEWLINE]CodeCombat integrates a variety of cross-curricular connections to core subject areas throughout our curriculum. [NEWLINE]Learn about the detailed Common Core Standards Alignment below:',
      carousel_4_button_1_text: 'Ozaria',
      carousel_4_button_2_text: 'CodeCombat',
      carousel_5_title: 'Next Generation Science Standards (NGSS)',
      carousel_5_text: 'The **[https://www.nextgenscience.org/]Next Generation Science Standards (NGSS)** are K–12 science content standards, setting expectations for what students should know and be able to do. These standards were developed by states to improve science education for all students.[NEWLINE]CodeCombat is a perfect curriculum partner for introducing key science and engineering concepts from NGSS.[NEWLINE]Learn about the detailed NGSS Standards Alignment below:',
      carousel_5_button_1_text: 'NGSS Alignment',
      carousel_5_button_2_text: 'CodeCombat',
    },

    codequest_page: {
      join_us: 'Join Us',
      start_application: 'Start Application',
      codequest: 'CodeQuest',
      date: 'Date',
      date_time: 'July 22 - July 27, 2024',
      supporting_text: 'Join us for an immersive educational experience like no other, designed to inspire and empower the next generation of computer science innovators through coding and AI. Students aged 13-17 are welcome.',
      apply_now: 'Apply Now',
      insight: 'An insightful real-world learning experience!',
      testimonials_heading: 'This rare opportunity brings together students from around the globe. Here’s the student experience at a glance.',
      engaging_hackathongs: 'Engaging Hackathons',
      insightful_speakers: 'Insightful Speakers',
      university_visits: 'University Campus Visits',
      silicon_valley_experience: 'Silicon Valley Experience',
      content_title: 'The Student Experience',
      core_curriculum_heading_1: 'Multiple ',
      core_curriculum_heading_2: 'hackathon competitions',
      core_curriculum_heading_3: ' designed to ',
      core_curriculum_heading_4: 'inspire creativity',
      core_curriculum_heading_5: ' in coding and ',
      core_curriculum_heading_6: 'teach real world applications of AI',
      core_curriculum_title_1: 'AI HackStack Project Challenge',
      core_curriculum_text_1: 'The first generative AI companion tool specifically crafted for those new to AI, enables students to go from text-to-code-to-output instantaneously. <br /><br /> Competitors will be partnered with other students to develop a project using AI prompting and present for judging.',
      core_curriculum_title_2: 'AI League CodeQuest Global Final',
      core_curriculum_text_2: 'An epic competitive coding esports platform that encourages creative programming in a game-based environment. <br /><br /> Competitors will be partnered with other students to develop the optimal code to outwit the other teams, collect head-to-head wins and finish atop the leaderboard.',
      core_curriculum_heading_11: 'Hackathons will be held at ',
      core_curriculum_heading_12: 'renowned universities',
      core_curriculum_heading_13: 'offering a unique experience for students to',
      core_curriculum_heading_14: 'immerse',
      core_curriculum_heading_15: ' themselves in the ',
      core_curriculum_heading_16: 'collegiate setting',
      core_curriculum_text_11: 'Globally acclaimed for its cutting-edge research and innovation, UC Berkeley provides comprehensive and rigorous computer science programs. These programs enhance creative problem-solving skills and encourage a deeper understanding of computational theory, equipping individuals to be transformative leaders in the rapidly evolving tech industry.',
      core_curriculum_text_12: 'Recognized worldwide as a leader in technology and innovation, Stanford offers robust programs in computer science, fostering creative thinking and a deep understanding of theoretical foundation, preparing individuals to become pioneering leaders in computer science and technology.',
      core_curriculum_heading_21: 'Our roster of speakers offer ',
      core_curriculum_heading_22: 'unparalleled insight',
      core_curriculum_heading_23: 'into what it takes to pursue success in computer science and will help judge the competitions.',
      core_curriculum_title_21: 'UC Berkeley Featured Speaker',
      core_curriculum_text_21: 'While immersed in the collegiate setting of this storied university, students will be welcomed by representatives from the Department of Electrical Engineering and Computer Sciences at UC Berkeley, who will provide a glimpse into the extensive research and cutting edge developments in computer science happening right here on campus. Students will gain insight into what it is like to be a part of these research programs and what career pathways can be realized.',
      core_curriculum_title_22: 'Google X - The Moonshot Factory Featured Speaker',
      core_curriculum_text_22: 'In 2010, Google founders Larry Page and Sergey Brin decided to form a new division of the company to work on moonshots: far-out, sci-fi sounding technologies that could one day make the world a radically better place. 10 years in, X has incubated hundreds of different moonshot projects, many of which have gone on to become independent businesses. Hear how this diverse group of inventors and entrepreneurs build and launch technologies that aim to improve the lives of millions, even billions, of people.',
      core_curriculum_title_23: 'Nick Winter, CEO, CodeCombat',
      core_curriculum_text_23: 'Nick is the founder and CEO of CodeCombat. A proven leader in the edtech industry, Nick blends his passion for education with his technological expertise to make learning programming more accessible and engaging for students across the globe. Prior to CodeCombat, he co-founded Skritter, a platform for learning Chinese and Japanese characters. With a strong commitment to revolutionize the education sector, Nick actively contributes to making coding a fundamental skill for the future generation. His dedication and vision continue to inspire and impact the realm of edtech.',
      core_curriculum_title_24: 'Apple Tech Development Workshop',
      core_curriculum_text_24: 'Hear first hand from a panel of venture capitalists and tech leaders as they detail the process for building a global tech platform and creating a successful business plan. This interactive presentation will pull back the curtain on what it\'s like to build the next great piece of tech and how to launch it.',
      core_curriculum_heading_31: 'San Francisco and Silicon Valley offer students the unique opportunity to ',
      core_curriculum_heading_32: 'experience life at a tech giant',
      core_curriculum_heading_33: ' and ',
      core_curriculum_heading_34: 'explore the sights of the city',
      core_curriculum_title_31: 'Visit Google HQ & X- The Moonshot Factory',
      core_curriculum_text_31: 'Located in Mountain View California, the Google campus offers a unique glimpse into the heart of Silicon Valley innovation. Students will encounter whimsical architecture, a multitude of collaborative workspaces, and tech-driven art installations that inspire creativity and provide a peek at what working in tech could be like. This exclusive tour will visit X - The Moonshot Factory to see how this innovative team inside of Google is creating radical new technologies to solve some of the world\'s hardest problems.',
      core_curriculum_title_32: 'Apple Park HQ Visit & Workshop',
      core_curriculum_text_32: 'Apple Park is the global headquarters for the innovative tech&nbsp;&nbsp;giant and a must visit attraction when in San Fransisco. Students will experience Steve Jobs’ “Garage Culture” that inspired Apple to become the largest company in the world, and join a workshop with venture capitalists and tech leaders, to hear first hand what it takes to build a global tech platform and create your own business plan.',
      core_curriculum_title_33: 'San Francisco Tour',
      core_curriculum_text_33: 'Students have the opportunity to immerse themselves in the diverse and dynamic charm of San Francisco. From the iconic Golden Gate Bridge and historic Alcatraz Island to the bustling piers and serene parks, there&#39;s adventure at every turn. A visit to San Francisco is a fascinating blend of natural beauty, urban sophistication, and rich cultural heritage, promising an unforgettable experience.',
      cta_supporting: 'The specifics regarding the planned series of activities are subject to changes due. We commit to keeping you informed of such changes as much as possible, although they may occur without advance notice.',
      contact: 'Contact Our Team',
      if_question: 'If you have any questions',
      how_it_works: 'How it Works',
      apply: 'Apply',
      apply_time: 'January-February',
      apply_steps_1: 'Students interested in participating will fill out an application.',
      apply_steps_2: 'A skills assessment or evaluation may be needed to confirm your ability to participate.',
      confirm: 'Confirm',
      confirm_time: 'March-April',
      confirm_steps_1: 'If you are accepted, a program advisor will contact you to confirm the additional details.',
      confirm_steps_2: 'An initial deposit will be required to hold your spot in the program.',
      confirm_steps_3: 'Your travel will be coordinated and booked.',
      confirm_steps_4: 'A liability waiver will be required for all participants.',
      travel: 'Travel',
      travel_time: 'July',
      travel_steps_1: 'Prior to departure you will receive a comprehensive travel packet with all the information you will need to know.',
      travel_steps_2: 'Preparations have been made to shuttle participants from the airport to the hotel and to and from the activities throughout the week. Transportation back to the airport for departure will also be arranged.',
      travel_steps_3: 'The full package fee will be due prior to travel, minus the initial deposit fee.',
      frame_heading_1: 'The paced schedule will fill the days with a mixture of ',
      frame_heading_2: 'learning',
      frame_heading_3: ' and ',
      frame_heading_4: 'fun',
      all_participants: 'All Participants',
      international_participants: 'International Participants',
      schedule_day_title_1: 'Monday',
      schedule_day_title_2: 'Tuesday',
      schedule_day_title_3: 'Wednesday',
      schedule_day_title_4: 'Thursday',
      schedule_day_title_5: 'Friday',
      schedule_day_title_6: 'Saturday',
      schedule_event_title_1: 'Travel Day',
      schedule_event_title_2: 'San Francisco',
      schedule_event_title_3: 'UC Berkeley',
      schedule_event_title_4: 'Silicon Valley',
      schedule_event_title_5: 'Stanford',
      schedule_event_sub_title_1: 'Arrival',
      schedule_event_sub_title_2: 'Tour',
      schedule_event_sub_title_3: 'Hackathon',
      schedule_event_sub_title_4: 'Tours & Speakers',
      schedule_event_sub_title_6: 'Departure',
      frame_content_heading: 'Included in most package options',
      frame_content_flight_title: 'Airfare & Local Transportation',
      frame_content_flight_text: 'Round-trip flights on major carriers and transportation to and from airport, hotel and event locations.',
      frame_content_hotel_title: 'Hotel Accommodations',
      frame_content_hotel_text: 'All hotels must meet our high standards for quality, safety, and cleanliness.',
      frame_content_meal_title: 'Meals',
      frame_content_meal_text: 'Minimum three meals per day, as well as snacks and water available throughout each activity filled day.',
      frame_cta_text: 'Download Schedule',
      frame_cta_supporting: 'All experience details are subject to change.',
      frame_core_heading_1: 'This Opportunity is Open to ',
      frame_core_heading_2: 'International',
      frame_core_heading_3: ' and ',
      frame_core_heading_4: 'Domestic',
      frame_core_heading_5: ' Participants',
      frame_core_international_title_text: 'International: ',
      frame_core_international_title_span: 'FULL WEEK',
      frame_core_international_text: 'The complete experience including all three hackathon days, multiple university campus experiences and two days of San Francisco and Silicon Valley immersion.',
      frame_core_international_price: 'Pricing: $ 10,000',
      frame_core_international_price_text_1: 'For our ',
      frame_core_international_price_text_2: 'international participants',
      frame_core_international_price_text_3: 'coming from outside the US',
      frame_core_international_price_text_4: 'Includes air-travel and accommodations',
      frame_core_domestic_title_text: 'Domestic (US): ',
      frame_core_domestic_title_span: '3 DAYS',
      frame_core_domestic_text: 'Includes participation in all three hackathon days and features multiple university campus experiences.',
      frame_core_domestic_price: 'Pricing: $3,750 (Early bird price: $2,950 if you book before 3/31)',
      frame_core_domestic_price_text_1: 'For ',
      frame_core_domestic_price_text_2: 'US-based participants',
      frame_core_domestic_price_text_3: 'Includes air-travel and accommodations',
      frame_core_domestic_price_2: 'Pricing: $2,175 (Early bird price: $1,675 if you book before 3/31)',
      frame_core_domestic_price_text_4: 'local participants',
      frame_core_domestic_price_text_5: 'Does not include travel or accommodations. Students will need to meet at each event site to participate',
      accessibility_title: 'Health and Safety Precautions',
      accessibility_text_1: 'Students will remain in secure facilities guided by our team of education advisors.',
      accessibility_text_2: 'All chaperones and education advisors have completed background checks.',
      accessibility_text_3: 'All facilities will be approved for safety, on-site quality control, and cleanliness.',
      accessibility_text_4: 'At this time there are no travel restrictions due to Covid or another illness. If a travel restriction is reinstated or if our team deems there to be a concern for the health of the participants, the experience may be changed or cancelled.',
      faq: 'Frequently Asked Questions',
      faq_q_1: 'Is there an age requirement?',
      faq_a_1: 'Participants must be aged 13-17 and be able to provide legal documentation to travel.',
      faq_q_2: 'Can I travel with my child?',
      faq_a_2: 'Some parents do choose to travel, however the activities, events, travel and accommodations are only provided for students.',
      faq_q_3: 'How much experience do you need to participate?',
      faq_a_3: 'A basic understanding of programming in any language is all that a student must know. Since we are grouping them into teams of varying experience levels we expect those with more experience to support those with less.',
      faq_q_4: 'Should I bring my laptop?',
      faq_a_4: 'We will supply all the hardware and software needed to participate in the hackathons. While we will allow participants to use their personal computers, our team may not be able to fully support or troubleshoot all issues, so we recommend using the equipment provided.',
      faq_q_5: 'Do I need bring any identification supporting materials?',
      faq_a_5_1: 'Domestic - if the participant is traveling alone, we ask their parent or legal guardian to complete an emergency contact form that includes identification information about their child.',
      faq_a_5_2: 'Global - global students need to bring their passports (with VISA) with them.',
      faq_q_6: 'What accommodations can my child expect?',
      faq_a_6: 'All participants and chaperones will be staying at the same hotel, with separate accommodations for participants and chaperones. Participants will share a room with a fellow participant. Staff members are never allowed to be alone with participants. Parents who wish to accompany their child will share a room together.',
      faq_q_7: 'What if my child is allergic to certain foods or has medical needs?',
      faq_a_7: 'Any health concerns pertaining to your child should be identified in the emergency contact form.',
      faq_q_8: 'Who will be chaperoning my child?',
      faq_a_8_1: 'Our pledge is to put your children in the company of the most trustworthy and capable individuals we can hire–certified instructors and counselors who are well suited to the task of caring for participants. Each staff member undergoes an intense background and reference check; the effort we put into screening and selecting our staff is part of that pledge.',
      faq_a_8_2: 'Our staff work with your children in the context of a visible, well scrutinized environment that has many built-in checks and balances. Instructors and counselors are guided by clear, firm policies regarding behavior. Their actions are visible to co-workers and participants.',
      faq_q_9: 'What general safety measures do you have in place?',
      faq_a_9: 'All staff go through emergency and crisis management training.',
      faq_q_10: 'What is your refund policy?',
      faq_a_10: 'Deposits to hold your space are refundable up until travel is booked for the participant. Once travel is booked we will not be able to provide a refund.',
      more_faq: 'See more frequently asked questions in our ',
      help_center: 'help center',
    },
    hackstack: {
      'Action_missing-renderer-for-action-type-actiont': 'Missing renderer for action type "__actionType__"',
      ActionButton_create: 'Create',
      ActionButton_learn: 'Learn',
      'AddEndOfLessonMsgButton_end-lesson': 'End Lesson',
      'AddTeacherMsgButton_add-teacher-message': 'Add Teacher Message',
      'AlternatePromptChoicesForm_save-choices': 'Save Choices',
      App_alt: '',
      App_loading: 'Loading...',
      'ChatInputForm_enter-your-prompt-here': 'enter your prompt here',
      'ChatLayout_tw-fixed-tw-inset-0-tw-z-30-tw-bg-black5': 'tw-fixed tw-inset-0 tw-z-30 tw-bg-black/50 tw-transition-opacity tw-duration-300 tw-ease-in-out md:tw-hidden',
      'ChatMessage_are-you-sure-you-want-to-delete-this-mes': 'Are you sure you want to Delete this Message?',
      ChatMessage_delete: 'Delete',
      ChatMessage_edit: 'Edit',
      'ChatMessage_update-a-messageactorteacherteacherendof': 'Update a __messageActorTeacherTeacherEndOfLesson__ Lesson',
      CodeThumbnail_copy: 'Copy',
      'CodeThumbnail_open-in-editor': 'Open in editor',
      'CodeThumbnail_run-code': 'Run Code',
      'CodeThumbnail_edit-code': 'Edit Code',
      'ConfirmDeleteChatMessageButton_confirm-delete': 'Confirm Delete',
      ContinueRenderer_continue: 'Continue →',
      EditAlternatePromptChoicesPage_cancel: 'Cancel',
      'EditAlternatePromptChoicesPage_save-choices': 'Save Choices',
      'EditChatMessagePage_chat-message-settings': 'Chat Message Settings',
      'Empty_select-or-create-a-project-to-get-starte': 'Select or create a project to get started!',
      EndOfLessonRenderer_feedback: 'Feedback',
      'EndOfLessonRenderer_start-a-new-project': 'Start a New Project →',
      FullscreenModal_close: 'Close',
      'GenericError_something-went-wrong': 'Something went wrong',
      'HowItWorksPage_ah-now-thats-a-question-i-cant-answer-ju': "Ah, now that's a question I can't answer just yet. But if you want to have a say in it, you've got to experience what's possible, so... let's start creating. Are you ready?",
      'HowItWorksPage_ah-thats-the-best-part-you-dont-have-to-': "Ah! That's the best part. You don't have to. I take care of it all. Just chat with me, and I'll do the rest.",
      'HowItWorksPage_bet-so-what-if-i-wanna-create-a-sock-mat': 'bet - so what if i wanna create a sock matching sim game',
      'HowItWorksPage_but-i-dont-even-know-how-to-use-them-all': "but i don't even know how to use them all",
      'HowItWorksPage_but-i-dont-have-accounts-for-those-and-i': "but i don't have accounts for those and I think chatgpt is blocked here",
      'HowItWorksPage_but-who-made-you': 'but who made you?',
      'HowItWorksPage_codecombat-ai-hackstack-is-an-all-in-one': "CodeCombat AI HackStack is an all-in-one AI tool for creating games, art, songs, apps, and more by just chatting. It runs everything for you, hosts your projects, and helps with coding. CORE mode is free and teaches you through multiple-choice prompts. PRO+ mode is $9.99/mo for free-form prompts. Projects are secure and don't feed big tech data. It's made by the CodeCombat team to make AI accessible to everyone. Now, let's start creating.",
      'HowItWorksPage_core-mode-is-free-and-you-dont-even-need': "CORE mode is free and you don't even need an account to TRY IT! If you want to go wild with free-form prompts in PRO+ mode, it's $9.99/mo, but you can try a few of these for free every day.",
      'HowItWorksPage_did-they-use-ai-to-create-you': 'did they use ai to create you?',
      'HowItWorksPage_hey-ai-so-how-do-i-use-this-thingy': 'hey ai - so how do I use this thingy?',
      'HowItWorksPage_how-do-i-start': 'how do i start?',
      'HowItWorksPage_i-dont-know-how-to-code-tho': "i don't know how to code tho",
      'HowItWorksPage_i-got-you-we-can-build-that-and-more': 'I got you! We can build that and more.',
      'HowItWorksPage_i-used-ai': 'I used AI.',
      'HowItWorksPage_is-it-free': 'is it free??',
      'HowItWorksPage_just-chat': 'just chat?',
      'HowItWorksPage_just-chat-and-lets-see-what-we-can-creat': "Just chat and let's see what we can create together.",
      'HowItWorksPage_just-chat-with-me-ill-show-you': "Just chat with me, I'll show you.",
      'HowItWorksPage_learn-anything-create-something-do-every': 'Learn ANYTHING, create SOMETHING, do EVERYTHING with CodeCombat AI HackStack. AI empowerment for all!',
      'HowItWorksPage_lets-go': "LET'S GO!!!",
      HowItWorksPage_marketing: 'Marketing',
      'HowItWorksPage_maybe-i-should-just-stick-to-directly-us': 'maybe i should just stick to directly using chatgpt or use bing or bard',
      HowItWorksPage_more: 'more?',
      'HowItWorksPage_most-things-if-the-ai-isnt-smart-enough-': "Most things. If the AI isn't smart enough for something yet, it will be soon! You'll be able to access all sorts of creative projects in our gallery. Here are a few I'm working on with other users now: - A choose your own adventure story generator that can mail you a physical book - An ecommerce store for custom Roblox clothing and accessories - A virtual pimple popper extreme game Yes some creators are taking the “infinite creativity” thing literally!",
      'HowItWorksPage_no-coding-experience-no-problem-just-tel': "No coding experience, no problem. Just tell me what you want and I will generate the code for you. Many projects don't even need code, but if you know even just a little, I can amplify your abilities to create something spectacular.",
      'HowItWorksPage_no-worries-my-friend-i-have-the-keys-to-': 'No worries, my friend! I have the keys to the creative kingdom. You can access all the best AI tools with a single AI HackStack account.',
      'HowItWorksPage_not-with-ai-hackstack-i-access-all-the-l': 'Not with AI HackStack. I access all the latest models, from GPT-4 to Stable Diffusion and everything in between.',
      'HowItWorksPage_of-course': 'Of course.',
      'HowItWorksPage_oh-im-an-incredible-host-every-project-h': "Oh, I'm an incredible host! Every project has a URL you can share with the world. Build a website and start a business all with chat. Or download your project, sync to GitHub, or grab your code and venture offthe choice is yours.",
      'HowItWorksPage_ok-so-where-does-my-project-live': 'ok -so where does my project live?',
      'HowItWorksPage_ok-well-can-i-really-make-anything': 'ok well can i really make anything?',
      'HowItWorksPage_so-how-are-you-making-all-this': 'so - how are you making all this?',
      'HowItWorksPage_so-if-ai-can-create-ai-what-happens-next': 'so if ai can create ai what happens next?',
      'HowItWorksPage_the-codecombat-team-they-got-really-good': 'The CodeCombat team. They got really good at making it easy to learn hard stuff by teaching 20 million beginners how to code with game-based learning, so when the tech got good enough, they wanted to do the same thing for AI. If AI is the future of creation, then we need to make it easy for anyone to use!',
      'HowItWorksPage_tldr-summarize-this-chat': 'tl;dr. summarize this chat',
      'HowItWorksPage_well-start-you-off-easy-in-core-mode-wit': "We'll start you off easy in CORE mode with some super simple Q&A to prep you on how to make the best prompts. Then we string those prompts together to create your first project. Within a few minutes, you're ready for PRO+ mode, where the guardrails come off and anything is possible.",
      'HowItWorksPage_what-they-send-it-but-i-put-like-private': 'what?!!! they send it… -but i put, like, private stuff in there! like that love-you-more rap battle for alex!',
      'HowItWorksPage_wow-dont-you-need-like-a-100-different-a': "WOW!!! - don't you need like a 100 different ai tools for that",
      'HowItWorksPage_yeah-thats-why-those-are-free-they-feed-': "Yeah, that's why those are free. They feed your data into their next AI so it can learn to make better love rap battles. But when you use me, they don't store it or train on it. So if you're in a school or you're under 18 with parental consent or under 13 in general, you technically can't use ChatGPT directly. With AI HackStack you're safe, secure, and good to go.",
      'HowItWorksPage_yep-im-here-to-accelerate-your-creative-': "Yep! I'm here to accelerate your creative potential, supercharge your dreams, provide rocket fuel for your imagination! Games, music, movies, apps, art, websites, code and anything else rattling around in that amazing head of yours are all possible right here.",
      'HowItWorksPage_you-could-but-i-answer-faster-dont-rate-': "You could BUT I… - answer faster - don't rate -limit you - give you more AI models - teach you how to use AI - automatically build and host projects for you - have a simpler yet more powerful UI - give built -in ethics guidance so you don't inadvertently rip off artists - let you view the source code and remix anyone's projects Oh, and I don't… SEND ALL YOUR CHATS TO OPENAI/MICROSOFT/GOOGLE TO TRAIN ON!!!!!",
      LeftSidebar_new: '+ New ',
      LeftSidebar_projects: 'Projects',
      LeftSidebar_scenarios: 'Scenarios',
      'LeftSidebarItem_untitled-isprojectprojectscenario': 'Untitled __isProjectProjectScenario__',
      MessageBubble_ai: 'AI',
      'MessageBubble_ais-response-was-cut-off-because-it-reac': "AI's response was cut off because it reached its length limit. Try asking a more specific question, or break it into smaller parts.",
      MessageBubble_teacher: 'Teacher',
      MessageBubble_you: 'You',
      NewProjectPage_: '▲',
      'NewProjectPage_codecombat-ai': 'CodeCombat AI',
      NewProjectPage_filters: 'Filters ▼',
      'NewProjectPage_learn-more': 'Learn more',
      'NewProjectPage_new-ai-project': 'New AI Project',
      'NewProjectPage_prompt-the-ai-to-create-websites-games-w': 'Prompt the AI to create websites, games, web apps, stories, art, and more with the CodeCombat AI HackStack.',
      'NewScenarioPage_a-webpage': 'a webpage',
      'NewScenarioPage_codecombat-ai': 'CodeCombat AI',
      'NewScenarioPage_create-new-scenario': 'Create new Scenario',
      NewScenarioPage_document: 'Document',
      'NewScenarioPage_lets-go': "Let's Go!",
      NewScenarioPage_make: 'make',
      NewScenarioPage_mode: 'Mode',
      NewScenarioPage_task: 'Task',
      NewScenarioPage_tool: 'Tool',
      'NewScenarioPage_whats-this': "What's this?",
      'NotFound_not-found': 'Not Found',
      ProjectTile_with: 'with',
      'PromptQuizRenderer_choose-the-best-prompt': 'Choose the best prompt:',
      PromptQuizRenderer_continue: 'Continue →',
      'RenderedMessage_unknown-action-type-msgactiondatatype': 'Unknown action type: __msgActionDataType__',
      ScenarioDetailsPanel_beta: 'Beta',
      ScenarioDetailsPanel_draft: 'Draft',
      ScenarioDetailsPanel_name: 'Name',
      'ScenarioDetailsPanel_release-phase': 'Release phase',
      ScenarioDetailsPanel_released: 'Released',
      'ScenarioDetailsPanel_save-scenario': 'Save Scenario',
      'ScenarioDetailsPanel_scenario-settings': 'Scenario settings',
      'ScenarioDetailsPanel_allow-user-upload-file': 'Allow user to upload file',
      'ScenarioPage_youre-in-scenario-creation-mode-go-ahead': "You're in scenario creation mode! Go ahead, mess around and try to build a cool scenario, then click \"beta\" or \"released\" to share it with the world! If you ever don't like a prompt, just go back and edit it.",
      'ScenarioPromptMessage_alternate-choices': 'Alternate Choices',
      ScenarioPromptMessage_edit: 'Edit',
      'ScenarioPromptMessage_prompt-choices': 'Prompt Choices',
      TeacherMessageForm_create: 'Create',
      'Topbar_back-to-chat': '← Back to Chat',
      UpdateChatMessageForm_update: 'Update',
      'creditMessage_creditcreditsleft-creditinitialcredits-c': '__creditCreditsLeft__ / __creditInitialCredits__ credits left for __durAmount__ __creditDurationKey__',
      creditMessage_the: 'the',
      'onDelete_are-you-sure-you-want-to-delete-this-isp': 'Are you sure you want to delete this __isProjectProjectScenario__?',
      renderFilterCheckboxes_clear: 'Clear',
      'renderFilterCheckboxes_create-your-own-project': 'Create your own project',
      'renderFilterCheckboxes_creates-photorealistic-images-from-text': 'Creates photorealistic images from text.',
      'renderFilterCheckboxes_learn-how-to-use-a-model': 'Learn how to use a model',
      'renderFilterCheckboxes_learn-what-you-can-create-with-ai': 'Learn what you can create with AI.',
      'renderFilterCheckboxes_quickly-and-easily-creates-images-from-t': 'Quickly and easily creates images from text.',
      'renderFilterCheckboxes_use-models-to-create-your-own-ai-project': 'Use models to create your own AI projects.',
      'renderFilterCheckboxes_writes-code-for-web-games-and-apps': 'Writes code for web games and apps.',
      'renderFilterCheckboxes_writes-stories-and-summarizes-documents': 'Writes stories and summarizes documents.',
      'renderFilterCheckboxes_key-write': 'write',
      'renderFilterCheckboxes_key-code': 'code',
      'renderFilterCheckboxes_key-simulate': 'simulate',
      'renderFilterCheckboxes_key-study': 'study',
      'renderFilterCheckboxes_key-draw': 'draw',
      'renderFilterCheckboxes_key-graph': 'graph',
      'renderFilterCheckboxes_key-learn': 'learn',
      'renderFilterCheckboxes_key-advertise': 'advertise',
      'renderFilterCheckboxes_key-model': 'model',
      'renderFilterCheckboxes_key-solve': 'solve',
      choices: 'Choices',
      'could-not-find-project-with-id-projectid': 'Could not find project with id __projectId__',
      generated: 'generated',
      'missing-action-data-for-project-projecti': 'Missing action data for project __projectId__',
      'overwriting-existing-dev-command-callbac': 'Overwriting existing dev command callback for key: __key__',
      prompt: 'Prompt',
      'teacher-response': 'Teacher Response',
      'unhandled-payload-exhaustivecheck': 'Unhandled payload: __exhaustiveCheck__',
      modes: 'Modes',
      tools: 'Tools',
      tasks: 'Tasks',
      documents: 'Documents',
      'stable-diffusion-description': 'Creates photorealistic images from text.',
      'dall-e-3-description': 'Quickly and easily creates images from text.',
      'gpt-4-description': 'Writes code for web games and apps.',
      'claude-description': 'Writes stories and summarizes documents.',
      locked: 'LOCKED',
      view: 'View',
      continue: 'Continue',
      no_assigned_projects: 'Your teacher has not assigned any AI projects yet.',
      continue_here: 'Continue',
      start_new: 'Start from scratch',
      choice_prompt_1: 'What would you like to do next?',
      choice_prompt_2: 'You can continue with your project or start a new one from scratch!',
      create_from_scratch: 'Create from scratch',
      complete_to_unlock: 'Complete a __model__ learn mode project to unlock',
      actionbutton_finished: 'Learned',
      my_class: 'My Class',
      my_creations: 'My Creations',
      my_trainings: 'My Trainings',
      my_courses: 'My Courses',
      what_do_you_want_to_do_today: 'What do you want to do today?',
      learn_ai: 'Learn AI',
      create_ai: 'Create AI',
      learn_with_ai: 'Learn With AI',
      create_with_ai: 'Create With AI',
      name_conflict: 'Name Conflict, please choose a different name',
      edit: 'Edit',
      delete: 'Delete',
      duplicate: 'Duplicate',
      use_as_a_template: 'Use as a Template',
      get_inspired: 'Get Inspired',
      remixed_from: 'Remixed from',
      hackstack_credits: 'AI HackStack Credits',
      model: 'Model',
      play_as_a_student: 'Play as a Student',
      student_view: 'Student View',
      tags: 'Tags',
      see_all: 'See All',
      created_by: 'created by',
      remix: 'Remix',
      copy: 'copy',
      copied: 'copied!',
      copied_error: 'error copying!',
      NewScenarioPage_name: 'Display Name',
      learning_modules: 'Learning Modules',
      level_complete: 'You did it! Level complete. Continue your AI journey with the next level.',
      run_code_tour_title: 'Ready to see the magic?',
      run_code_tour_text: 'Press “Output” and watch your project come to life. No experience required!',
      hint_course_map_welcome: 'Explore courses across the AI Galaxy.',
      hint_intro_to_ai: 'Start with Intro to AI.',
      hint_click_to_continue: 'Click anywhere to continue',
      hint_click_target: 'Click the item to continue',
      hint_start_this_level: 'Start this level.',
      hint_star_lab_welcome: 'Take a break and play AI-inspired mini-games.',
      hint_level_learn: 'Learn how to chat with HackStack.',
      hint_level_practice: 'Use Practice levels to change existing projects.',
      hint_level_create: 'Build projects from scratch with Create levels.',
      hint_instructor_message: 'Your instructor gives guidance.',
      hint_ai_message: 'Here is HackStack\'s response.',
      hint_output: 'Open Output to see and test results.',
      hint_choice: 'Choose a response to continue.',
      hint_prompt_input: 'Tell HackStack what to do.',
      ready_to_review_helptext: 'Mark this when your project is complete. Your teacher will then see it as ready to review on their side.',
      ready_to_review_confirm_text: 'Ready to Submit? Click OK to notify your teacher to review your project.',
      no_course_instances: 'You do not have any course instances. Please contact your teacher to get access to the AI Hackstack.',
      restart_scenario_confirm: 'Your progress will be lost. Are you sure you want to restart?',
    },
    galaxy: {
      title: 'Welcome to HackStack Galaxy',
      description: 'Explore new worlds and use AI to help you in your journey. ',
      premium_only: 'Premium only',
      not_enrolled: 'Not Enrolled',
      need_sign_up: 'Sign up to access',
      locked_by_teacher: 'Locked by teacher',
    },
    new_premium: {
      mastering_code: 'Master coding and AI with **premium home access**',
      unlock_passion: 'Unlock unlimited access to hundreds of coding adventures and generative AI projects. Build real skills, tackle engaging challenges, and explore at your own pace from home.',
      boxes_title: 'Premium access to all games & projects, with a single subscription',
      junior_title: 'CodeCombat Junior',
      junior_text: 'Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace.',
      codecombat_worlds_text: 'Developed in partnership with Roblox Education, this experience accelerates your coding abilities to create amazing Roblox games and experiences.',
      junior_text_short: 'Our K-5 curriculum teaches coding concepts from icon blocks to text at a slower pace.',
      codecombat_text_short: 'A game-based coding adventure that features web development, game development, and more.',
      ai_league_text_short: 'A competitive coding esports platform that encourages creative programming.',
      codecombat_worlds_text_short: 'Developed with Roblox Education, learn coding and game development on Roblox.',
      ai_hackstack_text_short: 'Learn anything, create something, do everything with the first generative AI tool crafted for those new to AI.',
      subscription_includes_title: 'Your subscription includes',
      subscription_includes_1: 'Access to all learning adventures',
      subscription_includes_2: 'AI project creation credits',
      subscription_includes_3: 'More gems, heroes, and items',
      subscription_includes_4: 'Game, website, and app creation',
      subscription_includes_5: 'Premium support',
      testimonials_2_name: 'Amanda S.',
      features_1: 'Full Access to All[NEWLINE]Learning Adventures',
      features_2: 'Master AI with[NEWLINE]AI HackStack',
      features_3: 'Unlock More Gems,[NEWLINE]Heroes & Items',
      features_4: 'Create Games,[NEWLINE]Websites & Apps',
      features_5: 'Premium Support[NEWLINE]& AI-Powered Help',
      every_learner_different_learning_style: '**Every learner has a unique pace and passion for technology. Our engaging game-based learning programs provide the perfect environment to explore coding and AI, keeping you motivated and excited to learn—even as concepts become more advanced**',
      adapt_interests: 'We adapt to your interests',
      carousel_items_1_title: 'Coding[NEWLINE]Fundamentals',
      carousel_items_1_text: 'For learners with little to no coding experience, most sessions will start in CodeCombat Junior to build foundational skills before progressing to CodeCombat for deeper programming knowledge. AI HackStack will accelerate learning and showcase real-world applications of coding and AI. CodeCombat Worlds and AI League provide additional opportunities for practice, creativity, and fun.',
      carousel_items_2_text: 'If you love games and want to create them, our game development-focused curriculum is the perfect fit. You\'ll start building interactive projects with CodeCombat, then bring your ideas to life in CodeCombat Worlds, where you can design and publish real games on the Roblox platform. AI League offers a competitive edge by deepening your understanding of game dynamics, while AI HackStack helps refine and enhance your creations through iterative development.',
      carousel_items_3_text: 'Web development is constantly evolving, and staying ahead of the curve is essential. In this curriculum, foundational web development activities will be conducted in CodeCombat, while CodeCombat Junior provides an accessible starting point for younger learners. AI HackStack will serve as the primary platform for building and publishing projects, with limited use of CodeCombat Worlds and AI League to reinforce key coding concepts in an engaging way.',
      carousel_items_4_text: 'Esports enthusiasts will love the competitive spirit of this learning experience. Starting with CodeCombat Junior and CodeCombat, learners will build a strong coding foundation before taking on the challenge of our AI League global esports tournaments, where scholarships and prizes are up for grabs year-round. With a focus on creative coding and iteration, they’ll also harness the power of AI HackStack to level up their skills and gain a competitive edge.',
      carousel_items_5_title: 'AI Literacy',
      carousel_items_5_text: 'AI is shaping the future, and those who can harness its power will unlock endless opportunities. This learning experience starts with CodeCombat Junior and CodeCombat. It expands into AI HackStack, where learners will master the art of crafting effective AI prompts and using the latest generative AI tools in a safe and secure environment. ',
      cs_benefits: 'Computer science education offers immediate benefits, such as improving **problem-solving skills, sharpening mathematical abilities,** and strengthening **logical thinking—skills** that support success across many subjects. But the learning goes beyond just coding. It helps learners tackle complex challenges, adapt to new situations, and develop a growth mindset that lasts a lifetime.',
      our_solutions: 'Our solutions are designed to equip you with essential computer science skills today, preparing you for the **digital careers of tomorrow.**',
      learning_code_challenging: 'Learning to code can be challenging, but you don’t have to do it alone. Our innovative AI hints feature provides real-time guidance to help you keep progressing. It can evaluate your code, highlight errors, and explain how to fix them, all while ensuring you understand the reasoning behind each solution—without simply giving away the answer. Since AI hints only assist with your current coding challenge, you\'ll still need to think critically and solve each level on your own. Premium subscribers receive 10 AI hints per day, giving you the support you need to keep learning with confidence.',
      new_to_ai: 'For those new to AI, we offer **[/ai]AI HackStack**, an innovative tool that teaches learners how to use AI safely and responsibly. With secure access to cutting-edge AI models like ChatGPT-4, Claude, Stable Diffusion, DALL·E, and more, users can create and experiment with AI- powered projects. In just a short time, they’ll unlock the full creative potential of AI, turning prompts into code, games, art, websites, and more—all in minutes. Every Premium subscriber receives 50 prompts per month, providing plenty of opportunities to explore and build with AI.',
      premium_page_title: 'CodeCombat Premium',
    },
    parents_v2: {
      testimonials_1_quote: 'I can\'t even begin to explain the profound changes that have occurred in Luka academically since he\'s been working with you.',
      testimonials_1_name: 'Marina G.',
      testimonials_1_title: 'proud parent',
      testimonials_2_quote: 'One thing I am able to do now that I could not do before is actually believe I can code.',
      testimonials_2_name: 'Student',
      testimonials_2_title: 'Mountain Ridge Middle School',
      testimonials_3_quote: 'Even though the class starts every Saturday at 7am, my son is so excited that he wakes up before me! CodeCombat creates a pathway for my son to advance his coding skills.',
      testimonials_3_name: 'Latthaphon Pohpon',
      testimonials_3_title: 'Parent',
      comprehensive_package_item_0_text: 'One-Hour[NEWLINE]Private 1:1[NEWLINE]Sessions',
      comprehensive_package_item_1_text: '24/7 Access to[NEWLINE]Play and Learn',
      comprehensive_package_item_2_text: 'Same-Day[NEWLINE]Support',
      comprehensive_package_item_3_text: 'Progress[NEWLINE]Updates',
      comprehensive_package_item_4_text: 'Class[NEWLINE]Recordings',
      comprehensive_package_item_5_text: 'Student[NEWLINE]Certification',
      comprehensive_package_item_6_text: '30-Day[NEWLINE]Money-Back[NEWLINE]Guarantee',
      grid_most_popular: 'Most Popular',
      grid_best_value: 'Best Value',
      grid_self_paced: '**[/premium]Self Paced**',
      grid_1_sessions_weekly: '**[/payments/initial-online-classes-71]1 Session Weekly**',
      grid_2_sessions_weekly: '**[/payments/initial-online-classes-71]2 Sessions Weekly**',
      grid_features: 'Features',
      grid_99_annual: '$99 Annual',
      grid_219_monthly: '$219 Monthly',
      grid_399_monthly: '$399 Monthly',
      grid_self_paced_year_price: '$__price__ Annual',
      grid_self_paced_year_price_without_currency: '__price__ Annual',
      grid_personalized_instruction: '1:1 Personalized Instruction',
      grid_premium_access: 'Premium Access',
      grid_codecombat: 'CodeCombat',
      grid_ozaria: 'Ozaria',
      grid_ai_league: 'AI League',
      grid_codecombat_worlds: 'CodeCombat Worlds',
      grid_ai_hackstack: 'AI HackStack',
      grid_parent_dashboard: 'Personalized Parent Dashboard',
      grid_lesson_slides: 'Contextual Lesson Slides',
      grid_connections_applications: 'Real-world Connections & Applications',
      grid_monthly_reports: 'Monthly Progress Reports',
      grid_completion_certificates: 'Course Completion Certificates',
      grid_apcsp_option: 'AP CSP Preparation Option',
      grid_class_recording: 'Class Recording Option*',
      grid_money_back: '30-Day Money-Back Guarantee**',
      grid_ai_hints_allowance: 'CodeCombat AI Hints Allowance (Daily)***',
      grid_prompts_allowance: 'CodeCombat AI HackStack Prompts Allowance (Monthly)***',
      step_boxes_header_text: 'The engaging, project-based curriculum focuses on teaching **real-world text-based coding languages**. While our hands-on approach ensures that students spend a majority of their class time coding, having fun, and experiencing real-time feedback, thus preventing feelings of frustration or stagnation.',
      step_box_1_title: 'Live Instructions',
      step_box_1_subtitle: 'Engage',
      step_box_1_footer_text: 'What kind of loops exist in the real world?',
      step_box_2_title: 'Live Instructions',
      step_box_2_subtitle: 'Explore',
      step_box_2_footer_text: 'Loops are a way to repeat a sequence of code.',
      step_box_3_title: 'Game Time',
      step_box_3_subtitle: 'Evaluate',
      step_box_3_footer_text: 'Build a game using loops.',
      step_box_4_title: 'Game Time',
      step_box_4_subtitle: 'Extend',
      step_box_4_footer_text: 'Use loops to collect the lightstones.',
      step_boxes_footer_text: 'Trusted by over **320,000 educators** worldwide, our scaffolded curriculum is critical to helping students persevere. Our students type real code from the start, become more confident with each class, and learn how Computer Science is relevant to their daily lives.',
      play_code_create: 'Play, code and create with the most engaging **live online coding classes**',
      unlock_passion: 'Unlock your child’s passion for computer science and potential for success with our flexible curriculum and personalized instruction.',
      schedule_free_class: 'Schedule a Free Class',
      enroll_now: 'Or, **[https://codecombat.com/payments/initial-online-classes-71]enroll now**',
      create_parent_account: 'Create Parent Account',
      to_explore: 'To explore',
      testimonials_1_full_review_text: 'Testimonial 1 Full Review Text',
      adapt_interests: 'We adapt to your child’s interests',
      comprehensive_packages: 'Our comprehensive packages include',
      classes_recorded: 'Classes are recorded by default for quality and training purposes. We store class recordings for 3-5 business days. We will not record classes if requested.',
      subscriptions_billed: 'All subscriptions are billed in advance and may be paused, canceled, or resumed with no additional fees. Live Online Classes subscriptions are 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply **contact us** within 30 days of purchase and we will refund 100% of your payment. All plans are automatically renewed at the same level and billing cycle unless otherwise changed or canceled. We do not offer refunds after the first 30 days. Cancellation after the first 30 days will take effect at the start of the next billing cycle.',
      ai_hints: 'AI hints and prompt allowances are subject to change',
      prefix_or: 'Or, ',
      signup_description: 'Sign Up for Self-Paced Access',
      homeschool_solution: 'Looking for a homeschool solution',
      teach_child: 'If you plan to teach your child, we can provide a turnkey solution that empowers you to deliver our curriculum in your own home. We provide all the teaching resources needed for you and your child to succeed including course solution guides. Contact our team to learn more - email **[mailto:classes@codecombat.com]classes@codecombat.com** to connect with a learning advisor.',
      meet_instructors: '**Meet our Instructors**',
      why_cs_important: 'Why computer science is important',
      cs_benefits: "Computer science education provides the immediate benefits of boosting **problem-solving competencies, sharpening mathematical abilities**, and encourages the **logical thinking** necessary for success across many other core school subjects. The learning extends far beyond the code, enhancing students' capability to solve complex problems, adapt to different situations and foster a growth mindset. See how Ozaria helps make those **cross curricular connections.**",
      curriculum_design: 'Our curriculum is designed to equip your child today with the crucial computer science skills that will prepare them for the **digital jobs of tomorrow.**',
      concepts_covered: 'Concepts covered',
      beginner_level: 'Beginner',
      beginner_title: 'For students with little to no text-based coding experience',
      intermediate_level: 'Intermediate',
      intermediate_title: 'For students with some text-based coding experience',
      advanced_level: 'Advanced',
      advanced_title: 'For students with substantial experience in  text-based coding and a good grasp of complex concepts',
      cs_careers: 'For those interested in pursuing careers in coding and computer science, no worries; AI is not going to replace you. In fact, according to the **[https://www.mckinsey.com/mgi/our-research/generative-ai-and-the-future-of-work-in-america]McKinsey Global Institute Report [Generative AI and the future of work in America]**, by 2030, STEM jobs will see the second highest labor demand growth at +23%, just behind healthcare. STEM professionals will be well positioned to understand and adopt the latest AI technologies as they continue to evolve, making those with computer science knowledge even more effective and valuable.',
      why_game_based: 'Why game-based learning works',
      game_based_effective: 'Game-based learning is so effective because it provides a safe environment where failure is not feared but seen as an expected opportunity for growth and understanding. This approach encourages players to learn from their mistakes and adapt their strategies for success. Furthermore, the interactive and dynamic nature of games helps young learners retain information more effectively, as they are learning through practical, hands-on experiences. It actively engages them in the learning process, increasing their motivation and enjoyment.',
      how_integrate_ai: 'How we integrate AI safely and responsibly',
      see_how: 'See how our instructors blend core curriculum concept review, real-world application, in-game practice and creative coding exercises into a fun and personalized experience.',
      ai_technology_description: 'Our AI technology adheres to **safety-first principles**, providing confidence to both learners and instructors. We do not allow our backend LLM providers to train on your chats and have established **protective measures against inappropriate content**. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating learners about potential AI pitfalls. Moreover, we log AI chat activity for instructor monitoring and uphold **stringent data privacy and security protocols**.',
      instructors_offer_guidance: "Our instructors offer the guidance and support your child needs, but can’t always be there. That’s where our innovative AI hints feature helps the learning continue between sessions. This support feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available students will still need to work through each level's coding challenge. Subscribers receive an allocation of 20 AI hints per day to ensure they always have the support they need.",
      new_to_ai: 'For those new to AI, we offer **[/ai]CodeCombat AI HackStack**. Our instructors use this innovative tool to teach your child how to use AI safely and responsibly. The application provides secure access to many of the latest LLMs including ChatGPT-4, Claude, Stable Diffusion, DALL-E and others. After just a short time working with our instructors, your child will unlock the full creative potential of the tool, allowing prompt-to-code-to-published projects in minutes. This AI-powered application enables users to generate games, art, websites code and more. Every live online classes subscriber receives 200 prompts per month to create multiple AI projects.',
      ap_csp_preparation: 'AP CSP Preperation',
      ap_csp_description: 'Did you know that you don’t need to be enrolled in an AP CSP class to take the AP CSP exam? If your child plans to pursue a career in computer science taking the AP Computer Science Principles exam can be a promising first step, and we can help. Passing the exam serves as a recognized avenue to postsecondary credit, enabling learners to bypass costly and time-consuming college requirements. Our course, endorsed by the College Board affirms that our curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment.',
      get_prepared_for_ap_csp_exam: '**[/apcsp]Get prepared for the AP CSP exam**',
      schedule_a_free_class: 'Schedule a Free Class',
      boxes_title: 'Personalized instruction and premium access with a single subscription',
      ozaria_title: 'Ozaria',
      ozaria_text: 'An enchanting narrative coding adventure that establishes the fundamentals of computer science.',
      personalized_instruction: 'An enchanting narrative coding adventure that establishes the fundamentals of computer science.',
      codecombat_title: 'CodeCombat',
      codecombat_text: 'A game-based computer science curriculum that features web development, game development and prep for the AP CSP exam.',
      ai_league_sports_title: 'AI League Sports',
      ai_league_sports_text: 'An epic competitive coding esports platform that encourages creative programming in a game-based environment.',
      codecombat_worlds_title: 'CodeCombat Worlds',
      codecombat_worlds_text: 'Developed in partnership with Roblox Education,this experience accelerates your child’s coding abilities to create amazing Roblox games and experiences.',
      ai_hackstack_title: 'AI HackStack',
      ai_hackstack_text: 'Learn anything, create something, do everything with the first generative AI companion tool specifically crafted for those new to AI. It’s AI empowerment for all!',
      every_child_different_learning_style: '**Every child has a different learning style and academic interests. We’ve developed a suite of effective game-based learning programs to ensure your child stays engaged and excited to keep learning even when topics become complex or challenging.**',
      carousel_items_1_title: 'Coding[NEWLINE]Fundamental',
      carousel_items_1_title_prefix: '**Focus:**',
      carousel_items_1_text: 'For students with little to no coding experience, most class sessions will be in Ozaria to build foundational skills and then in CodeCombat to deepen programming knowledge. AI HackStack will be used to help accelerate your child’s coding abilities and showcase real-world applications of their new-found skills. CodeCombat Worlds and AI League will offer occasional practice and creative play opportunities.',
      carousel_items_2_title: 'Game[NEWLINE]Development',
      carousel_items_2_title_prefix: '**Focus:**',
      carousel_items_2_text: 'If your child loves games and wants to make them, then our game development focused curriculum will feature CodeCombat at the core for the initial game development activities and projects. In no time your child will be working in CodeCombat Worlds building and publishing real games to the Roblox platform. Competing in our AI League provides additional insight into successful game dynamics and development, while AI HackStack will be a powerful tool for iterative game development.',
      carousel_items_3_title: 'Web[NEWLINE]Development',
      carousel_items_3_title_prefix: '**Focus:**',
      carousel_items_3_text: 'Developing for the web is ever evolving and it’s important to stay ahead of the curve. In this curriculum focus the initial web development activities will be conducted in CodeCombat, while Ozaria will be used for those new to coding. AI HackStack will be heavily implemented as the platform to build an publish to the web, with limited use of CodeCombat Worlds and AI League to help reinforce key coding concepts.',
      carousel_items_4_title: 'Competitive[NEWLINE]Coding Esports',
      carousel_items_4_title_prefix: '**Focus:**',
      carousel_items_4_text: 'Esports enthusiasts will love the competitive spirit of this curriculum focus. With a foundation built from CodeCombat, your child will be competing in our AI League global esports tournaments year-round with scholarships and prizes on the line. With an emphasis on creative coding and iteration your child will learn how to use our AI HackStack tool to supercharge their abilities in competition.',
      carousel_items_5_title: 'AI[NEWLINE]Applications',
      carousel_items_5_title_prefix: '**Focus:**',
      carousel_items_5_text: 'AI is everywhere and those that can harness its power will be able to maximise their potential. This curriculum focus builds from CodeCombat but it’s AI HackStack that will help teach the art of drafting the strongest AI prompts and how to use all the latest generative AI tools in a safe and secure environment. The generative AI feature built into CodeCombat Worlds will offer yet another real world opportunity to see what your child can do with AI.',
      carousel_items_6_title: 'AP CSP[NEWLINE]Preparations',
      carousel_items_6_title_prefix: '**Focus:**',
      carousel_items_6_text: 'If your child plans to pursue a career in computer science taking the AP Computer Science Principles exam can be a promising first step. Passing the exam serves as a recognized avenue to postsecondary credit, enabling learners to bypass costly and time-consuming college requirements. Our course, endorsed by the College Board affirms that our curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment. You do not need to be enrolled in a high school AP class to take the exam and we can support you in finding an in-person exam location.',
      instructors_1_text: "Brian is a passionate coding teacher with 13 years in the classroom teaching mathematics and computer science. He has experience with Java, Python, Javascript, HTML, and CSS. With a bachelor’s in Mathematics Education and a Masters's in Educational Theory he loves sharing his passion for math and computer science with others. He believes that by teaching computer science we are preparing our youth to be the next generation of exceptional problem solvers.",
      instructors_2_text: "Shreeaa has a passion for helping others discover the joy of coding. Having previously found success with a career in software development, she brings real-world knowledge to her classes. Her teaching style is hands-on and practical, with a focus on helping one gain the skills they need to create real-world projects while having lots of fun. Whether you're new to coding or looking to expand your knowledge, she’s here to support you on your journey.",
      instructors_3_text: "Tai is currently studying both Criminal Justice and Cyber Security. He has a passion for justice and technology, and hopes to use his skills to make the world a safer place. In addition to his studies, Tai worked at the YMCA for over five years, where he gained valuable experience in child care. He is dedicated to fostering a safe and supportive environment for all, whether it's working with children or in the tech industry.",
      instructors_4_text: "Carson has been teaching coding for two years, with professional experience in many programming languages, including Python, Javascript and HTML. Carson's teaching approach focuses on relating the concepts to things the student is passionate about or interested in. He prefers to let the student explore and find their own path, while guiding them through learning in the way that suits their style and personality.",
      instructors_5_text: "Dania is a Computer Engineering graduate with a passion for teaching and spreading knowledge. Dania has over six years of experience teaching different programming languages and computer literacy. She believes in the importance of learning coding at a young age to ensure them an edge in today's fast-moving digital world where coding is the global language.",
      instructors_6_text: "Riley’s journey began when he taught himself Python while pursuing his first Bachelor's degree. His passion for education led him to become a high school Social Studies teacher, where he continued to enhance his coding skills on the side. After three years of teaching, he decided to return to school to earn another Bachelor's degree in Computer Science. His enthusiasm for education remains as strong as ever, and now he is genuinely excited to be teaching something he loves. He fosters meaningful interactions with his students, igniting their genuine interest in the subject matter rather than relying solely on strict memorization.",
      instructors_7_text: 'Ishraq is a passionate coding teacher with experience in full-stack web development. She started coding in middle school and believes that coding at a young age is vital. Having started coding at a young age she understands how important it is for them to enjoy the process of learning and goes the extra mile to ensure her students love every class.',
      instructors_8_text: 'This is Edi, short for Edwin. He lives in Bali, Indonesia and has been running a programming school for the past two years. In his former career he was an IT professional who traveled across the globe implementing project structure. His passions are teaching and sharing knowledge and loves the chance to teach children and introduce them to the wonderful world of programming. Sampai Jumpa lagi (Indonesian for see you soon)!',
      instructors_9_text: 'Meet Kislay, a mom, engineering graduate, coding instructor, and math enthusiast with three years of edtech teaching experience. She is passionate about teaching coding and math to others, and has helped hundreds of students from diverse backgrounds with their math concepts and coding languages such as Python, JavaScript, HTML/CSS, and Node.js. Her teaching style emphasizes practical, real-world applications, and her goal is to help her students build the skills and confidence they need to succeed in the tech industry.',
      instructors_10_text: 'Nadeem was first inspired to take up coding while studying Java in community college. After transferring to the University of California, Berkeley and picking up Python, his passion and excitement for coding grew. As a current PhD student in computational mathematics, coding now sits at the heart of what he works on everyday. Coming from a large family, Nadeem has always enjoyed being around kids, and relishes the opportunity to mentor young students.',
      instructors_11_text: 'Bhavika has a Masters Degree in Information Systems and  extensive experience in tech. She started her career in Web Development and has explored other areas of IT, such as Middleware Administration and QA Testing. She has experience in several programming languages including Python, Django, AngularJS, Lua Coding, HTML and CSS. She believes no one is ever too young to start learning these vital skills.',
      instructors_12_text: 'Sergio has been a Technology/Computer Science teacher for seven years, working in international schools in both South America and South Korea. He is originally from Venezuela and is currently living in Colombia. With a degree in Computer Science Education, he teaches Python, HTML, CSS, JavaScript, and Swift, amongst others non-coding subjects. He has also earned several certificates in programming languages and is currently working on a Data Science certification. He believes that learning how to code can help anyone solve problems in the real world. And yes, he can teach in spanish.',
      instructors_13_text: 'Bella currently studies Computer Science at UC Berkeley and is passionate about sharing the excitement of the technological world with others. From robotics to web development, Bella has been teaching computer programming for over five years and fosters an inclusive and supportive learning environment so that students can prosper and take control of their coding journey.',
      faq_1_question: 'What should I expect in the trial class?',
      faq_1_answer: 'Each trial class is a private 60 minute session with **45 minutes of instruction** for the student followed by **15 minutes for discussion with a parent or guardian**. These 15 minutes are important and are set aside to answer any questions, provide insight into how the ongoing curriculum progresses, and help you select the right skill level and coding language for your child.',
      faq_2_question: 'How are instructors matched with my child?',
      faq_2_answer: 'After the initial trial class, our team carefully matches our online instructors to each student based on their experience level, personality, interests, and schedule. Our team will work with you to improve your experience if you or your child doesn’t love learning with your instructor.',
      faq_3_question: 'Are there any student age limits?',
      faq_3_answer: 'We offer a variety of approaches to ensure younger and older students alike can get the most out of our curriculum and instruction. We mostly serve elementary to high school aged students. However, if your child can type, use a mouse, and is comfortable using a computer, they are welcome to join our class.',
      faq_4_question: 'What kind of technology do I need to join the class?',
      faq_4_answer: 'Your student will need a reliable internet connection and a laptop or desktop computer. We do not recommend tablets, as students will need the ability to screen share their browser.',
      faq_5_question: 'What is the cancellation policy?',
      faq_5_answer: 'Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply contact us at **[mailto:classes@codecombat.com]classes@codecombat.com** within 30 days of purchase and we will promptly refund 100% of your purchase, no questions asked.',
      faq_6_question: 'What if I need to reschedule a class?',
      faq_6_answer: "Once you have booked a weekly class with us, we have reserved time in our schedule exclusively for you, so we require 48 hours' advance notice for rescheduling classes. You can reschedule your class by emailing **[mailto:classes@codecombat.com]classes@codecombat.com**. Classes missed or canceled with less than 48 hours' notice will not be rescheduled or refunded.",
      faq_7_question: 'What if we have vacation planned?',
      faq_7_answer: 'We offer the option to pause your classes for up to two weeks. If an extended break is needed, we will suspend your subscription for the duration of your break and will connect with you upon your return to reinstate classes. Please note that we may need to find a new time if your student’s instructor is no longer available at your previous time.',
      faq_8_question: 'Do you provide group classes?',
      faq_8_answer: 'We do not arrange or assign group classes, but if you have a group of students looking to work together, we are happy to facilitate a group class for them.',
      faq_9_question: 'Do you offer any discounts?',
      faq_9_answer: 'We offer discounts for siblings and group classes. We do not arrange or assign group classes, but if you have a group of students looking to work together, we will facilitate a group class for them. Please reach out to **[mailto:classes@codecombat.com]classes@codecombat.com** for questions about specific pricing details.',
      faq_10_question: 'Will my student get to work with the same instructor?',
      faq_10_answer: 'Yes, once your subscription is arranged, your student will work with the same instructor each week. Periodically a substitute might need to be arranged for scheduling conflicts, but this is rare.',
      faq_11_question: 'Is my child’s data secure?',
      faq_11_answer: 'We take student safety, cybersecurity, and data privacy seriously, and follow the stringent school-grade privacy regulations including COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, as well as GDPR. All student data is stored securely on Amazon Web Services in the US. Our AI integrations have guardrails to protect Personal Identifiable Information (PII) and restrict sensitive content. Project sharing is controlled and peer-to-peer communication is restricted. Visit  **[https://codecombat.com/privacy]https://codecombat.com/privacy** for more information.',
      faq_12_question: 'Do you offer classes in other languages?',
      faq_12_answer: 'We offer the full class experience in both English and Spanish. However our talented group of instructors speak many other languages. If you have a specific language preference please reach out to **[mailto:classes@codecombat.com]classes@codecombat.com** to see if we can accommodate your child’s preferred language.',
      faq_13_question: 'What makes our class experience different?',
      faq_13_answer: 'Unlike other coding education platforms, our game-based approach uses our proprietary games and technology to deliver more engaging experience and more effective outcomes. We’ve developed our own web-based games and a fully immersive experience on Roblox that makes learning to code and game creation more enjoyable.',
    },
    roblox: {
      header_title: 'Empowering every player to become a **creator**!',
      header_content: 'Experience the easiest and most enjoyable way to code and create your own Roblox games',
      link_reward: 'Account Linking Rewards',
      link_reward_desc: 'Link your CodeCombat and Roblox accounts to unlock features and rewards',
      link_encouragement: 'The more people link their accounts, the more rewards you\'ll receive!',
      connect_button_list_item_1: 'Manage subscriptions',
      connect_button_list_item_2: 'Unlock premium content',
      connect_button_list_item_3: 'Track progress',
      connect_button_list_item_4: 'Earn exclusive rewards',
      connect_button_list_item_5: 'Access curricular resources',
      connect_button_list_item_6: 'Unlock generative AI features',
      connect_button_list_item_7: 'Creative mode publishing',
      connect_button_list_item_8: 'Parent and teacher dashboards',
      link_now: 'Link Now',
      pcc_on_roblox: 'Play, Code and Create on Roblox',
      play_title: 'Play',
      play_desc: 'Explore the 3D immersive experience of CodeCombat Worlds. Program your pets and adventure into a universe of creativity and shared experiences with friends.',
      code_title: 'Code',
      code_desc: 'Learn real Lua coding, from beginner to advanced. Use code to explore, gather resources, build, and discover your path to glory.',
      create_title: 'Create',
      create_desc: 'No Roblox Studio? No problem. Code in-game in Creative Mode to make full Roblox games to share with your friends.',
      what_create: 'What will you create?',
      access_guidebook: 'Access Guidebook',
      guidebook_description: 'Everything you need to know to get started',
      faq_1_question: 'Do I need to know Lua or Roblox Studio?',
      faq_1_answer: 'No. This experience will allow anyone to play, code and create from the very start of their adventure, without any coding experience.',
      faq_2_question: 'Can I create my own games?',
      faq_2_answer: 'Yes. Game development is at the core of this experience and after completing the essential learning levels you will have the opportunity to create your own.',
      faq_3_question: 'Will my creations be available on Roblox?',
      faq_3_answer: 'Yes. Players can share their experiences within CodeCombat Worlds and import their experiences to Studio for publishing via a plugin, maintaining Studio compatibility.',
      faq_4_question: 'Do I need a Roblox account?',
      faq_4_answer: "Yes. All players can sign-up for free at roblox.com. Don't forget to link your CodeCombat account and Roblox account to access all the features and rewards.",
      faq_5_question: 'Will it work on my Chromebook or mobile device?',
      faq_5_answer: 'Yes. CodeCombat Worlds allows you to play, type real code and create games on PC, Mac, Chromebooks, tablets, phones, and consoles.',
      promo_modal_title: 'Discover CodeCombat Worlds',
      promo_modal_text: '**Want to build a Roblox game but can’t code?** Jump into **CodeCombat Worlds** — where you’ll learn by playing! Start in Rift Village, coding your pets to harvest, and battle. Then tackle Lua (the coding language of Roblox) in the Learning Levels, and finally unleash your ideas in Creative Mode to craft immersive Roblox games. The power to create is in your hands!',
      having_trouble: 'Having trouble?',
      check_help_doc: 'View our connection guide here',
    },
    pd_page: {
      implementation_training_title: 'Implementation Training',
      implementation_training_blurb: 'Educators are provided with a live, online 60 minute onboarding training and guidance on how to use CodeCombat or Ozaria to support specific institutional and instructional goals. The implementation is focused on a comprehensive teacher dashboard walkthrough that covers:',
      list_1: 'How to add classes & students',
      list_2: 'How to track & lock student progress',
      list_3: 'An overview of how to use the resources available in the Resource Hub, including: Course Guide, Lesson Plans, Lesson Slides, & Educator FAQ',
      modal_subtitle: 'To get licenses for our professional development course, send us a message and our classroom success team will be in touch!',
      email_message: 'Hi! I’m interested in learning more about your professional development course and discussing pricing options.',
      professional_development_title: 'Professional Development[NEWLINE](With Ozaria)',
      professional_development_blurb: 'This 40+ hour online, self-directed course provides educators with the knowledge, skills and resources to implement high-quality CS instruction.',
      list_4: 'It adheres to the ESSA guidelines for exemplary professional learning, is endorsed by the CSTA and qualifies for valuable professional education credit hours.',
      list_5: 'The course is built on a Learn It, Try It, Teach It model ensuring teachers have a solid foundation of the concepts before they implement it in the classroom.',
      list_6: 'Earn up to 3 graduate-level education credit hours while exploring core CS concepts and teaching strategies that include computational thinking, inquiry-based learning, SEL and DEI.',
      download_table_of_contents: 'Download Table of Contents',
      ap_csp_professional_development_title: 'AP CSP Professional Development[NEWLINE](With CodeCombat)',
      ap_csp_professional_development_blurb: 'This 40+ hour online, largely self-directed course is ideal for any educator who wants to prepare their students to succeed on the AP Computer Science Principles exam using CodeCombat.',
      list_7: 'Both this course and the CodeCombat AP CSP curriculum are endorsed by the College Board. The hours completed in this course can be used to qualify for valuable professional education credit.',
      list_8: 'The course leverages synchronous, small group conversations with AP CSP teachers from across the globe in order to deepen one’s CS knowledge and enrich one’s classroom practices.',
      list_9: 'Through CodeCombat’s partnership with Southern New Hampshire University (SNHU), you can earn up to 3 graduate-level credit hours while learning how to best prepare your students to take the AP CSP exam.',
      download_syllabus: 'Download Syllabus',
      get_full_course: 'Get Full Course',
      try_sample_lesson: 'Try Sample Lesson',
      trophy_header: 'Level up as a Computer Science Teacher with our Professional Development offerings!',
    },
    junior_page: {
      testimonials_1_quote: 'The future is programmable and you will need to be able to code to participate… I think CodeCombat has the best CS curriculum on the market… the teacher toolkit is what sets it apart.',
      testimonials_1_name: 'Jacob Kaminski',
      testimonials_1_title: 'STEM Program Director, American STEM Prep',
      start_their_coding_journey_today: '**Start** their coding journey **today!**',
      our_flagship_k_5_curriculum: 'Our **flagship K-5 curriculum** features a scaffolded progression of learning levels that **teach coding concepts at a slower pace**, modeled specifically for elementary students.',
      sign_up_to_start_today: 'Sign up to start today',
      testimonials_1_full_review_text: 'Full review text',
      scaffolded_approach: 'Scaffolded Approach',
      no_matter_the_coding_experience: 'No matter the coding experience, CodeCombat Junior **meets students where they’re at.** They can code with icon blocks, word blocks, blocks and text code in parallel, or text-based coding with industry standard languages.',
      accessible_to_all: 'Accessible to All',
      with_our_tablet_friendly_platform: 'We’ve anticipated the challenges our youngest learners might face, incorporating **no-reading and no-typing options.** The simplified user interface performs exceptionally well on Chromebooks, as well as tablets and iPads without physical keyboards, ensuring equity and accessibility for all, irrespective of their device.',
      adaptive_to_each_student: 'Adaptive to Each Student',
      codecombat_junior_automatically_assesses: 'CodeCombat Junior automatically assesses learner’s coding success and recommends **custom-generated practice levels** when they need extra support. This provides a personalized learning pathway for every student while offering the ability for parents and educators to track progress.',
      coding_fundamentals_and_cross_curricular_connections: 'Coding Fundamentals and Cross-Curricular Connections',
      our_curriculum_offers_student_facing: 'For educators, our curriculum offers student-facing lesson slides and approachable activities to teach both core K-5 coding concepts and cross-curricular connections. The unplugged activities **integrate coding concepts with other disciplines like Math and ELA.** Topics include sequencing stories, visualizing and graphing data, narratives, and number sentences. All of our lessons are designed to **meet Computer Science Teachers Association (CSTA) Standards and Common Core Standards.**',
      request_a_quote: 'Request a Quote',
      scope_and_sequence: 'Scope and Sequence',
      check_out_this_resource: 'Check out **[https://docs.google.com/spreadsheets/d/1_2zr55qsEcbHDyDNoelYamN9ov0G35ju7s-ufttSzVQ]this resource** as a starting point for your personalized approach.',
      connect_with_our_team: 'Connect with our team to access all the teacher resources, a personalized learning pathway, generative practice levels, and more. We’ll help you integrate this comprehensive K-5 coding curriculum to ensure your students thrive at every stage of their coding journey.',
      faq_1_question: 'FAQ 1 Question',
      faq_1_answer: 'FAQ 1 Answer',
      faq_2_question: 'FAQ 2 Question',
      faq_2_answer: 'FAQ 2 Answer',
      faq_3_question: 'FAQ 3 Question',
      faq_3_answer: 'FAQ 3 Answer',
      faq_4_question: 'FAQ 4 Question',
      faq_4_answer: 'FAQ 4 Answer',
      meta_title: 'CodeCombat Junior: K-5 Computer Science for Schools',
      our_comprehensive_implementation: 'Our comprehensive implementation',
      trends_1_title: 'Kickstarting CS in K-5 Classrooms',
      trends_1_text: "Watch as CodeCombat's Director of Education, Charlotte Cheng, and STEM Program Director, Jacob Kaminski, explore how to integrate **CodeCombat Junior** and **CodeCombat Worlds** into your classroom. They share practical strategies, success stories, and answer questions from fellow educators.",
      trends_1_linkText: 'Learn more',
      trends_2_title: 'CodeCombat Junior: A New Dynamic Approach to K-5 Coding',
      trends_2_text: 'Learn more about how **CodeCombat Junior** can bring coding education to K-5 classrooms. From drag-and-drop icon-based block coding to text-based coding in Python and JavaScript, this adaptable platform supports students at every stage. With over 1,100 levels and more in development, CodeCombat Junior offers endless opportunities.',
      trends_2_linkText: 'Read the blog',
      get_a_headstart: 'Get a Headstart from Home',
      parents_junior_perfect: 'Parents, CodeCombat Junior is the perfect way to start introducing your child not only to computer science but all the benefits, including problem solving, logic and reasoning, persistence, computational thinking and creative exploration.',
      explore_learning_options: 'Explore Learning Options',
      promo_modal_subtitle: 'Play, Learn, and Grow with Game‑Based Coding',
      promo_modal_text: '**Kickstart their coding adventure with scaffolded levels designed for ages 5–8—no reading or typing needed!** They’ll learn with icon blocks, word blocks, or simple text side by side, and tackle adaptive challenges that keep them engaged. Works seamlessly on **Chromebooks**, **tablets**, and **iPads**.',
    },
    paywall: {
      badge_free: 'Free',
      'badge_sales-call': 'Unlock with Call',
      badge_paid: 'Paid',
      badge_tooltip_free: 'Explore our levels at no cost!',
      'badge_tooltip_sales-call': 'Interested in more? Give us a call and unlock!',
      badge_tooltip_paid: 'This content is exclusive to users with a valid license.',
    },
    exams: {
      timer_tip: 'A timer will start when you click Start Exam',
      no_permission: 'Only users with permission can take the exam',
      level_num: 'Challenge __num__',
      time_left: 'Time Left (HH:mm):',
      submit_tip: 'Are you sure you want to mark as complete? You will not be able to play the levels again.',
      start_exam: 'Start Exam',
      continue_exam: 'Continue Exam',
      return_to_exam: 'Return to the Exam',
    },
    hoc_page: {
      hoai_activities_poetry_title: 'AI HackStack: Poetry in Motion',
      hoai_activities_poetry_description: 'Bring poetry to life with AI HackStack! Learners explore a poem’s theme, craft prompts to generate images, and evaluate AI outputs for bias while blending ELA skills with AI literacy as words transform into art.',
      hoai_activities_social_title: 'AI HackStack: Social Media Showdown',
      hoai_labels_grade: 'Grades 6+',
      hoai_labels_multimodal: 'Multimodal AI',
      hoai_labels_ela: 'ELA',
      hoai_labels_algebra: 'Algebra',
      hoai_labels_cs: 'CS',
      hoai_activities_social_description: 'Play social media manager in this algebra and AI challenge! Prompt AI to build formulas, model engagement, and judge celebrity content battles while mastering math and AI literacy.',
      hoai_activities_vibe_title: 'AI HackStack: Vibe Coding Lab',
      hoai_activities_vibe_description: 'Dive into vibe coding with AI HackStack! Guide a hero with simple algorithms, explore syntax, and prompt AI to remix code into games and sites for a creative, fast, and fun coding experience.',
      hoai_activities_esports_title: 'CodeCombat: AI Esports',
      hoai_activities_esports_description: 'AI meets esports in this coding challenge! Learn prompts and algorithms, experiment with vibe coding, then team up with an AI assistant to face the CPU in the ultimate AI League battle.',
      learn_and_engage_with_these_csedweek_activities: '**Learn** and **engage** with these **CSEdWeek** activities!',
      latest_activities: 'Latest Activities',
      hoai_activities: 'Hour of AI Activities',
      turn_csedweek_into_a_cs_year: 'Turn CSEdWeek into a CS Year',
      start_teaching_today_with_free_trial_access_to_all_games_and_teaching_resources: 'Start teaching today with free trial access to all games and teaching resources.',
      more_of_our_csedweek_activities: 'More of Our CSEdWeek Activities',
      latest_activities_1_title: 'AI HackStack: Exploring AI Basics',
      latest_activities_1_text: 'Unleash your creativity and explore the future with AI HackStack! From designing AI-generated art to building intelligent tools, dive into hands-on activities that make learning safe, fun, and inspiring for all skill levels.',
      latest_activities_1_label_1: 'Grades 6-8',
      latest_activities_1_label_2: 'Multimodal AI',
      latest_activities_2_title: 'CodeCombat Junior',
      latest_activities_2_text: 'Ready, set, code! Help your pet collect gems by mastering the basics of programming. Learn to create sequences, solve puzzles, and build algorithms in this hands-on adventure!',
      latest_activities_2_label_1: 'Grades K-5',
      latest_activities_2_label_2: 'JavaScript, Python',
      latest_activities_2_label_3: 'Tablet Friendly',
      try_activity: 'Try Activity',
      view_lesson: 'View Lesson',
      codecombat_worlds_title: 'CodeCombat Worlds',
      codecombat_worlds_text: 'Master coding by creating your own Roblox games, from coding pets in the Overworld to crafting games in Creative Mode!',
      codecombat_worlds_label_1: 'Grades 2+',
      codecombat_worlds_label_2: 'Lua',
      codecombat_worlds_label_3: 'Tablet Friendly',
      codecombat_worlds_label_4: 'Download Required',
      goblins_glory_title: "CodeCombat: Goblins 'n' Glory",
      goblins_glory_text: 'We need your help! Embark on an epic quest where you take control of the game through your powers of programming.',
      goblins_glory_label_1: 'Grades 6-8',
      goblins_glory_label_2: 'JavaScript, Python',
      ai_league_title: 'Esports Bootcamp: AI League',
      ai_league_text: 'Competitive coding has never been so epic! Learn the skills you need to play like the pros in our Esports Bootcamp. No coding experience needed.',
      ai_league_label_1: 'Grades 6-8',
      ai_league_label_2: 'JavaScript, Python',
      ozaria_title: 'Ozaria: Your Journey Begins',
      ozaria_text: 'Enter the world of Ozaria where you must use the power of coding to defeat a darkness that has taken over the world!',
      ozaria_label_1: 'Grades 6-8',
      ozaria_label_2: 'JavaScript, Python',
      escape_dungeon_title: 'Beginner CS: Escape the Dungeon!',
      escape_dungeon_text: 'Choose your hero and code your way through the ogre patrols, lava pits, and laser beams of Kithgard Dungeon. Level up, earn gems, and loot magic items to unlock new programming powers!',
      escape_dungeon_label_1: 'Grades 6-8',
      escape_dungeon_label_2: 'JavaScript, Python',
      beginner_game_dev_title: 'Beginner Game Dev: Build Your Own Game!',
      beginner_game_dev_text: 'First, level up your Python or JavaScript programming skills by coding your way out of danger and grabbing sweet loot. Then use your programming powers to build your own game and see if your friends can beat it!',
      beginner_game_dev_label_1: 'Grades 6-8',
      beginner_game_dev_label_2: 'JavaScript, Python',
      intermediate_game_dev_title: 'Intermediate Game Dev: Code, Play, Create',
      intermediate_game_dev_text: 'Code and play a series of game levels while learning important Computer Science concepts. On the final level, show off your creativity and skills to code your own game from scratch!',
      intermediate_game_dev_label_1: 'Grades 6+',
      intermediate_game_dev_label_2: 'JavaScript, Python',
      advanced_game_dev_title: 'Advanced Game Dev: Build an Arcade Game!',
      advanced_game_dev_text: 'Ready to create an even cooler game? Brush up on advanced coding concepts like functions and events using Python or JavaScript, then use those skills to build your own arcade survival game!',
      advanced_game_dev_label_1: 'Grades 6+',
      advanced_game_dev_label_2: 'JavaScript, Python',
    },
  },
}
